/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/dompurify/dist/purify.js":
/*!***********************************************!*\
  !*** ./node_modules/dompurify/dist/purify.js ***!
  \***********************************************/
/***/ (function(module) {

/*! @license DOMPurify 2.4.4 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.4/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  0;
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
      seal = Object.seal,
      create = Object.create; // eslint-disable-line import/no-mutable-exports

  var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;

  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }

  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }

  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }

  if (!construct) {
    construct = function construct(Func, args) {
      return _construct(Func, _toConsumableArray(args));
    };
  }

  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);
  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringToString = unapply(String.prototype.toString);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);
  var regExpTest = unapply(RegExp.prototype.test);
  var typeErrorCreate = unconstruct(TypeError);
  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return apply(func, thisArg, args);
    };
  }
  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return construct(func, args);
    };
  }
  /* Add properties to a lookup table */

  function addToSet(set, array, transformCaseFunc) {
    transformCaseFunc = transformCaseFunc ? transformCaseFunc : stringToLowerCase;

    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }

    var l = array.length;

    while (l--) {
      var element = array[l];

      if (typeof element === 'string') {
        var lcElement = transformCaseFunc(element);

        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }

          element = lcElement;
        }
      }

      set[element] = true;
    }

    return set;
  }
  /* Shallow clone an object */

  function clone(object) {
    var newObject = create(null);
    var property;

    for (property in object) {
      if (apply(hasOwnProperty, object, [property]) === true) {
        newObject[property] = object[property];
      }
    }

    return newObject;
  }
  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */

  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);

      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }

        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }

      object = getPrototypeOf(object);
    }

    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }

    return fallbackValue;
  }

  var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']); // SVG

  var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']); // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.

  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
  var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']); // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.

  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
  var text = freeze(['#text']);

  var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
  var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
  var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode

  var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
  var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape

  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape

  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );
  var DOCTYPE_NAME = seal(/^html$/i);

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };
  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */


  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    } // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.


    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';

    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }

    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html) {
          return html;
        },
        createScriptURL: function createScriptURL(scriptUrl) {
          return scriptUrl;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };

  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };
    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */


    DOMPurify.version = '2.4.4';
    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */

    DOMPurify.removed = [];

    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;
      return DOMPurify;
    }

    var originalDocument = window.document;
    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        Element = window.Element,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        HTMLFormElement = window.HTMLFormElement,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;
    var ElementPrototype = Element.prototype;
    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode'); // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.

    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');

      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }

    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);

    var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
    var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        createDocumentFragment = _document.createDocumentFragment,
        getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;
    var documentMode = {};

    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}

    var hooks = {};
    /**
     * Expose whether this browser supports running the full DOMPurify.
     */

    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && typeof implementation.createHTMLDocument !== 'undefined' && documentMode !== 9;
    var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
        ERB_EXPR$1 = ERB_EXPR,
        TMPLIT_EXPR$1 = TMPLIT_EXPR,
        DATA_ATTR$1 = DATA_ATTR,
        ARIA_ATTR$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$1 = ATTR_WHITESPACE;
    var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */

    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
    /* Allowed attribute names */

    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
    /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */

    var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */

    var FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */

    var FORBID_ATTR = null;
    /* Decide if ARIA attributes are okay */

    var ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */

    var ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */

    var ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */

    var ALLOW_SELF_CLOSE_IN_ATTR = true;
    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */

    var SAFE_FOR_TEMPLATES = false;
    /* Decide if document with <html>... should be returned */

    var WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */

    var SET_CONFIG = false;
    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */

    var FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */

    var RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */

    var RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */

    var RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */

    var SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */

    var SANITIZE_NAMED_PROPS = false;
    var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */

    var KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */

    var IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */

    var USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */

    var FORBID_CONTENTS = null;
    var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
    /* Tags that are safe for data: URIs */

    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
    /* Attributes safe for values like "javascript:" */

    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */

    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */

    var ALLOWED_NAMESPACES = null;
    var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
    /* Parsing of strict XHTML documents */

    var PARSER_MEDIA_TYPE;
    var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    var transformCaseFunc;
    /* Keep a reference to config to pass to hooks */

    var CONFIG = null;
    /* Ideally, do not touch anything below this line */

    /* ______________________________________________ */

    var formElement = document.createElement('form');

    var isRegexOrFunction = function isRegexOrFunction(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity


    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }
      /* Shield configuration object from tampering */


      if (!cfg || _typeof(cfg) !== 'object') {
        cfg = {};
      }
      /* Shield configuration object from prototype pollution */


      cfg = clone(cfg);
      PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.

      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
      /* Set configuration parameters */

      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
      ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
      cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
      cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true

      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true

      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false

      ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true

      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false

      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false

      RETURN_DOM = cfg.RETURN_DOM || false; // Default false

      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false

      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false

      FORCE_BODY = cfg.FORCE_BODY || false; // Default false

      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true

      SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false

      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true

      IN_PLACE = cfg.IN_PLACE || false; // Default false

      IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
        CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
      }

      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }

      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }
      /* Parse profile info */


      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
        ALLOWED_ATTR = [];

        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html$1);
          addToSet(ALLOWED_ATTR, html);
        }

        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg$1);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl$1);
          addToSet(ALLOWED_ATTR, mathMl);
          addToSet(ALLOWED_ATTR, xml);
        }
      }
      /* Merge configuration parameters */


      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }

        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }

      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }

        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }

      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
      }

      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }

        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
      }
      /* Add #text in case KEEP_CONTENT is set to true */


      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }
      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */


      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }
      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */


      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      } // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.


      if (freeze) {
        freeze(cfg);
      }

      CONFIG = cfg;
    };

    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
    var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']); // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.

    var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */

    var ALL_SVG_TAGS = addToSet({}, svg$1);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);
    var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */

    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.

      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: NAMESPACE,
          tagName: 'template'
        };
      }

      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);

      if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
        return false;
      }

      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        } // The only way to switch from MathML to SVG is via`
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.


        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        } // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.


        return Boolean(ALL_SVG_TAGS[tagName]);
      }

      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        } // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points


        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        } // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.


        return Boolean(ALL_MATHML_TAGS[tagName]);
      }

      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        } // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace


        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
      } // For XHTML and XML documents that support custom namespaces


      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
        return true;
      } // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
      // Return false just in case.


      return false;
    };
    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */


    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, {
        element: node
      });

      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };
    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */


    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }

      node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes

      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };
    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */


    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc;
      var leadingWhitespace;

      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }

      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }

      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */

      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }
      /* Use createHTMLDocument in case DOMParser is not available */


      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);

        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
        } catch (_) {// Syntax error if dirtyPayload is invalid xml
        }
      }

      var body = doc.body || doc.documentElement;

      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }
      /* Work on whole document or just its body */


      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }

      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */


    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
    };
    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */


    var _isClobbered = function _isClobbered(elm) {
      return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
    };
    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */


    var _isNode = function _isNode(object) {
      return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };
    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */


    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }

      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };
    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */


    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeElements', currentNode, null);
      /* Check if element is clobbered or can clobber */


      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Check if tagname contains Unicode */


      if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Now let's check the element's type and name */


      var tagName = transformCaseFunc(currentNode.nodeName);
      /* Execute a hook if present */

      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });
      /* Detect mXSS attempts abusing namespace confusion */


      if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Mitigate a problem with templates inside select */


      if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Remove element if anything forbids its presence */


      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Check if we have a custom element to handle */
        if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }
        /* Keep content except for bad-listed elements */


        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;

          if (childNodes && parentNode) {
            var childCount = childNodes.length;

            for (var i = childCount - 1; i >= 0; --i) {
              parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
            }
          }
        }

        _forceRemove(currentNode);

        return true;
      }
      /* Check whether element has a valid namespace */


      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }

      if ((tagName === 'noscript' || tagName === 'noembed') && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Sanitize element content to be template-safe */


      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
        content = stringReplace(content, ERB_EXPR$1, ' ');
        content = stringReplace(content, TMPLIT_EXPR$1, ' ');

        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, {
            element: currentNode.cloneNode()
          });
          currentNode.textContent = content;
        }
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeElements', currentNode, null);

      return false;
    };
    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity


    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }
      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */


      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        if ( // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
          return false;
        }
        /* Check value is safe. First, is attr inert? If so, is safe */

      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if (!value) ; else {
        return false;
      }

      return true;
    };
    /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */


    var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
      return tagName.indexOf('-') > 0;
    };
    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */


    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr;
      var value;
      var lcName;
      var l;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeAttributes', currentNode, null);

      var attributes = currentNode.attributes;
      /* Check if we have attributes; if not we might have a text node */

      if (!attributes) {
        return;
      }

      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;
      /* Go backwards over all attributes; safely remove bad ones */

      while (l--) {
        attr = attributes[l];
        var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;
        value = name === 'value' ? attr.value : stringTrim(attr.value);
        lcName = transformCaseFunc(name);
        /* Execute a hook if present */

        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set

        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);

        value = hookEvent.attrValue;
        /* Did the hooks approve of the attribute? */

        if (hookEvent.forceKeepAttr) {
          continue;
        }
        /* Remove attribute */


        _removeAttribute(name, currentNode);
        /* Did the hooks approve of the attribute? */


        if (!hookEvent.keepAttr) {
          continue;
        }
        /* Work around a security issue in jQuery 3.0 */


        if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);

          continue;
        }
        /* Sanitize attribute content to be template-safe */


        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
          value = stringReplace(value, ERB_EXPR$1, ' ');
          value = stringReplace(value, TMPLIT_EXPR$1, ' ');
        }
        /* Is `value` valid for this attribute? */


        var lcTag = transformCaseFunc(currentNode.nodeName);

        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }
        /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */


        if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
          // Remove the attribute with this value
          _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value


          value = SANITIZE_NAMED_PROPS_PREFIX + value;
        }
        /* Handle attributes that require Trusted Types */


        if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
          if (namespaceURI) ; else {
            switch (trustedTypes.getAttributeType(lcTag, lcName)) {
              case 'TrustedHTML':
                value = trustedTypesPolicy.createHTML(value);
                break;

              case 'TrustedScriptURL':
                value = trustedTypesPolicy.createScriptURL(value);
                break;
            }
          }
        }
        /* Handle invalid data-* attribute set by try-catching it */


        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }

          arrayPop(DOMPurify.removed);
        } catch (_) {}
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeAttributes', currentNode, null);
    };
    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */


    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode;

      var shadowIterator = _createIterator(fragment);
      /* Execute a hook if present */


      _executeHook('beforeSanitizeShadowDOM', fragment, null);

      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);
        /* Sanitize tags and elements */


        if (_sanitizeElements(shadowNode)) {
          continue;
        }
        /* Deep shadow DOM detected */


        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(shadowNode);
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };
    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity


    DOMPurify.sanitize = function (dirty) {
      var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body;
      var importedNode;
      var currentNode;
      var oldNode;
      var returnNode;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */

      IS_EMPTY_INPUT = !dirty;

      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }
      /* Stringify, in case dirty is an object */


      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        // eslint-disable-next-line no-negated-condition
        if (typeof dirty.toString !== 'function') {
          throw typeErrorCreate('toString is not a function');
        } else {
          dirty = dirty.toString();

          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        }
      }
      /* Check we can run. Otherwise fall back or ignore */


      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }

          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }

        return dirty;
      }
      /* Assign config vars */


      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }
      /* Clean up removed elements */


      DOMPurify.removed = [];
      /* Check if dirty is correctly typed for IN_PLACE */

      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }

      if (IN_PLACE) {
        /* Do some early pre-sanitization to avoid unsafe root nodes */
        if (dirty.nodeName) {
          var tagName = transformCaseFunc(dirty.nodeName);

          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
          }
        }
      } else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);

        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }
        /* Initialize the document to work on */


        body = _initDocument(dirty);
        /* Check we have a DOM node from the data */

        if (!body) {
          return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
      }
      /* Remove first element node (ours) if FORCE_BODY is set */


      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }
      /* Get node iterator */


      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
      /* Now start iterating over the created document */


      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }
        /* Sanitize tags and elements */


        if (_sanitizeElements(currentNode)) {
          continue;
        }
        /* Shadow DOM detected, sanitize it */


        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(currentNode);

        oldNode = currentNode;
      }

      oldNode = null;
      /* If we sanitized `dirty` in-place, return it. */

      if (IN_PLACE) {
        return dirty;
      }
      /* Return sanitized string or DOM */


      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);

          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }

        if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }

        return returnNode;
      }

      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
      /* Serialize doctype if allowed */

      if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
        serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
      }
      /* Sanitize final string template-safe */


      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
      }

      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };
    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */


    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);

      SET_CONFIG = true;
    };
    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */


    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };
    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */


    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }

      var lcTag = transformCaseFunc(tag);
      var lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };
    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */


    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }

      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };
    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */


    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        return arrayPop(hooks[entryPoint]);
      }
    };
    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */


    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };
    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */


    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };

    return DOMPurify;
  }

  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map


/***/ }),

/***/ "./src/bot/cards/chat-search-refiners/chat-search-refiners.component.tsx":
/*!*******************************************************************************!*\
  !*** ./src/bot/cards/chat-search-refiners/chat-search-refiners.component.tsx ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatSearchRefiners = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const { Bubble } = botframework_webchat_1.Components;
//TODO align styles once themes are available
const useSearchStyles = react_jss_1.createUseStyles(({ palette, spacing, sizes, fonts }) => ({
    bubble: {
        marginBottom: spacing.medium
    },
    content: Object.assign(Object.assign({}, fonts.normalPlus), { padding: `${spacing.smallPlus} ${spacing.smallPlus} ${spacing.smallPlus} ${spacing.medium}`, color: palette.neutralEmptyOn, lineHeight: sizes.small, display: "flex", justifyContent: "space-between", alignItems: "center" })
}));
const ChatSearchRefiners = ({ refiners, activity, sortOrder, children }) => {
    const searchStyles = useSearchStyles();
    const gridStyles = smarthub_common_1.useGridStyles();
    const localize = smarthub_common_1.useLocalizeConfig();
    const [expanded, setExpanded] = react_1.useState(false);
    const handleRefineOrder = () => {
        setExpanded(!expanded);
    };
    return react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.sm12, expanded ? gridStyles.lg4 : "", gridStyles.padL].join(" ") },
        react_1.default.createElement(Bubble, { className: searchStyles.bubble, fromUser: false, nub: false },
            children({ activity, attachment: sortOrder }),
            react_1.default.createElement("div", { className: searchStyles.content },
                react_1.default.createElement("span", null, expanded ? localize.refinerTitle : localize.refinerExpandTitle),
                react_1.default.createElement(react_2.IconButton, { title: expanded ? localize.hideRefiners : localize.showRefiners, ariaLabel: expanded ? localize.hideRefiners : localize.showRefiners, onClick: handleRefineOrder },
                    react_1.default.createElement(react_2.Icon, { iconName: expanded ? "ChevronUp" : "ChevronDown" }))),
            expanded && children({ activity, attachment: refiners })));
};
exports.ChatSearchRefiners = ChatSearchRefiners;


/***/ }),

/***/ "./src/bot/cards/chat-search-refiners/index.ts":
/*!*****************************************************!*\
  !*** ./src/bot/cards/chat-search-refiners/index.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-search-refiners.component */ "./src/bot/cards/chat-search-refiners/chat-search-refiners.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/cards/chat-search-results/chat-search-results.component.tsx":
/*!*****************************************************************************!*\
  !*** ./src/bot/cards/chat-search-results/chat-search-results.component.tsx ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatSearchResults = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const models_1 = __webpack_require__(/*! ../../../models */ "./src/models/index.ts");
const chat_search_refiners_1 = __webpack_require__(/*! ../chat-search-refiners */ "./src/bot/cards/chat-search-refiners/index.ts");
const { useActivities } = botframework_webchat_1.hooks;
const { Bubble } = botframework_webchat_1.Components;
//TODO align styles once themes are available
const useSearchStyles = react_jss_1.createUseStyles(({ palette, fonts, sizes, spacing }) => ({
    bubble: {
        marginBottom: spacing.medium
    },
    card: {
        marginBottom: spacing.medium,
        display: "flex"
    },
    content: Object.assign(Object.assign({}, fonts.normalPlus), { padding: spacing.medium, color: palette.emptyOn, lineHeight: sizes.small })
}));
const ChatSearchResults = ({ activity, children }) => {
    var _a, _b;
    const searchStyles = useSearchStyles();
    const gridStyles = smarthub_common_1.useGridStyles();
    const [state, setState] = react_1.useState(null);
    const [activities] = useActivities();
    const lastActivity = activities[activities.length - 1];
    const lastActivityId = ((_a = lastActivity.channelData) === null || _a === void 0 ? void 0 : _a.resultType) == "refined"
        && ((_b = lastActivity.channelData) === null || _b === void 0 ? void 0 : _b.resultId) === activity.channelData.resultId
        && lastActivity.attachments.length
        ? lastActivity.id
        : activity.id;
    react_1.useEffect(() => {
        var _a, _b;
        const resultSet = activities.filter(({ channelData }) => (channelData === null || channelData === void 0 ? void 0 : channelData.resultId) == activity.channelData.resultId);
        const carousels = resultSet.filter(({ channelData, attachments }) => (channelData === null || channelData === void 0 ? void 0 : channelData.resultType) == "refined"
            && attachments.length);
        const messages = resultSet.filter(({ channelData, attachments }) => (channelData === null || channelData === void 0 ? void 0 : channelData.resultType) == "refined"
            && !attachments.length);
        if (carousels[0].id != activity.id)
            return;
        let newState = {
            sortOrder: null,
            refiners: null,
            results: null,
            paging: null,
            promoted: null,
            stats: {
                start: 0,
                end: 0,
                total: 0
            }
        };
        let lastRefinementId = null;
        carousels.forEach((a, i) => {
            newState.sortOrder = a.attachments.find(t => t.name == "ICS.Flex.Results.SortOrder");
            newState.refiners = a.attachments.find(t => t.name == "ICS.Flex.Results.Refiners");
            newState.paging = a.attachments.find(t => t.name == "Results Navigator");
            if (lastRefinementId != a.channelData.refinementId) {
                newState.results = a.attachments.filter(t => t.name == "Result Card Attachment").map(t => (Object.assign(Object.assign({}, t), { $schema: models_1.SearchResultCardSchema })));
                newState.promoted = a.attachments.filter(t => t.name == "ICS.Flex.Results.Promoted").map(t => (Object.assign(Object.assign({}, t), { $schema: models_1.SearchResultCardSchema })));
            }
            else
                newState.results.push(...a.attachments.filter(t => t.name == "Result Card Attachment").map(t => (Object.assign(Object.assign({}, t), { $schema: models_1.SearchResultCardSchema }))));
            lastRefinementId = a.channelData.refinementId;
        });
        const lastMessage = messages.length
            ? messages[messages.length - 1]
            : null;
        if (lastMessage && lastMessage.channelData.refinementId == lastRefinementId) {
            const matches = lastMessage.text.match(/Here are suggestions (?<start>[1-9]|[1-9][0-9]|[1-9][0-9][0-9]) to (?<end>[1-9]|[1-9][0-9]|[1-9][0-9][0-9]) out of the (?<total>[1-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9]) that I found./);
            if (matches === null || matches === void 0 ? void 0 : matches.groups) {
                newState.stats.start = 1;
                newState.stats.end = +matches.groups.end;
                newState.stats.total = +matches.groups.total;
            }
        }
        else if (newState.results.length > 0)
            newState.stats.start = newState.stats.end = newState.stats.total = 1;
        const pagingActions = (_b = (_a = newState.paging) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.actions;
        if (pagingActions === null || pagingActions === void 0 ? void 0 : pagingActions.length) {
            const prevActionIdx = pagingActions.findIndex(a => a.data.action == "previous");
            if (~prevActionIdx)
                pagingActions.splice(prevActionIdx, 1);
            const nextAction = pagingActions.find(a => a.data.action == "more");
            if (nextAction)
                nextAction.title = "View more";
        }
        setState(newState);
    }, [lastActivityId]);
    return react_1.useMemo(() => {
        var _a;
        return react_1.default.createElement("div", { className: [gridStyles.grid, gridStyles.padR].join(" ") }, state && react_1.default.createElement("div", { className: gridStyles.row },
            react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.sm12, gridStyles.padL].join(" ") },
                react_1.default.createElement(Bubble, { className: searchStyles.bubble, fromUser: false, nub: false },
                    react_1.default.createElement("div", { className: searchStyles.content }, state.stats.total > 1 ?
                        `Here are suggestions ${state.stats.start} to ${state.stats.end} out of the ${state.stats.total} that I found` :
                        state.stats.total == 1 ?
                            "Here is a suggestion that I found" :
                            "I couldn't find any suggestions for your query or refinement"))),
            (state.refiners || state.sortOrder) && react_1.default.createElement(chat_search_refiners_1.ChatSearchRefiners, { activity: activity, sortOrder: state.sortOrder, refiners: state.refiners }, children),
            ((_a = state.results) === null || _a === void 0 ? void 0 : _a.length) > 0 && react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.sm12, state.refiners ? gridStyles.lg8 : "", gridStyles.padL].join(" ") },
                react_1.default.createElement("div", null, state.promoted.map((promo, index) => react_1.default.createElement("div", { key: index, className: searchStyles.card }, children({ activity: activity, attachment: promo })))),
                react_1.default.createElement("div", null, state.results.map((r, i) => react_1.default.createElement("div", { key: i, className: searchStyles.card }, children({ activity: activity, attachment: r })))),
                state.paging && react_1.default.createElement("div", null, children({ activity: activity, attachment: state.paging })))));
    }, [state, gridStyles, searchStyles]);
};
exports.ChatSearchResults = ChatSearchResults;


/***/ }),

/***/ "./src/bot/cards/chat-search-results/index.ts":
/*!****************************************************!*\
  !*** ./src/bot/cards/chat-search-results/index.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-search-results.component */ "./src/bot/cards/chat-search-results/chat-search-results.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/cards/handle-carousel/handle-carousel.fn.tsx":
/*!**************************************************************!*\
  !*** ./src/bot/cards/handle-carousel/handle-carousel.fn.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.handleCarousel = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const __1 = __webpack_require__(/*! .. */ "./src/bot/cards/index.ts");
const handleCarousel = (props, activityInfo) => {
    const { activity, activity: { channelData: { resultType } = { resultType: null } } } = activityInfo;
    return resultType == "refined"
        ? children => react_1.default.createElement(__1.ChatSearchResults, { activity: activity }, children)
        : null;
};
exports.handleCarousel = handleCarousel;


/***/ }),

/***/ "./src/bot/cards/handle-carousel/index.ts":
/*!************************************************!*\
  !*** ./src/bot/cards/handle-carousel/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./handle-carousel.fn */ "./src/bot/cards/handle-carousel/handle-carousel.fn.tsx"), exports);


/***/ }),

/***/ "./src/bot/cards/handle-oauth/handle-oauth.fn.ts":
/*!*******************************************************!*\
  !*** ./src/bot/cards/handle-oauth/handle-oauth.fn.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.handleOAuth = void 0;
const handleOAuth = ({ store }, activityInfo) => {
    const { activity } = activityInfo;
    const { activities } = store.getState();
    const timestamp = new Date(activity.timestamp);
    const cutoff = new Date();
    const [lastMessage] = activities
        .filter(a => a.type === 'message')
        .slice(-1);
    cutoff.setMinutes(cutoff.getMinutes() - 5);
    return timestamp < cutoff || activity.id !== lastMessage.id
        ? false
        : null;
};
exports.handleOAuth = handleOAuth;


/***/ }),

/***/ "./src/bot/cards/handle-oauth/index.ts":
/*!*********************************************!*\
  !*** ./src/bot/cards/handle-oauth/index.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./handle-oauth.fn */ "./src/bot/cards/handle-oauth/handle-oauth.fn.ts"), exports);


/***/ }),

/***/ "./src/bot/cards/index.ts":
/*!********************************!*\
  !*** ./src/bot/cards/index.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-search-refiners */ "./src/bot/cards/chat-search-refiners/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-search-results */ "./src/bot/cards/chat-search-results/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./handle-carousel */ "./src/bot/cards/handle-carousel/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./handle-oauth */ "./src/bot/cards/handle-oauth/index.ts"), exports);


/***/ }),

/***/ "./src/bot/controls/bot-skill/bot-skill.component.tsx":
/*!************************************************************!*\
  !*** ./src/bot/controls/bot-skill/bot-skill.component.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BotSkill = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_3 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (({ theme: { palette, spacing, sizes, fonts } }) => ({
    card: {
        root: {
            borderRadius: spacing.small,
            border: `${spacing.tiny} solid ${palette.neutralMinus4}`,
            height: sizes.xxLarge,
            "& .card-description.ms-DocumentCardTitle": fonts.smallPlus,
            "& .ms-DocumentCardTitle": fonts.large
        },
    },
    preview: {
        root: {
            backgroundColor: palette.neutralMinus4,
            "div": {
                height: "100%"
            }
        },
        fileList: {},
        fileListIcon: {},
        fileListLink: {},
        fileListOverflowText: {},
        icon: {},
        previewIcon: {}
    }
}));
const BotSkill = ({ skill, onClick }) => {
    const { title, image, description } = skill;
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const preview = {
        previewImages: [
            {
                name: title,
                previewImageSrc: image,
                width: 64,
                imageFit: react_3.ImageFit.centerContain
            }
        ],
        styles: styles.preview
    };
    return (react_1.default.createElement(react_2.DocumentCard, { styles: styles.card, title: description, "aria-label": description, type: react_2.DocumentCardType.compact, onClick: () => onClick(skill) },
        react_1.default.createElement(react_2.DocumentCardPreview, Object.assign({}, preview)),
        react_1.default.createElement(react_2.DocumentCardDetails, null,
            react_1.default.createElement(react_2.DocumentCardTitle, { title: title, shouldTruncate: true }),
            react_1.default.createElement(react_2.DocumentCardTitle, { className: 'card-description', title: description, shouldTruncate: true }))));
};
exports.BotSkill = BotSkill;


/***/ }),

/***/ "./src/bot/controls/bot-skill/index.ts":
/*!*********************************************!*\
  !*** ./src/bot/controls/bot-skill/index.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./bot-skill.component */ "./src/bot/controls/bot-skill/bot-skill.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/chat-buttons/chat-buttons.component.tsx":
/*!******************************************************************!*\
  !*** ./src/bot/controls/chat-buttons/chat-buttons.component.tsx ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatButtons = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const send_button_1 = __webpack_require__(/*! ../send-button */ "./src/bot/controls/send-button/index.ts");
const clear_button_1 = __webpack_require__(/*! ../clear-button */ "./src/bot/controls/clear-button/index.ts");
const upload_button_1 = __webpack_require__(/*! ../upload-button */ "./src/bot/controls/upload-button/index.ts");
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const { useStyleOptions } = botframework_webchat_1.hooks;
const ChatButtons = ({ scope }) => {
    const [{ hideUploadButton }] = useStyleOptions();
    return react_1.useMemo(() => (react_1.default.createElement(react_1.default.Fragment, null,
        (scope === null || scope === void 0 ? void 0 : scope.target) == 'panel' &&
            react_1.default.createElement(clear_button_1.ClearButton, null),
        (scope === null || scope === void 0 ? void 0 : scope.target) != 'panel' && !hideUploadButton &&
            react_1.default.createElement(upload_button_1.UploadButton, null),
        react_1.default.createElement(send_button_1.SendButton, { scope: scope }))), [scope]);
};
exports.ChatButtons = ChatButtons;


/***/ }),

/***/ "./src/bot/controls/chat-buttons/index.ts":
/*!************************************************!*\
  !*** ./src/bot/controls/chat-buttons/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-buttons.component */ "./src/bot/controls/chat-buttons/chat-buttons.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/chat-context/chat-context.component.tsx":
/*!******************************************************************!*\
  !*** ./src/bot/controls/chat-context/chat-context.component.tsx ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = ({ theme: { palette, fonts, sizes, spacing }, }) => ({
    root: {
        backgroundColor: palette.primaryMinus2,
        transition: "background-color 300ms ease-in",
        padding: 0,
        border: "0",
        minHeight: sizes.large,
        borderRadius: spacing.small,
    },
    flexContainer: {
        padding: `0 ${spacing.medium}`,
        alignItems: "center",
    },
    rootHovered: {
        backgroundColor: palette.primary,
    },
    description: Object.assign(Object.assign({}, fonts.normalPlus), { textTransform: "uppercase", letterSpacing: spacing.tiny, lineHeight: "100%", color: palette.primaryMinus2On }),
    label: Object.assign(Object.assign({}, fonts.tiny), { fontWeight: "100", textTransform: "uppercase", letterSpacing: spacing.tiny, lineHeight: "100%", marginBottom: spacing.smallPlus, color: palette.primaryMinus2On }),
    icon: {
        color: palette.primaryMinus2On,
    },
    descriptionHovered: {
        color: palette.primaryOn,
    },
    labelHovered: {
        color: palette.primaryOn,
    },
    iconHovered: {
        color: palette.primaryOn,
    },
});
const ChatContext = ({ context, onClick }) => {
    const { description, title, subTitle, icon } = context;
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const iconProps = (icon === null || icon === void 0 ? void 0 : icon.length) ? {
        iconName: icon,
    }
        : null;
    return (react_1.default.createElement(react_2.CompoundButton, { onClick: () => onClick(context), styles: styles, secondaryText: title, text: subTitle, iconProps: iconProps, title: description, ariaLabel: title }));
};
exports.ChatContext = ChatContext;


/***/ }),

/***/ "./src/bot/controls/chat-context/index.ts":
/*!************************************************!*\
  !*** ./src/bot/controls/chat-context/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-context.component */ "./src/bot/controls/chat-context/chat-context.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/chat-controls/chat-controls-int.component.tsx":
/*!************************************************************************!*\
  !*** ./src/bot/controls/chat-controls/chat-controls-int.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatControlsInternal = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const chat_scope_menu_1 = __webpack_require__(/*! ../chat-scope-menu */ "./src/bot/controls/chat-scope-menu/index.ts");
const chat_text_box_1 = __webpack_require__(/*! ../chat-text-box */ "./src/bot/controls/chat-text-box/index.ts");
const search_text_box_1 = __webpack_require__(/*! ../search-text-box */ "./src/bot/controls/search-text-box/index.ts");
const chat_buttons_1 = __webpack_require__(/*! ../chat-buttons */ "./src/bot/controls/chat-buttons/index.ts");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const { SuggestedActions, DictationInterims } = botframework_webchat_1.Components;
const { useSendBoxSpeechInterimsVisible, useDirection } = botframework_webchat_1.hooks;
const useStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b;
    const { palette, spacing, styles } = theme;
    const controls = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.chat) === null || _a === void 0 ? void 0 : _a.controls) !== null && _b !== void 0 ? _b : {};
    const props = { theme };
    return {
        root: ({ responsive }) => (Object.assign(Object.assign({ display: "flex", position: "relative", flexDirection: "row", height: "auto", backgroundColor: palette.neutralMinus3, boxSizing: "border-box", padding: spacing.medium, width: smarthub_common_1.responsiveColumnWidths[responsive["full"]] }, smarthub_common_1.themeStyle(controls.root, props)), { "&:focus-within $line": Object.assign({ opacity: 1 }, smarthub_common_1.themeStyle(controls.lineActive, props)) })),
        active: {},
        line: Object.assign({ position: "absolute", left: 0, right: 0, bottom: 0, height: spacing.xSmall, backgroundColor: palette.primaryMinus2, transition: "opacity 200ms ease-in", opacity: 0 }, smarthub_common_1.themeStyle(controls.line, props)),
        buttons: Object.assign({ alignItems: "center", display: "flex" }, smarthub_common_1.themeStyle(controls.buttons, props)),
        inputBar: Object.assign({ flex: "1 1", display: "flex", flexDirection: "row", boxSizing: "border-box", borderRadius: spacing.small, position: "relative", backgroundColor: palette.neutralEmpty, overflow: "hidden", height: "auto" }, smarthub_common_1.themeStyle(controls.inputBar, props)),
    };
});
const ChatControlsInternal = ({ coachmark, hideOnVisible = false, }) => {
    const view = smarthub_common_1.useViewConfig();
    const { visible } = smarthub_common_1.usePanelView("chat");
    const styleProps = smarthub_common_1.useStyleProps(null, view.chat.dockSizes);
    const styles = useStyles(styleProps);
    const textBoxRef = react_1.useRef();
    const localize = smarthub_common_1.useLocalizeConfig();
    const [speechInterimsVisible] = useSendBoxSpeechInterimsVisible();
    const [direction] = useDirection();
    const scope = smarthub_common_1.useChatScope();
    const register = smarthub_common_1.useRegisterFocus();
    const focus = react_1.useCallback(() => textBoxRef.current.focus(), []);
    const handleMenuClose = react_1.useCallback((selection) => {
        const { scope: nextScope } = selection || {};
        if ((nextScope === null || nextScope === void 0 ? void 0 : nextScope.target) == (scope === null || scope === void 0 ? void 0 : scope.target))
            focus();
    }, [scope]);
    react_1.useEffect(() => {
        if (visible != hideOnVisible)
            register("chat-controls", focus);
    }, [visible, hideOnVisible]);
    const changesRef = react_1.useRef({
        scope,
        hidden: hideOnVisible == visible,
    });
    react_1.useEffect(() => {
        const { current: { scope: currentScope, hidden: isHidden }, } = changesRef;
        const hidden = hideOnVisible == visible;
        const changed = hidden != isHidden || scope != currentScope;
        const { target } = scope || {};
        if (!hidden && (visible || (target == "panel" && changed)))
            focus();
        changesRef.current = {
            scope,
            hidden,
        };
    });
    return react_1.useMemo(() => {
        const { chatControlsLabel } = localize;
        const content = visible != hideOnVisible ? (react_1.default.createElement("div", { className: styles.root },
            react_1.default.createElement("div", { dir: direction, "aria-label": chatControlsLabel, role: "form", className: styles.inputBar },
                react_1.default.createElement(SuggestedActions, null),
                scope && react_1.default.createElement(chat_scope_menu_1.ChatScopeMenu, { onClose: handleMenuClose }),
                (scope === null || scope === void 0 ? void 0 : scope.target) == "panel" ? (react_1.default.createElement(search_text_box_1.SearchTextBox, { scope: scope, componentRef: textBoxRef })) : speechInterimsVisible ? (react_1.default.createElement(DictationInterims, null)) : (react_1.default.createElement(chat_text_box_1.ChatTextBox, { scope: scope, componentRef: textBoxRef })),
                react_1.default.createElement("div", { className: styles.buttons },
                    react_1.default.createElement(chat_buttons_1.ChatButtons, { scope: scope })),
                react_1.default.createElement("div", { className: styles.line })))) : null;
        return content && coachmark != null ? (react_1.default.createElement(utilities_1.CoachMarkWrapper, Object.assign({}, coachmark), content)) : (content);
    }, [visible == hideOnVisible, coachmark, styles, scope, localize]);
};
exports.ChatControlsInternal = ChatControlsInternal;


/***/ }),

/***/ "./src/bot/controls/chat-controls/chat-controls.component.tsx":
/*!********************************************************************!*\
  !*** ./src/bot/controls/chat-controls/chat-controls.component.tsx ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatControls = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const chat_controls_int_component_1 = __webpack_require__(/*! ./chat-controls-int.component */ "./src/bot/controls/chat-controls/chat-controls-int.component.tsx");
const ChatControls = ({ config: { coachmarks } }) => {
    const chromeCoachmark = coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(coachmark => coachmark.target === 'component-chrome');
    return react_1.default.createElement(chat_controls_int_component_1.ChatControlsInternal, { coachmark: chromeCoachmark });
};
exports.ChatControls = ChatControls;


/***/ }),

/***/ "./src/bot/controls/chat-controls/index.ts":
/*!*************************************************!*\
  !*** ./src/bot/controls/chat-controls/index.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-controls.component */ "./src/bot/controls/chat-controls/chat-controls.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-controls-int.component */ "./src/bot/controls/chat-controls/chat-controls-int.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/chat-hint/chat-hint.component.tsx":
/*!************************************************************!*\
  !*** ./src/bot/controls/chat-hint/chat-hint.component.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatHint = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (({ theme: { palette } }) => ({
    root: {
        transition: "background-color 300ms ease-in",
        backgroundColor: palette.neutralMinus1,
        borderRadius: "100px",
        border: 0
    },
    label: {
        transition: "color 150ms ease-in",
        color: palette.neutralMinus1On
    },
    rootHovered: {
        backgroundColor: palette.primaryMinus2
    },
    labelHovered: {
        color: palette.primaryMinus2On
    }
}));
const ChatHint = ({ hint, onClick }) => {
    var _a;
    const styleProps = smarthub_common_1.useThemeStyleProps();
    const styles = smarthub_common_1.useFluentStyles(fluentStyles, styleProps);
    const buttonText = ((_a = hint.text) === null || _a === void 0 ? void 0 : _a.length) ? hint.text : hint.value;
    return (react_1.default.createElement(react_2.DefaultButton, { styles: styles, text: buttonText, title: buttonText, ariaLabel: buttonText, onClick: () => onClick(hint) }));
};
exports.ChatHint = ChatHint;


/***/ }),

/***/ "./src/bot/controls/chat-hint/index.ts":
/*!*********************************************!*\
  !*** ./src/bot/controls/chat-hint/index.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-hint.component */ "./src/bot/controls/chat-hint/chat-hint.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/chat-scope-menu/chat-scope-compact-menu.component.tsx":
/*!********************************************************************************!*\
  !*** ./src/bot/controls/chat-scope-menu/chat-scope-compact-menu.component.tsx ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatScopeCompactMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_2 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const chat_hint_1 = __webpack_require__(/*! ../chat-hint */ "./src/bot/controls/chat-hint/index.ts");
const chat_context_1 = __webpack_require__(/*! ../chat-context */ "./src/bot/controls/chat-context/index.ts");
const bot_skill_1 = __webpack_require__(/*! ../bot-skill */ "./src/bot/controls/bot-skill/index.ts");
const useStyles = react_jss_1.createUseStyles(({ palette, spacing, sizes, fonts }) => ({
    menu: ({ width }) => ({
        backgroundColor: palette.neutralEmpty,
        color: palette.neutralEmptyOn,
        position: "relative",
        display: "flex",
        flexDirection: "column",
        width
    }),
    section: {
        boxSizing: "border-box",
        padding: spacing.medium,
    },
    header: {
        padding: `0 ${spacing.medium}`,
        lineHeight: sizes.normal,
        boxSizing: "border-box",
        backgroundColor: palette.neutralEmpty,
        color: palette.neutralEmptyOn,
        borderBottom: `${spacing.tiny} solid ${palette.neutralMinus1}`
    },
    rightButton: {
        position: "absolute",
        right: "0",
        color: "#444"
    },
    subTitle: Object.assign({ fontWeight: "100" }, fonts.large),
    title: Object.assign({ marginLeft: spacing.smallPlus, fontWeight: "500" }, fonts.large),
    description: Object.assign(Object.assign({}, fonts.small), { marginLeft: spacing.smallPlus, fontStyle: "italic" })
}));
const fluentStyles = (({ responsive: { colSize }, theme: { spacing } }) => ({
    root: {
        width: colSize
            ? colSize == 12
                ? '100%'
                : `calc(${smarthub_common_1.responsiveColumnWidths[colSize]} - ${spacing.medium})`
            : undefined
    }
}));
const stackTokens = {
    childrenGap: 12
};
const stackProps = {
    horizontal: true,
    tokens: stackTokens,
    wrap: true
};
const ChatScopeCompactMenu = (props) => {
    var _a, _b;
    const { scope, state, close } = props;
    const responsiveProps = react_2.useMemo(() => ({
        sm: {
            colSize: 12
        },
        md: {
            colSize: 12
        },
        lgx: {
            colSize: state.size != 'full' ? 12 : 6
        }
    }), [state]);
    const styleProps = smarthub_common_1.useThemeStyleProps(null, responsiveProps);
    const stackStyles = smarthub_common_1.useFluentStyles(fluentStyles, styleProps);
    const styles = useStyles(props);
    const scopes = smarthub_common_1.useChatScopes();
    const entity = smarthub_common_1.usePanelEntity();
    const invokeSkill = smarthub_common_1.useHandleSkill();
    const setScope = smarthub_common_1.useSetChatScope();
    const sendMessage = smarthub_common_1.useSendMessage();
    const handleHint = (hint) => {
        sendMessage(hint.value);
        close({ hint });
    };
    const handleSkill = (skill) => {
        invokeSkill({
            $id: "",
            $schema: smarthub_common_1.SkillActionSchema,
            ref: skill.$id,
            invokeText: skill.invokeText
        });
        close({ skill });
    };
    const handleContext = react_2.useCallback((scope) => {
        setScope(scope, { entity });
        close({ scope });
    }, [entity]);
    return (react_2.default.createElement("div", { className: styles.menu, role: "menu", "aria-label": "Select a hint or task,  or choose another topic." },
        react_2.default.createElement("header", { className: styles.header },
            react_2.default.createElement("span", { className: styles.subTitle }, scope.subTitle),
            react_2.default.createElement("span", { className: styles.title },
                scope.title,
                ":"),
            react_2.default.createElement("span", { className: styles.description }, scope.description),
            react_2.default.createElement(react_1.IconButton, { title: "Close the topic menu", className: styles.rightButton, onClick: () => { close(); } },
                react_2.default.createElement(react_1.Icon, { iconName: "ChromeClose" }))),
        ((_a = scope.hints) === null || _a === void 0 ? void 0 : _a.length) && react_2.default.createElement("section", { className: styles.section },
            react_2.default.createElement(react_1.Separator, null, "Suggestions and Hints"),
            react_2.default.createElement(react_1.Stack, Object.assign({}, stackProps), scope.hints.map((hint, i) => react_2.default.createElement(chat_hint_1.ChatHint, { key: i, hint: hint, onClick: handleHint })))),
        ((_b = scope.skills) === null || _b === void 0 ? void 0 : _b.length) && react_2.default.createElement("section", { className: styles.section },
            react_2.default.createElement(react_1.Separator, null, "Popular Tasks"),
            react_2.default.createElement(react_1.Stack, Object.assign({}, stackProps), scope.skills.map((skill, i) => react_2.default.createElement(react_1.StackItem, { key: i, styles: stackStyles },
                react_2.default.createElement(bot_skill_1.BotSkill, { skill: skill, onClick: handleSkill }))))),
        (scopes === null || scopes === void 0 ? void 0 : scopes.length) > 1 && react_2.default.createElement("section", { className: styles.section },
            react_2.default.createElement(react_1.Separator, null, "Other Topics"),
            react_2.default.createElement(react_1.Stack, Object.assign({}, stackProps), scopes.map((otherScope, i) => scope != otherScope && react_2.default.createElement(chat_context_1.ChatContext, { key: i, context: otherScope, onClick: handleContext }))))));
};
exports.ChatScopeCompactMenu = ChatScopeCompactMenu;


/***/ }),

/***/ "./src/bot/controls/chat-scope-menu/chat-scope-menu.component.tsx":
/*!************************************************************************!*\
  !*** ./src/bot/controls/chat-scope-menu/chat-scope-menu.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatScopeMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const chat_scope_compact_menu_component_1 = __webpack_require__(/*! ./chat-scope-compact-menu.component */ "./src/bot/controls/chat-scope-menu/chat-scope-compact-menu.component.tsx");
const useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing }) => ({
    scope: {
        position: "relative",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        background: palette.primaryMinus2,
        paddingLeft: spacing.medium,
        color: palette.primaryMinus2On,
        transition: "background-color 300ms ease-in",
        textTransform: "uppercase",
        letterSpacing: spacing.tiny,
        "&:hover": {
            background: palette.primary
        },
        height: "100%"
    },
    text: {
        flex: "1 1",
        whiteSpace: "nowrap"
    },
    title: Object.assign(Object.assign({}, fonts.mediumPlus), { lineHeight: fonts.mediumPlus.fontSize }),
    subTitle: Object.assign(Object.assign({}, fonts.tiny), { lineHeight: fonts.tiny.fontSize, marginBottom: spacing.small }),
    moreIcon: {
        fontSize: fonts.superLarge.fontSize,
        right: spacing.smallPlus,
        width: spacing.xLarge,
        color: palette.primaryMinus2On,
    },
    icon: {
        fontSize: fonts.superLarge.fontSize,
        marginRight: spacing.normal,
        color: palette.primaryMinus2On,
    }
}));
const onRenderPlainCard = (_a) => {
    var { buttonRef } = _a, rest = tslib_1.__rest(_a, ["buttonRef"]);
    const width = `${buttonRef.current.offsetParent.clientWidth}px`;
    return (react_1.default.createElement(chat_scope_compact_menu_component_1.ChatScopeCompactMenu, Object.assign({}, Object.assign(Object.assign({}, rest), { width }))));
};
//TODO localise
const ChatScopeMenu = ({ onClose }) => {
    var _a, _b, _c;
    const buttonRef = react_1.useRef(null);
    const hoverCard = react_1.useRef(null);
    const [sticky, setSticky] = react_1.useState(false);
    const scope = smarthub_common_1.useChatScope();
    const state = smarthub_common_1.usePanelView('chat');
    const styles = useStyles();
    const close = (selection) => {
        hoverCard.current.dismiss();
        if (onClose)
            onClose(selection);
    };
    const cardProps = {
        onRenderPlainCard,
        directionalHint: react_2.DirectionalHint.topLeftEdge,
        renderData: { scope, state, close, buttonRef },
        gapSpace: 6,
        calloutProps: {
            isBeakVisible: false,
            minPagePadding: 0
        },
    };
    return (react_1.default.createElement(react_2.HoverCard, { componentRef: hoverCard, "aria-label": "Select a chat topic.", plainCardProps: cardProps, trapFocus: true, sticky: sticky, type: react_2.HoverCardType.plain, cardDismissDelay: 500, instantOpenOnClick: true, openHotKey: react_2.KeyCodes.enter, onCardHide: () => setSticky(false) },
        react_1.default.createElement("div", { ref: buttonRef, className: styles.scope, role: "button", "aria-label": "Select a chat topic.", tabIndex: 0, onClick: () => setSticky(true) },
            ((_a = scope.icon) === null || _a === void 0 ? void 0 : _a.length) > 0 && react_1.default.createElement(react_2.Icon, { className: styles.icon, iconName: scope.icon, title: scope.description }),
            ((_b = scope.title) === null || _b === void 0 ? void 0 : _b.length) > 0 && react_1.default.createElement("div", { className: styles.text },
                ((_c = scope.subTitle) === null || _c === void 0 ? void 0 : _c.length) > 0 && react_1.default.createElement("div", { className: styles.subTitle }, scope.subTitle),
                react_1.default.createElement("div", { className: styles.title }, scope.title)),
            react_1.default.createElement(react_2.Icon, { className: styles.moreIcon, iconName: "MoreVertical", title: scope === null || scope === void 0 ? void 0 : scope.description }))));
};
exports.ChatScopeMenu = ChatScopeMenu;


/***/ }),

/***/ "./src/bot/controls/chat-scope-menu/index.ts":
/*!***************************************************!*\
  !*** ./src/bot/controls/chat-scope-menu/index.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-scope-menu.component */ "./src/bot/controls/chat-scope-menu/chat-scope-menu.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-scope-compact-menu.component */ "./src/bot/controls/chat-scope-menu/chat-scope-compact-menu.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/chat-text-box/chat-text-box.component.tsx":
/*!********************************************************************!*\
  !*** ./src/bot/controls/chat-text-box/chat-text-box.component.tsx ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatTextBox = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const botframework_webchat_component_1 = __webpack_require__(/*! botframework-webchat-component */ "botframework-webchat-component");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const chat_styles_1 = __webpack_require__(/*! ../chat.styles */ "./src/bot/controls/chat.styles.ts");
//const {useDisabled, useSubmitSendBox, useTextBoxValue, useScrollToEnd, useScrollUp, useScrollDown} = hooks;
const { useDisabled, useSubmitSendBox, useTextBoxValue, useScrollToEnd } = botframework_webchat_component_1.hooks;
const PREVENT_DEFAULT_HANDLER = event => event.preventDefault();
const ChatTextBox = ({ scope, componentRef }) => {
    var _a;
    const [disabled] = useDisabled();
    const ref = react_1.useRef();
    const chatPanelState = smarthub_common_1.usePanelView('chat');
    const setChatPanelState = smarthub_common_1.useSetPanelView('chat');
    const scrollToEnd = useScrollToEnd();
    //const scrollUp = useScrollUp();
    //const scrollDown = useScrollDown();
    const [textBoxValue, setTextBoxValue] = useTextBoxValue();
    const localize = smarthub_common_1.useLocalizeConfig();
    const submitSendBox = useSubmitSendBox();
    const styles = chat_styles_1.useInputStyles();
    const inputLabel = ((_a = scope === null || scope === void 0 ? void 0 : scope.placeholder) === null || _a === void 0 ? void 0 : _a.length) ? scope.placeholder
        : localize.chatPlaceholder;
    const placeholderText = inputLabel;
    const focus = react_1.useCallback(() => { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus(); }, []);
    const handleChange = react_1.useCallback(({ target: { value } }) => {
        setTextBoxValue(value, { selectionEnd: 0, selectionStart: 0 });
    }, [setTextBoxValue]);
    const handleKeyPress = react_1.useCallback(event => {
        const { key, shiftKey } = event;
        if (key === 'Enter' && !shiftKey) {
            event.preventDefault();
            submitSendBox();
            scrollToEnd();
        }
    }, [submitSendBox, scrollToEnd]);
    const handleSubmit = react_1.useCallback(event => {
        event.preventDefault();
        submitSendBox();
        scrollToEnd();
    }, [submitSendBox, scrollToEnd]);
    const handleFocus = react_1.useCallback((e) => {
        if (!chatPanelState.visible && (!scope || (scope === null || scope === void 0 ? void 0 : scope.target) == 'bot'))
            setChatPanelState(Object.assign(Object.assign({}, chatPanelState), { visible: true }));
    }, [chatPanelState, scope]);
    react_1.useEffect(() => {
        if (componentRef)
            componentRef.current = {
                focus,
                target: 'bot',
                input: ref === null || ref === void 0 ? void 0 : ref.current
            };
    }, []);
    /*const handleKeyDown = useCallback(event => {
      const { ctrlKey, metaKey, shiftKey, key } = event;
      if (ctrlKey || metaKey || shiftKey)
        return;
      
      let handled = true;
      switch (key) {
        case 'End':
          scrollDown({ displacement: Infinity });
          break;
        case 'Home':
          scrollUp({ displacement: Infinity });
          break;
        case 'PageDown':
          scrollDown();
          break;
        case 'PageUp':
          scrollUp();
          break;
        default:
          handled = false;
          break;
      }
  
      if (handled) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, [scrollDown, scrollUp]);*/
    return (react_1.default.createElement("form", { className: styles.form, "aria-disabled": disabled, onSubmit: disabled ? PREVENT_DEFAULT_HANDLER : handleSubmit },
        react_1.default.createElement("input", { id: "chatTextBox", name: "chatTextBox", type: "text", ref: ref, className: styles.text, placeholder: placeholderText, disabled: disabled, 
            //onKeyDown={disabled ? undefined : handleKeyDown}
            onChange: disabled ? undefined : handleChange, onKeyPress: disabled ? undefined : handleKeyPress, onFocus: disabled ? undefined : handleFocus, readOnly: disabled, "aria-label": inputLabel, value: textBoxValue })));
};
exports.ChatTextBox = ChatTextBox;


/***/ }),

/***/ "./src/bot/controls/chat-text-box/index.ts":
/*!*************************************************!*\
  !*** ./src/bot/controls/chat-text-box/index.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-text-box.component */ "./src/bot/controls/chat-text-box/chat-text-box.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/chat.styles.ts":
/*!*****************************************!*\
  !*** ./src/bot/controls/chat.styles.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.buttonStyles = exports.useInputStyles = void 0;
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
exports.useInputStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b;
    const { palette, fonts, spacing, styles } = theme;
    const controls = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.chat) === null || _a === void 0 ? void 0 : _a.controls) !== null && _b !== void 0 ? _b : {};
    const props = { theme };
    return {
        form: Object.assign({ width: "100%", display: "block" }, (smarthub_common_1.themeStyle(controls.form, props))),
        text: Object.assign(Object.assign(Object.assign({}, fonts.normal), { border: "none", background: "transparent", padding: `0 ${spacing.medium}`, height: "100%", width: "100%", boxSizing: "border-box", color: palette.neutralEmptyOn, ["&::placeholder"]: Object.assign(Object.assign(Object.assign({}, fonts.normal), { color: palette.neutralPlus2 }), (smarthub_common_1.themeStyle(controls.inputPlaceholder, props))), "&:focus-visible": Object.assign({ outline: "none" }, (smarthub_common_1.themeStyle(controls.inputFocus, props))) }), (smarthub_common_1.themeStyle(controls.input, props)))
    };
});
exports.buttonStyles = (({ theme }) => {
    var _a, _b;
    const { sizes, fonts, styles } = theme;
    const controls = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.chat) === null || _a === void 0 ? void 0 : _a.controls) !== null && _b !== void 0 ? _b : {};
    const props = { theme };
    return {
        root: Object.assign({ width: sizes.large, height: sizes.large }, (smarthub_common_1.themeStyle(controls.button, props))),
        icon: Object.assign(Object.assign({}, fonts.superLarge), (smarthub_common_1.themeStyle(controls.buttonIcon, props)))
    };
});


/***/ }),

/***/ "./src/bot/controls/clear-button/clear-button.component.tsx":
/*!******************************************************************!*\
  !*** ./src/bot/controls/clear-button/clear-button.component.tsx ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ClearButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_hooks_1 = __webpack_require__(/*! @fluentui/react-hooks */ "@fluentui/react-hooks");
const chat_styles_1 = __webpack_require__(/*! ../chat.styles */ "./src/bot/controls/chat.styles.ts");
const { useDisabled } = botframework_webchat_1.hooks;
const ClearButton = () => {
    const id = react_hooks_1.useId();
    const styles = smarthub_common_1.useFluentStylesWithProps(chat_styles_1.buttonStyles);
    const [keywords, setKeywords] = smarthub_common_1.useKeywords();
    const [disabled] = useDisabled();
    const focus = smarthub_common_1.useFocus();
    const localize = smarthub_common_1.useLocalizeConfig();
    const handleCancel = react_1.useCallback(() => {
        setKeywords("");
        focus('chat-controls');
    }, [focus, setKeywords]);
    return (react_1.default.createElement(react_1.default.Fragment, null, (keywords === null || keywords === void 0 ? void 0 : keywords.length) > 0 && react_1.default.createElement(react_2.TooltipHost, { id: id, directionalHint: react_2.DirectionalHint.topCenter, content: localize.chatClearTitle },
        react_1.default.createElement(react_2.IconButton, { name: localize.chatClearText, iconProps: {
                iconName: "Cancel"
            }, ariaLabel: localize.chatClearLabel, styles: styles, disabled: disabled, onClick: handleCancel }))));
};
exports.ClearButton = ClearButton;


/***/ }),

/***/ "./src/bot/controls/clear-button/index.ts":
/*!************************************************!*\
  !*** ./src/bot/controls/clear-button/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./clear-button.component */ "./src/bot/controls/clear-button/clear-button.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/index.ts":
/*!***********************************!*\
  !*** ./src/bot/controls/index.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./bot-skill */ "./src/bot/controls/bot-skill/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-buttons */ "./src/bot/controls/chat-buttons/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-context */ "./src/bot/controls/chat-context/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-controls */ "./src/bot/controls/chat-controls/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-hint */ "./src/bot/controls/chat-hint/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-scope-menu */ "./src/bot/controls/chat-scope-menu/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-text-box */ "./src/bot/controls/chat-text-box/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./clear-button */ "./src/bot/controls/clear-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./search-text-box */ "./src/bot/controls/search-text-box/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./send-button */ "./src/bot/controls/send-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./upload-button */ "./src/bot/controls/upload-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat.styles */ "./src/bot/controls/chat.styles.ts"), exports);


/***/ }),

/***/ "./src/bot/controls/search-text-box/index.ts":
/*!***************************************************!*\
  !*** ./src/bot/controls/search-text-box/index.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./search-text-box.component */ "./src/bot/controls/search-text-box/search-text-box.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/search-text-box/search-text-box.component.tsx":
/*!************************************************************************!*\
  !*** ./src/bot/controls/search-text-box/search-text-box.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SearchTextBox = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const botframework_webchat_component_1 = __webpack_require__(/*! botframework-webchat-component */ "botframework-webchat-component");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const chat_styles_1 = __webpack_require__(/*! ../chat.styles */ "./src/bot/controls/chat.styles.ts");
const { useTextBoxValue } = botframework_webchat_component_1.hooks;
//TODO move keywords into central state
const SearchTextBox = ({ scope, componentRef }) => {
    var _a;
    const localiseConfig = smarthub_common_1.useLocalizeConfig();
    const ref = react_1.useRef();
    const [textBoxValue, setTextBoxValue] = useTextBoxValue();
    const [keywords, setKeywords] = smarthub_common_1.useKeywords();
    const styles = chat_styles_1.useInputStyles();
    const inputLabel = ((_a = scope === null || scope === void 0 ? void 0 : scope.placeholder) === null || _a === void 0 ? void 0 : _a.length) ? scope.placeholder
        : localiseConfig.searchPlaceholder;
    const placeholderText = inputLabel;
    const focus = react_1.useCallback(() => { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus(); }, []);
    react_1.useEffect(() => {
        if (componentRef)
            componentRef.current = {
                focus,
                target: 'panel',
                input: ref === null || ref === void 0 ? void 0 : ref.current
            };
    }, []);
    react_1.useEffect(() => {
        setTextBoxValue(keywords !== null && keywords !== void 0 ? keywords : "", { selectionEnd: 0, selectionStart: 0 });
    }, [keywords]);
    const handleChange = react_1.useCallback(({ target: { value } }) => {
        setTextBoxValue(value, { selectionEnd: 0, selectionStart: 0 });
    }, [setTextBoxValue]);
    const handleSubmit = react_1.useCallback(event => {
        event.preventDefault();
        setKeywords(textBoxValue);
    }, [setKeywords, textBoxValue]);
    const handleKeyPress = react_1.useCallback(event => {
        const { key, shiftKey } = event;
        if (key === 'Enter' && !shiftKey) {
            event.preventDefault();
            setKeywords(textBoxValue);
        }
    }, [setKeywords, textBoxValue]);
    return (react_1.default.createElement("form", { className: styles.form, onSubmit: handleSubmit },
        react_1.default.createElement("input", { type: "text", ref: ref, className: styles.text, placeholder: placeholderText, onChange: handleChange, onKeyPress: handleKeyPress, "aria-label": inputLabel, value: textBoxValue })));
};
exports.SearchTextBox = SearchTextBox;


/***/ }),

/***/ "./src/bot/controls/send-button/index.ts":
/*!***********************************************!*\
  !*** ./src/bot/controls/send-button/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./send-button.component */ "./src/bot/controls/send-button/send-button.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/send-button/send-button.component.tsx":
/*!****************************************************************!*\
  !*** ./src/bot/controls/send-button/send-button.component.tsx ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SendButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_hooks_1 = __webpack_require__(/*! @fluentui/react-hooks */ "@fluentui/react-hooks");
const chat_styles_1 = __webpack_require__(/*! ../chat.styles */ "./src/bot/controls/chat.styles.ts");
const { MicrophoneButton } = botframework_webchat_1.Components;
const { useDisabled, useScrollToEnd, useSubmitSendBox, useTextBoxValue, useWebSpeechPonyfill } = botframework_webchat_1.hooks;
const SendButton = ({ scope }) => {
    var _a;
    const id = react_hooks_1.useId();
    const styles = smarthub_common_1.useFluentStylesWithProps(chat_styles_1.buttonStyles);
    const [, setKeywords] = smarthub_common_1.useKeywords();
    const [disabled] = useDisabled();
    const focus = smarthub_common_1.useFocus();
    const scrollToEnd = useScrollToEnd();
    const submitSendBox = useSubmitSendBox();
    const [textBoxValue] = useTextBoxValue();
    const { chatQueryTitle, chatQueryLabel, chatSendTitle, chatSendLabel, chatSendText, chatQueryText } = smarthub_common_1.useLocalizeConfig();
    const [{ SpeechRecognition }] = useWebSpeechPonyfill();
    const supportSpeechRecognition = !!SpeechRecognition;
    const handleSend = react_1.useCallback(() => {
        if ((scope === null || scope === void 0 ? void 0 : scope.target) == 'panel')
            setKeywords(textBoxValue);
        else {
            scrollToEnd();
            submitSendBox();
        }
        focus('chat-controls');
    }, [focus, scrollToEnd, textBoxValue, submitSendBox, scope, setKeywords]);
    return (supportSpeechRecognition
        ? react_1.default.createElement(MicrophoneButton, null)
        : react_1.default.createElement(react_2.TooltipHost, { id: id, directionalHint: react_2.DirectionalHint.topCenter, content: (scope === null || scope === void 0 ? void 0 : scope.target) == 'panel'
                ? chatQueryTitle
                : chatSendTitle },
            react_1.default.createElement(react_2.IconButton, { name: (scope === null || scope === void 0 ? void 0 : scope.target) == 'panel'
                    ? chatQueryText
                    : chatSendText, iconProps: {
                    iconName: (_a = scope === null || scope === void 0 ? void 0 : scope.buttonIcon) !== null && _a !== void 0 ? _a : "Send"
                }, ariaLabel: (scope === null || scope === void 0 ? void 0 : scope.target) == 'panel'
                    ? chatQueryLabel
                    : chatSendLabel, styles: styles, disabled: disabled, onClick: handleSend })));
};
exports.SendButton = SendButton;


/***/ }),

/***/ "./src/bot/controls/upload-button/index.ts":
/*!*************************************************!*\
  !*** ./src/bot/controls/upload-button/index.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./upload-button.component */ "./src/bot/controls/upload-button/upload-button.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/upload-button/upload-button.component.tsx":
/*!********************************************************************!*\
  !*** ./src/bot/controls/upload-button/upload-button.component.tsx ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UploadButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_hooks_1 = __webpack_require__(/*! @fluentui/react-hooks */ "@fluentui/react-hooks");
const chat_styles_1 = __webpack_require__(/*! ../chat.styles */ "./src/bot/controls/chat.styles.ts");
const { useDisabled, useSendFiles } = botframework_webchat_1.hooks;
const UploadButton = () => {
    const id = react_hooks_1.useId();
    const styles = smarthub_common_1.useFluentStylesWithProps(chat_styles_1.buttonStyles);
    const [disabled] = useDisabled();
    const localize = smarthub_common_1.useLocalizeConfig();
    const focus = smarthub_common_1.useFocus();
    const inputRef = react_1.useRef(null);
    const sendFiles = useSendFiles();
    const handleSend = react_1.useCallback(() => {
        inputRef.current && inputRef.current.click();
    }, [inputRef.current]);
    const handleFileChange = react_1.useCallback(({ target: { files } }) => {
        sendFiles(files);
        focus('chat-controls');
        if (inputRef.current) {
            inputRef.current.value = null;
        }
    }, [inputRef.current, sendFiles, focus]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", { style: { display: 'none' }, "aria-disabled": disabled, "aria-hidden": "true", multiple: true, onChange: handleFileChange, readOnly: disabled, ref: elementRef => inputRef.current = elementRef, tabIndex: -1, type: "file" }),
        react_1.default.createElement(react_2.TooltipHost, { id: id, directionalHint: react_2.DirectionalHint.topCenter, content: localize.chatUploadTitle },
            react_1.default.createElement(react_2.IconButton, { name: localize.chatUploadText, iconProps: {
                    iconName: "Attach"
                }, ariaLabel: localize.chatUploadLabel, styles: styles, disabled: disabled, onClick: handleSend }))));
};
exports.UploadButton = UploadButton;


/***/ }),

/***/ "./src/bot/index.ts":
/*!**************************!*\
  !*** ./src/bot/index.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./cards */ "./src/bot/cards/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./controls */ "./src/bot/controls/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel */ "./src/bot/panel/index.ts"), exports);


/***/ }),

/***/ "./src/bot/panel/chat-footer/chat-footer.component.tsx":
/*!*************************************************************!*\
  !*** ./src/bot/panel/chat-footer/chat-footer.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatFooter = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_hooks_1 = __webpack_require__(/*! @fluentui/react-hooks */ "@fluentui/react-hooks");
const react_2 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const fluentStyles = ((props) => {
    var _a, _b, _c;
    return ({
        root: Object.assign({ marginLeft: 'auto' }, (smarthub_common_1.themeStyle((_c = (_b = (_a = props.theme.styles) === null || _a === void 0 ? void 0 : _a.chat) === null || _b === void 0 ? void 0 : _b.footer) === null || _c === void 0 ? void 0 : _c.poweredBy, props)))
    });
});
const useStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b;
    const { palette, spacing, styles, sizes, fonts } = theme;
    const footer = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.chat) === null || _a === void 0 ? void 0 : _a.footer) !== null && _b !== void 0 ? _b : {};
    const props = { theme };
    return {
        root: Object.assign({ display: "flex", backgroundColor: palette.neutralMinus3 }, (smarthub_common_1.themeStyle(footer.root, props))),
        inner: {
            width: "100%"
        },
        nav: Object.assign({ display: "flex", width: "100%", height: sizes.large, alignItems: "center", boxSizing: 'border-box', padding: `0 ${spacing.medium}` }, (smarthub_common_1.themeStyle(footer.nav, props))),
        poweredByImage: Object.assign({ maxHeight: sizes.large }, (smarthub_common_1.themeStyle(footer.poweredByImage, props))),
        poweredByLink: Object.assign({ display: "flex" }, (smarthub_common_1.themeStyle(footer.poweredByLink, props))),
        link: Object.assign(Object.assign(Object.assign(Object.assign({}, fonts.normal), { boxSizing: "border-box", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }), (smarthub_common_1.themeStyle(footer.link, props))), { fontWeight: (palette === null || palette === void 0 ? void 0 : palette.bold) == 'true' ? 'bold' : 'normal' }),
    };
});
const ChatFooter = ({ config: { props: { actions } = { actions: [] } } }) => {
    const { chatFooterLabel, focusZoneHorizontalLabel, chatPoweredByAlt, chatPoweredByLabel, chatPoweredByTitle } = smarthub_common_1.useLocalizeConfig();
    const styles = useStyles();
    const toolTipStyles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const id = react_hooks_1.useId();
    const { poweredByUri } = smarthub_common_1.useSourceInfo();
    const footer = react_2.useRef();
    const register = smarthub_common_1.useRegisterFocus();
    const imageUri = smarthub_common_1.useThemeImageURI(smarthub_common_1.ImageKeys.chatPoweredBy);
    react_2.useEffect(() => {
        register('chat-footer', () => {
            footer.current.focus();
        });
    }, []);
    return (react_2.default.createElement("div", { className: styles.root },
        react_2.default.createElement(react_1.FocusZone, { componentRef: footer, direction: react_1.FocusZoneDirection.horizontal, className: [styles.inner].join(' ') },
            react_2.default.createElement("nav", { className: styles.nav, "aria-label": `${chatFooterLabel} ${focusZoneHorizontalLabel}` }, actions === null || actions === void 0 ? void 0 :
                actions.map(({ name, action, title, description, shortTitle }) => react_2.default.createElement(utilities_1.ActionLink, { key: name, action: action, title: title, label: description, className: styles.link, headerLevel: false }, shortTitle)),
                (poweredByUri === null || poweredByUri === void 0 ? void 0 : poweredByUri.length) > 0 && react_2.default.createElement(react_1.TooltipHost, { styles: toolTipStyles, id: id, directionalHint: react_1.DirectionalHint.topCenter, content: chatPoweredByTitle },
                    react_2.default.createElement("a", { target: '_blank', "aria-label": chatPoweredByLabel, className: styles.poweredByLink, href: poweredByUri },
                        react_2.default.createElement("img", { className: styles.poweredByImage, alt: chatPoweredByAlt, src: imageUri })))))));
};
exports.ChatFooter = ChatFooter;


/***/ }),

/***/ "./src/bot/panel/chat-footer/index.ts":
/*!********************************************!*\
  !*** ./src/bot/panel/chat-footer/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-footer.component */ "./src/bot/panel/chat-footer/chat-footer.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/panel/chat-header/chat-header.component.tsx":
/*!*************************************************************!*\
  !*** ./src/bot/panel/chat-header/chat-header.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatHeader = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const useStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b, _c;
    const { palette, spacing, styles, sizes, fonts } = theme;
    const header = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.chat) === null || _a === void 0 ? void 0 : _a.header) !== null && _b !== void 0 ? _b : {};
    const props = { theme };
    return {
        root: Object.assign({ display: "flex", backgroundColor: palette.primary }, smarthub_common_1.themeStyle(header.root, props)),
        imageSection: Object.assign({ padding: spacing.normal, display: "flex" }, smarthub_common_1.themeStyle(header.imageSection, props)),
        image: Object.assign(Object.assign({}, (_c = styles === null || styles === void 0 ? void 0 : styles.chatHeader) === null || _c === void 0 ? void 0 : _c.image), { display: "block !important" }),
        titleSection: Object.assign(Object.assign({ marginLeft: spacing.normal, boxSizing: "border-box", display: "flex", flexDirection: "column", justifyContent: "space-evenly" }, smarthub_common_1.themeStyle(header.titleSection, props)), { "& h1$title": Object.assign(Object.assign(Object.assign({}, fonts.superLarge), { margin: "0px !important", border: "0px !important", padding: "0px !important", boxSizing: "border-box", lineHeight: sizes.normal, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", color: palette.primaryOn }), smarthub_common_1.themeStyle(header.title, props)), "& h2$subTitle": Object.assign(Object.assign(Object.assign({}, fonts.normal), { margin: "0px !important", border: "0px !important", padding: "0px !important", boxSizing: "border-box", lineHeight: sizes.small, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", color: palette.primaryOn }), smarthub_common_1.themeStyle(header.subTitle, props)) }),
        title: {},
        subTitle: {},
    };
});
const ChatHeader = () => {
    const localize = smarthub_common_1.useLocalizeConfig();
    const styles = useStyles();
    const imageUri = smarthub_common_1.useThemeImageURI(smarthub_common_1.ImageKeys.chatHead);
    return (react_1.default.createElement("div", { className: styles.root },
        react_1.default.createElement("div", { className: styles.imageSection },
            react_1.default.createElement("img", { className: styles.image, alt: localize.chatHeadImageAlt, src: imageUri })),
        react_1.default.createElement("div", { className: styles.titleSection },
            react_1.default.createElement("h1", { className: styles.title, "aria-label": localize.chatHeadTitleLabel }, localize.chatHeadTitle),
            react_1.default.createElement("h2", { className: styles.subTitle, "aria-label": localize.chatHeadSubTitleLabel }, localize.chatHeadSubTitle))));
};
exports.ChatHeader = ChatHeader;


/***/ }),

/***/ "./src/bot/panel/chat-header/index.ts":
/*!********************************************!*\
  !*** ./src/bot/panel/chat-header/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-header.component */ "./src/bot/panel/chat-header/chat-header.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/panel/chat-launcher/chat-launcher.component.tsx":
/*!*****************************************************************!*\
  !*** ./src/bot/panel/chat-launcher/chat-launcher.component.tsx ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatLauncher = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const useStyles = react_jss_1.createUseStyles((theme) => {
    const { palette, spacing } = theme;
    return {
        root: {
            position: "absolute",
            background: "rgba(255,255,255)",
            color: "#333",
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            "& *::-webkit-scrollbar": {
                width: spacing.medium,
                height: spacing.medium,
                border: "0",
            },
            "& *:hover::-webkit-scrollbar": {
                width: spacing.medium,
                height: spacing.medium,
            },
        },
        inner: {
            overflow: "auto",
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
        },
        toggleBtn: {
            width: "30px",
            height: "30px",
            padding: "10px",
            zIndex: 9999,
            background: palette.primary,
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            borderRadius: "50%",
            top: "calc(50% - 15px)",
            cursor: "pointer",
            left: "-15px",
        },
        right: {
            right: "0",
            borderRight: "1px solid #ddd",
            transition: "right 0.3s ease",
        },
        visibleRight: {
            right: "100%",
            boxShadow: "rgb(0 0 0 / 12%) -4px 0px 8px",
        },
        left: {
            left: "0",
            borderLeft: "1px solid #ddd",
            transition: "left 0.3s ease",
        },
        visibleLeft: {
            left: "100%",
            boxShadow: "rgb(0 0 0 / 12%) 4px 0px 8px",
        },
        title: {
            fontSize: "20px",
            fontWeight: "600",
            lineHeight: "1.2em",
            marginBottom: "10px",
        },
        sectionHeader: {
            fontSize: "17px",
            fontWeight: "600",
        },
        sectionText: {
            fontSize: "13px",
        },
        buttonWrapper: {
            display: "flex",
            flexDirection: "column",
            gap: "10px",
        },
        button: {
            background: palette.primary,
            padding: "10px",
            color: "white",
            textAlign: "center",
            borderRadius: "10px",
            display: "flex",
            cursor: "pointer",
            gap: "10px",
        },
        buttonIcon: {
            fontSize: "30px",
            width: "50px",
            padding: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        buttonText: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            flex: 1,
        },
        buttonTitle: {
            fontSize: "18px",
            fontWeight: "600",
        },
        buttonSubtitle: {
            fontSize: "12px",
            lineHeight: "1.2em",
        },
        page: {
            background: "white",
            position: "absolute",
            height: "100%",
            width: "100%",
            zIndex: -1,
            right: "0",
            transition: "right 0.3s ease",
        },
        pageVisible: {
            right: "100%",
            boxShadow: "rgb(0 0 0 / 12%) -4px 0px 8px",
        },
    };
});
const ChatLauncher = ({ config: { props: { html, enabled, mode, version, sessionKey, cacheLocation }, }, }) => {
    const [showPage, setShowPage] = react_1.useState(false);
    //const localize = useLocalizeConfig();
    const invokeSkill = smarthub_common_1.useHandleSkill();
    const setLauncherState = smarthub_common_1.useSetPreference(smarthub_common_1.preferenceKeys.chatLauncherState);
    const styles = useStyles();
    const [dockPostion] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys.chatDockPosition, false);
    const [launcherState] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys.chatLauncherState, false);
    const { chat: { dockPositions: { preferred: position }, }, } = smarthub_common_1.useViewConfig();
    const preferredPosition = react_1.useMemo(() => {
        if (dockPostion) {
            return dockPostion;
        }
        return position;
    }, [dockPostion, position]);
    const isVisible = react_1.useMemo(() => {
        if (launcherState == "open") {
            return true;
        }
        return false;
    }, [launcherState]);
    const toggleLauncher = react_1.useCallback(() => {
        if (launcherState == "open") {
            setLauncherState("closed");
        }
        else {
            setLauncherState("open");
        }
    }, [launcherState]);
    const startSkill = react_1.useCallback(() => {
        invokeSkill({
            $id: "",
            $schema: smarthub_common_1.SkillActionSchema,
            ref: "[ICS.Flex.Bot.Skill.DemoEnvironment.dll, ICS.Flex.Bot.Skill.DemoEnvironment.Dialogs.StudentApplicationDialog]",
            invokeText: "Apply Now",
        });
    }, []);
    return (react_1.default.createElement("div", { className: [
            styles.root,
            preferredPosition == "right" ? styles.right : styles.left,
            isVisible &&
                (preferredPosition == "right"
                    ? styles.visibleRight
                    : styles.visibleLeft),
        ].join(" ") },
        react_1.default.createElement("div", { className: [styles.page, showPage && styles.pageVisible].join(" ") },
            react_1.default.createElement("div", { onClick: () => {
                    setShowPage(false);
                }, className: styles.toggleBtn, style: {
                    transform: isVisible ? "rotate(180deg)" : "rotate(0deg)",
                } },
                react_1.default.createElement("svg", { fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 512" },
                    react_1.default.createElement("path", { d: "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" }))),
            react_1.default.createElement("div", { className: styles.inner },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: styles.title }, "Submit an Enquiry"),
                    react_1.default.createElement("div", { className: styles.sectionText }, "Thank you for starting your enquiry. Please complete the form below or talk with the bot to complete your application process."),
                    react_1.default.createElement(SkillForm, null)))),
        react_1.default.createElement("div", { onClick: () => {
                toggleLauncher();
            }, className: styles.toggleBtn, style: {
                transform: isVisible ? "rotate(180deg)" : "rotate(0deg)",
            } },
            react_1.default.createElement("svg", { fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 512" },
                react_1.default.createElement("path", { d: "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" }))),
        react_1.default.createElement("div", { className: styles.inner },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles.title }, "International Student Recruitment"),
                react_1.default.createElement("div", { className: styles.sectionText }, "Welcome to our student recruitment dashboard panel. We are here to help support your application process from start to finish. Get started below!")),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles.sectionHeader }, "Common Actions"),
                react_1.default.createElement("div", { className: styles.sectionText }, "Quickstart activities to help you get started.")),
            react_1.default.createElement("div", { className: styles.buttonWrapper },
                react_1.default.createElement("div", { className: styles.button, onClick: () => {
                        setShowPage(true);
                    } },
                    react_1.default.createElement("div", { className: styles.buttonIcon },
                        react_1.default.createElement("svg", { fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" },
                            react_1.default.createElement("path", { d: "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" }))),
                    react_1.default.createElement("div", { className: styles.buttonText },
                        react_1.default.createElement("div", { className: styles.buttonTitle }, "Search"),
                        react_1.default.createElement("div", { className: styles.buttonSubtitle }, "Find your dream course with help from our bot"))),
                react_1.default.createElement("div", { className: styles.button, onClick: () => {
                        startSkill();
                        setShowPage(true);
                    } },
                    react_1.default.createElement("div", { className: styles.buttonIcon },
                        react_1.default.createElement("svg", { fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512" },
                            react_1.default.createElement("path", { d: "M288 64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32H256c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" }))),
                    react_1.default.createElement("div", { className: styles.buttonText },
                        react_1.default.createElement("div", { className: styles.buttonTitle }, "Enquire"),
                        react_1.default.createElement("div", { className: styles.buttonSubtitle }, "Start your university journey today"))),
                react_1.default.createElement("div", { className: styles.button, onClick: () => {
                        setShowPage(true);
                    } },
                    react_1.default.createElement("div", { className: styles.buttonIcon },
                        react_1.default.createElement("svg", { fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 576 512" },
                            react_1.default.createElement("path", { d: "M544 0c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM416 96c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM320 224V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zM160 288c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32zM64 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-17.7 14.3-32 32-32s32 14.3 32 32z" }))),
                    react_1.default.createElement("div", { className: styles.buttonText },
                        react_1.default.createElement("div", { className: styles.buttonTitle }, "Status"),
                        react_1.default.createElement("div", { className: styles.buttonSubtitle }, "Track the progress of your application")))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles.sectionHeader }, "Our Bot Advisors"),
                react_1.default.createElement("div", { className: styles.sectionText }, "We have many speciality advisors to help find the information you need.")),
            react_1.default.createElement("div", { className: styles.buttonWrapper },
                react_1.default.createElement("div", { className: styles.button },
                    react_1.default.createElement("div", { className: styles.buttonIcon },
                        react_1.default.createElement("svg", { fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 640 512" },
                            react_1.default.createElement("path", { d: "M320 0c17.7 0 32 14.3 32 32V96H472c39.8 0 72 32.2 72 72V440c0 39.8-32.2 72-72 72H168c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72H288V32c0-17.7 14.3-32 32-32zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H400zM264 256a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm152 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM48 224H64V416H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H576V224h16z" }))),
                    react_1.default.createElement("div", { className: styles.buttonText },
                        react_1.default.createElement("div", { className: styles.buttonTitle }, "Fiona"),
                        react_1.default.createElement("div", { className: styles.buttonSubtitle }, "Financial support and scholarship advisor"))),
                react_1.default.createElement("div", { className: styles.button },
                    react_1.default.createElement("div", { className: styles.buttonIcon },
                        react_1.default.createElement("svg", { fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 640 512" },
                            react_1.default.createElement("path", { d: "M320 0c17.7 0 32 14.3 32 32V96H472c39.8 0 72 32.2 72 72V440c0 39.8-32.2 72-72 72H168c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72H288V32c0-17.7 14.3-32 32-32zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H400zM264 256a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm152 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM48 224H64V416H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H576V224h16z" }))),
                    react_1.default.createElement("div", { className: styles.buttonText },
                        react_1.default.createElement("div", { className: styles.buttonTitle }, "Holly"),
                        react_1.default.createElement("div", { className: styles.buttonSubtitle }, "Our international student relations expert"))),
                react_1.default.createElement("div", { className: styles.button },
                    react_1.default.createElement("div", { className: styles.buttonIcon },
                        react_1.default.createElement("svg", { fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 640 512" },
                            react_1.default.createElement("path", { d: "M320 0c17.7 0 32 14.3 32 32V96H472c39.8 0 72 32.2 72 72V440c0 39.8-32.2 72-72 72H168c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72H288V32c0-17.7 14.3-32 32-32zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H400zM264 256a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm152 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM48 224H64V416H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H576V224h16z" }))),
                    react_1.default.createElement("div", { className: styles.buttonText },
                        react_1.default.createElement("div", { className: styles.buttonTitle }, "Cathy"),
                        react_1.default.createElement("div", { className: styles.buttonSubtitle }, "Our university application specialist")))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles.sectionHeader }, "Languages"),
                react_1.default.createElement("div", { className: styles.sectionText }, "Talk to the bot in your native language. Choose below:")),
            react_1.default.createElement("div", { className: styles.buttonWrapper },
                react_1.default.createElement("div", { className: styles.button },
                    react_1.default.createElement("div", { className: styles.buttonText },
                        react_1.default.createElement("div", { className: styles.buttonTitle }, "English"))),
                react_1.default.createElement("div", { className: styles.button },
                    react_1.default.createElement("div", { className: styles.buttonText },
                        react_1.default.createElement("div", { className: styles.buttonTitle }, "Spanish"))),
                react_1.default.createElement("div", { className: styles.button },
                    react_1.default.createElement("div", { className: styles.buttonText },
                        react_1.default.createElement("div", { className: styles.buttonTitle }, "Chinese")))))));
};
exports.ChatLauncher = ChatLauncher;
const SkillForm = () => {
    return (react_1.default.createElement("div", { style: {
            display: "flex",
            gap: "10px",
            marginTop: "10px",
            flexDirection: "column",
        } },
        react_1.default.createElement("label", { style: {
                fontWeight: "bold",
            } }, "What area of study are you interested in?"),
        react_1.default.createElement("select", { style: {
                width: "100%",
                padding: "5px",
                border: "1px solid #ccc",
            }, placeholder: "Please select" },
            react_1.default.createElement("option", { value: "business" }, "Business"),
            react_1.default.createElement("option", { value: "computer science" }, "Computer Science"),
            react_1.default.createElement("option", { value: "economics" }, "Economics"),
            react_1.default.createElement("option", { value: "finance" }, "Finance"),
            react_1.default.createElement("option", { value: "law" }, "Law"),
            react_1.default.createElement("option", { value: "psychology" }, "Psychology")),
        react_1.default.createElement("label", { style: {
                fontWeight: "bold",
            } }, "Are you a domestic or international student?"),
        react_1.default.createElement("select", { style: {
                width: "100%",
                padding: "5px",
                border: "1px solid #ccc",
            } },
            react_1.default.createElement("option", { value: "domestic" }, "Domestic"),
            react_1.default.createElement("option", { value: "international" }, "International")),
        react_1.default.createElement("label", { style: {
                fontWeight: "bold",
            } }, "Do you require a visa to enter the United Kingdom?"),
        react_1.default.createElement("select", { style: {
                width: "100%",
                padding: "5px",
                border: "1px solid #ccc",
            } },
            react_1.default.createElement("option", { value: "no" }, "No"),
            react_1.default.createElement("option", { value: "yes" }, "Yes")),
        react_1.default.createElement("label", { style: {
                fontWeight: "bold",
            } }, "Do you require assistance with funding?"),
        react_1.default.createElement("select", { style: {
                width: "100%",
                padding: "5px",
                border: "1px solid #ccc",
            } },
            react_1.default.createElement("option", { value: "no" }, "No"),
            react_1.default.createElement("option", { value: "yes" }, "Yes")),
        react_1.default.createElement("label", { style: {
                fontWeight: "bold",
            } }, "What year are you planning to start your studies?"),
        react_1.default.createElement("select", { style: {
                width: "100%",
                padding: "5px",
                border: "1px solid #ccc",
            } },
            react_1.default.createElement("option", { value: "2023" }, "2023"),
            react_1.default.createElement("option", { value: "2024" }, "2024"),
            react_1.default.createElement("option", { value: "2025" }, "2025")),
        react_1.default.createElement("label", { style: {
                fontWeight: "bold",
            } }, "What is your name?"),
        react_1.default.createElement("input", { type: "text", style: {
                width: "100%",
                padding: "5px",
                border: "1px solid #ccc",
            } }),
        react_1.default.createElement("label", { style: {
                fontWeight: "bold",
            } }, "What is your Email?"),
        react_1.default.createElement("input", { type: "text", style: {
                width: "100%",
                padding: "5px",
                border: "1px solid #ccc",
            } }),
        react_1.default.createElement("label", { style: {
                fontWeight: "bold",
            } }, "What is your phone number?"),
        react_1.default.createElement("input", { type: "text", style: {
                width: "100%",
                padding: "5px",
                border: "1px solid #ccc",
            } }),
        react_1.default.createElement("button", { style: {
                width: "100%",
                padding: "5px",
                fontWeight: "bold",
                border: "1px solid #ccc",
                backgroundColor: "#f5f5f5",
            } }, "Submit Enquiry")));
};


/***/ }),

/***/ "./src/bot/panel/chat-launcher/index.ts":
/*!**********************************************!*\
  !*** ./src/bot/panel/chat-launcher/index.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-launcher.component */ "./src/bot/panel/chat-launcher/chat-launcher.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/panel/chat-splash/chat-menu/chat-menu.component.tsx":
/*!*********************************************************************!*\
  !*** ./src/bot/panel/chat-splash/chat-menu/chat-menu.component.tsx ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const core_1 = __webpack_require__(/*! ../../../../core */ "./src/core/index.ts");
const ChatMenu = () => {
    var _a;
    const viewConfig = smarthub_common_1.useViewConfig();
    const setChatPosition = smarthub_common_1.useSetPreference(smarthub_common_1.preferenceKeys.chatDockPosition);
    //const setLauncherState = useSetPreference(preferenceKeys.chatLauncherState);
    const setChatSize = smarthub_common_1.useSetPreference(smarthub_common_1.preferenceKeys.chatDockSize);
    const { chatMenuTitle, chatMenuLabel, chatMenuResetDesc, chatMenuResetTitle, chatMenuResetText, 
    //chatMenuLauncherTitle,
    //chatMenuLauncherText,
    chatMenuCloseTitle, chatMenuCloseDesc, chatMenuCloseText, } = smarthub_common_1.useLocalizeConfig();
    const chatPanelState = smarthub_common_1.usePanelView("chat");
    const setChatPanelState = smarthub_common_1.useSetPanelView("chat");
    const [, setChromeState] = smarthub_common_1.useChromeState();
    const resetDirectline = smarthub_common_1.useResetDirectline();
    const focus = smarthub_common_1.useFocus();
    const dockConfig = smarthub_common_1.useResponsiveProps((_a = viewConfig.chat) === null || _a === void 0 ? void 0 : _a.dockSizes);
    const close = react_1.useCallback(() => {
        if (viewConfig.mode == "full")
            setChatPanelState(Object.assign(Object.assign({}, chatPanelState), { visible: false }));
        else
            setChromeState("closed");
    }, [chatPanelState]);
    const changeChatSize = react_1.useCallback((dock) => {
        setChatSize(dock);
    }, []);
    const changeChatPosition = react_1.useCallback((dockPosition) => {
        setChatPosition(dockPosition);
    }, []);
    /*
    const changeLauncherState = useCallback((state: LauncherState) => {
      setLauncherState(state);
    }, []); */
    const reset = react_1.useCallback(() => {
        resetDirectline();
        focus("chat-controls");
    }, [resetDirectline]);
    return react_1.useMemo(() => {
        var _a;
        return (react_1.default.createElement(core_1.ViewMenu, { title: chatMenuTitle, label: chatMenuLabel, changeDockSize: changeChatSize, changeDockPosition: changeChatPosition, dockSize: chatPanelState.size, dockPosition: chatPanelState.position, focusName: "chat-menu", dockConfig: dockConfig, dockPositionConfig: (_a = viewConfig === null || viewConfig === void 0 ? void 0 : viewConfig.chat) === null || _a === void 0 ? void 0 : _a.dockPositions, buttons: {
                afterItems: [
                    /*{
                      key: "Launcher",
                      text: chatMenuLauncherText,
                      name: chatMenuLauncherText,
                      title: chatMenuLauncherTitle,
                      iconProps: { iconName: "OpenPane" },
                      ariaDescription: chatMenuResetDesc,
                      ariaLabel: chatMenuResetTitle,
                      onClick: () => changeLauncherState("open" as LauncherState),
                    },*/
                    {
                        key: "reset",
                        text: chatMenuResetText,
                        name: chatMenuResetText,
                        title: chatMenuResetTitle,
                        iconProps: { iconName: "Refresh" },
                        ariaDescription: chatMenuResetDesc,
                        ariaLabel: chatMenuResetTitle,
                        onClick: () => reset(),
                    },
                ],
            }, closeProps: {
                onClick: close,
                text: chatMenuCloseText,
                title: chatMenuCloseTitle,
                description: chatMenuCloseDesc,
            } }));
    }, [reset, close, changeChatSize, chatPanelState, viewConfig]);
};
exports.ChatMenu = ChatMenu;


/***/ }),

/***/ "./src/bot/panel/chat-splash/chat-menu/index.ts":
/*!******************************************************!*\
  !*** ./src/bot/panel/chat-splash/chat-menu/index.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-menu.component */ "./src/bot/panel/chat-splash/chat-menu/chat-menu.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/panel/chat-splash/chat-splash.component.tsx":
/*!*************************************************************!*\
  !*** ./src/bot/panel/chat-splash/chat-splash.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatSplash = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const usehooks_ts_1 = __webpack_require__(/*! usehooks-ts */ "./node_modules/usehooks-ts/dist/esm/index.js");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const dompurify_1 = tslib_1.__importDefault(__webpack_require__(/*! dompurify */ "./node_modules/dompurify/dist/purify.js"));
const useStyles = react_jss_1.createUseStyles(({ palette, fonts }) => ({
    root: (props) => ({
        position: "absolute",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        zIndex: 1000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
    }),
    inner: (props) => {
        var _a, _b, _c, _d;
        return ({
            display: "flex",
            padding: ((_a = props === null || props === void 0 ? void 0 : props.container) === null || _a === void 0 ? void 0 : _a.padding) || "20px",
            margin: ((_b = props === null || props === void 0 ? void 0 : props.container) === null || _b === void 0 ? void 0 : _b.margin) || "25px",
            backgroundColor: ((_c = props === null || props === void 0 ? void 0 : props.container) === null || _c === void 0 ? void 0 : _c.backgroundColor) || "#fff",
            color: ((_d = props === null || props === void 0 ? void 0 : props.container) === null || _d === void 0 ? void 0 : _d.textColor) || "#333",
            flexDirection: "column",
            overflow: "auto",
            position: "absolute",
            inset: "0 0 0 0",
            boxShadow: "0 0 10px 0 rgba(0,0,0,0.3)",
        });
    },
    body: (props) => {
        var _a;
        return ({
            display: "flex",
            flexDirection: "column",
            flex: 1,
            "& p": Object.assign(Object.assign({}, fonts.normal), { fontSize: (_a = props === null || props === void 0 ? void 0 : props.container) === null || _a === void 0 ? void 0 : _a.fontSize, margin: 0, marginBottom: "10px" }),
        });
    },
    primaryButton: (props) => {
        var _a, _b, _c, _d, _e, _f;
        return ({
            backgroundColor: ((_a = props === null || props === void 0 ? void 0 : props.buttons) === null || _a === void 0 ? void 0 : _a.primaryButtonBackgroundColor) || palette.primary,
            color: (_b = props === null || props === void 0 ? void 0 : props.buttons) === null || _b === void 0 ? void 0 : _b.primaryButtonTextColor,
            fontSize: (_c = props === null || props === void 0 ? void 0 : props.buttons) === null || _c === void 0 ? void 0 : _c.primaryButtonFontSize,
            padding: (_d = props === null || props === void 0 ? void 0 : props.buttons) === null || _d === void 0 ? void 0 : _d.primaryButtonPadding,
            ["&:hover"]: {
                color: (_e = props === null || props === void 0 ? void 0 : props.buttons) === null || _e === void 0 ? void 0 : _e.primaryButtonHoverTextColor,
                backgroundColor: ((_f = props === null || props === void 0 ? void 0 : props.buttons) === null || _f === void 0 ? void 0 : _f.primaryButtonHoverBackgroundColor) ||
                    palette.primaryMinus1,
            },
        });
    },
    cancelButton: (props) => {
        var _a, _b, _c, _d, _e, _f;
        return ({
            backgroundColor: ((_a = props === null || props === void 0 ? void 0 : props.buttons) === null || _a === void 0 ? void 0 : _a.secondaryButtonBackgroundColor) || palette.primary,
            color: (_b = props === null || props === void 0 ? void 0 : props.buttons) === null || _b === void 0 ? void 0 : _b.secondaryButtonTextColor,
            fontSize: (_c = props === null || props === void 0 ? void 0 : props.buttons) === null || _c === void 0 ? void 0 : _c.secondaryButtonFontSize,
            padding: (_d = props === null || props === void 0 ? void 0 : props.buttons) === null || _d === void 0 ? void 0 : _d.secondaryButtonPadding,
            ["&:hover"]: {
                color: (_e = props === null || props === void 0 ? void 0 : props.buttons) === null || _e === void 0 ? void 0 : _e.secondaryButtonHoverTextColor,
                backgroundColor: ((_f = props === null || props === void 0 ? void 0 : props.buttons) === null || _f === void 0 ? void 0 : _f.secondayButtonHoverBackgroundColor) ||
                    palette.primaryMinus1,
            },
        });
    },
    footer: {},
}));
const ChatSplash = ({ config: { props }, }) => {
    const { config, configUri, enabled, mode, version, sessionKey, cacheLocation, } = props;
    const localize = smarthub_common_1.useLocalizeConfig();
    const [isChecked, setIsChecked] = react_1.useState(true);
    const [splashVisibility_local, setSplashVisibility_local] = usehooks_ts_1.useLocalStorage(sessionKey, null);
    const [splashVisibility_session, setSplashVisibility_session] = usehooks_ts_1.useSessionStorage(sessionKey, null);
    const viewConfig = smarthub_common_1.useViewConfig();
    const chatPanelState = smarthub_common_1.usePanelView("chat");
    const setChatPanelState = smarthub_common_1.useSetPanelView("chat");
    const [, setChromeState] = smarthub_common_1.useChromeState();
    // load JSON from configUri
    const [configParams, setConfigParams] = react_1.useState();
    const splashConfig = react_1.useMemo(() => {
        return configParams || config;
    }, [configParams, config]);
    /* eslint-disable */ console.log(...oo_oo(`23a1859e_0`, "configParams", configParams));
    /* eslint-disable */ console.log(...oo_oo(`23a1859e_1`, "config", config));
    const styles = useStyles(splashConfig);
    react_1.useEffect(() => {
        if (configUri) {
            fetch(configUri)
                .then((response) => response.json())
                .then((data) => {
                setConfigParams(data);
            })
                .catch((error) => {
                /* eslint-disable */ console.log(...oo_oo(`23a1859e_2`, "Failed to load config from " + configUri));
            });
        }
    }, [configUri]);
    const getCache = react_1.useCallback(() => {
        let cacheStr = null;
        switch (cacheLocation) {
            case "local":
                cacheStr = splashVisibility_local;
                break;
            case "session":
                cacheStr = splashVisibility_session;
                break;
        }
        return cacheStr;
    }, [splashVisibility_local, splashVisibility_session, cacheLocation]);
    const setCache = react_1.useCallback(() => {
        let new_cache = {
            date: new Date().toISOString(),
            version: version,
            accepted: isChecked,
        };
        switch (cacheLocation) {
            case "local":
                if (splashVisibility_local === null) {
                    setSplashVisibility_local(new_cache);
                }
                break;
            case "session":
                if (splashVisibility_session === null) {
                    setSplashVisibility_session(new_cache);
                }
                break;
        }
    }, [splashVisibility_local, splashVisibility_session, cacheLocation]);
    const shouldShowSplash = react_1.useCallback(() => {
        let accepted = false;
        if (!enabled) {
            return false;
        }
        const cacheStr = getCache();
        if (cacheStr) {
            try {
                let tncs = cacheStr;
                accepted =
                    tncs.version != null &&
                        tncs.version == version &&
                        tncs.date != null &&
                        tncs.accepted == true;
                return !accepted;
            }
            catch (ex) {
                /* eslint-disable */ console.log(...oo_oo(`23a1859e_3`, "Failed to parse acceptance record. " + cacheStr));
                return false;
            }
        }
        // show splash if no cache found
        return true;
    }, [splashVisibility_local, splashVisibility_session, cacheLocation]);
    const close = react_1.useCallback(() => {
        if (viewConfig.mode == "full")
            setChatPanelState(Object.assign(Object.assign({}, chatPanelState), { visible: false }));
        else
            setChromeState("closed");
    }, [chatPanelState]);
    const onChange = react_1.useCallback((ev, checked) => {
        setIsChecked(!!checked);
    }, []);
    if (!shouldShowSplash()) {
        return null;
    }
    return (react_1.default.createElement("div", { className: styles.root },
        react_1.default.createElement("div", { className: styles.inner },
            react_1.default.createElement("div", { className: styles.body, dangerouslySetInnerHTML: {
                    __html: dompurify_1.default.sanitize(splashConfig === null || splashConfig === void 0 ? void 0 : splashConfig.html, {
                        ADD_ATTR: ["target"],
                    }),
                } }),
            react_1.default.createElement("div", { className: styles.footer },
                mode === "explicit" && (react_1.default.createElement(react_2.Checkbox, { label: localize.chatSplashAcceptCbxLabel, title: localize.chatSplashAcceptCbxTitle, checked: isChecked, onChange: onChange })),
                react_1.default.createElement("div", { style: {
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                    } },
                    react_1.default.createElement(react_2.PrimaryButton, { text: localize.chatSplashConfirmBtnText, "aria-label": localize.chatSplashConfirmBtnLabel, title: localize.chatSplashConfirmBtnTitle, tabIndex: 0, width: "100%", className: styles.primaryButton, disabled: !isChecked, onClick: () => {
                            setCache();
                        } }),
                    react_1.default.createElement(react_2.PrimaryButton, { text: localize.chatSplashCancelBtnText, "aria-label": localize.chatSplashCancelBtnLabel, title: localize.chatSplashCancelBtnTitle, width: "100%", className: styles.cancelButton, onClick: () => {
                            close();
                        } }))))));
};
exports.ChatSplash = ChatSplash;
/* eslint-disable */ ;
function oo_cm() { try {
    return (0, eval)("globalThis._console_ninja") || (0, eval)("/* https://github.com/wallabyjs/console-ninja#how-does-it-work */'use strict';var _0x5de714=_0x42cc;(function(_0x180270,_0xc4b29d){var _0x66eabe=_0x42cc,_0x5dec07=_0x180270();while(!![]){try{var _0x3360a9=-parseInt(_0x66eabe(0x1f2))/0x1*(parseInt(_0x66eabe(0x213))/0x2)+-parseInt(_0x66eabe(0x229))/0x3*(parseInt(_0x66eabe(0x212))/0x4)+parseInt(_0x66eabe(0x21f))/0x5*(parseInt(_0x66eabe(0x1e9))/0x6)+parseInt(_0x66eabe(0x1c4))/0x7*(parseInt(_0x66eabe(0x29c))/0x8)+-parseInt(_0x66eabe(0x224))/0x9+-parseInt(_0x66eabe(0x1ca))/0xa*(-parseInt(_0x66eabe(0x20c))/0xb)+parseInt(_0x66eabe(0x264))/0xc*(-parseInt(_0x66eabe(0x1be))/0xd);if(_0x3360a9===_0xc4b29d)break;else _0x5dec07['push'](_0x5dec07['shift']());}catch(_0x4521e7){_0x5dec07['push'](_0x5dec07['shift']());}}}(_0x9795,0xe2a6c));var ue=Object[_0x5de714(0x1fd)],te=Object['defineProperty'],he=Object[_0x5de714(0x273)],le=Object[_0x5de714(0x21a)],fe=Object[_0x5de714(0x252)],_e=Object[_0x5de714(0x206)]['hasOwnProperty'],pe=(_0x3d77a6,_0x3fafff,_0x2fb998,_0x23619b)=>{var _0x14b9c0=_0x5de714;if(_0x3fafff&&typeof _0x3fafff==_0x14b9c0(0x1d0)||typeof _0x3fafff==_0x14b9c0(0x265)){for(let _0x8be15e of le(_0x3fafff))!_e[_0x14b9c0(0x1fa)](_0x3d77a6,_0x8be15e)&&_0x8be15e!==_0x2fb998&&te(_0x3d77a6,_0x8be15e,{'get':()=>_0x3fafff[_0x8be15e],'enumerable':!(_0x23619b=he(_0x3fafff,_0x8be15e))||_0x23619b[_0x14b9c0(0x28d)]});}return _0x3d77a6;},ne=(_0x5b8ac7,_0x55e256,_0x273199)=>(_0x273199=_0x5b8ac7!=null?ue(fe(_0x5b8ac7)):{},pe(_0x55e256||!_0x5b8ac7||!_0x5b8ac7[_0x5de714(0x245)]?te(_0x273199,_0x5de714(0x239),{'value':_0x5b8ac7,'enumerable':!0x0}):_0x273199,_0x5b8ac7)),Y=class{constructor(_0x18fd3e,_0x518dec,_0x4e07d2,_0x479ba0){var _0x4f8d85=_0x5de714;this[_0x4f8d85(0x200)]=_0x18fd3e,this[_0x4f8d85(0x1cb)]=_0x518dec,this[_0x4f8d85(0x233)]=_0x4e07d2,this[_0x4f8d85(0x22e)]=_0x479ba0,this['_allowedToSend']=!0x0,this[_0x4f8d85(0x1d6)]=!0x0,this[_0x4f8d85(0x2a5)]=!0x1,this[_0x4f8d85(0x2a3)]=[],this[_0x4f8d85(0x25a)]=!0x1,this[_0x4f8d85(0x230)]=!0x1,this[_0x4f8d85(0x24f)]=!!this[_0x4f8d85(0x200)]['WebSocket'],this['_WebSocketClass']=null,this['_connectAttemptCount']=0x0,this[_0x4f8d85(0x280)]=0x14,this[_0x4f8d85(0x28b)]=0x0,this[_0x4f8d85(0x203)]=0x3e8,this['_sendErrorMessage']=this[_0x4f8d85(0x24f)]?_0x4f8d85(0x247):_0x4f8d85(0x246);}async[_0x5de714(0x267)](){var _0x597c3b=_0x5de714;if(this[_0x597c3b(0x25b)])return this[_0x597c3b(0x25b)];let _0x662894;if(this[_0x597c3b(0x24f)])_0x662894=this['global'][_0x597c3b(0x1ff)];else{if(this[_0x597c3b(0x200)][_0x597c3b(0x27b)]?.[_0x597c3b(0x26c)])_0x662894=this[_0x597c3b(0x200)]['process']?.['_WebSocket'];else try{let _0x30682a=await import(_0x597c3b(0x288));_0x662894=(await import((await import(_0x597c3b(0x278)))[_0x597c3b(0x216)](_0x30682a[_0x597c3b(0x1d9)](this[_0x597c3b(0x22e)],_0x597c3b(0x1f0)))['toString']()))[_0x597c3b(0x239)];}catch{try{_0x662894=require(require(_0x597c3b(0x288))['join'](this[_0x597c3b(0x22e)],'ws'));}catch{throw new Error(_0x597c3b(0x24a));}}}return this['_WebSocketClass']=_0x662894,_0x662894;}[_0x5de714(0x1e5)](){var _0x16f586=_0x5de714;this[_0x16f586(0x230)]||this['_connected']||this['_connectAttemptCount']>=this[_0x16f586(0x280)]||(this[_0x16f586(0x1d6)]=!0x1,this[_0x16f586(0x230)]=!0x0,this[_0x16f586(0x1c6)]++,this['_ws']=new Promise((_0x40c381,_0x320656)=>{var _0x14fc2f=_0x16f586;this[_0x14fc2f(0x267)]()[_0x14fc2f(0x1fc)](_0x8517e1=>{var _0x13e29f=_0x14fc2f;let _0x1f8f3f=new _0x8517e1('ws://'+this[_0x13e29f(0x1cb)]+':'+this['port']);_0x1f8f3f[_0x13e29f(0x287)]=()=>{var _0x5d5175=_0x13e29f;this[_0x5d5175(0x294)]=!0x1,this[_0x5d5175(0x21b)](_0x1f8f3f),this[_0x5d5175(0x291)](),_0x320656(new Error(_0x5d5175(0x24c)));},_0x1f8f3f[_0x13e29f(0x202)]=()=>{var _0x3568f5=_0x13e29f;this['_inBrowser']||_0x1f8f3f['_socket']&&_0x1f8f3f[_0x3568f5(0x1ee)][_0x3568f5(0x243)]&&_0x1f8f3f['_socket'][_0x3568f5(0x243)](),_0x40c381(_0x1f8f3f);},_0x1f8f3f['onclose']=()=>{var _0x252d39=_0x13e29f;this[_0x252d39(0x1d6)]=!0x0,this[_0x252d39(0x21b)](_0x1f8f3f),this[_0x252d39(0x291)]();},_0x1f8f3f['onmessage']=_0x21795d=>{var _0x57ff28=_0x13e29f;try{_0x21795d&&_0x21795d[_0x57ff28(0x258)]&&this[_0x57ff28(0x24f)]&&JSON['parse'](_0x21795d['data'])[_0x57ff28(0x1dd)]===_0x57ff28(0x228)&&this[_0x57ff28(0x200)][_0x57ff28(0x295)][_0x57ff28(0x228)]();}catch{}};})['then'](_0x3c12aa=>(this[_0x14fc2f(0x25a)]=!0x0,this[_0x14fc2f(0x230)]=!0x1,this[_0x14fc2f(0x1d6)]=!0x1,this['_allowedToSend']=!0x0,this[_0x14fc2f(0x2a5)]=!0x1,this[_0x14fc2f(0x28b)]=0x0,this[_0x14fc2f(0x1c6)]=0x0,_0x3c12aa))['catch'](_0x1c8ccb=>(this[_0x14fc2f(0x25a)]=!0x1,this['_connecting']=!0x1,_0x320656(new Error('failed\\x20to\\x20connect\\x20to\\x20host:\\x20'+(_0x1c8ccb&&_0x1c8ccb['message'])))));}));}[_0x5de714(0x21b)](_0x1930a9){var _0x5b5707=_0x5de714;this[_0x5b5707(0x25a)]=!0x1,this[_0x5b5707(0x230)]=!0x1;try{_0x1930a9[_0x5b5707(0x27c)]=null,_0x1930a9[_0x5b5707(0x287)]=null,_0x1930a9['onopen']=null;}catch{}try{_0x1930a9['readyState']<0x2&&_0x1930a9[_0x5b5707(0x290)]();}catch{}}['_attemptToReconnectShortly'](){var _0x4e61b6=_0x5de714;clearTimeout(this[_0x4e61b6(0x1bd)]),!(this[_0x4e61b6(0x1c6)]>=this[_0x4e61b6(0x280)])&&(this['_reconnectTimeout']=setTimeout(()=>{var _0x1a507d=_0x4e61b6;this[_0x1a507d(0x25a)]||this['_connecting']||(this[_0x1a507d(0x1e5)](),this['_ws']?.[_0x1a507d(0x242)](()=>this[_0x1a507d(0x291)]()));},0x1f4),this[_0x4e61b6(0x1bd)][_0x4e61b6(0x243)]&&this[_0x4e61b6(0x1bd)][_0x4e61b6(0x243)]());}async[_0x5de714(0x2ab)](_0x2c672d){var _0x116643=_0x5de714;try{if(!this['_allowedToSend'])return;if(this[_0x116643(0x2a5)]){this[_0x116643(0x2a3)]['push'](_0x2c672d);return;}this[_0x116643(0x1d6)]&&this['_connectToHostNow'](),this['_activeConnectionMessageCount']++;let _0x30cbb4=this[_0x116643(0x28b)]>=this[_0x116643(0x203)];_0x30cbb4&&(this[_0x116643(0x2a5)]=!0x0);let _0x36711f=await this[_0x116643(0x23d)];_0x36711f['send'](JSON[_0x116643(0x23c)](_0x2c672d)),this['_connected']&&_0x30cbb4&&(this[_0x116643(0x1d6)]=!0x1,this[_0x116643(0x21b)](_0x36711f),this[_0x116643(0x1e5)](),this[_0x116643(0x23d)]?.[_0x116643(0x1fc)](()=>{var _0x1187ae=_0x116643;if(this[_0x1187ae(0x2a3)]['length']){let _0x3765da=this[_0x1187ae(0x2a3)][_0x1187ae(0x23f)](0x0,this['_maxActiveConnectionMessageCount']);for(let _0x1f7b28=0x0;_0x1f7b28<_0x3765da[_0x1187ae(0x223)];_0x1f7b28++)this[_0x1187ae(0x2ab)](_0x3765da[_0x1f7b28]);}}));}catch(_0x5cb730){console[_0x116643(0x298)](this[_0x116643(0x1d2)]+':\\x20'+(_0x5cb730&&_0x5cb730[_0x116643(0x1e2)])),this[_0x116643(0x294)]=!0x1,this['_attemptToReconnectShortly']();}}};function H(_0x3da308,_0x1146cf,_0x270692,_0x3671ea,_0x9ccb35){var _0x4931ef=_0x5de714;let _0x40102b=_0x270692[_0x4931ef(0x22f)](',')[_0x4931ef(0x27d)](_0x149096=>{var _0x24fbc6=_0x4931ef;try{_0x3da308[_0x24fbc6(0x2a4)]||((_0x9ccb35===_0x24fbc6(0x22b)||_0x9ccb35===_0x24fbc6(0x289))&&(_0x9ccb35+=_0x3da308[_0x24fbc6(0x27b)]?.[_0x24fbc6(0x1da)]?.[_0x24fbc6(0x1d7)]?_0x24fbc6(0x234):_0x24fbc6(0x256)),_0x3da308[_0x24fbc6(0x2a4)]={'id':+new Date(),'tool':_0x9ccb35});let _0x1105fb=new Y(_0x3da308,_0x1146cf,_0x149096,_0x3671ea);return _0x1105fb[_0x24fbc6(0x2ab)][_0x24fbc6(0x299)](_0x1105fb);}catch(_0x1fa6a2){return console['warn'](_0x24fbc6(0x1f7),_0x1fa6a2&&_0x1fa6a2['message']),()=>{};}});return _0x435322=>_0x40102b[_0x4931ef(0x1dc)](_0x5d5cf0=>_0x5d5cf0(_0x435322));}function _0x42cc(_0x43dc8c,_0xd8c54a){var _0x97950c=_0x9795();return _0x42cc=function(_0x42cc4c,_0x525b47){_0x42cc4c=_0x42cc4c-0x1bd;var _0x101f60=_0x97950c[_0x42cc4c];return _0x101f60;},_0x42cc(_0x43dc8c,_0xd8c54a);}function _0x9795(){var _0x259951=['_setNodeId','_connectAttemptCount','level','_hasSetOnItsPath','_propertyName','508090RDjWmO','host','getOwnPropertySymbols',':logPointId:','sort','substr','object','disabledTrace','_sendErrorMessage','array','_cleanNode','_addObjectProperty','_allowedToConnectOnSend','node','nan','join','versions','Error','forEach','method','cappedElements','_isArray','stackTraceLimit','test','message','_propertyAccessor','hostname','_connectToHostNow','timeStamp','sortProps','totalStrLength','6xnYElZ','perf_hooks','Set','127.0.0.1','[object\\x20Array]','_socket','bigint','ws/index.js','autoExpand','218413XFHlCj','_isPrimitiveType','_setNodePermissions','hrtime','resolveGetters','logger\\x20failed\\x20to\\x20connect\\x20to\\x20host','match','rootExpression','call','_getOwnPropertySymbols','then','create','String','WebSocket','global','trace','onopen','_maxActiveConnectionMessageCount','_property','negativeZero','prototype','_isPrimitiveWrapperType','_consoleNinjaAllowedToStart','_console_ninja','_treeNodePropertiesBeforeFullValue','autoExpandMaxDepth','132TPNDJV','cappedProps','_addProperty','_addFunctionsNode','argumentResolutionError','[object\\x20Map]','206208KJHuuW','6sVhwgo','_capIfString','_hasMapOnItsPath','pathToFileURL','toString','setter','_HTMLAllCollection','getOwnPropertyNames','_disposeWebsocket','symbol','props','console','7535100KnWmbp','Boolean','autoExpandPropertyCount','NEGATIVE_INFINITY','length','6988032WFkdSq','expressionsToEvaluate','capped','root_exp','reload','27FFjZiz','undefined','next.js','_processTreeNodeResult','number','nodeModules','split','_connecting','_isUndefined','autoExpandPreviousObjects','port','\\x20server','_setNodeExpandableState','POSITIVE_INFINITY','HTMLAllCollection','disabledLog','default','replace','unshift','stringify','_ws','funcName','splice','_undefined','current','catch','unref','_isSet','__es'+'Module','Console\\x20Ninja\\x20failed\\x20to\\x20send\\x20logs,\\x20restarting\\x20the\\x20process\\x20may\\x20help','Console\\x20Ninja\\x20failed\\x20to\\x20send\\x20logs,\\x20refreshing\\x20the\\x20page\\x20may\\x20help','time',[\"localhost\",\"127.0.0.1\",\"example.cypress.io\",\"vm-icsdev-03\",\"10.2.0.6\"],'failed\\x20to\\x20find\\x20and\\x20load\\x20WebSocket','_dateToString','logger\\x20websocket\\x20error','_addLoadNode','now','_inBrowser',\"c:\\\\Users\\\\ChrisLocal\\\\.vscode\\\\extensions\\\\wallabyjs.console-ninja-0.0.105\\\\node_modules\",'string','getPrototypeOf','boolean','constructor','RegExp','\\x20browser','strLength','data','_p_length','_connected','_WebSocketClass','root_exp_id','parent','Map','valueOf','toLowerCase','elements','log','type','12hBGDay','function','expId','getWebSocketClass','_getOwnPropertyDescriptor','value','serialize','_setNodeExpressionPath','_WebSocket','_hasSymbolPropertyOnItsPath','index','reduceLimits','date','allStrLength','[object\\x20Set]','getOwnPropertyDescriptor','_numberRegExp','_getOwnPropertyNames','_treeNodePropertiesAfterFullValue','_objectToString','url','null','_blacklistedProperty','process','onclose','map','slice','1.0.0','_maxConnectAttemptCount','nuxt','getter','get','negativeInfinity','49778','_additionalMetadata','onerror','path','remix','name','_activeConnectionMessageCount','error','enumerable','isArray','count','close','_attemptToReconnectShortly','_isNegativeZero','hits','_allowedToSend','location','push','timeEnd','warn','bind','webpack','concat','16CIbXwK','_setNodeLabel','_setNodeQueryPath','autoExpandLimit','_type','unknown','1680709857963','_messageQueue','_console_ninja_session','_delayMessageSending','performance','_Symbol','Buffer','noFunctions','isExpressionToEvaluate','send','_sortProps','_reconnectTimeout','9780199oSddQO','_p_','Number','_isMap','','depth','5108649RqPOxL'];_0x9795=function(){return _0x259951;};return _0x9795();}function V(_0x245436){var _0x36cecd=_0x5de714;let _0x423a3f=function(_0x3960e5,_0x51eebb){return _0x51eebb-_0x3960e5;},_0x1dab56;if(_0x245436['performance'])_0x1dab56=function(){var _0x325c88=_0x42cc;return _0x245436[_0x325c88(0x2a6)][_0x325c88(0x24e)]();};else{if(_0x245436['process']&&_0x245436[_0x36cecd(0x27b)][_0x36cecd(0x1f5)])_0x1dab56=function(){var _0x1b3482=_0x36cecd;return _0x245436['process'][_0x1b3482(0x1f5)]();},_0x423a3f=function(_0xc6cce5,_0x2692bc){return 0x3e8*(_0x2692bc[0x0]-_0xc6cce5[0x0])+(_0x2692bc[0x1]-_0xc6cce5[0x1])/0xf4240;};else try{let {performance:_0x71a494}=require(_0x36cecd(0x1ea));_0x1dab56=function(){return _0x71a494['now']();};}catch{_0x1dab56=function(){return+new Date();};}}return{'elapsed':_0x423a3f,'timeStamp':_0x1dab56,'now':()=>Date['now']()};}function X(_0x4b0400,_0x2e93f8,_0x3588e6){var _0x45de05=_0x5de714;if(_0x4b0400[_0x45de05(0x208)]!==void 0x0)return _0x4b0400[_0x45de05(0x208)];let _0x146248=_0x4b0400[_0x45de05(0x27b)]?.[_0x45de05(0x1da)]?.[_0x45de05(0x1d7)];return _0x146248&&_0x3588e6===_0x45de05(0x281)?_0x4b0400[_0x45de05(0x208)]=!0x1:_0x4b0400['_consoleNinjaAllowedToStart']=_0x146248||!_0x2e93f8||_0x4b0400['location']?.[_0x45de05(0x1e4)]&&_0x2e93f8['includes'](_0x4b0400[_0x45de05(0x295)][_0x45de05(0x1e4)]),_0x4b0400[_0x45de05(0x208)];}((_0x1ab2a5,_0x905ac1,_0x45cfda,_0x1f5c29,_0x1a4e0a,_0x3f1e88,_0x285731,_0x3ccbb0,_0x3a2bd6)=>{var _0x3886ef=_0x5de714;if(_0x1ab2a5[_0x3886ef(0x209)])return _0x1ab2a5['_console_ninja'];if(!X(_0x1ab2a5,_0x3ccbb0,_0x1a4e0a))return _0x1ab2a5[_0x3886ef(0x209)]={'consoleLog':()=>{},'consoleTrace':()=>{},'consoleTime':()=>{},'consoleTimeEnd':()=>{},'autoLog':()=>{},'autoTrace':()=>{},'autoTime':()=>{},'autoTimeEnd':()=>{}},_0x1ab2a5[_0x3886ef(0x209)];let _0x51f37f={'props':0x64,'elements':0x64,'strLength':0x400*0x32,'totalStrLength':0x400*0x32,'autoExpandLimit':0x1388,'autoExpandMaxDepth':0xa},_0x4eb728={'props':0x5,'elements':0x5,'strLength':0x100,'totalStrLength':0x100*0x3,'autoExpandLimit':0x1e,'autoExpandMaxDepth':0x2},_0x52e007=V(_0x1ab2a5),_0x12c66b=_0x52e007['elapsed'],_0x35a29b=_0x52e007[_0x3886ef(0x1e6)],_0x5b9bc6=_0x52e007[_0x3886ef(0x24e)],_0x53d25f={'hits':{},'ts':{}},_0x162599=_0x2f70b0=>{_0x53d25f['ts'][_0x2f70b0]=_0x35a29b();},_0x13d6a0=(_0x29181d,_0xbe3ae3)=>{var _0x4e399a=_0x3886ef;let _0x35b1ec=_0x53d25f['ts'][_0xbe3ae3];if(delete _0x53d25f['ts'][_0xbe3ae3],_0x35b1ec){let _0x428e73=_0x12c66b(_0x35b1ec,_0x35a29b());_0x33781f(_0x43a9f0(_0x4e399a(0x248),_0x29181d,_0x5b9bc6(),_0x2838ea,[_0x428e73],_0xbe3ae3));}},_0x5079ba=_0x1fbb28=>_0x392e17=>{var _0x3cadd4=_0x3886ef;try{_0x162599(_0x392e17),_0x1fbb28(_0x392e17);}finally{_0x1ab2a5['console'][_0x3cadd4(0x248)]=_0x1fbb28;}},_0x5958b0=_0x53d691=>_0x790be5=>{var _0x233a84=_0x3886ef;try{let [_0x5b58c8,_0x7853ce]=_0x790be5['split'](_0x233a84(0x1cd));_0x13d6a0(_0x7853ce,_0x5b58c8),_0x53d691(_0x5b58c8);}finally{_0x1ab2a5['console'][_0x233a84(0x297)]=_0x53d691;}};_0x1ab2a5[_0x3886ef(0x209)]={'consoleLog':(_0x8a1393,_0xb93335)=>{var _0x33b8d8=_0x3886ef;_0x1ab2a5[_0x33b8d8(0x21e)][_0x33b8d8(0x262)][_0x33b8d8(0x28a)]!==_0x33b8d8(0x238)&&_0x33781f(_0x43a9f0('log',_0x8a1393,_0x5b9bc6(),_0x2838ea,_0xb93335));},'consoleTrace':(_0x10a26c,_0x5d7d45)=>{var _0xea2a42=_0x3886ef;_0x1ab2a5['console']['log'][_0xea2a42(0x28a)]!==_0xea2a42(0x1d1)&&_0x33781f(_0x43a9f0('trace',_0x10a26c,_0x5b9bc6(),_0x2838ea,_0x5d7d45));},'consoleTime':()=>{var _0x321955=_0x3886ef;_0x1ab2a5['console'][_0x321955(0x248)]=_0x5079ba(_0x1ab2a5['console']['time']);},'consoleTimeEnd':()=>{var _0x6572da=_0x3886ef;_0x1ab2a5[_0x6572da(0x21e)][_0x6572da(0x297)]=_0x5958b0(_0x1ab2a5['console'][_0x6572da(0x297)]);},'autoLog':(_0x30376f,_0x563a88)=>{var _0x2e7b32=_0x3886ef;_0x33781f(_0x43a9f0(_0x2e7b32(0x262),_0x563a88,_0x5b9bc6(),_0x2838ea,[_0x30376f]));},'autoTrace':(_0x3c1318,_0x159e6b)=>{var _0x2a960c=_0x3886ef;_0x33781f(_0x43a9f0(_0x2a960c(0x201),_0x159e6b,_0x5b9bc6(),_0x2838ea,[_0x3c1318]));},'autoTime':(_0x436d6b,_0x3a2dd5,_0x3440d6)=>{_0x162599(_0x3440d6);},'autoTimeEnd':(_0x597aea,_0x6c2f56,_0x42ca63)=>{_0x13d6a0(_0x6c2f56,_0x42ca63);}};let _0x33781f=H(_0x1ab2a5,_0x905ac1,_0x45cfda,_0x1f5c29,_0x1a4e0a),_0x2838ea=_0x1ab2a5[_0x3886ef(0x2a4)];class _0xd341c9{constructor(){var _0x2a5973=_0x3886ef;this['_keyStrRegExp']=/^(?!(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$)[_$a-zA-Z\\xA0-\\uFFFF][_$a-zA-Z0-9\\xA0-\\uFFFF]*$/,this[_0x2a5973(0x274)]=/^(0|[1-9][0-9]*)$/,this['_quotedRegExp']=/'([^\\\\']|\\\\')*'/,this['_undefined']=_0x1ab2a5[_0x2a5973(0x22a)],this[_0x2a5973(0x219)]=_0x1ab2a5[_0x2a5973(0x237)],this['_getOwnPropertyDescriptor']=Object['getOwnPropertyDescriptor'],this[_0x2a5973(0x275)]=Object[_0x2a5973(0x21a)],this[_0x2a5973(0x2a7)]=_0x1ab2a5['Symbol'],this['_regExpToString']=RegExp[_0x2a5973(0x206)][_0x2a5973(0x217)],this[_0x2a5973(0x24b)]=Date[_0x2a5973(0x206)][_0x2a5973(0x217)];}['serialize'](_0x508f92,_0x34d892,_0x3e6ab1,_0x1bb4b6){var _0x1d2745=_0x3886ef,_0x4742bb=this,_0x558fc0=_0x3e6ab1[_0x1d2745(0x1f1)];function _0x2aa47f(_0x318f0f,_0x3579de,_0x2bee4e){var _0x2a46f9=_0x1d2745;_0x3579de['type']='unknown',_0x3579de[_0x2a46f9(0x28c)]=_0x318f0f[_0x2a46f9(0x1e2)],_0x71c6b8=_0x2bee4e['node'][_0x2a46f9(0x241)],_0x2bee4e[_0x2a46f9(0x1d7)][_0x2a46f9(0x241)]=_0x3579de,_0x4742bb[_0x2a46f9(0x20a)](_0x3579de,_0x2bee4e);}if(_0x34d892&&_0x34d892[_0x1d2745(0x210)])_0x2aa47f(_0x34d892,_0x508f92,_0x3e6ab1);else try{_0x3e6ab1[_0x1d2745(0x1c7)]++,_0x3e6ab1[_0x1d2745(0x1f1)]&&_0x3e6ab1[_0x1d2745(0x232)][_0x1d2745(0x296)](_0x34d892);var _0x2f00a1,_0x10519c,_0x4c0492,_0x287649,_0x258f16=[],_0xeb821=[],_0x21e706,_0x215595=this[_0x1d2745(0x2a0)](_0x34d892),_0x308083=_0x215595===_0x1d2745(0x1d3),_0x459343=!0x1,_0x2b3f6c=_0x215595===_0x1d2745(0x265),_0x4e7f30=this[_0x1d2745(0x1f3)](_0x215595),_0x1c15f7=this[_0x1d2745(0x207)](_0x215595),_0x317754=_0x4e7f30||_0x1c15f7,_0x2a79f7={},_0x10cd2e=0x0,_0x278456=!0x1,_0x71c6b8,_0xb68ab=/^(([1-9]{1}[0-9]*)|0)$/;if(_0x3e6ab1[_0x1d2745(0x1c3)]){if(_0x308083){if(_0x10519c=_0x34d892[_0x1d2745(0x223)],_0x10519c>_0x3e6ab1['elements']){for(_0x4c0492=0x0,_0x287649=_0x3e6ab1[_0x1d2745(0x261)],_0x2f00a1=_0x4c0492;_0x2f00a1<_0x287649;_0x2f00a1++)_0xeb821['push'](_0x4742bb[_0x1d2745(0x20e)](_0x258f16,_0x34d892,_0x215595,_0x2f00a1,_0x3e6ab1));_0x508f92[_0x1d2745(0x1de)]=!0x0;}else{for(_0x4c0492=0x0,_0x287649=_0x10519c,_0x2f00a1=_0x4c0492;_0x2f00a1<_0x287649;_0x2f00a1++)_0xeb821['push'](_0x4742bb[_0x1d2745(0x20e)](_0x258f16,_0x34d892,_0x215595,_0x2f00a1,_0x3e6ab1));}_0x3e6ab1[_0x1d2745(0x221)]+=_0xeb821['length'];}if(!(_0x215595===_0x1d2745(0x279)||_0x215595===_0x1d2745(0x22a))&&!_0x4e7f30&&_0x215595!==_0x1d2745(0x1fe)&&_0x215595!==_0x1d2745(0x2a8)&&_0x215595!==_0x1d2745(0x1ef)){var _0x53231c=_0x1bb4b6[_0x1d2745(0x21d)]||_0x3e6ab1['props'];if(this[_0x1d2745(0x244)](_0x34d892)?(_0x2f00a1=0x0,_0x34d892[_0x1d2745(0x1dc)](function(_0x466396){var _0x272f44=_0x1d2745;if(_0x10cd2e++,_0x3e6ab1[_0x272f44(0x221)]++,_0x10cd2e>_0x53231c){_0x278456=!0x0;return;}if(!_0x3e6ab1['isExpressionToEvaluate']&&_0x3e6ab1[_0x272f44(0x1f1)]&&_0x3e6ab1['autoExpandPropertyCount']>_0x3e6ab1[_0x272f44(0x29f)]){_0x278456=!0x0;return;}_0xeb821[_0x272f44(0x296)](_0x4742bb[_0x272f44(0x20e)](_0x258f16,_0x34d892,_0x272f44(0x1eb),_0x2f00a1++,_0x3e6ab1,function(_0x281495){return function(){return _0x281495;};}(_0x466396)));})):this['_isMap'](_0x34d892)&&_0x34d892[_0x1d2745(0x1dc)](function(_0x4b9c7a,_0x3e2a7f){var _0x2ba566=_0x1d2745;if(_0x10cd2e++,_0x3e6ab1[_0x2ba566(0x221)]++,_0x10cd2e>_0x53231c){_0x278456=!0x0;return;}if(!_0x3e6ab1[_0x2ba566(0x2aa)]&&_0x3e6ab1[_0x2ba566(0x1f1)]&&_0x3e6ab1['autoExpandPropertyCount']>_0x3e6ab1[_0x2ba566(0x29f)]){_0x278456=!0x0;return;}var _0x330f00=_0x3e2a7f['toString']();_0x330f00[_0x2ba566(0x223)]>0x64&&(_0x330f00=_0x330f00[_0x2ba566(0x27e)](0x0,0x64)+'...'),_0xeb821[_0x2ba566(0x296)](_0x4742bb[_0x2ba566(0x20e)](_0x258f16,_0x34d892,_0x2ba566(0x25e),_0x330f00,_0x3e6ab1,function(_0x34b0a1){return function(){return _0x34b0a1;};}(_0x4b9c7a)));}),!_0x459343){try{for(_0x21e706 in _0x34d892)if(!(_0x308083&&_0xb68ab[_0x1d2745(0x1e1)](_0x21e706))&&!this[_0x1d2745(0x27a)](_0x34d892,_0x21e706,_0x3e6ab1)){if(_0x10cd2e++,_0x3e6ab1[_0x1d2745(0x221)]++,_0x10cd2e>_0x53231c){_0x278456=!0x0;break;}if(!_0x3e6ab1[_0x1d2745(0x2aa)]&&_0x3e6ab1[_0x1d2745(0x1f1)]&&_0x3e6ab1[_0x1d2745(0x221)]>_0x3e6ab1['autoExpandLimit']){_0x278456=!0x0;break;}_0xeb821[_0x1d2745(0x296)](_0x4742bb[_0x1d2745(0x1d5)](_0x258f16,_0x2a79f7,_0x34d892,_0x215595,_0x21e706,_0x3e6ab1));}}catch{}if(_0x2a79f7[_0x1d2745(0x259)]=!0x0,_0x2b3f6c&&(_0x2a79f7['_p_name']=!0x0),!_0x278456){var _0x149348=[][_0x1d2745(0x29b)](this[_0x1d2745(0x275)](_0x34d892))[_0x1d2745(0x29b)](this[_0x1d2745(0x1fb)](_0x34d892));for(_0x2f00a1=0x0,_0x10519c=_0x149348['length'];_0x2f00a1<_0x10519c;_0x2f00a1++)if(_0x21e706=_0x149348[_0x2f00a1],!(_0x308083&&_0xb68ab[_0x1d2745(0x1e1)](_0x21e706[_0x1d2745(0x217)]()))&&!this[_0x1d2745(0x27a)](_0x34d892,_0x21e706,_0x3e6ab1)&&!_0x2a79f7[_0x1d2745(0x1bf)+_0x21e706[_0x1d2745(0x217)]()]){if(_0x10cd2e++,_0x3e6ab1[_0x1d2745(0x221)]++,_0x10cd2e>_0x53231c){_0x278456=!0x0;break;}if(!_0x3e6ab1[_0x1d2745(0x2aa)]&&_0x3e6ab1['autoExpand']&&_0x3e6ab1[_0x1d2745(0x221)]>_0x3e6ab1['autoExpandLimit']){_0x278456=!0x0;break;}_0xeb821[_0x1d2745(0x296)](_0x4742bb[_0x1d2745(0x1d5)](_0x258f16,_0x2a79f7,_0x34d892,_0x215595,_0x21e706,_0x3e6ab1));}}}}}if(_0x508f92[_0x1d2745(0x263)]=_0x215595,_0x317754?(_0x508f92[_0x1d2745(0x269)]=_0x34d892['valueOf'](),this[_0x1d2745(0x214)](_0x215595,_0x508f92,_0x3e6ab1,_0x1bb4b6)):_0x215595===_0x1d2745(0x270)?_0x508f92[_0x1d2745(0x269)]=this['_dateToString']['call'](_0x34d892):_0x215595===_0x1d2745(0x255)?_0x508f92[_0x1d2745(0x269)]=this['_regExpToString'][_0x1d2745(0x1fa)](_0x34d892):_0x215595==='symbol'&&this[_0x1d2745(0x2a7)]?_0x508f92[_0x1d2745(0x269)]=this[_0x1d2745(0x2a7)]['prototype'][_0x1d2745(0x217)][_0x1d2745(0x1fa)](_0x34d892):!_0x3e6ab1[_0x1d2745(0x1c3)]&&!(_0x215595===_0x1d2745(0x279)||_0x215595==='undefined')&&(delete _0x508f92[_0x1d2745(0x269)],_0x508f92['capped']=!0x0),_0x278456&&(_0x508f92[_0x1d2745(0x20d)]=!0x0),_0x71c6b8=_0x3e6ab1['node'][_0x1d2745(0x241)],_0x3e6ab1[_0x1d2745(0x1d7)]['current']=_0x508f92,this[_0x1d2745(0x20a)](_0x508f92,_0x3e6ab1),_0xeb821['length']){for(_0x2f00a1=0x0,_0x10519c=_0xeb821[_0x1d2745(0x223)];_0x2f00a1<_0x10519c;_0x2f00a1++)_0xeb821[_0x2f00a1](_0x2f00a1);}_0x258f16[_0x1d2745(0x223)]&&(_0x508f92[_0x1d2745(0x21d)]=_0x258f16);}catch(_0xa41b8f){_0x2aa47f(_0xa41b8f,_0x508f92,_0x3e6ab1);}return this[_0x1d2745(0x286)](_0x34d892,_0x508f92),this['_treeNodePropertiesAfterFullValue'](_0x508f92,_0x3e6ab1),_0x3e6ab1[_0x1d2745(0x1d7)]['current']=_0x71c6b8,_0x3e6ab1[_0x1d2745(0x1c7)]--,_0x3e6ab1[_0x1d2745(0x1f1)]=_0x558fc0,_0x3e6ab1[_0x1d2745(0x1f1)]&&_0x3e6ab1[_0x1d2745(0x232)]['pop'](),_0x508f92;}[_0x3886ef(0x1fb)](_0x14e060){var _0x4035db=_0x3886ef;return Object[_0x4035db(0x1cc)]?Object[_0x4035db(0x1cc)](_0x14e060):[];}[_0x3886ef(0x244)](_0x1bf695){var _0x3cacb0=_0x3886ef;return!!(_0x1bf695&&_0x1ab2a5['Set']&&this[_0x3cacb0(0x277)](_0x1bf695)===_0x3cacb0(0x272)&&_0x1bf695[_0x3cacb0(0x1dc)]);}[_0x3886ef(0x27a)](_0x5e4c57,_0x54215a,_0x369538){var _0x2d3f23=_0x3886ef;return _0x369538[_0x2d3f23(0x2a9)]?typeof _0x5e4c57[_0x54215a]=='function':!0x1;}['_type'](_0x355a67){var _0x3a5d19=_0x3886ef,_0x51148d='';return _0x51148d=typeof _0x355a67,_0x51148d===_0x3a5d19(0x1d0)?this[_0x3a5d19(0x277)](_0x355a67)===_0x3a5d19(0x1ed)?_0x51148d=_0x3a5d19(0x1d3):this['_objectToString'](_0x355a67)==='[object\\x20Date]'?_0x51148d=_0x3a5d19(0x270):_0x355a67===null?_0x51148d=_0x3a5d19(0x279):_0x355a67[_0x3a5d19(0x254)]&&(_0x51148d=_0x355a67[_0x3a5d19(0x254)]['name']||_0x51148d):_0x51148d===_0x3a5d19(0x22a)&&this[_0x3a5d19(0x219)]&&_0x355a67 instanceof this[_0x3a5d19(0x219)]&&(_0x51148d=_0x3a5d19(0x237)),_0x51148d;}['_objectToString'](_0x20cba4){var _0x1747e8=_0x3886ef;return Object[_0x1747e8(0x206)][_0x1747e8(0x217)][_0x1747e8(0x1fa)](_0x20cba4);}['_isPrimitiveType'](_0x2ab52d){var _0x3613f9=_0x3886ef;return _0x2ab52d===_0x3613f9(0x253)||_0x2ab52d==='string'||_0x2ab52d===_0x3613f9(0x22d);}['_isPrimitiveWrapperType'](_0x197476){var _0x185da3=_0x3886ef;return _0x197476===_0x185da3(0x220)||_0x197476==='String'||_0x197476===_0x185da3(0x1c0);}[_0x3886ef(0x20e)](_0x144cf2,_0x474c33,_0x3d4c2f,_0x34432a,_0x574152,_0x790d4b){var _0x2c09b5=this;return function(_0x7fc04c){var _0x5de0f4=_0x42cc,_0x1f7f5d=_0x574152['node'][_0x5de0f4(0x241)],_0x2fa9cb=_0x574152[_0x5de0f4(0x1d7)]['index'],_0x623410=_0x574152[_0x5de0f4(0x1d7)][_0x5de0f4(0x25d)];_0x574152['node'][_0x5de0f4(0x25d)]=_0x1f7f5d,_0x574152['node']['index']=typeof _0x34432a=='number'?_0x34432a:_0x7fc04c,_0x144cf2[_0x5de0f4(0x296)](_0x2c09b5[_0x5de0f4(0x204)](_0x474c33,_0x3d4c2f,_0x34432a,_0x574152,_0x790d4b)),_0x574152[_0x5de0f4(0x1d7)][_0x5de0f4(0x25d)]=_0x623410,_0x574152[_0x5de0f4(0x1d7)][_0x5de0f4(0x26e)]=_0x2fa9cb;};}[_0x3886ef(0x1d5)](_0x2134e6,_0x3a0630,_0x386992,_0x52b31e,_0x179028,_0x2a93f5,_0x2ed162){var _0x24cf63=_0x3886ef,_0x3648b8=this;return _0x3a0630[_0x24cf63(0x1bf)+_0x179028[_0x24cf63(0x217)]()]=!0x0,function(_0x324ca9){var _0x6b12d7=_0x24cf63,_0x20270e=_0x2a93f5[_0x6b12d7(0x1d7)][_0x6b12d7(0x241)],_0x4ee8db=_0x2a93f5['node']['index'],_0x70af0f=_0x2a93f5[_0x6b12d7(0x1d7)]['parent'];_0x2a93f5['node'][_0x6b12d7(0x25d)]=_0x20270e,_0x2a93f5[_0x6b12d7(0x1d7)][_0x6b12d7(0x26e)]=_0x324ca9,_0x2134e6[_0x6b12d7(0x296)](_0x3648b8['_property'](_0x386992,_0x52b31e,_0x179028,_0x2a93f5,_0x2ed162)),_0x2a93f5[_0x6b12d7(0x1d7)]['parent']=_0x70af0f,_0x2a93f5[_0x6b12d7(0x1d7)]['index']=_0x4ee8db;};}[_0x3886ef(0x204)](_0x1a30be,_0x5919b7,_0x5a37c9,_0x567f3d,_0x5a4bd0){var _0x503327=_0x3886ef,_0x37f4d5=this;_0x5a4bd0||(_0x5a4bd0=function(_0x229421,_0x463f5e){return _0x229421[_0x463f5e];});var _0x3537b0=_0x5a37c9[_0x503327(0x217)](),_0x29cf27=_0x567f3d[_0x503327(0x225)]||{},_0x472d8f=_0x567f3d[_0x503327(0x1c3)],_0x50541f=_0x567f3d[_0x503327(0x2aa)];try{var _0x5cc006=this[_0x503327(0x1c1)](_0x1a30be),_0x378648=_0x3537b0;_0x5cc006&&_0x378648[0x0]==='\\x27'&&(_0x378648=_0x378648[_0x503327(0x1cf)](0x1,_0x378648[_0x503327(0x223)]-0x2));var _0x26d081=_0x567f3d['expressionsToEvaluate']=_0x29cf27[_0x503327(0x1bf)+_0x378648];_0x26d081&&(_0x567f3d[_0x503327(0x1c3)]=_0x567f3d[_0x503327(0x1c3)]+0x1),_0x567f3d[_0x503327(0x2aa)]=!!_0x26d081;var _0x4f7956=typeof _0x5a37c9==_0x503327(0x21c),_0x461cb9={'name':_0x4f7956||_0x5cc006?_0x3537b0:this[_0x503327(0x1c9)](_0x3537b0)};if(_0x4f7956&&(_0x461cb9['symbol']=!0x0),!(_0x5919b7==='array'||_0x5919b7===_0x503327(0x1db))){var _0x8d1d88=this[_0x503327(0x268)](_0x1a30be,_0x5a37c9);if(_0x8d1d88&&(_0x8d1d88['set']&&(_0x461cb9[_0x503327(0x218)]=!0x0),_0x8d1d88[_0x503327(0x283)]&&!_0x26d081&&!_0x567f3d['resolveGetters']))return _0x461cb9[_0x503327(0x282)]=!0x0,this[_0x503327(0x22c)](_0x461cb9,_0x567f3d),_0x461cb9;}var _0x1e465f;try{_0x1e465f=_0x5a4bd0(_0x1a30be,_0x5a37c9);}catch(_0x58984f){return _0x461cb9={'name':_0x3537b0,'type':_0x503327(0x2a1),'error':_0x58984f['message']},this[_0x503327(0x22c)](_0x461cb9,_0x567f3d),_0x461cb9;}var _0x2ed1a8=this[_0x503327(0x2a0)](_0x1e465f),_0x41eb66=this[_0x503327(0x1f3)](_0x2ed1a8);if(_0x461cb9[_0x503327(0x263)]=_0x2ed1a8,_0x41eb66)this[_0x503327(0x22c)](_0x461cb9,_0x567f3d,_0x1e465f,function(){var _0x248b73=_0x503327;_0x461cb9['value']=_0x1e465f[_0x248b73(0x25f)](),!_0x26d081&&_0x37f4d5[_0x248b73(0x214)](_0x2ed1a8,_0x461cb9,_0x567f3d,{});});else{var _0x32e415=_0x567f3d['autoExpand']&&_0x567f3d['level']<_0x567f3d[_0x503327(0x20b)]&&_0x567f3d[_0x503327(0x232)]['indexOf'](_0x1e465f)<0x0&&_0x2ed1a8!=='function'&&_0x567f3d[_0x503327(0x221)]<_0x567f3d[_0x503327(0x29f)];_0x32e415||_0x567f3d[_0x503327(0x1c7)]<_0x472d8f||_0x26d081?(this[_0x503327(0x26a)](_0x461cb9,_0x1e465f,_0x567f3d,_0x26d081||{}),this[_0x503327(0x286)](_0x1e465f,_0x461cb9)):this[_0x503327(0x22c)](_0x461cb9,_0x567f3d,_0x1e465f,function(){var _0x1c126e=_0x503327;_0x2ed1a8===_0x1c126e(0x279)||_0x2ed1a8===_0x1c126e(0x22a)||(delete _0x461cb9[_0x1c126e(0x269)],_0x461cb9[_0x1c126e(0x226)]=!0x0);});}return _0x461cb9;}finally{_0x567f3d[_0x503327(0x225)]=_0x29cf27,_0x567f3d[_0x503327(0x1c3)]=_0x472d8f,_0x567f3d[_0x503327(0x2aa)]=_0x50541f;}}[_0x3886ef(0x214)](_0x2003a9,_0x334096,_0x26b2be,_0x406d77){var _0xcecebc=_0x3886ef,_0x438b19=_0x406d77[_0xcecebc(0x257)]||_0x26b2be['strLength'];if((_0x2003a9===_0xcecebc(0x251)||_0x2003a9===_0xcecebc(0x1fe))&&_0x334096['value']){let _0x556a29=_0x334096['value'][_0xcecebc(0x223)];_0x26b2be['allStrLength']+=_0x556a29,_0x26b2be[_0xcecebc(0x271)]>_0x26b2be[_0xcecebc(0x1e8)]?(_0x334096['capped']='',delete _0x334096[_0xcecebc(0x269)]):_0x556a29>_0x438b19&&(_0x334096[_0xcecebc(0x226)]=_0x334096['value'][_0xcecebc(0x1cf)](0x0,_0x438b19),delete _0x334096[_0xcecebc(0x269)]);}}[_0x3886ef(0x1c1)](_0x30974e){var _0x24faed=_0x3886ef;return!!(_0x30974e&&_0x1ab2a5[_0x24faed(0x25e)]&&this[_0x24faed(0x277)](_0x30974e)===_0x24faed(0x211)&&_0x30974e[_0x24faed(0x1dc)]);}[_0x3886ef(0x1c9)](_0x5a3f8f){var _0x4de6b0=_0x3886ef;if(_0x5a3f8f[_0x4de6b0(0x1f8)](/^\\d+$/))return _0x5a3f8f;var _0x3cf7d4;try{_0x3cf7d4=JSON[_0x4de6b0(0x23c)](''+_0x5a3f8f);}catch{_0x3cf7d4='\\x22'+this['_objectToString'](_0x5a3f8f)+'\\x22';}return _0x3cf7d4[_0x4de6b0(0x1f8)](/^\"([a-zA-Z_][a-zA-Z_0-9]*)\"$/)?_0x3cf7d4=_0x3cf7d4[_0x4de6b0(0x1cf)](0x1,_0x3cf7d4['length']-0x2):_0x3cf7d4=_0x3cf7d4[_0x4de6b0(0x23a)](/'/g,'\\x5c\\x27')[_0x4de6b0(0x23a)](/\\\\\"/g,'\\x22')[_0x4de6b0(0x23a)](/(^\"|\"$)/g,'\\x27'),_0x3cf7d4;}['_processTreeNodeResult'](_0x43a71c,_0xb8af3a,_0x3e8b72,_0x50e39b){var _0xad7e1e=_0x3886ef;this[_0xad7e1e(0x20a)](_0x43a71c,_0xb8af3a),_0x50e39b&&_0x50e39b(),this[_0xad7e1e(0x286)](_0x3e8b72,_0x43a71c),this[_0xad7e1e(0x276)](_0x43a71c,_0xb8af3a);}[_0x3886ef(0x20a)](_0x2d4594,_0x658d5f){var _0x5bdce6=_0x3886ef;this[_0x5bdce6(0x1c5)](_0x2d4594,_0x658d5f),this[_0x5bdce6(0x29e)](_0x2d4594,_0x658d5f),this[_0x5bdce6(0x26b)](_0x2d4594,_0x658d5f),this[_0x5bdce6(0x1f4)](_0x2d4594,_0x658d5f);}[_0x3886ef(0x1c5)](_0xbf475e,_0x10f791){}['_setNodeQueryPath'](_0x9bf3a4,_0x480223){}['_setNodeLabel'](_0x54915b,_0x478fb4){}[_0x3886ef(0x231)](_0x16e0d8){var _0x415be2=_0x3886ef;return _0x16e0d8===this[_0x415be2(0x240)];}[_0x3886ef(0x276)](_0x96b231,_0x38314d){var _0xc16b92=_0x3886ef;this[_0xc16b92(0x29d)](_0x96b231,_0x38314d),this['_setNodeExpandableState'](_0x96b231),_0x38314d[_0xc16b92(0x1e7)]&&this[_0xc16b92(0x2ac)](_0x96b231),this[_0xc16b92(0x20f)](_0x96b231,_0x38314d),this['_addLoadNode'](_0x96b231,_0x38314d),this[_0xc16b92(0x1d4)](_0x96b231);}[_0x3886ef(0x286)](_0x4621aa,_0x44eddb){var _0x3476c3=_0x3886ef;try{_0x4621aa&&typeof _0x4621aa[_0x3476c3(0x223)]=='number'&&(_0x44eddb[_0x3476c3(0x223)]=_0x4621aa[_0x3476c3(0x223)]);}catch{}if(_0x44eddb[_0x3476c3(0x263)]===_0x3476c3(0x22d)||_0x44eddb[_0x3476c3(0x263)]===_0x3476c3(0x1c0)){if(isNaN(_0x44eddb[_0x3476c3(0x269)]))_0x44eddb[_0x3476c3(0x1d8)]=!0x0,delete _0x44eddb[_0x3476c3(0x269)];else switch(_0x44eddb[_0x3476c3(0x269)]){case Number[_0x3476c3(0x236)]:_0x44eddb['positiveInfinity']=!0x0,delete _0x44eddb[_0x3476c3(0x269)];break;case Number[_0x3476c3(0x222)]:_0x44eddb[_0x3476c3(0x284)]=!0x0,delete _0x44eddb[_0x3476c3(0x269)];break;case 0x0:this[_0x3476c3(0x292)](_0x44eddb[_0x3476c3(0x269)])&&(_0x44eddb[_0x3476c3(0x205)]=!0x0);break;}}else _0x44eddb['type']===_0x3476c3(0x265)&&typeof _0x4621aa[_0x3476c3(0x28a)]=='string'&&_0x4621aa[_0x3476c3(0x28a)]&&_0x44eddb[_0x3476c3(0x28a)]&&_0x4621aa[_0x3476c3(0x28a)]!==_0x44eddb['name']&&(_0x44eddb[_0x3476c3(0x23e)]=_0x4621aa[_0x3476c3(0x28a)]);}[_0x3886ef(0x292)](_0x59da45){var _0x551b67=_0x3886ef;return 0x1/_0x59da45===Number[_0x551b67(0x222)];}[_0x3886ef(0x2ac)](_0x223694){var _0xb73016=_0x3886ef;!_0x223694[_0xb73016(0x21d)]||!_0x223694['props'][_0xb73016(0x223)]||_0x223694[_0xb73016(0x263)]===_0xb73016(0x1d3)||_0x223694[_0xb73016(0x263)]===_0xb73016(0x25e)||_0x223694[_0xb73016(0x263)]===_0xb73016(0x1eb)||_0x223694['props'][_0xb73016(0x1ce)](function(_0x17ec2b,_0xc4d7bb){var _0x2b9c14=_0xb73016,_0xe2ec0b=_0x17ec2b[_0x2b9c14(0x28a)][_0x2b9c14(0x260)](),_0x31dd43=_0xc4d7bb[_0x2b9c14(0x28a)]['toLowerCase']();return _0xe2ec0b<_0x31dd43?-0x1:_0xe2ec0b>_0x31dd43?0x1:0x0;});}[_0x3886ef(0x20f)](_0x301937,_0x1c2400){var _0x55e4a1=_0x3886ef;if(!(_0x1c2400[_0x55e4a1(0x2a9)]||!_0x301937[_0x55e4a1(0x21d)]||!_0x301937[_0x55e4a1(0x21d)][_0x55e4a1(0x223)])){for(var _0x3cfff1=[],_0xde088f=[],_0x455482=0x0,_0x17f8cd=_0x301937[_0x55e4a1(0x21d)][_0x55e4a1(0x223)];_0x455482<_0x17f8cd;_0x455482++){var _0x1336fe=_0x301937['props'][_0x455482];_0x1336fe[_0x55e4a1(0x263)]===_0x55e4a1(0x265)?_0x3cfff1[_0x55e4a1(0x296)](_0x1336fe):_0xde088f[_0x55e4a1(0x296)](_0x1336fe);}if(!(!_0xde088f['length']||_0x3cfff1[_0x55e4a1(0x223)]<=0x1)){_0x301937[_0x55e4a1(0x21d)]=_0xde088f;var _0x29ef09={'functionsNode':!0x0,'props':_0x3cfff1};this['_setNodeId'](_0x29ef09,_0x1c2400),this[_0x55e4a1(0x29d)](_0x29ef09,_0x1c2400),this[_0x55e4a1(0x235)](_0x29ef09),this[_0x55e4a1(0x1f4)](_0x29ef09,_0x1c2400),_0x29ef09['id']+='\\x20f',_0x301937[_0x55e4a1(0x21d)][_0x55e4a1(0x23b)](_0x29ef09);}}}[_0x3886ef(0x24d)](_0x32337f,_0x82c950){}[_0x3886ef(0x235)](_0x3968b3){}[_0x3886ef(0x1df)](_0x1089cf){var _0xe8aee4=_0x3886ef;return Array[_0xe8aee4(0x28e)](_0x1089cf)||typeof _0x1089cf==_0xe8aee4(0x1d0)&&this[_0xe8aee4(0x277)](_0x1089cf)==='[object\\x20Array]';}['_setNodePermissions'](_0x4bbf30,_0x58deb5){}[_0x3886ef(0x1d4)](_0x1e485b){var _0x5e91c1=_0x3886ef;delete _0x1e485b[_0x5e91c1(0x26d)],delete _0x1e485b[_0x5e91c1(0x1c8)],delete _0x1e485b[_0x5e91c1(0x215)];}[_0x3886ef(0x26b)](_0x1697fb,_0x4a69e2){}[_0x3886ef(0x1e3)](_0x1452d1){var _0x5cbe9b=_0x3886ef;return _0x1452d1?_0x1452d1['match'](this[_0x5cbe9b(0x274)])?'['+_0x1452d1+']':_0x1452d1[_0x5cbe9b(0x1f8)](this['_keyStrRegExp'])?'.'+_0x1452d1:_0x1452d1[_0x5cbe9b(0x1f8)](this['_quotedRegExp'])?'['+_0x1452d1+']':'[\\x27'+_0x1452d1+'\\x27]':'';}}let _0x18b3ec=new _0xd341c9();function _0x43a9f0(_0xb6f140,_0x52b314,_0x1cf6f1,_0x233420,_0x1e3428,_0x3b9f97){var _0x3c786e=_0x3886ef;let _0x27edf9,_0x2ddae7;try{_0x2ddae7=_0x35a29b(),_0x27edf9=_0x53d25f[_0x52b314],!_0x27edf9||_0x2ddae7-_0x27edf9['ts']>0x1f4&&_0x27edf9['count']&&_0x27edf9['time']/_0x27edf9['count']<0x64?(_0x53d25f[_0x52b314]=_0x27edf9={'count':0x0,'time':0x0,'ts':_0x2ddae7},_0x53d25f[_0x3c786e(0x293)]={}):_0x2ddae7-_0x53d25f[_0x3c786e(0x293)]['ts']>0x32&&_0x53d25f[_0x3c786e(0x293)][_0x3c786e(0x28f)]&&_0x53d25f[_0x3c786e(0x293)][_0x3c786e(0x248)]/_0x53d25f[_0x3c786e(0x293)]['count']<0x64&&(_0x53d25f[_0x3c786e(0x293)]={});let _0x51a290=[],_0x2984e2=_0x27edf9[_0x3c786e(0x26f)]||_0x53d25f[_0x3c786e(0x293)][_0x3c786e(0x26f)]?_0x4eb728:_0x51f37f,_0x3e1853=_0x18b4df=>{var _0x3fd78a=_0x3c786e;let _0xbd90a1={};return _0xbd90a1[_0x3fd78a(0x21d)]=_0x18b4df[_0x3fd78a(0x21d)],_0xbd90a1[_0x3fd78a(0x261)]=_0x18b4df[_0x3fd78a(0x261)],_0xbd90a1[_0x3fd78a(0x257)]=_0x18b4df[_0x3fd78a(0x257)],_0xbd90a1[_0x3fd78a(0x1e8)]=_0x18b4df['totalStrLength'],_0xbd90a1[_0x3fd78a(0x29f)]=_0x18b4df[_0x3fd78a(0x29f)],_0xbd90a1[_0x3fd78a(0x20b)]=_0x18b4df[_0x3fd78a(0x20b)],_0xbd90a1['sortProps']=!0x1,_0xbd90a1[_0x3fd78a(0x2a9)]=!_0x3a2bd6,_0xbd90a1[_0x3fd78a(0x1c3)]=0x1,_0xbd90a1[_0x3fd78a(0x1c7)]=0x0,_0xbd90a1[_0x3fd78a(0x266)]=_0x3fd78a(0x25c),_0xbd90a1[_0x3fd78a(0x1f9)]=_0x3fd78a(0x227),_0xbd90a1[_0x3fd78a(0x1f1)]=!0x0,_0xbd90a1[_0x3fd78a(0x232)]=[],_0xbd90a1[_0x3fd78a(0x221)]=0x0,_0xbd90a1[_0x3fd78a(0x1f6)]=!0x0,_0xbd90a1[_0x3fd78a(0x271)]=0x0,_0xbd90a1[_0x3fd78a(0x1d7)]={'current':void 0x0,'parent':void 0x0,'index':0x0},_0xbd90a1;};for(var _0x25c2ed=0x0;_0x25c2ed<_0x1e3428[_0x3c786e(0x223)];_0x25c2ed++)_0x51a290[_0x3c786e(0x296)](_0x18b3ec[_0x3c786e(0x26a)]({'timeNode':_0xb6f140==='time'||void 0x0},_0x1e3428[_0x25c2ed],_0x3e1853(_0x2984e2),{}));if(_0xb6f140===_0x3c786e(0x201)){let _0xb500ce=Error[_0x3c786e(0x1e0)];try{Error[_0x3c786e(0x1e0)]=0x1/0x0,_0x51a290[_0x3c786e(0x296)](_0x18b3ec[_0x3c786e(0x26a)]({'stackNode':!0x0},new Error()['stack'],_0x3e1853(_0x2984e2),{'strLength':0x1/0x0}));}finally{Error[_0x3c786e(0x1e0)]=_0xb500ce;}}return{'method':_0x3c786e(0x262),'version':_0x3f1e88,'args':[{'id':_0x52b314,'ts':_0x1cf6f1,'args':_0x51a290,'context':_0x3b9f97,'session':_0x233420}]};}catch(_0x2d5fcb){return{'method':_0x3c786e(0x262),'version':_0x3f1e88,'args':[{'id':_0x52b314,'ts':_0x1cf6f1,'args':[{'type':'unknown','error':_0x2d5fcb&&_0x2d5fcb['message'],'context':_0x3b9f97,'session':_0x233420}]}]};}finally{try{if(_0x27edf9&&_0x2ddae7){let _0x4a114d=_0x35a29b();_0x27edf9[_0x3c786e(0x28f)]++,_0x27edf9[_0x3c786e(0x248)]+=_0x12c66b(_0x2ddae7,_0x4a114d),_0x27edf9['ts']=_0x4a114d,_0x53d25f[_0x3c786e(0x293)][_0x3c786e(0x28f)]++,_0x53d25f['hits'][_0x3c786e(0x248)]+=_0x12c66b(_0x2ddae7,_0x4a114d),_0x53d25f[_0x3c786e(0x293)]['ts']=_0x4a114d,(_0x27edf9[_0x3c786e(0x28f)]>0x32||_0x27edf9[_0x3c786e(0x248)]>0x64)&&(_0x27edf9[_0x3c786e(0x26f)]=!0x0),(_0x53d25f[_0x3c786e(0x293)]['count']>0x3e8||_0x53d25f[_0x3c786e(0x293)][_0x3c786e(0x248)]>0x12c)&&(_0x53d25f['hits']['reduceLimits']=!0x0);}}catch{}}}return _0x1ab2a5['_console_ninja'];})(globalThis,_0x5de714(0x1ec),_0x5de714(0x285),_0x5de714(0x250),_0x5de714(0x29a),_0x5de714(0x27f),_0x5de714(0x2a2),_0x5de714(0x249),_0x5de714(0x1c2));");
}
catch (e) { } }
;
function oo_oo(i, ...v) { try {
    oo_cm().consoleLog(i, v);
}
catch (e) { } return v; }
;
oo_oo;
function oo_tr(i, ...v) { try {
    oo_cm().consoleTrace(i, v);
}
catch (e) { } return v; }
;
oo_tr;
function oo_ts() { try {
    oo_cm().consoleTime();
}
catch (e) { } }
;
oo_ts;
function oo_te() { try {
    oo_cm().consoleTimeEnd();
}
catch (e) { } }
;
oo_te; /*eslint eslint-comments/disable-enable-pair:,eslint-comments/no-unlimited-disable:,eslint-comments/no-aggregating-enable:,eslint-comments/no-duplicate-disable:,eslint-comments/no-unused-disable:,eslint-comments/no-unused-enable:,*/


/***/ }),

/***/ "./src/bot/panel/chat-splash/index.ts":
/*!********************************************!*\
  !*** ./src/bot/panel/chat-splash/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-splash.component */ "./src/bot/panel/chat-splash/chat-splash.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/panel/chat-transcript/chat-transcript.component.tsx":
/*!*********************************************************************!*\
  !*** ./src/bot/panel/chat-transcript/chat-transcript.component.tsx ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatTranscript = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const { BasicWebChat } = botframework_webchat_1.Components;
const useStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b;
    const { styles } = theme;
    const chat = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.chat) === null || _a === void 0 ? void 0 : _a.panel) !== null && _b !== void 0 ? _b : {};
    const props = { theme };
    return {
        transcript: Object.assign({ overflow: "hidden", "@global": {
                ".webchat__basic-transcript__scrollable": {
                    overflowY: "overlay",
                },
                ".webchat__basic-transcript__scrollable ul li:before": {
                    content: "none !important",
                },
            } }, smarthub_common_1.themeStyle(chat.transcript, props)),
    };
});
const ChatTranscript = () => {
    const styles = useStyles();
    return react_1.default.createElement(BasicWebChat, { className: styles.transcript });
};
exports.ChatTranscript = ChatTranscript;


/***/ }),

/***/ "./src/bot/panel/chat-transcript/index.ts":
/*!************************************************!*\
  !*** ./src/bot/panel/chat-transcript/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-transcript.component */ "./src/bot/panel/chat-transcript/chat-transcript.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/panel/index.ts":
/*!********************************!*\
  !*** ./src/bot/panel/index.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-footer */ "./src/bot/panel/chat-footer/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-header */ "./src/bot/panel/chat-header/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-splash/chat-menu */ "./src/bot/panel/chat-splash/chat-menu/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-transcript */ "./src/bot/panel/chat-transcript/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-splash */ "./src/bot/panel/chat-splash/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-launcher */ "./src/bot/panel/chat-launcher/index.ts"), exports);


/***/ }),

/***/ "./src/content/about/about.component.tsx":
/*!***********************************************!*\
  !*** ./src/content/about/about.component.tsx ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.About = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_2 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing, sizes }) => ({
    root: {
        padding: spacing.medium
    },
    header: Object.assign(Object.assign({}, fonts.superLarge), { fontWeight: "100", padding: `${spacing.medium} 0`, color: palette.neutralEmptyOn }),
    detail: {
        flex: "1 1 100%",
        display: "flex",
        flexDirection: "row",
        marginBottom: spacing.xxLarge,
        color: palette.neutralEmptyOn
    },
    logo: {
        paddingTop: spacing.smallPlus,
    },
    image: {
        maxWidth: sizes.mega,
        maxHeight: "100%"
    },
    detailList: {
        display: "flex",
        flex: "1 1",
        paddingLeft: spacing.smallPlus,
        flexDirection: "column",
    },
    description: Object.assign(Object.assign({ paddingBottom: spacing.xxLarge }, fonts.large), { fontWeight: "100" }),
    info: Object.assign({}, fonts.small),
    label: Object.assign({}, fonts.smallPlus),
    linkList: {
        boxSizing: "border-box",
        padding: 0,
        display: "block",
        width: "100%",
    },
    linkListItem: {
        display: "block",
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
        listStyleType: "none",
        width: "100%",
    }
}));
const About = ({ config, config: { props: { links } = {} }, data }) => {
    var _a, _b, _c, _d;
    const handleCommand = smarthub_common_1.useHandleCommand();
    const source = smarthub_common_1.useSourceInfo();
    const { definition: theme } = smarthub_common_1.useTheme();
    const styles = useStyles();
    const localize = smarthub_common_1.useLocalizeConfig();
    const openAction = react_2.useCallback((action) => {
        handleCommand(action);
    }, []);
    return (react_2.default.createElement(core_1.ComponentChrome, { config: config, className: styles.root },
        react_2.default.createElement("div", { className: styles.header }, source.title),
        react_2.default.createElement("div", { className: styles.detail },
            react_2.default.createElement("div", { className: styles.logo },
                react_2.default.createElement("img", { alt: localize.logoImage, className: styles.image, src: theme.image.appLogoOnEmptyL })),
            react_2.default.createElement("div", { className: styles.detailList },
                react_2.default.createElement("div", { className: styles.description }, source.description),
                react_2.default.createElement("div", { className: styles.info },
                    react_2.default.createElement("span", { className: styles.label },
                        localize.aboutVersionPrefix,
                        ": "),
                    react_2.default.createElement("span", null, source.version)),
                react_2.default.createElement("div", { className: styles.info },
                    react_2.default.createElement("span", { className: styles.label },
                        localize.aboutPublishedPrefix,
                        ": "),
                    react_2.default.createElement("span", null, source.publisher)),
                ((_b = (_a = source.environment) === null || _a === void 0 ? void 0 : _a.label) === null || _b === void 0 ? void 0 : _b.length) > 0 && react_2.default.createElement("div", { className: styles.info },
                    react_2.default.createElement("span", { className: styles.label },
                        localize.aboutEnvironmentPrefix,
                        ": "),
                    react_2.default.createElement("span", null, source.environment.label)), (_d = (_c = source.environment) === null || _c === void 0 ? void 0 : _c.areas) === null || _d === void 0 ? void 0 :
                _d.map(({ label, name }) => react_2.default.createElement("div", { className: styles.info },
                    react_2.default.createElement("span", { className: styles.label },
                        name,
                        ": "),
                    react_2.default.createElement("span", null, label))))),
        react_2.default.createElement("ul", { className: styles.linkList }, links === null || links === void 0 ? void 0 : links.map((link, i) => react_2.default.createElement("li", { key: i, className: styles.linkListItem },
            react_2.default.createElement(react_1.Link, { onClick: () => openAction(link.action), "aria-label": link.name, title: link.name }, link.name))))));
};
exports.About = About;


/***/ }),

/***/ "./src/content/about/index.ts":
/*!************************************!*\
  !*** ./src/content/about/index.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./about.component */ "./src/content/about/about.component.tsx"), exports);


/***/ }),

/***/ "./src/content/adaptive-card/adaptive-card-embed.component.tsx":
/*!*********************************************************************!*\
  !*** ./src/content/adaptive-card/adaptive-card-embed.component.tsx ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AdaptiveCardEmbed = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
const AdaptiveCards = tslib_1.__importStar(__webpack_require__(/*! adaptivecards */ "adaptivecards"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles({
    main: {
        width: "100%",
        height: "100%",
    }
});
const useACStyles = smarthub_common_1.createUseAdaptiveCardStyles();
const AdaptiveCardEmbed = ({ card, onSubmit, onFailure, onSuccess }) => {
    const hostConfig = smarthub_common_1.useHostConfig();
    const styles = useStyles();
    const acStyles = useACStyles();
    const errorMessage = smarthub_common_1.useLocalize(smarthub_common_1.LocalizeKeys.invalidSchema);
    const adaptiveCard = react_1.useRef(new AdaptiveCards.AdaptiveCard());
    const container = react_1.useRef(null);
    const [error, setError] = react_1.useState(null);
    const handleCommand = smarthub_common_1.useHandleCommand();
    const submit = react_1.useCallback((data) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            if (onSubmit)
                onSubmit(data);
            if (data.action) {
                const action = Object.assign(Object.assign({}, data.action), { body: data.action.$schema == smarthub_common_1.SubmitActionSchema
                        ? JSON.stringify(data, (k, v) => k == "action" ? undefined : v)
                        : undefined });
                yield handleCommand(action);
            }
            if (onSuccess)
                onSuccess(data);
        }
        catch (ex) {
            if (onFailure)
                onFailure(ex);
        }
    }), []);
    const openUrl = (url) => {
        handleCommand({
            $schema: smarthub_common_1.LinkActionSchema,
            $id: "",
            uri: url
        });
    };
    const onAction = react_1.useCallback((action) => {
        switch (action.getJsonTypeName()) {
            case AdaptiveCards.OpenUrlAction.JsonTypeName:
                return openUrl(action.url);
            case AdaptiveCards.SubmitAction.JsonTypeName:
                return submit(action.data);
        }
    }, []);
    react_1.useEffect(() => {
        if (card.$schema != models_1.IAdaptiveCardSchema) {
            setError("Invalid schema, cannot render data as an adaptive card");
            return;
        }
        const { current } = adaptiveCard;
        current.hostConfig = hostConfig;
        current.onExecuteAction = onAction;
        current.parse(card);
        const el = container.current;
        while (el.firstChild)
            el.removeChild(el.lastChild);
        const element = current.render();
        element.classList.add(acStyles.adaptiveCard);
        container.current.appendChild(element);
    }, [card, hostConfig, acStyles]);
    return react_1.useMemo(() => react_1.default.createElement(react_1.default.Fragment, null,
        error
            && react_1.default.createElement(utilities_1.ErrorBox, { error: { message: errorMessage } }),
        !error
            && react_1.default.createElement("div", { className: styles.main, ref: container })), [error, acStyles]);
};
exports.AdaptiveCardEmbed = AdaptiveCardEmbed;


/***/ }),

/***/ "./src/content/adaptive-card/adaptive-card.component.tsx":
/*!***************************************************************!*\
  !*** ./src/content/adaptive-card/adaptive-card.component.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AdaptiveCard = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
const adaptive_card_embed_component_1 = __webpack_require__(/*! ./adaptive-card-embed.component */ "./src/content/adaptive-card/adaptive-card-embed.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const AdaptiveCard = ({ config, config: { consumes, props }, data }) => {
    const transform = smarthub_common_1.useTransform();
    const sharedCard = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'card'));
    const [card, setCard] = react_1.useState(null);
    react_1.useEffect(() => {
        var _a;
        const input = (_a = sharedCard !== null && sharedCard !== void 0 ? sharedCard : data) !== null && _a !== void 0 ? _a : props === null || props === void 0 ? void 0 : props.card;
        if (input) {
            if (input.$schema == models_1.IAdaptiveCardSchema)
                setCard(input);
            else {
                const result = transform(models_1.IAdaptiveCardSchema, input);
                setCard(result);
            }
        }
    }, [props, data, sharedCard]);
    return react_1.useMemo(() => (react_1.default.createElement(core_1.ComponentChrome, { config: config, hasContent: card }, card && react_1.default.createElement(adaptive_card_embed_component_1.AdaptiveCardEmbed, { card: card }))), [card]);
};
exports.AdaptiveCard = AdaptiveCard;


/***/ }),

/***/ "./src/content/adaptive-card/index.ts":
/*!********************************************!*\
  !*** ./src/content/adaptive-card/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./adaptive-card.component */ "./src/content/adaptive-card/adaptive-card.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./adaptive-card-embed.component */ "./src/content/adaptive-card/adaptive-card-embed.component.tsx"), exports);


/***/ }),

/***/ "./src/content/bookmark-list/bookmark-list.component.tsx":
/*!***************************************************************!*\
  !*** ./src/content/bookmark-list/bookmark-list.component.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BookmarkList = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const cards_1 = __webpack_require__(/*! ../cards */ "./src/content/cards/index.ts");
const BookmarkList = ({ config, config: { props: { refinerNames } = {} } }) => {
    const { provides, consumes, responsive, children = [] } = config;
    const render = smarthub_common_1.useRender();
    const refinersProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'refiners');
    const sortOptionsProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'sort-options');
    const setRefiners = smarthub_common_1.useSetSharedState(refinersProvider);
    const setSortOptions = smarthub_common_1.useSetSharedState(sortOptionsProvider);
    const [dataSet, setDataSet] = react_1.useState({ items: null });
    const sort = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'sort-option'));
    const refineBy = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'refine-by'));
    const group = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'group'));
    const [query] = smarthub_common_1.useBookmarks();
    const fetchData = (filters, items, next) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const { items: nextItems, refiners, sortOptions, continuation } = yield query(filters, refinerNames, next);
            setSortOptions(sortOptions);
            setRefiners(refiners);
            setDataSet({
                items: [...(items !== null && items !== void 0 ? items : []), ...(nextItems !== null && nextItems !== void 0 ? nextItems : [])],
                continuation
            });
        }
        catch (ex) {
            setDataSet({ error: ex, items: null });
        }
    });
    const loadMore = react_1.useCallback(() => {
        setDataSet(Object.assign(Object.assign({}, dataSet), { loading: true }));
        return fetchData({
            sort,
            filters: Object.assign(Object.assign({}, refineBy), { group })
        }, dataSet.items, dataSet.continuation);
    }, [sort, refineBy, group]);
    react_1.useEffect(() => {
        fetchData({
            sort,
            filters: Object.assign(Object.assign({}, refineBy), { group })
        });
    }, [sort, refineBy, group, config]);
    const renderCard = react_1.useCallback((data) => {
        const card = children.find(c => c.$id == 'card');
        return render(card, data, cards_1.ThumbCard)();
    }, [children]);
    return react_1.useMemo(() => {
        const { error, items, continuation } = dataSet;
        return (react_1.default.createElement(core_1.ComponentChrome, { config: config, hasContent: !items || items.length > 0, error: error },
            react_1.default.createElement(core_1.CardListBase, { items: items, renderCard: renderCard, paging: continuation != null, onLoadMore: loadMore, responsive: responsive })));
    }, [dataSet, config]);
};
exports.BookmarkList = BookmarkList;


/***/ }),

/***/ "./src/content/bookmark-list/index.ts":
/*!********************************************!*\
  !*** ./src/content/bookmark-list/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./bookmark-list.component */ "./src/content/bookmark-list/bookmark-list.component.tsx"), exports);


/***/ }),

/***/ "./src/content/button-grid/button-grid-item.component.tsx":
/*!****************************************************************!*\
  !*** ./src/content/button-grid/button-grid-item.component.tsx ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ButtonGridItem = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (({ theme: { spacing, sizes } }) => ({
    buttonStyles: {
        root: {
            minWidth: sizes.normal,
            padding: `0 ${spacing.small}`,
            border: "0",
            width: "100%"
        }
    }
}));
const ButtonGridItem = ({ buttonProps, selected, onButtonClick }) => {
    const { buttonStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const onClick = react_1.useCallback((ev) => {
        if (onButtonClick)
            onButtonClick(buttonProps.uniqueId, buttonProps.data);
        if (buttonProps.onClick)
            buttonProps.onClick(ev);
    }, [buttonProps, onButtonClick]);
    const styles = react_1.useMemo(() => (Object.assign(Object.assign({}, buttonProps.styles), buttonStyles)), [buttonProps]);
    return react_1.default.createElement(react_2.StackItem, { grow: 1, shrink: 1 }, selected
        ? react_1.default.createElement(react_2.PrimaryButton, Object.assign({}, buttonProps, { styles: styles, onClick: onClick }))
        : react_1.default.createElement(react_2.DefaultButton, Object.assign({}, buttonProps, { styles: styles, onClick: onClick })));
};
exports.ButtonGridItem = ButtonGridItem;


/***/ }),

/***/ "./src/content/button-grid/button-grid.component.tsx":
/*!***********************************************************!*\
  !*** ./src/content/button-grid/button-grid.component.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ButtonGrid = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const button_grid_item_component_1 = __webpack_require__(/*! ./button-grid-item.component */ "./src/content/button-grid/button-grid-item.component.tsx");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (({ theme: { spacing } }) => ({
    stackStyles: {
        inner: {
            gap: spacing.medium
        }
    }
}));
const ButtonGrid = ({ selectedId, buttons, ariaLabel, title, horizontal, horizontalAlign, verticalAlign, fill, wrap, onButtonClick }) => {
    const { stackStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    return (react_1.default.createElement(react_2.Stack, { styles: stackStyles, horizontal: horizontal == null ? true : horizontal, wrap: wrap == null ? true : wrap, horizontalAlign: horizontalAlign == null ? 'start' : horizontalAlign, verticalAlign: verticalAlign == null ? 'start' : verticalAlign, verticalFill: fill == null ? false : fill, title: title, "aria-label": ariaLabel }, buttons.map(props => react_1.default.createElement(button_grid_item_component_1.ButtonGridItem, { key: props.uniqueId, buttonProps: props, selected: props.uniqueId == selectedId, onButtonClick: onButtonClick }))));
};
exports.ButtonGrid = ButtonGrid;


/***/ }),

/***/ "./src/content/button-grid/index.ts":
/*!******************************************!*\
  !*** ./src/content/button-grid/index.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./button-grid-item.component */ "./src/content/button-grid/button-grid-item.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./button-grid.component */ "./src/content/button-grid/button-grid.component.tsx"), exports);


/***/ }),

/***/ "./src/content/calendar/calender-activity.component.tsx":
/*!**************************************************************!*\
  !*** ./src/content/calendar/calender-activity.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CalendarActivity = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const cards_1 = __webpack_require__(/*! ../cards */ "./src/content/cards/index.ts");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const duration_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/duration */ "dayjs/plugin/duration"));
dayjs_1.default.extend(duration_1.default);
const CalendarActivity = ({ config }) => {
    const { $id, query, consumes, responsive, props: { include } = { include: { allDay: true, events: true } } } = config;
    const fetch = smarthub_common_1.useFetch();
    const transform = smarthub_common_1.useTransform();
    const [dataSet, setDataSet] = react_1.useState({ items: null });
    const [meetingItems, setMeetingItems] = react_1.useState([]);
    const [filters, setFilters] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setFilters(consumes), [consumes]);
    const fetchData = (filters, { continuation: next } = {}) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const requiresParam = consumes === null || consumes === void 0 ? void 0 : consumes.some(({ required, name }) => required && (filters === null || filters === void 0 ? void 0 : filters[name]) == null);
            if (requiresParam)
                return;
            const { data, continuation } = yield fetch(query, filters, next);
            setDataSet({
                items: transform(models_1.ICalendarSchema, data),
                continuation
            });
        }
        catch (ex) {
            setDataSet({ error: ex, items: null });
        }
    });
    const setNextMeetingTime = react_1.useCallback(() => {
        var _a, _b;
        const finalItems = [];
        (_b = (_a = dataSet.items) === null || _a === void 0 ? void 0 : _a.meetings) === null || _b === void 0 ? void 0 : _b.map((item, i) => {
            var _a, _b, _c, _d;
            if ((_a = dataSet.items) === null || _a === void 0 ? void 0 : _a.meetings[i + 1]) {
                const durationDiff = dayjs_1.default((_b = dataSet.items) === null || _b === void 0 ? void 0 : _b.meetings[i + 1].start.dateTime).diff(dayjs_1.default((_c = dataSet.items) === null || _c === void 0 ? void 0 : _c.meetings[i].end.dateTime));
                item.nextMeetingTime = Math.sign(durationDiff) == 1 ? (_d = dataSet.items) === null || _d === void 0 ? void 0 : _d.meetings[i + 1].start.dateTime : null;
            }
            finalItems.push(item);
        });
        const allDayItems = finalItems === null || finalItems === void 0 ? void 0 : finalItems.filter(meeting => meeting.isAllDay);
        const eventsItems = finalItems === null || finalItems === void 0 ? void 0 : finalItems.filter(meeting => !meeting.isAllDay);
        const orderedMeetings = [...new Set([
                ...(include.allDay ? allDayItems : []),
                ...(include.events ? eventsItems : [])
            ])];
        setMeetingItems(orderedMeetings);
    }, [dataSet.items]);
    react_1.useEffect(() => {
        setNextMeetingTime();
    }, [dataSet]);
    react_1.useEffect(() => {
        fetchData(filters);
    }, [filters, fetch, config]);
    const renderCard = react_1.useCallback((data) => {
        return react_1.default.createElement(cards_1.EventCard, { config: config, data: data });
    }, [config]);
    return react_1.useMemo(() => (react_1.default.createElement(core_1.ComponentChrome, { config: config, hasContent: !meetingItems || meetingItems.length > 0 },
        react_1.default.createElement(core_1.CardListBase, { items: meetingItems, renderCard: renderCard, paging: dataSet.continuation != null, responsive: responsive }))), [dataSet, meetingItems]);
};
exports.CalendarActivity = CalendarActivity;


/***/ }),

/***/ "./src/content/calendar/index.ts":
/*!***************************************!*\
  !*** ./src/content/calendar/index.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./calender-activity.component */ "./src/content/calendar/calender-activity.component.tsx"), exports);


/***/ }),

/***/ "./src/content/card-list/card-list.component.tsx":
/*!*******************************************************!*\
  !*** ./src/content/card-list/card-list.component.tsx ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardList = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const cards_1 = __webpack_require__(/*! ../cards */ "./src/content/cards/index.ts");
const react_2 = __webpack_require__(/*! react */ "react");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const CardList = ({ config }) => {
    const { $id, query, provides, consumes, responsive, children = [], props: { noResults } = {}, coachmarks, chrome } = config;
    const refinersProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'refiners');
    const sortOptionsProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'sort-options');
    const fetch = smarthub_common_1.useFetch();
    const render = smarthub_common_1.useRender();
    const setRefiners = smarthub_common_1.useSetSharedState(refinersProvider);
    const setSortOptions = smarthub_common_1.useSetSharedState(sortOptionsProvider);
    const [dataSet, setDataSet] = react_2.useState({ items: null });
    const [filters, setFilters] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setFilters(consumes), [consumes]);
    const fetchData = (filters, { items, continuation: next } = {}) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const requiresParam = consumes === null || consumes === void 0 ? void 0 : consumes.some(({ required, name }) => required && (filters === null || filters === void 0 ? void 0 : filters[name]) == null);
            if (requiresParam)
                return;
            const { data, continuation, refiners, sortOptions } = yield fetch(query, filters, next);
            setDataSet({
                items: [
                    ...(items !== null && items !== void 0 ? items : []),
                    ...(data !== null && data !== void 0 ? data : [])
                ],
                continuation
            });
            if (sortOptionsProvider)
                setSortOptions(sortOptions);
            if (refinersProvider)
                setRefiners(refiners);
        }
        catch (ex) {
            setDataSet({ error: ex, items: null });
        }
    });
    const loadMore = react_1.useCallback(() => {
        return fetchData(filters, dataSet);
    }, [dataSet]);
    react_1.useEffect(() => {
        fetchData(filters);
    }, [filters, fetch, config]);
    const renderCard = react_1.useCallback((data) => {
        const card = children.find(c => c.$id == 'card');
        return render(card, data, cards_1.ThumbCard)();
    }, [children]);
    return react_1.useMemo(() => {
        const { error, items, continuation } = dataSet;
        return (react_1.default.createElement(core_1.ComponentChrome, { hasContent: !items || (items === null || items === void 0 ? void 0 : items.length) > 0, config: config, error: error }, (items === null || items === void 0 ? void 0 : items.length) > 0 && react_1.default.createElement(core_1.CardListBase, { items: items, renderCard: renderCard, coachmarks: coachmarks, paging: continuation != null, onLoadMore: loadMore, responsive: responsive, noResults: noResults, chrome: chrome })));
    }, [dataSet, config]);
};
exports.CardList = CardList;


/***/ }),

/***/ "./src/content/card-list/index.ts":
/*!****************************************!*\
  !*** ./src/content/card-list/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./card-list.component */ "./src/content/card-list/card-list.component.tsx"), exports);


/***/ }),

/***/ "./src/content/cards/card.style.ts":
/*!*****************************************!*\
  !*** ./src/content/cards/card.style.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCardStyle = void 0;
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
exports.useCardStyle = react_jss_1.createUseStyles(({ palette, spacing }) => ({
    card: ({ scale, offset, fill } = {}) => ({
        paddingTop: scale > 0
            ? (offset === null || offset === void 0 ? void 0 : offset.length) > 0
                ? `calc(${scale}% - ${spacing[offset]})`
                : `${scale}%`
            : undefined,
        boxShadow: "rgb(0 0 0 / 13%) 0px 1.6px 3.6px 0px, rgb(0 0 0 / 11%) 0px 0.3px 0.9px 0px",
        borderRadius: spacing.small,
        overflow: "hidden",
        position: "relative",
        minWidth: "0",
        maxWidth: "none",
        width: "100%",
        height: !fill || scale > 0
            ? "auto"
            : "100%",
        display: "flex",
        flexDirection: 'column',
        backgroundColor: palette.neutralEmpty,
        color: palette.neutralEmptyOn,
        transitionProperty: "box-shadow, transform",
        transitionDuration: "200ms",
        transitionTimingFunction: "ease-in",
        ["&:focus"]: {
            boxShadow: "rgb(0 0 0 / 23%) 0px 2.4px 4.8px 0px, rgb(0 0 0 / 21%) 0px 0.6px 1.8px 0px",
        },
        ["&:hover"]: {
            boxShadow: "rgb(0 0 0 / 23%) 0px 2.4px 4.8px 0px, rgb(0 0 0 / 21%) 0px 0.6px 1.8px 0px",
        }
    })
}));


/***/ }),

/***/ "./src/content/cards/comment-card/comment-card-styles.ts":
/*!***************************************************************!*\
  !*** ./src/content/cards/comment-card/comment-card-styles.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.activityStyles = void 0;
exports.activityStyles = (({ theme: { palette, spacing, fonts } }) => ({
    root: {
        marginBottom: spacing.medium
    },
    commentText: Object.assign(Object.assign({}, fonts.normal), { color: palette.neutralEmptyOn }),
    activityText: Object.assign(Object.assign({}, fonts.normal), { display: 'block', alignSelf: 'center', color: palette.neutralEmptyOn }),
    activityTypeIcon: {
        height: "100%",
    },
    timeStamp: {
        color: palette.neutralEmptyOn
    }
}));


/***/ }),

/***/ "./src/content/cards/comment-card/comment-card.component.tsx":
/*!*******************************************************************!*\
  !*** ./src/content/cards/comment-card/comment-card.component.tsx ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CommentCard = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const models_1 = __webpack_require__(/*! ../../../models */ "./src/models/index.ts");
const page_helper_1 = __webpack_require__(/*! ../../../content/page/page-metadata.component/page.helper */ "./src/content/page/page-metadata.component/page.helper.ts");
const page_comment_form_component_1 = __webpack_require__(/*! ../../../content/page/page-comment-form.component */ "./src/content/page/page-comment-form.component.tsx");
const comment_card_styles_1 = __webpack_require__(/*! ./comment-card-styles */ "./src/content/cards/comment-card/comment-card-styles.ts");
const CommentCard = ({ config, config: { consumes, provides, query, props: { localisedText, maxLength } = {} }, data: { data } }) => {
    const transform = smarthub_common_1.useTransform();
    const styles = smarthub_common_1.useFluentStylesWithProps(comment_card_styles_1.activityStyles);
    const profile = smarthub_common_1.useProfile();
    const handleCommand = smarthub_common_1.useHandleCommand();
    const [comment, setComment] = react_1.useState(null);
    const [mode, setMode] = react_1.useState(null);
    const setRefreshKey = smarthub_common_1.useSetSharedState(provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'refreshKey'));
    const page = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"));
    react_1.useEffect(() => {
        const card = transform(models_1.ICommentSchema, data);
        setComment(card);
    }, [data]);
    const handleOnSuccess = react_1.useCallback((data) => {
        setMode(null);
        setRefreshKey((new Date()).getTime());
    }, []);
    const renderDescription = (props, render) => {
        var _a;
        const { comment, profile } = props;
        const { $id, message, author: { id: authorId } = {} } = comment;
        const isOwner = authorId && (profile === null || profile === void 0 ? void 0 : profile.$id) === authorId;
        return react_1.default.createElement(react_2.Stack, { horizontal: true },
            isOwner && !((_a = page === null || page === void 0 ? void 0 : page.comments) === null || _a === void 0 ? void 0 : _a.closed) && react_1.default.createElement("div", null,
                react_1.default.createElement(react_2.IconButton, { ariaLabel: "edit the comment", onClick: () => setMode('update') },
                    react_1.default.createElement(react_2.Icon, { iconName: "Edit" })),
                react_1.default.createElement(react_2.IconButton, { ariaLabel: "delete the comment", onClick: () => setMode('delete') },
                    react_1.default.createElement(react_2.Icon, { iconName: "Delete" })),
                mode &&
                    react_1.default.createElement(page_comment_form_component_1.PageCommentForm, { id: $id, mode: mode, message: message, query: query, maxLength: maxLength, localizedText: localisedText, params: { page }, onSuccess: data => handleOnSuccess(data) })),
            render(props));
    };
    return react_1.useMemo(() => {
        if (!comment)
            return null;
        const { $id, message, author: { name, action, image } = {}, created } = comment;
        const profileLink = react_1.default.createElement(react_2.Link, { onClick: () => handleCommand(action), title: name, "aria-label": name }, name);
        const content = react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: decodeURIComponent(message) } });
        return react_1.default.createElement(core_1.ComponentChrome, { config: config },
            react_1.default.createElement(react_2.ActivityItem, { key: `${$id}`, styles: styles, onRenderActivityDescription: (props, render) => renderDescription(Object.assign(Object.assign({}, props), { profile, comment }), render), comments: profileLink, activityDescription: content, timeStamp: created, activityPersonas: [{
                        imageUrl: image,
                        text: name,
                        imageInitials: page_helper_1.getInitials(name),
                        onClick: () => handleCommand(action)
                    }] }));
    }, [comment, config, mode, data, styles, profile]);
};
exports.CommentCard = CommentCard;


/***/ }),

/***/ "./src/content/cards/comment-card/index.ts":
/*!*************************************************!*\
  !*** ./src/content/cards/comment-card/index.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./comment-card.component */ "./src/content/cards/comment-card/comment-card.component.tsx"), exports);


/***/ }),

/***/ "./src/content/cards/event-card/event-card.component.tsx":
/*!***************************************************************!*\
  !*** ./src/content/cards/event-card/event-card.component.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EventCard = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
//TODO Use event interface and transform
const useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing }) => ({
    card: Object.assign(Object.assign({}, fonts.normal), { borderLeft: `${spacing.smallPlus} solid ${palette.primary}`, padding: spacing.smallPlus, backgroundColor: palette.neutralFullOn, borderRadius: spacing.small, boxShadow: "rgb(0 0 0 / 13%) 0px 1.6px 3.6px 0px, rgb(0 0 0 / 11%) 0px 0.3px 0.9px 0px" }),
    meetingInfo: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: spacing.smallPlus,
    },
    freeTime: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: palette.neutral,
        margin: `${spacing.xLarge} auto ${spacing.medium}`,
        padding: `${spacing.smallPlus} ${spacing.xLarge}`,
        borderRadius: '100%',
    },
    meetingContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    meetingTitle: Object.assign(Object.assign({}, fonts.mediumPlus), { display: "flex", marginTop: spacing.medium })
}));
const fluentStyles = (({ theme: { fonts, spacing } }) => ({
    title: {
        root: Object.assign(Object.assign({}, fonts.normalPlus), { display: "flex" })
    },
    calendarIcon: {
        root: {
            position: "relative",
            top: spacing.small,
            marginRight: spacing.smallPlus,
        }
    }
}));
const EventCard = ({ config, data: { index = 0, data } = { data: null, index: 0 } }) => {
    const calendarStyles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const styles = useStyles();
    const { cardLabel, allDay, meetingAttendeeAria, join, joinMeeting, meetingFreeFor, meetingFreeFrom } = smarthub_common_1.useLocalizeConfig();
    const [persona, setPersona] = react_1.useState([]);
    react_1.useEffect(() => {
        const filterNames = (data === null || data === void 0 ? void 0 : data.attendees.map(e => e.emailAddress.name)) || [];
        const personaArr = [];
        filterNames === null || filterNames === void 0 ? void 0 : filterNames.forEach(person => {
            personaArr.push({ 'personaName': person });
        });
        setPersona(personaArr);
    }, [data === null || data === void 0 ? void 0 : data.attendees]);
    return react_1.useMemo(() => (data
        ? react_1.default.createElement(core_1.ComponentChrome, { config: config, "aria-label": `${data === null || data === void 0 ? void 0 : data.subject}, ${cardLabel}`, focusable: true, enableCoachmark: index === 0 },
            react_1.default.createElement("div", { className: styles.meetingContainer },
                react_1.default.createElement("div", { className: styles.card },
                    react_1.default.createElement("div", { className: styles.meetingTitle },
                        (data === null || data === void 0 ? void 0 : data.type) != "occurrence" ? react_1.default.createElement(react_2.Icon, { styles: calendarStyles.calendarIcon, iconName: "Calendar" })
                            : react_1.default.createElement(react_2.Icon, { styles: calendarStyles.calendarIcon, iconName: "RecurringEvent" }),
                        react_1.default.createElement(utilities_1.TextOverflow, { lines: 2, text: data === null || data === void 0 ? void 0 : data.subject },
                            react_1.default.createElement(react_2.Link, { href: data.webLink, target: "_blank" }, data === null || data === void 0 ? void 0 : data.subject))),
                    react_1.default.createElement(utilities_1.TextOverflow, { lines: 1, text: data.isAllDay
                            ? allDay
                            : `${smarthub_common_1.formatDateTime([data.start.dateTime, 'HH:mm'])} - ${smarthub_common_1.timeDifference(data.start.dateTime, data.end.dateTime)}` }),
                    react_1.default.createElement("div", { className: styles.meetingInfo },
                        react_1.default.createElement(react_2.Facepile, { personaSize: react_2.PersonaSize.size24, personas: persona, maxDisplayablePersonas: 6, ariaLabel: meetingAttendeeAria }),
                        data.isOnlineMeeting && react_1.default.createElement(react_2.DefaultButton, { title: joinMeeting, text: join, onClick: () => window.open(data.onlineMeeting.joinUrl, '_blank') }))),
                (data === null || data === void 0 ? void 0 : data.nextMeetingTime) && react_1.default.createElement("div", { className: styles.freeTime },
                    meetingFreeFor,
                    " ",
                    smarthub_common_1.timeDifference(data.end.dateTime, data.nextMeetingTime),
                    " ",
                    meetingFreeFrom,
                    " ",
                    smarthub_common_1.formatDateTime([data.end.dateTime, 'HH:mm']),
                    " ")))
        : null), [data, persona, calendarStyles]);
};
exports.EventCard = EventCard;


/***/ }),

/***/ "./src/content/cards/event-card/index.ts":
/*!***********************************************!*\
  !*** ./src/content/cards/event-card/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./event-card.component */ "./src/content/cards/event-card/event-card.component.tsx"), exports);


/***/ }),

/***/ "./src/content/cards/index.ts":
/*!************************************!*\
  !*** ./src/content/cards/index.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./thumb-card */ "./src/content/cards/thumb-card/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./tile */ "./src/content/cards/tile/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./slide */ "./src/content/cards/slide/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./person-card */ "./src/content/cards/person-card/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./link-tile */ "./src/content/cards/link-tile/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./event-card */ "./src/content/cards/event-card/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./comment-card */ "./src/content/cards/comment-card/index.ts"), exports);


/***/ }),

/***/ "./src/content/cards/link-tile/index.ts":
/*!**********************************************!*\
  !*** ./src/content/cards/link-tile/index.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./link-tile.component */ "./src/content/cards/link-tile/link-tile.component.tsx"), exports);


/***/ }),

/***/ "./src/content/cards/link-tile/link-tile.component.tsx":
/*!*************************************************************!*\
  !*** ./src/content/cards/link-tile/link-tile.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LinkTile = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const models_1 = __webpack_require__(/*! ../../../models */ "./src/models/index.ts");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const card_style_1 = __webpack_require__(/*! ../card.style */ "./src/content/cards/card.style.ts");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const fluentStyles = (({ config, theme: { palette, spacing, sizes } }) => {
    var _a, _b, _c, _d;
    return ({
        stack: {
            root: {
                flexDirection: "column-reverse",
            }
        },
        tile: {
            root: {
                width: "100%",
                height: "100%",
                position: "absolute",
                overflow: "hidden",
            }
        },
        content: {
            root: {
                padding: spacing.medium,
                overflow: "hidden",
                position: "absolute",
                alignItems: "center",
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                height: "100%",
                justifyContent: "center",
                backgroundColor: palette[config === null || config === void 0 ? void 0 : config.palette]
            }
        },
        title: {
            root: {
                maxHeight: "100%",
                color: palette[(_a = config === null || config === void 0 ? void 0 : config.textPalette) !== null && _a !== void 0 ? _a : `${config === null || config === void 0 ? void 0 : config.palette}On`],
                fontWeight: react_2.FontWeights.semibold,
                margin: "auto 0",
                display: "-webkit-box",
                lineClamp: "4",
                boxOrient: "vertical",
                textOverflow: "ellipsis",
                overflow: "hidden",
            }
        },
        description: {
            root: {
                color: palette[(_b = config === null || config === void 0 ? void 0 : config.textPalette) !== null && _b !== void 0 ? _b : `${config === null || config === void 0 ? void 0 : config.palette}On`],
                fontWeight: react_2.FontWeights.regular
            }
        },
        promoStar: {
            root: {
                color: palette[(_c = config === null || config === void 0 ? void 0 : config.textPalette) !== null && _c !== void 0 ? _c : `${config === null || config === void 0 ? void 0 : config.palette}On`],
                textAlign: "center",
                position: "absolute",
                width: sizes.smallPlus,
                top: "0",
                left: "0",
                opacity: "0.6"
            }
        },
        bookmark: {
            root: {
                color: palette[(_d = config === null || config === void 0 ? void 0 : config.textPalette) !== null && _d !== void 0 ? _d : `${config === null || config === void 0 ? void 0 : config.palette}On`],
                position: "absolute",
                width: sizes.normal,
                bottom: "0",
                right: "0"
            }
        }
    });
});
const linkStyles = {
    root: {
        margin: "auto 0"
    }
};
const cardConfig = {
    scale: 60
};
const LinkTile = ({ config, config: { props: { defaultTheme, themes, showDescription }, responsive, coachmarks }, data: { data, index = 0 } = { data: null, index: 0 } }) => {
    const { cardLabel, invalidSchema: message, linkTileTitle, linkTileAria } = smarthub_common_1.useLocalizeConfig();
    const transform = smarthub_common_1.useTransform();
    const [{ card, theme }, setState] = react_1.useState({ card: null, theme: null });
    react_1.useEffect(() => {
        var _a;
        const card = transform(models_1.ILinkTileSchema, data);
        const theme = (_a = themes === null || themes === void 0 ? void 0 : themes.find(t => t.name == (card === null || card === void 0 ? void 0 : card.theme))) !== null && _a !== void 0 ? _a : defaultTheme;
        setState({ card, theme });
    }, [data]);
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles, theme, responsive);
    const cardStyle = card_style_1.useCardStyle(cardConfig);
    const focusStyle = smarthub_common_1.useFocusStyles();
    const bookmarkCoachmark = index === 0
        ? coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(coachmark => coachmark.target === 'bookmark-button') : null;
    const error = card && card.$schema != models_1.ILinkTileSchema
        ? {
            message
        }
        : null;
    return react_1.useMemo(() => {
        var _a;
        return card
            ? react_1.default.createElement(core_1.ComponentChrome, { config: config, "aria-label": `${card === null || card === void 0 ? void 0 : card.title}, ${cardLabel}`, focusable: true, enableCoachmark: index === 0, error: error },
                react_1.default.createElement("div", { className: cardStyle.card },
                    react_1.default.createElement(react_2.Stack, { styles: styles.stack },
                        react_1.default.createElement(react_2.StackItem, { styles: styles.content },
                            card.promoted === true && react_1.default.createElement(react_2.Icon, { styles: styles.promoStar, iconName: "StarburstSolid" }),
                            react_1.default.createElement(utilities_1.ActionLink, { colour: `${theme === null || theme === void 0 ? void 0 : theme.palette}On`, styles: linkStyles, "aria-label": `${linkTileAria} ${card.title}`, title: `${linkTileTitle} ${card.title}`, action: card.action },
                                react_1.default.createElement(react_2.Text, { variant: "mediumPlus", styles: styles.title }, card === null || card === void 0 ? void 0 : card.title)),
                            showDescription && ((_a = card === null || card === void 0 ? void 0 : card.description) === null || _a === void 0 ? void 0 : _a.length) > 0 && react_1.default.createElement(react_2.Text, { variant: "medium", styles: styles.description }, card.description),
                            (card === null || card === void 0 ? void 0 : card.bookmark) && react_1.default.createElement(react_2.Text, { styles: styles.bookmark }, bookmarkCoachmark != null
                                ? react_1.default.createElement(utilities_1.CoachMarkWrapper, Object.assign({}, bookmarkCoachmark),
                                    react_1.default.createElement(utilities_1.Bookmark, { title: card.title, bookmarkInfo: card.bookmark }))
                                : react_1.default.createElement(utilities_1.Bookmark, { title: card.title, bookmarkInfo: card.bookmark }))))))
            : react_1.default.createElement(react_1.default.Fragment, null);
    }, [styles, card, focusStyle.focus, cardStyle.card, bookmarkCoachmark]);
};
exports.LinkTile = LinkTile;


/***/ }),

/***/ "./src/content/cards/person-card/index.ts":
/*!************************************************!*\
  !*** ./src/content/cards/person-card/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./person-card */ "./src/content/cards/person-card/person-card.tsx"), exports);


/***/ }),

/***/ "./src/content/cards/person-card/person-card.tsx":
/*!*******************************************************!*\
  !*** ./src/content/cards/person-card/person-card.tsx ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PersonCard = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const card_style_1 = __webpack_require__(/*! ../card.style */ "./src/content/cards/card.style.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const fluentStyles = (({ theme: { spacing } }) => ({
    coin: {
        image: {
            marginRight: 0,
            cursor: 'pointer',
        }
    },
    persona: {
        root: {
            flexDirection: "column",
            height: 'auto',
            margin: spacing.medium
        },
        details: {
            marginTop: spacing.xxLarge,
            textAlign: "center",
            padding: 0
        },
    }
}));
const useBookMarkStyles = react_jss_1.createUseStyles({
    bookmark: {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "-25px"
    }
});
const getCustomPrimaryTextRenderer = (action) => {
    return (props) => {
        return (react_1.default.createElement(utilities_1.ActionLink, { "aria-label": props["aria-label"], title: props.title, action: action },
            react_1.default.createElement(utilities_1.TextOverflow, { lines: 2, text: props.text, font: smarthub_common_1.SizeKeys.mediumPlus, showTooltip: true })));
    };
};
const PersonCard = ({ config, data: { data, index = 0 } = { index: 0, data: null }, config: { $id, query, consumes, coachmarks } }) => {
    const transform = smarthub_common_1.useTransform();
    const fetch = smarthub_common_1.useFetch();
    const [card, setCard] = react_1.useState(null);
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const bookmarkStyles = useBookMarkStyles();
    const cardStyle = card_style_1.useCardStyle();
    const focusStyle = smarthub_common_1.useFocusStyles();
    const openAction = smarthub_common_1.useHandleCommand();
    const { invalidSchema: message, personaLinkAria, personaLinkTitle, cardLabel } = smarthub_common_1.useLocalizeConfig();
    const [filters, setFilters] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setFilters(consumes), [consumes]);
    const bookmarkCoachmark = index === 0
        ? coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(coachmark => coachmark.target === 'bookmark-button') : null;
    const onClick = react_1.useCallback(() => {
        openAction(card.action);
    }, [card]);
    const error = card && card.$schema != smarthub_common_1.IPersonSchema
        ? {
            message
        }
        : null;
    react_1.useEffect(() => {
        const fetchData = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            try {
                const result = yield fetch(query, filters);
                const data = transform(smarthub_common_1.IPersonSchema, result.data);
                setCard(data);
            }
            catch (ex) {
                smarthub_common_1.Logger.error("Failed to fetch person data", false, { ex });
            }
        });
        if (query)
            fetchData();
        else {
            const item = transform(smarthub_common_1.IPersonSchema, data);
            setCard(item);
        }
    }, [filters, config, data, fetch]);
    return react_1.useMemo(() => {
        const props = card
            ? {
                coinProps: {
                    styles: styles.coin,
                    onClick: onClick,
                },
                styles: styles.persona,
                size: react_2.PersonaSize.size100,
                text: card.name,
                secondaryText: card.jobTitle,
                tertiaryText: card.department,
                imageUrl: card.image,
                imageAlt: card.name,
                title: `${personaLinkTitle} ${card.name}`,
                "aria-label": `${personaLinkAria} ${card.name}`,
                onRenderPrimaryText: getCustomPrimaryTextRenderer(card.action)
            }
            : null;
        return card
            ? react_1.default.createElement(core_1.ComponentChrome, { config: config, "aria-label": `${card === null || card === void 0 ? void 0 : card.name}, ${cardLabel}`, focusable: true, enableCoachmark: index === 0, error: error },
                react_1.default.createElement("div", { className: cardStyle.card },
                    react_1.default.createElement(react_2.Stack, null,
                        react_1.default.createElement(react_2.StackItem, null,
                            react_1.default.createElement(react_2.Persona, Object.assign({}, props)),
                            card.bookmark && react_1.default.createElement("div", { className: bookmarkStyles.bookmark }, bookmarkCoachmark != null
                                ? react_1.default.createElement(utilities_1.CoachMarkWrapper, Object.assign({}, bookmarkCoachmark),
                                    react_1.default.createElement(utilities_1.Bookmark, { title: card === null || card === void 0 ? void 0 : card.name, bookmarkInfo: card.bookmark }))
                                : react_1.default.createElement(utilities_1.Bookmark, { title: card === null || card === void 0 ? void 0 : card.name, bookmarkInfo: card.bookmark }))))))
            : null;
    }, [styles, card, focusStyle.focus, cardStyle.card]);
};
exports.PersonCard = PersonCard;


/***/ }),

/***/ "./src/content/cards/slide/index.ts":
/*!******************************************!*\
  !*** ./src/content/cards/slide/index.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./slide.component */ "./src/content/cards/slide/slide.component.tsx"), exports);


/***/ }),

/***/ "./src/content/cards/slide/slide.component.tsx":
/*!*****************************************************!*\
  !*** ./src/content/cards/slide/slide.component.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Slide = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const models_1 = __webpack_require__(/*! ../../../models */ "./src/models/index.ts");
const ms_stream_1 = __webpack_require__(/*! ../../ms-stream */ "./src/content/ms-stream/index.ts");
const card_style_1 = __webpack_require__(/*! ../card.style */ "./src/content/cards/card.style.ts");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const fluentStyles = (({ theme: { palette, type, spacing } }) => ({
    stack: {
        root: {
            flexDirection: "column-reverse",
        }
    },
    tile: {
        root: {
            width: "100%",
            height: "100%",
            position: "absolute",
            overflow: "hidden"
        }
    },
    content: {
        root: Object.assign(Object.assign({ padding: spacing.medium, overflow: "hidden", position: "absolute", width: "100%", boxSizing: "border-box", display: "flex", flexDirection: "column", justifyContent: "flex-end", backgroundColor: palette.filmPlus1, backdropFilter: `blur(${spacing.small})` }, react_2.AnimationStyles.fadeIn500), { animationDelay: "2s" })
    },
    image: {
        root: {
            position: "relative",
            height: "100%"
        },
        image: {
            minWidth: "100%",
            minHeight: "100%",
            height: "100%",
            width: "auto",
            filter: type == "dark"
                ? "contrast(1.1) saturate(1.3) brightness(0.7)"
                : "contrast(1.1) saturate(1.3) brightness(0.9)",
        }
    }
}));
const cardConfig = {
    scale: 60
};
const Slide = ({ config, data: { data, index = 0 } = { index: 0, data: null } }) => {
    const transform = smarthub_common_1.useTransform();
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const cardStyle = card_style_1.useCardStyle(cardConfig);
    const [card, setCard] = react_1.useState(null);
    const { cardLabel, invalidSchema: message, slideTitle } = smarthub_common_1.useLocalizeConfig();
    react_1.useEffect(() => {
        const card = transform(models_1.ISlideSchema, data);
        setCard(card);
    }, [data]);
    const error = card && card.$schema != models_1.ISlideSchema
        ? {
            message
        }
        : null;
    return react_1.useMemo(() => {
        var _a, _b, _c;
        const linkTitle = (card === null || card === void 0 ? void 0 : card.title) ? `${slideTitle}, ${card.title}` : '';
        return (card
            ? react_1.default.createElement(core_1.ComponentChrome, { config: config, "aria-label": `${card === null || card === void 0 ? void 0 : card.title}, ${cardLabel}`, focusable: true, enableCoachmark: index === 0, error: error },
                react_1.default.createElement("div", { className: cardStyle.card }, ((_a = card.embed) === null || _a === void 0 ? void 0 : _a.type) == 'video'
                    ? react_1.default.createElement(ms_stream_1.StreamEmbed, { uri: card.embed.uri })
                    : react_1.default.createElement(react_2.Stack, { styles: styles.stack },
                        react_1.default.createElement(react_2.StackItem, { styles: styles.tile },
                            react_1.default.createElement(react_2.Image, { src: card.image.uri, alt: card.description, styles: styles.image })),
                        react_1.default.createElement(react_2.StackItem, { styles: styles.content },
                            card.action ?
                                react_1.default.createElement(utilities_1.ActionLink, { "aria-label": card.label, title: linkTitle, action: card.action, colour: smarthub_common_1.PaletteKeys.filmPlus1On },
                                    react_1.default.createElement(utilities_1.TextOverflow, { lines: 2, text: card.title, font: smarthub_common_1.SizeKeys.mediumPlus, colour: smarthub_common_1.PaletteKeys.filmPlus1On, showTooltip: true, fixed: true }))
                                :
                                    react_1.default.createElement(utilities_1.TextOverflow, { lines: 2, text: card.title, font: smarthub_common_1.SizeKeys.superLarge, colour: smarthub_common_1.PaletteKeys.filmPlus1On, showTooltip: true }),
                            ((_b = card.subTitle) === null || _b === void 0 ? void 0 : _b.length) > 0 && react_1.default.createElement(utilities_1.TextOverflow, { lines: 1, text: card.subTitle, font: smarthub_common_1.SizeKeys.medium, colour: smarthub_common_1.PaletteKeys.filmPlus1On, showTooltip: true }),
                            ((_c = card.description) === null || _c === void 0 ? void 0 : _c.length) > 0 && react_1.default.createElement(utilities_1.TextOverflow, { lines: 2, text: card.description, font: smarthub_common_1.SizeKeys.medium, colour: smarthub_common_1.PaletteKeys.filmPlus1On, showTooltip: true })))))
            : react_1.default.createElement(react_1.default.Fragment, null));
    }, [styles, card, cardStyle.card]);
};
exports.Slide = Slide;


/***/ }),

/***/ "./src/content/cards/thumb-card/card-body.component.tsx":
/*!**************************************************************!*\
  !*** ./src/content/cards/thumb-card/card-body.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardBody = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const card_line_component_1 = __webpack_require__(/*! ./card-line.component */ "./src/content/cards/thumb-card/card-line.component.tsx");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (({ theme: { spacing } }) => ({
    lineStyles: {
        root: {
            gap: spacing.normal
        }
    },
    bodyStyles: {
        root: {
            padding: spacing.smallPlus
        }
    }
}));
const CardBody = ({ card, horizontal, compact }) => {
    var _a, _b;
    const { lineStyles, bodyStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    return react_1.default.createElement(react_2.StackItem, { styles: bodyStyles, grow: 1 },
        react_1.default.createElement(react_2.Stack, { styles: lineStyles }, (_b = (_a = card.lines) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.map((line, index) => react_1.default.createElement(card_line_component_1.CardLine, { key: index, line: line, horizontal: horizontal, compact: compact }))));
};
exports.CardBody = CardBody;


/***/ }),

/***/ "./src/content/cards/thumb-card/card-footer.component.tsx":
/*!****************************************************************!*\
  !*** ./src/content/cards/thumb-card/card-footer.component.tsx ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardFooter = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const card_line_component_1 = __webpack_require__(/*! ./card-line.component */ "./src/content/cards/thumb-card/card-line.component.tsx");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (({ config: horizontal, theme: { palette, spacing } }) => ({
    footerStyles: {
        root: {
            gap: spacing.smallPlus,
            padding: spacing.smallPlus,
            borderTop: `${spacing.tiny} solid ${palette.neutralMinus4}`,
            alignItems: horizontal
                ? 'center'
                : undefined,
        }
    },
    lineStyles: {
        root: {
            alignItems: horizontal
                ? 'center'
                : undefined,
            gap: spacing.smallPlus
        }
    },
    mainStyles: {
        root: {
            flex: "1 1",
            gap: spacing.smallPlus,
            alignItems: horizontal
                ? "center"
                : "flex-end"
        }
    }
}));
const CardFooter = ({ card, horizontal, compact, index, coachmarks }) => {
    var _a, _b, _c;
    const { footerStyles, mainStyles, lineStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles, horizontal);
    const bookmarkCoachmark = (card === null || card === void 0 ? void 0 : card.bookmark) && index === 0
        ? coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(coachmark => coachmark.target === 'bookmark-button') : null;
    return react_1.default.createElement(react_2.Stack, { horizontal: horizontal, styles: footerStyles }, (_b = (_a = card.lines) === null || _a === void 0 ? void 0 : _a.footer) === null || _b === void 0 ? void 0 :
        _b.map((line, index) => react_1.default.createElement(card_line_component_1.CardLine, { key: index, line: line, horizontal: horizontal, compact: compact })),
        react_1.default.createElement(react_2.Stack, { horizontal: true, styles: mainStyles },
            react_1.default.createElement(react_2.StackItem, { grow: 1 },
                react_1.default.createElement(react_2.Stack, { horizontal: horizontal, styles: lineStyles }, (_c = card.tags) === null || _c === void 0 ? void 0 : _c.map((tag, index) => react_1.default.createElement(utilities_1.Tag, { key: index, tagInfo: tag, width: horizontal ? 'auto' : 'fill' })))),
            (card === null || card === void 0 ? void 0 : card.bookmark) && react_1.default.createElement(react_2.StackItem, null, bookmarkCoachmark != null
                ? react_1.default.createElement(utilities_1.CoachMarkWrapper, Object.assign({}, bookmarkCoachmark),
                    react_1.default.createElement(utilities_1.Bookmark, { title: card.title, bookmarkInfo: card === null || card === void 0 ? void 0 : card.bookmark }))
                : react_1.default.createElement(utilities_1.Bookmark, { title: card.title, bookmarkInfo: card === null || card === void 0 ? void 0 : card.bookmark }))));
};
exports.CardFooter = CardFooter;


/***/ }),

/***/ "./src/content/cards/thumb-card/card-header.component.tsx":
/*!****************************************************************!*\
  !*** ./src/content/cards/thumb-card/card-header.component.tsx ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardHeader = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const card_image_component_1 = __webpack_require__(/*! ./card-image.component */ "./src/content/cards/thumb-card/card-image.component.tsx");
const card_icon_component_1 = __webpack_require__(/*! ./card-icon.component */ "./src/content/cards/thumb-card/card-icon.component.tsx");
const card_overlay_component_1 = __webpack_require__(/*! ./card-overlay.component */ "./src/content/cards/thumb-card/card-overlay.component.tsx");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (({ config: horizontal }) => ({
    root: Object.assign({ position: "relative" }, (horizontal
        ? {
            width: "auto",
            maxWidth: "33%",
            height: "100%",
            flex: "0 1 0%"
        }
        : {
            width: "100%",
            maxWidth: "100%",
            height: "auto"
        }))
}));
const CardHeader = ({ header, horizontal }) => {
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles, horizontal);
    return react_1.default.createElement(react_2.StackItem, { styles: styles },
        header.image && react_1.default.createElement(card_image_component_1.CardImage, { image: header.image, horizontal: horizontal }),
        header.icon && react_1.default.createElement(card_icon_component_1.CardIcon, { icon: header.icon, horizontal: horizontal, hasImage: header.image != null }),
        header.stack && react_1.default.createElement(card_overlay_component_1.CardOverlay, { stack: header.stack }));
};
exports.CardHeader = CardHeader;


/***/ }),

/***/ "./src/content/cards/thumb-card/card-icon.component.tsx":
/*!**************************************************************!*\
  !*** ./src/content/cards/thumb-card/card-icon.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardIcon = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_file_type_icons_1 = __webpack_require__(/*! @fluentui/react-file-type-icons */ "@fluentui/react-file-type-icons");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const useStyles = react_jss_1.createUseStyles(({ palette, spacing }) => ({
    icon: ({ icon, hasImage }) => {
        var _a, _b, _c, _d, _e;
        return ({
            color: (_a = palette[icon.colour]) !== null && _a !== void 0 ? _a : palette.neutralMinus3On,
            backgroundColor: hasImage
                ? undefined
                : (_b = palette[icon.backgroundColour]) !== null && _b !== void 0 ? _b : palette.neutralMinus3,
            width: "100%",
            height: "100%",
            top: 0,
            padding: spacing.medium,
            position: "absolute",
            display: "flex",
            justifyContent: !icon.position
                ? 'center'
                : ~icon.position.indexOf("left")
                    ? 'flex-start'
                    : ~((_c = icon.position) === null || _c === void 0 ? void 0 : _c.indexOf("right"))
                        ? 'flex-end'
                        : "center",
            alignItems: !icon.position
                ? 'center'
                : ~((_d = icon.position) === null || _d === void 0 ? void 0 : _d.indexOf("top"))
                    ? 'flex-start'
                    : ~((_e = icon.position) === null || _e === void 0 ? void 0 : _e.indexOf("bottom"))
                        ? 'flex-end'
                        : "center",
            boxSizing: "border-box"
        });
    },
    svg: ({ horizontal }) => {
        return horizontal ? {
            width: "auto",
            height: "100%",
            flex: "0 1 0%"
        } : {
            width: "100%",
            height: "auto"
        };
    }
}));
const CardIcon = (props) => {
    var _a;
    const { icon, horizontal, hasImage } = props;
    const styles = useStyles(props);
    const focusStyle = smarthub_common_1.useFocusStyles();
    const iconProps = ((_a = icon.extension) === null || _a === void 0 ? void 0 : _a.length) ? react_file_type_icons_1.getFileTypeIconProps({
        extension: icon.extension,
        size: icon.size
    })
        : {
            iconName: icon.name,
            title: icon.title
        };
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles.icon },
            react_1.default.createElement(react_2.Icon, Object.assign({}, iconProps, { "data-is-focusable": true, className: focusStyle.focus }))),
        !hasImage && react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: horizontal ? "10" : "6", width: "10", className: styles.svg }));
};
exports.CardIcon = CardIcon;


/***/ }),

/***/ "./src/content/cards/thumb-card/card-image.component.tsx":
/*!***************************************************************!*\
  !*** ./src/content/cards/thumb-card/card-image.component.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardImage = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles({
    svg: (horizontal) => {
        return horizontal ? {
            width: "auto",
            height: "100%",
            flex: "0 1 0%"
        } : {
            width: "100%",
            height: "auto"
        };
    }
});
const fluentStyles = (({ config: image, theme: { type, spacing, sizes } }) => ({
    root: Object.assign({ position: image.layout != 'portrait'
            ? 'absolute'
            : 'relative', top: '0', left: '0' }, (image.layout == 'avatar'
        ? {
            width: sizes.mega,
            height: sizes.mega,
            borderRadius: sizes.mega,
            margin: spacing.smallPlus
        }
        : {
            width: '100%',
            height: '100%'
        })),
    image: {
        width: "100%",
        filter: type == "dark"
            ? "contrast(1.1) saturate(1.3) brightness(0.7)"
            : "contrast(1.1) saturate(1.3) brightness(0.9)",
    }
}));
const focusConfig = {
    position: "absolute"
};
const CardImage = ({ image, horizontal }) => {
    const styles = useStyles(horizontal);
    const focusStyle = smarthub_common_1.useFocusStyles(image.layout != 'portrait'
        ? focusConfig
        : undefined);
    const imageStyles = smarthub_common_1.useFluentStylesWithProps(fluentStyles, image);
    const imageWidth = (image.layout == 'avatar') ? "6" : "10";
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.Image, { "data-is-focusable": true, className: focusStyle.focus, src: image.uri, alt: image.title, imageFit: image.layout != 'portrait'
                ? react_2.ImageFit.cover
                : react_2.ImageFit.none, styles: imageStyles }),
        image.layout != 'portrait' &&
            react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "6", width: imageWidth, className: styles.svg }));
};
exports.CardImage = CardImage;


/***/ }),

/***/ "./src/content/cards/thumb-card/card-line-icons.component.tsx":
/*!********************************************************************!*\
  !*** ./src/content/cards/thumb-card/card-line-icons.component.tsx ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardLineIcons = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (({ theme: { palette } }) => ({
    icon: (colour) => ({
        root: {
            color: (colour === null || colour === void 0 ? void 0 : colour.length) ? palette[colour] : undefined
        }
    }),
}));
const CardLineIcons = ({ icons, colour }) => {
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    return (react_1.default.createElement(react_1.default.Fragment, null, icons.map((icon, idx) => { var _a; return react_1.default.createElement(react_2.Icon, { "aria-hidden": "true", key: idx, iconName: icon.name, styles: styles.icon(((_a = icon.colour) === null || _a === void 0 ? void 0 : _a.length) ? icon.colour : colour) }); })));
};
exports.CardLineIcons = CardLineIcons;


/***/ }),

/***/ "./src/content/cards/thumb-card/card-line.component.tsx":
/*!**************************************************************!*\
  !*** ./src/content/cards/thumb-card/card-line.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardLine = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_2 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const card_line_icons_component_1 = __webpack_require__(/*! ./card-line-icons.component */ "./src/content/cards/thumb-card/card-line-icons.component.tsx");
const fluentStyles = ({ theme: { spacing } }) => ({
    root: {
        gap: spacing.smallPlus,
    }
});
const CardLine = ({ line: { colour, font, icons, show, text, action, title, label }, horizontal, compact }) => {
    var _a, _b, _c, _d, _e;
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const { before, after } = icons !== null && icons !== void 0 ? icons : {};
    const { min, med, max, fixed } = show !== null && show !== void 0 ? show : {};
    const lines = horizontal
        ? (_b = (_a = min !== null && min !== void 0 ? min : med) !== null && _a !== void 0 ? _a : max) !== null && _b !== void 0 ? _b : 1 : compact
        ? (_c = med !== null && med !== void 0 ? med : min) !== null && _c !== void 0 ? _c : 1 : (_e = (_d = max !== null && max !== void 0 ? max : med) !== null && _d !== void 0 ? _d : min) !== null && _e !== void 0 ? _e : 1;
    return (react_2.default.createElement(react_1.Stack, { horizontal: true, wrap: false, styles: styles },
        before && react_2.default.createElement(card_line_icons_component_1.CardLineIcons, { icons: before, colour: colour }),
        react_2.default.createElement(react_1.StackItem, { grow: 1 }, action ?
            react_2.default.createElement(utilities_1.ActionLink, { "aria-label": label, title: title, action: action },
                react_2.default.createElement(utilities_1.TextOverflow, { showTooltip: true, lines: lines, text: text, fixed: fixed, font: font, colour: colour })) :
            react_2.default.createElement(utilities_1.TextOverflow, { label: label, showTooltip: true, lines: lines, text: text, fixed: fixed, font: font, colour: colour })),
        after && react_2.default.createElement(card_line_icons_component_1.CardLineIcons, { icons: after, colour: colour })));
};
exports.CardLine = CardLine;


/***/ }),

/***/ "./src/content/cards/thumb-card/card-main.component.tsx":
/*!**************************************************************!*\
  !*** ./src/content/cards/thumb-card/card-main.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardMain = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const card_footer_component_1 = __webpack_require__(/*! ./card-footer.component */ "./src/content/cards/thumb-card/card-footer.component.tsx");
const card_body_component_1 = __webpack_require__(/*! ./card-body.component */ "./src/content/cards/thumb-card/card-body.component.tsx");
const styles = {
    root: {
        height: "100%"
    }
};
const CardMain = ({ card, horizontal, compact, index, coachmarks }) => {
    return react_1.default.createElement(react_2.StackItem, { grow: 1 },
        react_1.default.createElement(react_2.Stack, { styles: styles },
            react_1.default.createElement(card_body_component_1.CardBody, { card: card, horizontal: horizontal, compact: compact }),
            react_1.default.createElement(card_footer_component_1.CardFooter, { card: card, horizontal: horizontal, compact: compact, index: index, coachmarks: coachmarks })));
};
exports.CardMain = CardMain;


/***/ }),

/***/ "./src/content/cards/thumb-card/card-overlay.component.tsx":
/*!*****************************************************************!*\
  !*** ./src/content/cards/thumb-card/card-overlay.component.tsx ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardOverlay = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (({ config: { position = "top-left", backgroundColour }, theme: { palette, spacing, fonts, sizes } }) => ({
    stack: {
        root: {
            position: "absolute",
            overflow: "hidden",
            top: (position === null || position === void 0 ? void 0 : position.indexOf("top")) >= 0
                ? 0
                : undefined,
            bottom: (position === null || position === void 0 ? void 0 : position.indexOf("bottom")) >= 0
                ? 0
                : undefined,
            right: (position === null || position === void 0 ? void 0 : position.indexOf("right")) >= 0
                ? 0
                : undefined,
            left: (position === null || position === void 0 ? void 0 : position.indexOf("left")) >= 0
                ? 0
                : undefined,
            width: sizes.large,
            height: sizes.large,
            backgroundColor: palette[backgroundColour] || palette.filmPlus1,
            borderTopLeftRadius: (position === null || position === void 0 ? void 0 : position.indexOf("bottom")) >= 0 && (position === null || position === void 0 ? void 0 : position.indexOf("right")) >= 0
                ? spacing.small
                : undefined,
            borderTopRightRadius: (position === null || position === void 0 ? void 0 : position.indexOf("bottom")) >= 0 && (position === null || position === void 0 ? void 0 : position.indexOf("left")) >= 0
                ? spacing.small
                : undefined,
            borderBottomLeftRadius: (position === null || position === void 0 ? void 0 : position.indexOf("top")) >= 0 && (position === null || position === void 0 ? void 0 : position.indexOf("right")) >= 0
                ? spacing.small
                : undefined,
            borderBottomRightRadius: (position === null || position === void 0 ? void 0 : position.indexOf("top")) >= 0 && (position === null || position === void 0 ? void 0 : position.indexOf("left")) >= 0
                ? spacing.small
                : undefined,
        }
    },
    stackItemText: (item, index) => ({
        root: {
            color: palette[item.colour] || palette.filmPlus1On,
            fontWeight: index ? "400" : "200",
            lineHeight: index ? sizes.small : sizes.normal,
            fontSize: index ? fonts.large.fontSize : fonts.xLarge.fontSize,
            textTransform: "uppercase"
        }
    }),
    stackItem: () => ({
        root: Object.assign(Object.assign({}, fonts.small), { textAlign: "center", height: sizes.smallPlus })
    }),
}));
const CardOverlay = ({ stack }) => {
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles, stack);
    const focusStyle = smarthub_common_1.useFocusStyles();
    const renderItem = (item, index) => {
        return (react_1.default.createElement(react_2.StackItem, { styles: styles.stackItem(item, index), key: index },
            react_1.default.createElement(react_2.Text, { styles: styles.stackItemText(item, index), "data-is-focusable": true, className: focusStyle.focus }, item.text)));
    };
    const stackTokens = {
        childrenGap: 0
    };
    return (react_1.default.createElement(react_2.Stack, { tokens: stackTokens, styles: styles.stack, title: stack.title }, stack.items.map(renderItem)));
};
exports.CardOverlay = CardOverlay;


/***/ }),

/***/ "./src/content/cards/thumb-card/index.ts":
/*!***********************************************!*\
  !*** ./src/content/cards/thumb-card/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ThumbCard = void 0;
var thumb_card_component_1 = __webpack_require__(/*! ./thumb-card.component */ "./src/content/cards/thumb-card/thumb-card.component.tsx");
Object.defineProperty(exports, "ThumbCard", ({ enumerable: true, get: function () { return thumb_card_component_1.ThumbCard; } }));


/***/ }),

/***/ "./src/content/cards/thumb-card/thumb-card.component.tsx":
/*!***************************************************************!*\
  !*** ./src/content/cards/thumb-card/thumb-card.component.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ThumbCard = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const models_1 = __webpack_require__(/*! ../../../models */ "./src/models/index.ts");
const card_header_component_1 = __webpack_require__(/*! ./card-header.component */ "./src/content/cards/thumb-card/card-header.component.tsx");
const card_main_component_1 = __webpack_require__(/*! ./card-main.component */ "./src/content/cards/thumb-card/card-main.component.tsx");
const card_style_1 = __webpack_require__(/*! ../card.style */ "./src/content/cards/card.style.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const stackStyle = {
    root: {
        height: "100%"
    }
};
const ThumbCard = (props) => {
    const { config, config: { responsive = {}, coachmarks }, data: { data, index = 0 } = { index: 0 } } = props;
    const { horizontal, compact } = smarthub_common_1.useResponsiveProps(responsive);
    const styleProps = react_1.useMemo(() => ({ fill: !horizontal }), [horizontal]);
    const { cardLabel } = smarthub_common_1.useLocalizeConfig();
    const cardStyle = card_style_1.useCardStyle(styleProps);
    const transform = smarthub_common_1.useTransform();
    const message = smarthub_common_1.useLocalize(smarthub_common_1.LocalizeKeys.invalidSchema);
    const [card, setCard] = react_1.useState(null);
    react_1.useEffect(() => {
        const card = transform(models_1.IThumbCardSchema, data);
        setCard(card);
    }, [props, data]);
    const error = card && card.$schema != models_1.IThumbCardSchema
        ? {
            message
        }
        : null;
    return card
        ? react_1.default.createElement(core_1.ComponentChrome, { config: config, "aria-label": `${card.title}, ${cardLabel}`, className: cardStyle.card, focusable: true, enableCoachmark: index === 0, error: error },
            react_1.default.createElement(react_2.Stack, { horizontal: horizontal, styles: stackStyle },
                card.header && react_1.default.createElement(card_header_component_1.CardHeader, { header: card.header, horizontal: horizontal }),
                react_1.default.createElement(card_main_component_1.CardMain, { card: card, horizontal: horizontal, compact: compact, coachmarks: coachmarks, index: index })))
        : react_1.default.createElement(react_1.default.Fragment, null);
};
exports.ThumbCard = ThumbCard;


/***/ }),

/***/ "./src/content/cards/tile/index.ts":
/*!*****************************************!*\
  !*** ./src/content/cards/tile/index.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./tile.component */ "./src/content/cards/tile/tile.component.tsx"), exports);


/***/ }),

/***/ "./src/content/cards/tile/tile.component.tsx":
/*!***************************************************!*\
  !*** ./src/content/cards/tile/tile.component.tsx ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Tile = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const models_1 = __webpack_require__(/*! ../../../models */ "./src/models/index.ts");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const card_style_1 = __webpack_require__(/*! ../card.style */ "./src/content/cards/card.style.ts");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const fluentStyles = (({ theme: { palette, type, spacing } }) => ({
    stack: {
        root: {
            flexDirection: "column-reverse"
        }
    },
    tile: {
        root: {
            width: "100%",
            height: "100%",
            position: "absolute",
            overflow: "hidden"
        }
    },
    content: {
        root: Object.assign(Object.assign({ padding: spacing.medium, overflow: "hidden", position: "absolute", width: "100%", boxSizing: "border-box", display: "flex", flexDirection: "column", justifyContent: "flex-end", backgroundColor: palette.filmPlus1, backdropFilter: `blur(${spacing.small})` }, react_2.AnimationStyles.fadeIn500), { animationDelay: "2s" })
    },
    image: {
        root: {
            position: "relative",
            height: "100%"
        },
        image: {
            minWidth: "100%",
            objectFit: 'cover',
            minHeight: "100%",
            height: "100%",
            width: "auto",
            filter: type == "dark"
                ? "contrast(1.1) saturate(1.3) brightness(0.7)"
                : "contrast(1.1) saturate(1.3) brightness(0.9)",
        }
    }
}));
const cardConfig = {
    scale: 60,
    offset: smarthub_common_1.SizeKeys.small
};
const Tile = ({ config, data: { data, index = 0 } = { index: 0, data: null } }) => {
    const transform = smarthub_common_1.useTransform();
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles, null, config.responsive);
    const cardStyle = card_style_1.useCardStyle(cardConfig);
    const { cardLabel, invalidSchema: message, tileTitle } = smarthub_common_1.useLocalizeConfig();
    const [card, setCard] = react_1.useState(null);
    react_1.useEffect(() => {
        const card = transform(models_1.ITileSchema, data);
        setCard(card);
    }, [data]);
    const error = card && card.$schema != models_1.ITileSchema
        ? {
            message
        }
        : null;
    return react_1.useMemo(() => {
        var _a, _b;
        const linkTitle = (card === null || card === void 0 ? void 0 : card.title) ? `${tileTitle} ${card.title}` : '';
        return card
            ? react_1.default.createElement(core_1.ComponentChrome, { config: config, "aria-label": `${card === null || card === void 0 ? void 0 : card.title}, ${cardLabel}`, focusable: true, enableCoachmark: index === 0, error: error },
                react_1.default.createElement("div", { className: cardStyle.card },
                    react_1.default.createElement(react_2.Stack, { styles: styles.stack },
                        react_1.default.createElement(react_2.StackItem, { styles: styles.tile },
                            react_1.default.createElement(react_2.Image, { src: card.image.uri, alt: card.description, styles: styles.image })),
                        react_1.default.createElement(react_2.StackItem, { styles: styles.content },
                            card.action ?
                                react_1.default.createElement(utilities_1.ActionLink, { "aria-label": card.label, title: linkTitle, action: card.action },
                                    react_1.default.createElement(utilities_1.TextOverflow, { lines: 2, text: card.title, font: smarthub_common_1.SizeKeys.mediumPlus, colour: smarthub_common_1.PaletteKeys.filmPlus1On, showTooltip: true, fixed: true }))
                                :
                                    react_1.default.createElement(utilities_1.TextOverflow, { lines: 2, text: card.title, font: smarthub_common_1.SizeKeys.mediumPlus, colour: smarthub_common_1.PaletteKeys.filmPlus1On, showTooltip: true, fixed: true }),
                            ((_a = card.subTitle) === null || _a === void 0 ? void 0 : _a.length) > 0 && react_1.default.createElement(utilities_1.TextOverflow, { lines: 1, text: card.subTitle, font: smarthub_common_1.SizeKeys.medium, colour: smarthub_common_1.PaletteKeys.filmPlus1On, showTooltip: true }),
                            ((_b = card.description) === null || _b === void 0 ? void 0 : _b.length) > 0 && react_1.default.createElement(utilities_1.TextOverflow, { lines: 2, text: card.description, font: smarthub_common_1.SizeKeys.medium, colour: smarthub_common_1.PaletteKeys.filmPlus1On, showTooltip: true, fixed: true })))))
            : react_1.default.createElement(react_1.default.Fragment, null);
    }, [styles, card, cardStyle.card]);
};
exports.Tile = Tile;


/***/ }),

/***/ "./src/content/carousel/arrow.component.tsx":
/*!**************************************************!*\
  !*** ./src/content/carousel/arrow.component.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Arrow = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const fluentStyles = (({ config: dir, theme: { spacing, palette } }) => ({
    stack: {
        root: {
            height: '100%',
            width: 'auto',
            position: 'absolute',
            top: 0,
            left: dir === 'prev' ? spacing.small : undefined,
            right: dir === 'next' ? spacing.small : undefined,
            zIndex: 10,
        }
    },
    button: {
        root: {
            borderRadius: '50%',
            transition: "background-color 300ms ease-in",
            backgroundColor: palette.neutalFilmMinus1,
        }
    }
}));
const Arrow = ({ dir, label, title, onClick }) => {
    //TODO use style props future
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles, dir);
    const handleClick = react_1.useCallback(() => {
        onClick(dir);
    }, [onClick]);
    return (react_1.default.createElement(react_2.Stack, { styles: styles.stack, horizontal: false, verticalAlign: "center" },
        react_1.default.createElement(react_2.StackItem, null,
            react_1.default.createElement(react_2.IconButton, { "aria-label": label, title: title, styles: styles.button, onClick: handleClick, iconProps: {
                    iconName: dir == 'next' ? 'ChevronRight' : 'ChevronLeft'
                } }))));
};
exports.Arrow = Arrow;


/***/ }),

/***/ "./src/content/carousel/carousel.component.tsx":
/*!*****************************************************!*\
  !*** ./src/content/carousel/carousel.component.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Carousel = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const cards_1 = __webpack_require__(/*! ../cards */ "./src/content/cards/index.ts");
const arrow_component_1 = __webpack_require__(/*! ./arrow.component */ "./src/content/carousel/arrow.component.tsx");
const dots_component_1 = __webpack_require__(/*! ./dots.component */ "./src/content/carousel/dots.component.tsx");
const Carousel = ({ config }) => {
    const { $id, query, provides, consumes, children = [] } = config;
    const provider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'refiners');
    const fetch = smarthub_common_1.useFetch();
    const render = smarthub_common_1.useRender();
    const setRefiners = smarthub_common_1.useSetSharedState(provider);
    const [items, setItems] = react_1.useState(null);
    const [error, setError] = react_1.useState(null);
    const [filters, setFilters] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setFilters(consumes), [consumes]);
    const localize = smarthub_common_1.useLocalizeConfig();
    const [index, setIndex] = react_1.useState(0);
    react_1.useEffect(() => {
        const fetchData = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            try {
                const requiresParam = consumes === null || consumes === void 0 ? void 0 : consumes.some(({ required, name }) => required && (filters === null || filters === void 0 ? void 0 : filters[name]) == null);
                if (requiresParam)
                    return;
                const { data, refiners } = yield fetch(query, filters);
                setItems(data);
                if (refiners && provider)
                    setRefiners(refiners);
            }
            catch (ex) {
                setError(ex);
            }
        });
        fetchData();
    }, [filters, fetch]);
    const handleNav = react_1.useCallback((dir) => {
        const nextIndex = typeof dir == 'number'
            ? dir
            : dir == 'next'
                ? index == items.length - 1
                    ? 0
                    : index + 1
                : index == 0
                    ? items.length - 1
                    : index - 1;
        setIndex(nextIndex);
    }, [items, index, setIndex]);
    return react_1.useMemo(() => {
        const card = children.find(c => c.$id == 'card');
        return (items
            ? react_1.default.createElement(core_1.ComponentChrome, { config: config, hasContent: !items || (items === null || items === void 0 ? void 0 : items.length) > 0, error: error },
                (items === null || items === void 0 ? void 0 : items.length) > 1 && react_1.default.createElement(arrow_component_1.Arrow, { dir: "prev", label: localize.carousel.previousLabel, title: localize.carousel.previousTitle, onClick: handleNav }),
                (items === null || items === void 0 ? void 0 : items.length) > 0 && render(card, { data: items[index], index }, cards_1.Slide)(),
                (items === null || items === void 0 ? void 0 : items.length) > 1 && react_1.default.createElement(arrow_component_1.Arrow, { dir: "next", label: localize.carousel.nextLabel, title: localize.carousel.nextTitle, onClick: handleNav }),
                (items === null || items === void 0 ? void 0 : items.length) > 1 && react_1.default.createElement(dots_component_1.Dots, { currentIndex: index, count: items.length, onClick: handleNav }))
            : react_1.default.createElement(react_1.default.Fragment, null));
    }, [error, items, index, handleNav]);
};
exports.Carousel = Carousel;


/***/ }),

/***/ "./src/content/carousel/dot.component.tsx":
/*!************************************************!*\
  !*** ./src/content/carousel/dot.component.tsx ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Dot = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles(({ palette, spacing }) => ({
    root: ({ isActive, count }) => ({
        cursor: 'pointer',
        width: `calc(100% / ${count})`,
        maxWidth: spacing.xxLargePlus,
        height: spacing.smallPlus,
        backgroundColor: isActive
            ? palette.primary
            : palette.neutralPlus3,
        "&:hover": {
            backgroundColor: palette.primary
        }
    })
}));
const Dot = (props) => {
    const { index, label, title, onClick } = props;
    const styles = useStyles(props);
    const handleClick = react_1.useCallback(() => {
        onClick(index);
    }, [index, onClick]);
    return (react_1.default.createElement("div", { className: styles.root, onClick: handleClick, role: "button", "aria-label": label, title: title }));
};
exports.Dot = Dot;


/***/ }),

/***/ "./src/content/carousel/dots.component.tsx":
/*!*************************************************!*\
  !*** ./src/content/carousel/dots.component.tsx ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Dots = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const dot_component_1 = __webpack_require__(/*! ./dot.component */ "./src/content/carousel/dot.component.tsx");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const fluentStyles = (({ theme: { spacing } }) => ({
    stack: {
        root: {
            gap: spacing.small,
            position: 'absolute',
            top: "100%",
            zIndex: 11,
            width: '100%',
            opacity: '0.6',
            padding: spacing.small,
            transition: "opacity 300ms ease-in",
            "&:hover": {
                opacity: 1
            }
        }
    }
}));
const Dots = ({ count, currentIndex, onClick }) => {
    const localize = smarthub_common_1.useLocalizeConfig();
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    return react_1.useMemo(() => react_1.default.createElement(react_2.Stack, { styles: styles.stack, horizontal: true, horizontalAlign: 'center', verticalAlign: 'end' }, [...Array(count).keys()].map((i) => react_1.default.createElement(dot_component_1.Dot, { onClick: onClick, key: i, index: i, count: count, isActive: currentIndex == i, label: `${localize.carousel.dotLabel} ${i + 1}`, "aria-label": `${localize.carousel.dotTitle} ${i + 1}`, title: `${localize.carousel.dotTitle} ${i + 1}` }))), [styles, currentIndex, count, onClick]);
};
exports.Dots = Dots;


/***/ }),

/***/ "./src/content/carousel/index.ts":
/*!***************************************!*\
  !*** ./src/content/carousel/index.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./carousel.component */ "./src/content/carousel/carousel.component.tsx"), exports);


/***/ }),

/***/ "./src/content/category-menu/category-menu-buttons.component.tsx":
/*!***********************************************************************!*\
  !*** ./src/content/category-menu/category-menu-buttons.component.tsx ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CategoryMenuButtons = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const button_grid_1 = __webpack_require__(/*! ../button-grid */ "./src/content/button-grid/index.ts");
const CategoryMenuButtons = ({ title, categories, select, selectedId }) => {
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const [buttons, setButtons] = react_1.useState([]);
    react_1.useEffect(() => {
        const mapLinks = (links) => links.map(({ $id, title }) => ({
            uniqueId: $id,
            text: title,
            data: $id,
            title: `${localizeConfig.selectLabel} ${title}`,
            ariaLabel: `${localizeConfig.selectLabel} ${title}`,
        }));
        setButtons(mapLinks(categories));
    }, [categories, localizeConfig]);
    const onClick = react_1.useCallback((id, data) => {
        select(id);
    }, [select]);
    return react_1.useMemo(() => react_1.default.createElement(button_grid_1.ButtonGrid, { selectedId: selectedId, ariaLabel: title, onButtonClick: onClick, buttons: buttons, horizontalAlign: 'space-between' }), [onClick, selectedId, buttons]);
};
exports.CategoryMenuButtons = CategoryMenuButtons;


/***/ }),

/***/ "./src/content/category-menu/category-menu-nav.component.tsx":
/*!*******************************************************************!*\
  !*** ./src/content/category-menu/category-menu-nav.component.tsx ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CategoryMenuNav = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const navStyles = {
    root: {
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        overflowY: 'auto',
    },
};
const CategoryMenuNav = ({ title, categories, select, selectedId }) => {
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const [links, setLinks] = react_1.useState([]);
    react_1.useEffect(() => {
        const mapLinks = (links) => links.map(({ $id, title, children }) => ({
            key: `key-${$id !== null && $id !== void 0 ? $id : 'default'}`,
            categoryId: $id,
            name: title,
            url: "",
            target: "_blank",
            ariaLabel: `${localizeConfig.selectLabel} ${title}`,
            expandAriaLabel: `${localizeConfig.expandLabel} ${title}`,
            colapseAriaLabel: `${localizeConfig.collapseLabel} ${title}`,
            links: (children === null || children === void 0 ? void 0 : children.length) ? mapLinks(children)
                : null
        }));
        setLinks(mapLinks(categories));
    }, [categories, localizeConfig]);
    const onClick = react_1.useCallback((ev, { categoryId }) => {
        select(categoryId);
    }, [select]);
    return react_1.useMemo(() => react_1.default.createElement(react_2.Nav, { selectedKey: `key-${selectedId !== null && selectedId !== void 0 ? selectedId : 'default'}`, ariaLabel: title, styles: navStyles, onLinkClick: onClick, groups: [{
                links
            }] }), [selectedId, links]);
};
exports.CategoryMenuNav = CategoryMenuNav;


/***/ }),

/***/ "./src/content/category-menu/category-menu.component.tsx":
/*!***************************************************************!*\
  !*** ./src/content/category-menu/category-menu.component.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CategoryMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
const category_menu_nav_component_1 = __webpack_require__(/*! ./category-menu-nav.component */ "./src/content/category-menu/category-menu-nav.component.tsx");
const category_menu_buttons_component_1 = __webpack_require__(/*! ./category-menu-buttons.component */ "./src/content/category-menu/category-menu-buttons.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const CategoryMenu = ({ config }) => {
    const { $id, query, provides, title, props: { options, defaultTo, type } = {}, consumes } = config;
    const provider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'category-id');
    const parentConsumer = consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'parent-id');
    const [categories, setCategories] = react_1.useState([]);
    const fetch = smarthub_common_1.useFetch();
    const transform = smarthub_common_1.useTransform();
    const categoryId = smarthub_common_1.useReadSharedState(provider);
    const setCategoryId = smarthub_common_1.useSetSharedState(provider);
    const [filters, setFilters] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setFilters(consumes), [consumes]);
    react_1.useEffect(() => {
        const fetchData = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c;
            try {
                const { data } = yield fetch(query, filters);
                const navlinks = (_a = transform(models_1.ICategoryLinkSchema, data)) !== null && _a !== void 0 ? _a : [];
                const configLinks = [...options !== null && options !== void 0 ? options : []];
                if (defaultTo == 'first' && parentConsumer && configLinks.length > 0) {
                    const link = configLinks[0];
                    configLinks.splice(0, 1, Object.assign(Object.assign({}, link), { $id: ((_b = link.$id) === null || _b === void 0 ? void 0 : _b.length) ? link.$id
                            : (_c = filters === null || filters === void 0 ? void 0 : filters[parentConsumer.name]) !== null && _c !== void 0 ? _c : parentConsumer.value }));
                }
                const categories = [
                    ...configLinks,
                    ...navlinks !== null && navlinks !== void 0 ? navlinks : []
                ];
                setCategories(categories);
                if (defaultTo == 'first' && categories.length)
                    setCategoryId(categories[0].$id);
            }
            catch (ex) {
                smarthub_common_1.Logger.error("Failed to fetch category data", false, { ex });
            }
        });
        fetchData();
    }, [query, filters, fetch, parentConsumer]);
    const select = react_1.useCallback((id) => {
        setCategoryId(id);
    }, [setCategoryId]);
    return react_1.useMemo(() => react_1.default.createElement(core_1.ComponentChrome, { config: config, hasContent: !categories || categories.length > 0 }, type == 'buttons'
        ? react_1.default.createElement(category_menu_buttons_component_1.CategoryMenuButtons, { title: title, categories: categories, select: select, selectedId: categoryId })
        : react_1.default.createElement(category_menu_nav_component_1.CategoryMenuNav, { title: title, categories: categories, select: select, selectedId: categoryId })), [categoryId, categories, type]);
};
exports.CategoryMenu = CategoryMenu;


/***/ }),

/***/ "./src/content/category-menu/index.ts":
/*!********************************************!*\
  !*** ./src/content/category-menu/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./category-menu.component */ "./src/content/category-menu/category-menu.component.tsx"), exports);


/***/ }),

/***/ "./src/content/component-flow/component-flow.component.tsx":
/*!*****************************************************************!*\
  !*** ./src/content/component-flow/component-flow.component.tsx ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ComponentFlow = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const adaptive_card_1 = __webpack_require__(/*! ../adaptive-card */ "./src/content/adaptive-card/index.ts");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
//TODO for demo purposes only - refactor needed
const ComponentFlow = ({ config, config: { provides, props } }) => {
    var _a;
    const setComplete = smarthub_common_1.useSetSharedState(provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'complete'));
    const [card, setCard] = react_1.useState(((_a = props === null || props === void 0 ? void 0 : props.cards) === null || _a === void 0 ? void 0 : _a.length) ? props.cards[0].card : null);
    const onFailure = (data) => {
        _onSubmit({
            flowNext: data.action.flowError
        });
    };
    const onSuccess = (data) => {
        _onSubmit({
            flowNext: data.action.flowSuccess
        });
    };
    const onSubmit = (data) => {
        _onSubmit(data.action);
    };
    const _onSubmit = react_1.useCallback(({ flowNext }) => {
        if (flowNext) {
            const nextCard = props.cards.find(c => c.id == flowNext);
            if (nextCard) {
                setCard(nextCard.card);
                if (nextCard.end)
                    setComplete((new Date).getTime());
            }
        }
    }, [props]);
    return react_1.useMemo(() => (react_1.default.createElement(core_1.ComponentChrome, { config: config, hasContent: card }, card && react_1.default.createElement(adaptive_card_1.AdaptiveCardEmbed, { card: card, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure }))), [card]);
};
exports.ComponentFlow = ComponentFlow;


/***/ }),

/***/ "./src/content/component-flow/index.ts":
/*!*********************************************!*\
  !*** ./src/content/component-flow/index.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./component-flow.component */ "./src/content/component-flow/component-flow.component.tsx"), exports);


/***/ }),

/***/ "./src/content/data-table/data-table.component.tsx":
/*!*********************************************************!*\
  !*** ./src/content/data-table/data-table.component.tsx ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DataTable = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
const react_visibility_sensor_1 = tslib_1.__importDefault(__webpack_require__(/*! react-visibility-sensor */ "react-visibility-sensor"));
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const set_groups_helper_1 = __webpack_require__(/*! ./set-groups.helper */ "./src/content/data-table/set-groups.helper.ts");
const render_group_header_helper_1 = __webpack_require__(/*! ./render-group-header.helper */ "./src/content/data-table/render-group-header.helper.tsx");
const render_item_column_helper_1 = __webpack_require__(/*! ./render-item-column.helper */ "./src/content/data-table/render-item-column.helper.ts");
const extend_columns_helper_1 = __webpack_require__(/*! ./extend-columns.helper */ "./src/content/data-table/extend-columns.helper.tsx");
const data_table_styles_1 = __webpack_require__(/*! ./data-table.styles */ "./src/content/data-table/data-table.styles.ts");
const DataTable = ({ config }) => {
    const { $id, query, coachmarks, provides, consumes, props: { columnDefinitions = [], estimate = 20, grouped = false, isCollapsed = true } = {}, title } = config;
    const { loadMoreStackItemStyles, loadMoreStyles, iconStyles, toggleButtonStyles } = smarthub_common_1.useFluentStylesWithProps(data_table_styles_1.fluentStyles);
    const refinersProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'refiners');
    const sortOptionsProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'sort-options');
    const fetch = smarthub_common_1.useFetch();
    const setRefiners = smarthub_common_1.useSetSharedState(refinersProvider);
    const setSortOptions = smarthub_common_1.useSetSharedState(sortOptionsProvider);
    const [data, setData] = react_1.useState({
        rows: null,
        loading: true
    });
    const [error, setError] = react_1.useState(null);
    const [filters, setFilters] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setFilters(consumes), [consumes]);
    const transform = smarthub_common_1.useTransform();
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const fetchData = (filters, rows, contineParam) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const requiresParam = consumes === null || consumes === void 0 ? void 0 : consumes.some(({ required, name }) => required && (filters === null || filters === void 0 ? void 0 : filters[name]) == null);
            if (requiresParam)
                return;
            const { data, continuation, refiners, sortOptions } = yield fetch(query, filters, contineParam);
            let newRows = transform(models_1.IDataTableRowSchema, data, config.props);
            newRows = Array.isArray(newRows) ? newRows : [newRows];
            setData({
                rows: [...(rows !== null && rows !== void 0 ? rows : []), ...newRows],
                loading: false,
                continuation
            });
            if (sortOptionsProvider)
                setSortOptions(sortOptions);
            if (refinersProvider)
                setRefiners(refiners);
        }
        catch (ex) {
            smarthub_common_1.Logger.error(`query and fetch failed for component ${$id} error: ${ex.description}`);
            setError(ex);
        }
    });
    react_1.useEffect(() => {
        fetchData(filters);
    }, [filters, query, fetch]);
    const loadMore = () => {
        setData(Object.assign(Object.assign({}, data), { loading: true }));
        fetchData(filters, data.rows, data.continuation);
    };
    const onVisibilityChange = (isVisible) => {
        if (isVisible && !data.loading)
            loadMore();
    };
    return react_1.useMemo(() => {
        var _a;
        const groups = grouped && (data === null || data === void 0 ? void 0 : data.rows)
            ? set_groups_helper_1.setGroups(data === null || data === void 0 ? void 0 : data.rows, isCollapsed, { toggleButtonStyles })
            : undefined;
        const items = (data === null || data === void 0 ? void 0 : data.rows) ? grouped
            ? [].concat(...data.rows.map(group => group.rows)).filter(item => item != null)
            : data.rows
            : [];
        const columns = extend_columns_helper_1.extendColumns(columnDefinitions, localizeConfig, grouped, coachmarks, { iconStyles });
        return react_1.default.createElement(core_1.ComponentChrome, { hasContent: !(data === null || data === void 0 ? void 0 : data.rows) || ((_a = data === null || data === void 0 ? void 0 : data.rows) === null || _a === void 0 ? void 0 : _a.length) > 0, config: config, error: error },
            react_1.default.createElement(react_2.Stack, null,
                react_1.default.createElement(react_2.ShimmeredDetailsList, { setKey: "items", items: items, groups: groups, layoutMode: react_2.DetailsListLayoutMode.justified, columns: columns, selectionMode: react_2.SelectionMode.none, onRenderItemColumn: render_item_column_helper_1.onRenderItemColumn, shimmerLines: estimate, enableShimmer: !(data === null || data === void 0 ? void 0 : data.rows), ariaLabelForShimmer: localizeConfig.fetchingItems, ariaLabelForGrid: `${title} ${localizeConfig.suffixItems}`, listProps: {
                        renderedWindowsAhead: 0,
                        renderedWindowsBehind: 0,
                    }, groupProps: {
                        showEmptyGroups: true,
                        isAllGroupsCollapsed: isCollapsed,
                        onRenderHeader: render_group_header_helper_1.renderGroupHeader
                    } }),
                (data === null || data === void 0 ? void 0 : data.continuation) && react_1.default.createElement(react_2.StackItem, { styles: loadMoreStackItemStyles },
                    react_1.default.createElement(react_visibility_sensor_1.default, { onChange: onVisibilityChange },
                        react_1.default.createElement(react_2.PrimaryButton, { disabled: data.loading, styles: loadMoreStyles, text: localizeConfig.loadMore, ariaLabel: localizeConfig.loadMore, title: localizeConfig.loadMore, ariaDescription: localizeConfig.loadMoreDesc, onClick: loadMore })))));
    }, [data, error, config]);
};
exports.DataTable = DataTable;


/***/ }),

/***/ "./src/content/data-table/data-table.styles.ts":
/*!*****************************************************!*\
  !*** ./src/content/data-table/data-table.styles.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fluentStyles = void 0;
exports.fluentStyles = (({ theme: { spacing, palette, fonts, sizes } }) => ({
    loadMoreStackItemStyles: {
        root: {
            display: "flex",
            justifyContent: "center",
            flexDirection: "row",
            height: "auto",
            width: "100%",
            marginTop: spacing.xxLarge,
            padding: spacing.xxLarge,
        }
    },
    loadMoreStyles: {
        root: {
            width: "25%",
        }
    },
    toggleButtonStyles: {
        root: {
            width: sizes.normalPlus,
            height: `calc(${sizes.medium} + ${spacing.xSmall})`
        },
        icon: Object.assign({}, fonts.small)
    },
    iconStyles: (colour) => ({
        root: {
            color: colour ? palette[colour] : undefined,
            verticalAlign: "bottom",
        }
    }),
}));


/***/ }),

/***/ "./src/content/data-table/extend-columns.helper.tsx":
/*!**********************************************************!*\
  !*** ./src/content/data-table/extend-columns.helper.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.extendColumns = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const advancedFormat_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/advancedFormat */ "dayjs/plugin/advancedFormat"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_file_type_icons_1 = __webpack_require__(/*! @fluentui/react-file-type-icons */ "@fluentui/react-file-type-icons");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
dayjs_1.default.extend(advancedFormat_1.default);
const extendColumns = (columnDefinitions, localizeConfig, grouped, coachmarks, styles) => columnDefinitions.map(column => {
    const { data: { type } = { type: '' } } = column;
    return Object.assign(Object.assign({}, column), (type == "date"
        ? {
            onRender: (item) => {
                return react_1.default.createElement("span", null, dayjs_1.default(item[column.key]).format(localizeConfig.commonDateFormat));
            }
        }
        : type == "link"
            ? {
                onRender: (item) => {
                    var _a;
                    const { isGroup } = item;
                    const { text, action } = (_a = item[column.key]) !== null && _a !== void 0 ? _a : {};
                    const font = isGroup && grouped
                        ? smarthub_common_1.SizeKeys.mediumPlus
                        : smarthub_common_1.SizeKeys.normal;
                    return react_1.default.createElement(utilities_1.ActionLink, { action: action, "aria-label": text, title: text },
                        react_1.default.createElement(utilities_1.TextOverflow, { showTooltip: true, lines: 1, text: text, fixed: true, font: font, colour: smarthub_common_1.PaletteKeys.primary }));
                }
            }
            : type == "file-icon"
                ? {
                    onRender: (item) => {
                        return react_1.default.createElement(react_2.Icon, Object.assign({}, react_file_type_icons_1.getFileTypeIconProps({ extension: item[column.key], size: 16 })));
                    }
                }
                : type == "bookmark"
                    ? {
                        onRender: (item, index) => {
                            var _a, _b;
                            const bookmarkCoachmark = coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(coachmark => coachmark.target === 'bookmark-button');
                            return (react_1.default.createElement("div", { style: { marginTop: "-8px" } }, bookmarkCoachmark && index === 0
                                ? react_1.default.createElement(utilities_1.CoachMarkWrapper, Object.assign({}, bookmarkCoachmark),
                                    react_1.default.createElement(utilities_1.Bookmark, { title: (_a = item === null || item === void 0 ? void 0 : item.title) === null || _a === void 0 ? void 0 : _a.text, bookmarkInfo: item === null || item === void 0 ? void 0 : item.bookmark }))
                                : react_1.default.createElement(utilities_1.Bookmark, { title: (_b = item === null || item === void 0 ? void 0 : item.title) === null || _b === void 0 ? void 0 : _b.text, bookmarkInfo: item === null || item === void 0 ? void 0 : item.bookmark })));
                        }
                    }
                    : type == "tag"
                        ? {
                            onRender: (item) => {
                                var _a;
                                const tags = (_a = item[column.key]) !== null && _a !== void 0 ? _a : [];
                                return (react_1.default.createElement("div", null, tags === null || tags === void 0 ? void 0 : tags.map((tag, index) => react_1.default.createElement(utilities_1.Tag, { key: index, tagInfo: tag }))));
                            }
                        }
                        : type == "icon"
                            ? {
                                onRender: (item) => {
                                    var _a;
                                    const { icon, text } = (_a = item[column.key]) !== null && _a !== void 0 ? _a : {};
                                    return (react_1.default.createElement("div", null,
                                        react_1.default.createElement(react_2.Icon, { iconName: icon === null || icon === void 0 ? void 0 : icon.name, styles: styles.iconStyles(icon === null || icon === void 0 ? void 0 : icon.colour) }),
                                        react_1.default.createElement("span", null,
                                            " ",
                                            text)));
                                }
                            }
                            : {}));
});
exports.extendColumns = extendColumns;


/***/ }),

/***/ "./src/content/data-table/index.ts":
/*!*****************************************!*\
  !*** ./src/content/data-table/index.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./data-table.component */ "./src/content/data-table/data-table.component.tsx"), exports);


/***/ }),

/***/ "./src/content/data-table/render-group-header.helper.tsx":
/*!***************************************************************!*\
  !*** ./src/content/data-table/render-group-header.helper.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.renderGroupHeader = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const renderGroupHeader = (props) => {
    if (props) {
        const { group, onToggleCollapse } = props;
        const _a = group.data, { styles: { toggleButtonStyles } } = _a, item = tslib_1.__rest(_a, ["styles"]), { isCollapsed, count } = group;
        const onRenderCheck = () => {
            return count
                ? react_1.default.createElement(react_2.IconButton, { styles: toggleButtonStyles, onClick: () => onToggleCollapse(group), iconProps: {
                        iconName: isCollapsed
                            ? 'ChevronRight'
                            : 'ChevronDown'
                    } })
                : react_1.default.createElement(react_2.GroupSpacer, { count: 1 });
        };
        return react_1.default.createElement(react_2.DetailsRow, Object.assign({}, props, { item: item, itemIndex: -1, indentWidth: 0, groupNestingDepth: 0, selectionMode: react_2.SelectionMode.single, onRenderCheck: onRenderCheck }));
    }
    return null;
};
exports.renderGroupHeader = renderGroupHeader;


/***/ }),

/***/ "./src/content/data-table/render-item-column.helper.ts":
/*!*************************************************************!*\
  !*** ./src/content/data-table/render-item-column.helper.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.onRenderItemColumn = void 0;
const onRenderItemColumn = (item, index, column) => {
    return item[column.key];
};
exports.onRenderItemColumn = onRenderItemColumn;


/***/ }),

/***/ "./src/content/data-table/set-groups.helper.ts":
/*!*****************************************************!*\
  !*** ./src/content/data-table/set-groups.helper.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setGroups = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
// logic to set the startIndex of each group
const setGroups = (rows, isCollapsed, styles) => {
    return rows.map((_a, i) => {
        var { count, name, key, level } = _a, rest = tslib_1.__rest(_a, ["count", "name", "key", "level"]);
        return (Object.assign(Object.assign({}, rest), { isCollapsed,
            key,
            name,
            count,
            level, data: Object.assign(Object.assign({ styles }, rest), { index: i, isGroup: true }), startIndex: i != 0
                ? rows
                    .slice(0, i)
                    .map(item => item === null || item === void 0 ? void 0 : item.count)
                    .reduce((prev, next) => prev + next)
                : 0 }));
    });
};
exports.setGroups = setGroups;


/***/ }),

/***/ "./src/content/html-screen/html-screen.component.tsx":
/*!***********************************************************!*\
  !*** ./src/content/html-screen/html-screen.component.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HTMLScreen = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const dompurify_1 = tslib_1.__importDefault(__webpack_require__(/*! dompurify */ "./node_modules/dompurify/dist/purify.js"));
const HTMLScreen = ({ config: { props: { html }, }, }) => {
    return (react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: dompurify_1.default.sanitize(html) } }));
};
exports.HTMLScreen = HTMLScreen;


/***/ }),

/***/ "./src/content/html-screen/index.ts":
/*!******************************************!*\
  !*** ./src/content/html-screen/index.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./html-screen.component */ "./src/content/html-screen/html-screen.component.tsx"), exports);


/***/ }),

/***/ "./src/content/image/image-embed.component.tsx":
/*!*****************************************************!*\
  !*** ./src/content/image/image-embed.component.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ImageEmbed = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_2 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_hooks_1 = __webpack_require__(/*! @fluentui/react-hooks */ "@fluentui/react-hooks");
const styles = {
    image: {
        width: "100%",
        maxWidth: "100%",
    }
};
const ImageEmbed = ({ uri, width, height, description, alt, fit, orientation }) => {
    const tooltipId = react_hooks_1.useId('tooltip');
    return (react_2.default.createElement(react_1.TooltipHost, { id: tooltipId, content: (description === null || description === void 0 ? void 0 : description.length) ? description : alt },
        react_2.default.createElement(react_1.Image, { styles: styles, "aria-describedby": tooltipId, coverStyle: react_1.ImageCoverStyle[(orientation === null || orientation === void 0 ? void 0 : orientation.length) ? orientation : 'landscape'], imageFit: react_1.ImageFit[(fit === null || fit === void 0 ? void 0 : fit.length) ? fit : 'cover'], src: uri, alt: alt, width: width, height: height })));
};
exports.ImageEmbed = ImageEmbed;


/***/ }),

/***/ "./src/content/image/image.component.tsx":
/*!***********************************************!*\
  !*** ./src/content/image/image.component.tsx ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Image = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const image_embed_component_1 = __webpack_require__(/*! ./image-embed.component */ "./src/content/image/image-embed.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles({
    wrapper: {
        display: 'flex',
        height: '100%',
    }
});
const Image = ({ config, config: { consumes, props } }) => {
    var _a;
    const image = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "image"));
    const styles = useStyles();
    const uri = ((_a = image === null || image === void 0 ? void 0 : image.uri) === null || _a === void 0 ? void 0 : _a.length) ? image.uri : props === null || props === void 0 ? void 0 : props.uri;
    const message = smarthub_common_1.useLocalize(smarthub_common_1.LocalizeKeys.imageError);
    const error = !(uri === null || uri === void 0 ? void 0 : uri.length)
        ? {
            message
        }
        : undefined;
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.wrapper, error: error }, (uri === null || uri === void 0 ? void 0 : uri.length) && react_1.default.createElement(image_embed_component_1.ImageEmbed, Object.assign({ uri: uri }, props))));
};
exports.Image = Image;


/***/ }),

/***/ "./src/content/image/index.ts":
/*!************************************!*\
  !*** ./src/content/image/index.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./image-embed.component */ "./src/content/image/image-embed.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./image.component */ "./src/content/image/image.component.tsx"), exports);


/***/ }),

/***/ "./src/content/index.ts":
/*!******************************!*\
  !*** ./src/content/index.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./about */ "./src/content/about/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./adaptive-card */ "./src/content/adaptive-card/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./bookmark-list */ "./src/content/bookmark-list/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./button-grid */ "./src/content/button-grid/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./calendar */ "./src/content/calendar/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./card-list */ "./src/content/card-list/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./cards */ "./src/content/cards/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./carousel */ "./src/content/carousel/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./category-menu */ "./src/content/category-menu/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./component-flow */ "./src/content/component-flow/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./data-table */ "./src/content/data-table/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./image */ "./src/content/image/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./launch-button */ "./src/content/launch-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./list-command-bar */ "./src/content/list-command-bar/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./map */ "./src/content/map/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./ms-form */ "./src/content/ms-form/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./ms-power-app */ "./src/content/ms-power-app/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./ms-stream */ "./src/content/ms-stream/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./notification */ "./src/content/notification/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page */ "./src/content/page/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./preferences */ "./src/content/preferences/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./profile */ "./src/content/profile/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./splash-screen */ "./src/content/splash-screen/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./summarizer */ "./src/content/summarizer/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./up-next */ "./src/content/up-next/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./view */ "./src/content/view/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./timeline */ "./src/content/timeline/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./html-screen */ "./src/content/html-screen/index.ts"), exports);


/***/ }),

/***/ "./src/content/launch-button/index.ts":
/*!********************************************!*\
  !*** ./src/content/launch-button/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./launch-button.component */ "./src/content/launch-button/launch-button.component.tsx"), exports);


/***/ }),

/***/ "./src/content/launch-button/launch-button.component.tsx":
/*!***************************************************************!*\
  !*** ./src/content/launch-button/launch-button.component.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LaunchButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_2 = __webpack_require__(/*! react */ "react");
const react_3 = __webpack_require__(/*! react */ "react");
const useStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b;
    const { styles, palette } = theme;
    const launch = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.main) === null || _a === void 0 ? void 0 : _a.launch) !== null && _b !== void 0 ? _b : {};
    const props = { theme };
    return {
        right: {
            right: 0,
        },
        left: {
            left: 0,
        },
        image: Object.assign({ display: "block !important", maxWidth: "none", "&.$right": smarthub_common_1.themeStyle(launch.imageRight, props), "&.$left": smarthub_common_1.themeStyle(launch.imageLeft, props) }, smarthub_common_1.themeStyle(launch.image, props)),
        root: Object.assign({ zIndex: 1000000, position: "fixed", display: "flex", top: 0, bottom: 0, "&.$right": smarthub_common_1.themeStyle(launch.rootRight, props), "&.$left": smarthub_common_1.themeStyle(launch.rootLeft, props) }, smarthub_common_1.themeStyle(launch.root, props)),
        button: Object.assign({ padding: 0, border: "none", backgroundColor: "transparent", position: "absolute", cursor: "pointer", alignSelf: "center", "&.$right": smarthub_common_1.themeStyle(launch.buttonRight, props), "&.$left": smarthub_common_1.themeStyle(launch.buttonLeft, props), "&:focus": Object.assign({ outline: `${palette.filmPlus1} auto` }, smarthub_common_1.themeStyle(launch.buttonFocus, props)) }, smarthub_common_1.themeStyle(launch.button, props)),
    };
});
const LaunchButton = () => {
    const ref = react_2.useRef();
    const localize = smarthub_common_1.useLocalizeConfig();
    const [dockPostion] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys.chatDockPosition, false);
    const styles = useStyles();
    const [, setChromeState] = smarthub_common_1.useChromeState();
    const { chat: { dockPositions: { preferred: position }, }, } = smarthub_common_1.useViewConfig();
    const focus = react_2.useRef(false);
    const onClick = react_1.useCallback(() => {
        setChromeState("open");
        focus.current = true;
    }, [setChromeState]);
    const onKeyPress = react_1.useCallback((e) => {
        if (e.key == "Enter")
            onClick();
    }, []);
    const preferredPosition = react_1.useMemo(() => {
        if (dockPostion) {
            return dockPostion;
        }
        return position;
    }, [dockPostion, position]);
    const imageUri = smarthub_common_1.useThemeImageURI(preferredPosition == "right"
        ? smarthub_common_1.ImageKeys.launchButtonRight
        : smarthub_common_1.ImageKeys.launchButtonLeft);
    react_3.useEffect(() => {
        if (focus.current)
            ref.current.focus();
    }, []);
    return react_1.useMemo(() => (react_1.default.createElement("div", { className: [
            styles.root,
            preferredPosition == "right" ? styles.right : styles.left,
        ].join(" ") },
        react_1.default.createElement("button", { tabIndex: 0, className: [
                styles.button,
                preferredPosition == "right" ? styles.right : styles.left,
            ].join(" "), role: "button", "aria-label": localize.launchButtonLabel, title: localize.launchButtonTitle, onKeyPress: onKeyPress, onClick: onClick },
            react_1.default.createElement("img", { alt: localize.launchButtonAlt, src: imageUri, style: { maxWidth: "inherit" }, className: [
                    styles.image,
                    preferredPosition == "right" ? styles.right : styles.left,
                ].join(" ") })))), [preferredPosition]);
};
exports.LaunchButton = LaunchButton;


/***/ }),

/***/ "./src/content/list-command-bar/a-z-filter-button.component.tsx":
/*!**********************************************************************!*\
  !*** ./src/content/list-command-bar/a-z-filter-button.component.tsx ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AZFilterButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const button_styles_1 = __webpack_require__(/*! ./button.styles */ "./src/content/list-command-bar/button.styles.tsx");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (props) => {
    const { spacing, sizes } = props.theme;
    return {
        azButtonStyles: Object.assign(Object.assign({}, button_styles_1.buttonStyles(props)), { icon: {
                margin: `0 ${spacing.normal} 0 ${spacing.xSmall}`,
                fontSize: spacing.medium
            } }),
        menuStyles: {
            list: {
                maxWidth: `calc(5 * ${sizes.mediumPlus})`
            },
            subComponentStyles: {
                menuItem: {
                    root: {
                        padding: 0,
                        textAlign: "center"
                    },
                    item: {
                        width: sizes.mediumPlus,
                        display: "inline-block",
                    }
                },
                callout: {}
            }
        }
    };
};
const AZFilterButton = (props) => {
    const { menuStyles, azButtonStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    props.subMenuProps.styles = menuStyles;
    return react_1.default.createElement(react_2.CompoundButton, Object.assign({}, props, { styles: azButtonStyles }));
};
exports.AZFilterButton = AZFilterButton;


/***/ }),

/***/ "./src/content/list-command-bar/button.styles.tsx":
/*!********************************************************!*\
  !*** ./src/content/list-command-bar/button.styles.tsx ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.buttonStyles = void 0;
const buttonStyles = ({ theme: { palette, fonts, sizes, spacing } }) => ({
    splitButtonContainer: {
        margin: `${spacing.xSmall} ${spacing.smallPlus} ${spacing.xSmall} 0`
    },
    root: {
        padding: 0,
        border: 0,
        minHeight: sizes.medium,
    },
    rootHovered: {
        border: 0,
    },
    menuIcon: {
        margin: `0 ${spacing.normal}`
    },
    splitButtonMenuButton: {
        border: 0,
        borderRadius: 0,
    },
    splitButtonMenuIcon: {
        margin: `${spacing.small} ${spacing.small} 0 ${spacing.small}`,
    },
    splitButtonDivider: {
        display: "none",
    },
    textContainer: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    },
    flexContainer: {
        padding: `0 ${spacing.smallPlus}`,
        boxSizing: "border-box",
        alignItems: "center"
    },
    label: {
        lineHeight: "normal",
        marginBottom: "0",
        fontWeight: "400"
    },
    description: {
        lineHeight: fonts.large.fontSize,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }
});
exports.buttonStyles = buttonStyles;


/***/ }),

/***/ "./src/content/list-command-bar/index.ts":
/*!***********************************************!*\
  !*** ./src/content/list-command-bar/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ListCommandBar = void 0;
var list_command_bar_component_1 = __webpack_require__(/*! ./list-command-bar.component */ "./src/content/list-command-bar/list-command-bar.component.tsx");
Object.defineProperty(exports, "ListCommandBar", ({ enumerable: true, get: function () { return list_command_bar_component_1.ListCommandBar; } }));


/***/ }),

/***/ "./src/content/list-command-bar/list-command-bar.component.tsx":
/*!*********************************************************************!*\
  !*** ./src/content/list-command-bar/list-command-bar.component.tsx ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ListCommandBar = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const make_a_z_helper_1 = __webpack_require__(/*! ./make-a-z.helper */ "./src/content/list-command-bar/make-a-z.helper.tsx");
const make_button_helper_1 = __webpack_require__(/*! ./make-button.helper */ "./src/content/list-command-bar/make-button.helper.tsx");
const make_refiners_helper_1 = __webpack_require__(/*! ./make-refiners.helper */ "./src/content/list-command-bar/make-refiners.helper.tsx");
const make_sort_helper_1 = __webpack_require__(/*! ./make-sort.helper */ "./src/content/list-command-bar/make-sort.helper.tsx");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing }) => ({
    rootStyles: {
        display: "flex",
        width: "100%",
        backgroundColor: palette.neutralEmpty,
    },
    textStyles: Object.assign(Object.assign({}, fonts.mediumPlus), { paddingLeft: spacing.medium, color: palette.neutralEmptyOn, alignSelf: "center" }),
    commandStyles: {
        flex: "1 1"
    }
}));
const fluentStyles = ({ theme: { sizes } }) => ({
    image: {
        height: sizes.xSmall
    }
});
const ListCommandBar = ({ config }) => {
    const { description, title, consumes, provides, props: { actions = [], showTitle } = { buttons: [], showTitle: false } } = config;
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const refinerProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'refiners');
    const sortProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'sort-option');
    const letterProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'letter-filter');
    const letterFilter = smarthub_common_1.useReadSharedState(letterProvider);
    const setLetterFilter = smarthub_common_1.useSetSharedState(letterProvider);
    const sortOption = smarthub_common_1.useReadSharedState(sortProvider);
    const getThemeImageURI = smarthub_common_1.useGetThemeImageURI();
    const setSortOption = smarthub_common_1.useSetSharedState(sortProvider);
    const refinerValues = smarthub_common_1.useReadSharedState(refinerProvider);
    const setRefinerValues = smarthub_common_1.useSetSharedState(refinerProvider);
    const sortOptions = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "sort-options"));
    const refiners = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "refiners"));
    const openAction = smarthub_common_1.useHandleCommand();
    const { commandStyles, textStyles, rootStyles } = useStyles();
    const imageStyles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const refinerButtons = react_1.useMemo(() => make_refiners_helper_1.makeRefiners(refiners, refinerValues, localizeConfig, setRefinerValues), [refinerValues, refiners, setRefinerValues]);
    const azButton = react_1.useMemo(() => (letterProvider
        ? make_a_z_helper_1.makeAZ(letterFilter, localizeConfig, setLetterFilter)
        : []), [letterFilter, setLetterFilter]);
    const { leftBefore, leftAfter, more, rightAfter, rightBefore } = react_1.useMemo(() => ({
        leftBefore: make_button_helper_1.makeButton(actions, smarthub_common_1.AppActionPosition.nearBefore, openAction, getThemeImageURI, imageStyles),
        leftAfter: make_button_helper_1.makeButton(actions, smarthub_common_1.AppActionPosition.nearAfter, openAction, getThemeImageURI, imageStyles),
        more: make_button_helper_1.makeButton(actions, [smarthub_common_1.AppActionPosition.moreBefore, smarthub_common_1.AppActionPosition.moreAfter, undefined], openAction, getThemeImageURI, imageStyles),
        rightBefore: make_button_helper_1.makeButton(actions, smarthub_common_1.AppActionPosition.farBefore, openAction, getThemeImageURI, imageStyles),
        rightAfter: make_button_helper_1.makeButton(actions, smarthub_common_1.AppActionPosition.farAfter, openAction, getThemeImageURI, imageStyles)
    }), [actions, getThemeImageURI, imageStyles]);
    const items = react_1.useMemo(() => [
        ...leftBefore,
        ...azButton,
        ...refinerButtons,
        ...leftAfter,
    ], [refinerButtons, azButton, leftAfter, leftBefore]);
    const farItems = react_1.useMemo(() => [
        ...rightBefore,
        ...make_sort_helper_1.makeSort(sortOptions, sortOption, localizeConfig, setSortOption),
        ...rightAfter,
    ], [sortOptions, sortOption, rightAfter, rightBefore]);
    return (react_1.useMemo(() => (react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement("div", { className: rootStyles },
            showTitle && react_1.default.createElement("div", { className: textStyles }, title),
            react_1.default.createElement(react_2.CommandBar, { className: commandStyles, title: description, ariaLabel: description, items: items, overflowItems: more, farItems: farItems })))), [items, farItems, config, rootStyles, textStyles, commandStyles]));
};
exports.ListCommandBar = ListCommandBar;


/***/ }),

/***/ "./src/content/list-command-bar/make-a-z.helper.tsx":
/*!**********************************************************!*\
  !*** ./src/content/list-command-bar/make-a-z.helper.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeAZ = void 0;
const a_z_filter_button_component_1 = __webpack_require__(/*! ./a-z-filter-button.component */ "./src/content/list-command-bar/a-z-filter-button.component.tsx");
const makeAZ = (current, localizeConfig, onClick) => {
    const menuItems = [];
    for (let i = "A".charCodeAt(0); i <= "Z".charCodeAt(0); i++) {
        let char = String.fromCharCode(i);
        menuItems.push({
            key: char,
            text: char,
            ariaDescription: `${localizeConfig.azFilterValueDesc} ${char}`,
            ariaLabel: `${localizeConfig.azFilterValueTitle} ${char}`,
            title: `${localizeConfig.azFilterValueTitle} ${char}`,
            onClick: () => onClick(char)
        });
    }
    return [{
            key: "a-z",
            text: `${localizeConfig.azFilterText}`,
            commandBarButtonAs: a_z_filter_button_component_1.AZFilterButton,
            split: current != null,
            checked: current != null,
            iconProps: current
                ? { iconName: 'ChromeClose' }
                : null,
            secondaryText: current
                ? `${localizeConfig.azFilterSecondaryText} ${current}`
                : null,
            ariaDescription: `${localizeConfig.azFilterDesc} ${current}`,
            ariaLabel: `${localizeConfig.azFilterTitle} ${current}`,
            subMenuProps: {
                items: menuItems
            },
            onClick: () => current != null
                ? onClick(undefined)
                : null
        }];
};
exports.makeAZ = makeAZ;


/***/ }),

/***/ "./src/content/list-command-bar/make-button.helper.tsx":
/*!*************************************************************!*\
  !*** ./src/content/list-command-bar/make-button.helper.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeButton = void 0;
const makeButton = (buttons, pos, onClick, getThemeImage, styles) => {
    return buttons
        .filter(({ position }) => Array.isArray(pos)
        ? ~pos.indexOf(position)
        : position == pos)
        .map(({ title, name, shortTitle, icon, action, description }, idx) => ({
        key: `${name}-${idx}`,
        text: shortTitle,
        iconProps: {
            iconName: typeof icon == 'string' ? icon : undefined,
            imageProps: icon && typeof icon == 'object'
                ? {
                    styles: styles,
                    src: getThemeImage(icon.image),
                    alt: typeof icon.image == 'object'
                        ? icon.image.text
                        : title
                }
                : undefined
        },
        ariaDescription: description,
        ariaLabel: title,
        title: title,
        onClick: () => onClick(action),
    }));
};
exports.makeButton = makeButton;


/***/ }),

/***/ "./src/content/list-command-bar/make-refiners.helper.tsx":
/*!***************************************************************!*\
  !*** ./src/content/list-command-bar/make-refiners.helper.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeRefiners = void 0;
const split_compound_button_component_1 = __webpack_require__(/*! ./split-compound-button.component */ "./src/content/list-command-bar/split-compound-button.component.tsx");
const makeRefiners = (refiners, selected, localizeConfig, onClick) => {
    if (!refiners)
        return [];
    const onRefinerChange = (name, value) => {
        const result = value == undefined
            ? Object.assign({}, selected) : Object.assign(Object.assign({}, selected), { [name]: value });
        if (value == undefined)
            delete result[name];
        onClick(Object.keys(result).length
            ? result
            : null);
    };
    const buttons = refiners.map(({ values, text, name }) => {
        const current = selected && selected[name]
            ? values.find(({ token }) => token == selected[name])
            : null;
        const currentText = current ? current.text : '';
        return {
            key: name,
            text: text,
            secondaryText: currentText,
            commandBarButtonAs: split_compound_button_component_1.SplitCompoundButton,
            split: current != null,
            checked: current != null,
            iconProps: current
                ? { iconName: 'ChromeClose' }
                : null,
            ariaDescription: `${localizeConfig.refineByDesc} ${text} ${currentText}`,
            ariaLabel: `${localizeConfig.refineByTitle} ${text} ${currentText}`,
            onClick: current != null ?
                () => onRefinerChange(name)
                : null,
            subMenuProps: {
                items: values
                    .map((value) => ({
                    key: value.token,
                    text: value.text,
                    ariaDescription: `${localizeConfig.refineByValueDesc} ${text} ${value.text}`,
                    ariaLabel: `${localizeConfig.refineByValueTitle} ${text} ${value.text}`,
                    title: `${localizeConfig.refineByValueTitle} ${text} ${value.text}`,
                    onClick: () => onRefinerChange(name, value.token)
                }))
            }
        };
    });
    if (selected)
        buttons.push({
            key: "clear-all",
            text: "Clear All",
            primary: true,
            iconProps: { iconName: 'ChromeClose' },
            ariaDescription: `${localizeConfig.refineByDesc}`,
            ariaLabel: `${localizeConfig.refineByTitle}`,
            title: `${localizeConfig.refineByTitle}`,
            onClick: () => onClick(null)
        });
    return buttons;
};
exports.makeRefiners = makeRefiners;


/***/ }),

/***/ "./src/content/list-command-bar/make-sort.helper.tsx":
/*!***********************************************************!*\
  !*** ./src/content/list-command-bar/make-sort.helper.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeSort = void 0;
const split_compound_button_component_1 = __webpack_require__(/*! ./split-compound-button.component */ "./src/content/list-command-bar/split-compound-button.component.tsx");
const makeSort = (options, option, localizeConfig, onClick) => {
    var _a;
    if (!options)
        return [];
    const sort = (_a = (option
        ? options.find(({ name, direction }) => name == option.name &&
            direction == option.direction)
        : options.find(({ preferred }) => preferred))) !== null && _a !== void 0 ? _a : options[0];
    const asc = !sort.direction || sort.direction == 'ascending' || sort.direction == 'asc';
    return [{
            key: "sort-options",
            text: `${localizeConfig.sortByText}`,
            commandBarButtonAs: split_compound_button_component_1.SplitCompoundButton,
            split: false,
            iconProps: {
                iconName: asc ? 'ascending' : 'descending'
            },
            secondaryText: sort.text,
            ariaDescription: `${localizeConfig.sortByDesc} ${sort.text}`,
            ariaLabel: `${localizeConfig.sortByTitle} ${sort.text}`,
            subMenuProps: {
                items: options.map(({ text, name, direction }, i) => {
                    const asc = !direction || direction == 'ascending' || direction == 'asc';
                    return {
                        key: `${name}-${direction}`,
                        text: text,
                        iconProps: {
                            iconName: asc ? 'ascending' : 'descending'
                        },
                        ariaDescription: `${localizeConfig.sortByValueDesc} ${text}`,
                        ariaLabel: `${localizeConfig.sortByValueTitle} ${text}`,
                        title: `${localizeConfig.sortByValueTitle} ${text}`,
                        onClick: () => onClick({ name, direction })
                    };
                })
            },
        }];
};
exports.makeSort = makeSort;


/***/ }),

/***/ "./src/content/list-command-bar/split-compound-button.component.tsx":
/*!**************************************************************************!*\
  !*** ./src/content/list-command-bar/split-compound-button.component.tsx ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SplitCompoundButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const button_styles_1 = __webpack_require__(/*! ./button.styles */ "./src/content/list-command-bar/button.styles.tsx");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (props) => {
    var _a;
    const { theme, config } = props;
    const { spacing, fonts } = theme;
    return Object.assign(Object.assign({}, button_styles_1.buttonStyles(props)), { icon: {
            margin: `0 ${spacing.normal} 0 ${spacing.xSmall}`,
            fontSize: ((_a = config.iconProps) === null || _a === void 0 ? void 0 : _a.iconName) == 'ChromeClose'
                ? fonts.small.fontSize
                : fonts.superLarge.fontSize
        } });
};
const SplitCompoundButton = (props) => {
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles, props);
    return react_1.default.createElement(react_2.CompoundButton, Object.assign({}, props, { styles: styles }));
};
exports.SplitCompoundButton = SplitCompoundButton;


/***/ }),

/***/ "./src/content/map/index.ts":
/*!**********************************!*\
  !*** ./src/content/map/index.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./map-embed.component */ "./src/content/map/map-embed.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./map.component */ "./src/content/map/map.component.tsx"), exports);


/***/ }),

/***/ "./src/content/map/map-embed.component.tsx":
/*!*************************************************!*\
  !*** ./src/content/map/map-embed.component.tsx ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MapEmbed = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const page_1 = __webpack_require__(/*! ../page */ "./src/content/page/index.ts");
const MapEmbed = ({ location: { address, coordinates }, width, height }) => {
    var _a, _b;
    const query = ((_a = coordinates === null || coordinates === void 0 ? void 0 : coordinates.lat) === null || _a === void 0 ? void 0 : _a.length) && ((_b = coordinates === null || coordinates === void 0 ? void 0 : coordinates.long) === null || _b === void 0 ? void 0 : _b.length)
        ? `${coordinates.lat},${coordinates.long}`
        : `${address.line1} ${address.postcode}`;
    const mapUri = `https://maps.google.com/maps?q=${encodeURIComponent(query)}&output=embed`;
    return (react_1.default.createElement(page_1.PageViewEmbed, { uri: mapUri, width: width, height: height }));
};
exports.MapEmbed = MapEmbed;


/***/ }),

/***/ "./src/content/map/map.component.tsx":
/*!*******************************************!*\
  !*** ./src/content/map/map.component.tsx ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Map = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const map_embed_component_1 = __webpack_require__(/*! ./map-embed.component */ "./src/content/map/map-embed.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles({
    wrapper: {
        display: 'flex',
        height: '100%',
    }
});
const Map = ({ config, config: { consumes, props } }) => {
    var _a;
    const location = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "location"))) !== null && _a !== void 0 ? _a : props === null || props === void 0 ? void 0 : props.location;
    const styles = useStyles();
    const message = smarthub_common_1.useLocalize(smarthub_common_1.LocalizeKeys.pageError);
    const error = !location
        ? {
            message
        }
        : undefined;
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.wrapper, error: error }, location && react_1.default.createElement(map_embed_component_1.MapEmbed, { location: location, width: props === null || props === void 0 ? void 0 : props.width, height: props === null || props === void 0 ? void 0 : props.height })));
};
exports.Map = Map;


/***/ }),

/***/ "./src/content/ms-form/index.ts":
/*!**************************************!*\
  !*** ./src/content/ms-form/index.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./ms-form-embed.component */ "./src/content/ms-form/ms-form-embed.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./ms-form.component */ "./src/content/ms-form/ms-form.component.tsx"), exports);


/***/ }),

/***/ "./src/content/ms-form/ms-form-embed.component.tsx":
/*!*********************************************************!*\
  !*** ./src/content/ms-form/ms-form-embed.component.tsx ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MSFormEmbed = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const page_1 = __webpack_require__(/*! ../page */ "./src/content/page/index.ts");
const MSFormEmbed = ({ uri, width, height, themeColour, lang = 'en-US', sso }) => {
    const formUri = `${uri}${!~uri.indexOf('&embed=')
        ? '&embed=true'
        : ''}${sso && !~uri.indexOf('&lang=')
        ? `&lang=${lang}`
        : ''}${sso && themeColour && !~uri.indexOf('&themecolor')
        ? `&themecolor=${themeColour}`
        : ''}${sso && !~uri.indexOf('&oembedsso=')
        ? '&oembedsso=true'
        : ''}`;
    return (react_1.default.createElement(page_1.PageViewEmbed, { uri: formUri, width: width, height: height }));
};
exports.MSFormEmbed = MSFormEmbed;


/***/ }),

/***/ "./src/content/ms-form/ms-form.component.tsx":
/*!***************************************************!*\
  !*** ./src/content/ms-form/ms-form.component.tsx ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MSForm = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const ms_form_embed_component_1 = __webpack_require__(/*! ./ms-form-embed.component */ "./src/content/ms-form/ms-form-embed.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles({
    wrapper: {
        display: 'flex',
        height: '100%',
    }
});
const MSForm = ({ config, config: { consumes, props } }) => {
    var _a, _b;
    let { themeColour, uri, sso } = props !== null && props !== void 0 ? props : {};
    const form = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "form"));
    const { definition: { palette } } = smarthub_common_1.useTheme();
    const styles = useStyles();
    const message = smarthub_common_1.useLocalize(smarthub_common_1.LocalizeKeys.msFormError);
    themeColour = themeColour
        ? (_a = palette[themeColour]) !== null && _a !== void 0 ? _a : themeColour : null;
    uri = ((_b = form === null || form === void 0 ? void 0 : form.uri) === null || _b === void 0 ? void 0 : _b.length) ? form.uri
        : props === null || props === void 0 ? void 0 : props.uri;
    const error = !(uri === null || uri === void 0 ? void 0 : uri.length) ? {
        message
    }
        : undefined;
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.wrapper, error: error }, (uri === null || uri === void 0 ? void 0 : uri.length) && react_1.default.createElement(ms_form_embed_component_1.MSFormEmbed, { uri: uri, width: '100%', height: '100%', themeColour: themeColour, sso: sso })));
};
exports.MSForm = MSForm;


/***/ }),

/***/ "./src/content/ms-power-app/index.ts":
/*!*******************************************!*\
  !*** ./src/content/ms-power-app/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./ms-power-app-embed.component */ "./src/content/ms-power-app/ms-power-app-embed.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./ms-power-app.component */ "./src/content/ms-power-app/ms-power-app.component.tsx"), exports);


/***/ }),

/***/ "./src/content/ms-power-app/ms-power-app-embed.component.tsx":
/*!*******************************************************************!*\
  !*** ./src/content/ms-power-app/ms-power-app-embed.component.tsx ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MSPowerAppEmbed = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const page_1 = __webpack_require__(/*! ../page */ "./src/content/page/index.ts");
const MSPowerAppEmbed = ({ appId, width, height, key }) => {
    const appUri = `https://apps.powerapps.com/play/${appId}?source=iframe`;
    return (react_1.default.createElement(page_1.PageViewEmbed, { key: key, uri: appUri, width: width, height: height }));
};
exports.MSPowerAppEmbed = MSPowerAppEmbed;


/***/ }),

/***/ "./src/content/ms-power-app/ms-power-app.component.tsx":
/*!*************************************************************!*\
  !*** ./src/content/ms-power-app/ms-power-app.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MSPowerApp = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const ms_power_app_embed_component_1 = __webpack_require__(/*! ./ms-power-app-embed.component */ "./src/content/ms-power-app/ms-power-app-embed.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles({
    wrapper: {
        display: 'flex',
        height: '100%',
    }
});
const MSPowerApp = ({ config, config: { consumes, props } }) => {
    var _a, _b;
    const app = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "app"));
    const theme = smarthub_common_1.useTheme();
    const refreshKey = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "refresh-key"))) !== null && _a !== void 0 ? _a : "0";
    const styles = useStyles();
    const appId = ((_b = app === null || app === void 0 ? void 0 : app.uri) === null || _b === void 0 ? void 0 : _b.length) ? app.uri
        : ((props === null || props === void 0 ? void 0 : props.themed) && (props === null || props === void 0 ? void 0 : props.themed[theme.name]) && (props === null || props === void 0 ? void 0 : props.themed[theme.name].length)
            ? props.themed[theme.name]
            : props === null || props === void 0 ? void 0 : props.appId);
    const message = smarthub_common_1.useLocalize(smarthub_common_1.LocalizeKeys.msPowerAppError);
    const error = !(appId === null || appId === void 0 ? void 0 : appId.length)
        ? {
            message
        }
        : undefined;
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.wrapper, error: error }, (appId === null || appId === void 0 ? void 0 : appId.length) && react_1.default.createElement(ms_power_app_embed_component_1.MSPowerAppEmbed, { appId: appId, key: refreshKey, width: '100%', height: '100%' })));
};
exports.MSPowerApp = MSPowerApp;


/***/ }),

/***/ "./src/content/ms-stream/index.ts":
/*!****************************************!*\
  !*** ./src/content/ms-stream/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./ms-stream-embed.component */ "./src/content/ms-stream/ms-stream-embed.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./ms-stream.component */ "./src/content/ms-stream/ms-stream.component.tsx"), exports);


/***/ }),

/***/ "./src/content/ms-stream/ms-stream-embed.component.tsx":
/*!*************************************************************!*\
  !*** ./src/content/ms-stream/ms-stream-embed.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StreamEmbed = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const page_1 = __webpack_require__(/*! ../page */ "./src/content/page/index.ts");
const StreamEmbed = ({ uri, width = '100%', height = '100%', sort, autoplay, responsive, startAt }) => {
    var _a;
    const typedURI = new URL(uri);
    const pathNameInitialString = (_a = typedURI === null || typedURI === void 0 ? void 0 : typedURI.pathname) === null || _a === void 0 ? void 0 : _a.split('/')[1];
    const updatedURI = `${typedURI === null || typedURI === void 0 ? void 0 : typedURI.origin}${pathNameInitialString != 'embed' ? '/embed' : ''}${typedURI === null || typedURI === void 0 ? void 0 : typedURI.pathname}`;
    const streamUri = `${updatedURI}?autoplay=${autoplay ? 'true' : 'false'}${sort ? `&sort=${sort}` : ''}&responsive=${responsive ? 'true' : 'false'}&startAt=${startAt > 0 ? startAt : 0}`;
    return (react_1.default.createElement(page_1.PageViewEmbed, { uri: streamUri, width: width, height: height }));
};
exports.StreamEmbed = StreamEmbed;


/***/ }),

/***/ "./src/content/ms-stream/ms-stream.component.tsx":
/*!*******************************************************!*\
  !*** ./src/content/ms-stream/ms-stream.component.tsx ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Stream = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const ms_stream_embed_component_1 = __webpack_require__(/*! ./ms-stream-embed.component */ "./src/content/ms-stream/ms-stream-embed.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles({
    wrapper: {
        display: 'flex',
        height: '100%',
    }
});
const Stream = ({ config, config: { props: { uri, sort, autoplay, responsive, startAt } } }) => {
    const styles = useStyles();
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.wrapper },
        react_1.default.createElement(ms_stream_embed_component_1.StreamEmbed, { uri: uri, width: '100%', height: '100%', sort: sort, autoplay: autoplay, responsive: responsive, startAt: startAt })));
};
exports.Stream = Stream;


/***/ }),

/***/ "./src/content/notification/index.ts":
/*!*******************************************!*\
  !*** ./src/content/notification/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./notification.component */ "./src/content/notification/notification.component.tsx"), exports);


/***/ }),

/***/ "./src/content/notification/notification.component.tsx":
/*!*************************************************************!*\
  !*** ./src/content/notification/notification.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Notification = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const fluentStyles = (({ config: count = 1, responsive: { size } = { size: 12 }, theme: { palette, fonts, spacing, sizes } }) => ({
    card: {
        root: Object.assign({ position: "absolute", boxShadow: `-${spacing.normal} -${spacing.normal} ${spacing.normal} ${palette.filmMinus1}`, right: 0, bottom: 0, zIndex: 1000, backgroundColor: palette.notifyMinus1, width: smarthub_common_1.responsiveColumnWidths[size] }, react_2.AnimationStyles.slideUpIn20)
    },
    actions: {
        root: {
            padding: 0
        },
        primarySet: {
            //TODO - Remove after Fluent UI Fix
            ["& .ms-OverflowSet-item"]: {
                width: `${100 / count}%`
            }
        }
    },
    action: {
        item: {
            width: `${100 / count}%`
        }
    },
    infoButton: {
        root: {
            width: "100%",
            backgroundColor: palette.notifyPlus1,
            color: palette.notifyPlus1On,
        },
        rootHovered: {
            backgroundColor: palette.notify,
            color: palette.notifyOn,
        },
        rootPressed: {
            backgroundColor: palette.notifyPlus2,
            color: palette.notifyPlus2On,
        },
        rootFocused: {
            backgroundColor: palette.notifyPlus2,
            color: palette.notifyPlus2On
        },
        icon: {
            color: palette.notifyPlus1On,
        },
        iconHovered: {
            color: palette.notifyOn,
        },
        iconPressed: {
            color: palette.notifyPlus2On,
        },
        textContainer: {
            flexGrow: 0
        }
    },
    acceptButton: {
        root: {
            width: "100%",
            backgroundColor: palette.notifyPlus2,
            color: palette.notifyPlus2On,
        },
        rootHovered: {
            backgroundColor: palette.notifyPlus1,
            color: palette.notifyPlus1On
        },
        rootPressed: {
            backgroundColor: palette.notify,
            color: palette.notifyOn,
        },
        rootFocused: {
            backgroundColor: palette.notify,
            color: palette.notifyOn,
        },
        icon: {
            color: palette.notifyPlus2On
        },
        iconHovered: {
            color: palette.notifyPlus1On
        },
        iconPressed: {
            color: palette.notifyOn,
        },
        textContainer: {
            flexGrow: 0
        }
    },
    dismissButton: {
        root: {
            width: "100%",
            backgroundColor: palette.notify,
            color: palette.notifyOn
        },
        rootHovered: {
            backgroundColor: palette.notifyMinus2,
            color: palette.notifyMinus2On
        },
        rootPressed: {
            backgroundColor: palette.notifyPlus1,
            color: palette.notifyPlus1On,
        },
        rootFocused: {
            backgroundColor: palette.notifyPlus1,
            color: palette.notifyPlus1On,
        },
        icon: {
            color: palette.notifyOn,
        },
        iconHovered: {
            color: palette.notifyMinus2On
        },
        iconPressed: {
            color: palette.notifyPlus1On,
        },
        textContainer: {
            flexGrow: 0
        }
    },
    rejectButton: {
        root: {
            width: "100%",
            backgroundColor: palette.hazardPlus1,
            color: palette.hazardPlus1On
        },
        rootHovered: {
            backgroundColor: palette.hazard,
            color: palette.hazardOn,
        },
        rootPressed: {
            backgroundColor: palette.hazardPlus2,
            color: palette.hazardPlus2On,
        },
        rootFocused: {
            backgroundColor: palette.hazardPlus2,
            color: palette.hazardPlus2On,
        },
        icon: {
            color: palette.hazardPlus1On
        },
        iconHovered: {
            color: palette.hazardOn,
        },
        iconPressed: {
            color: palette.hazardPlus2On,
        },
        textContainer: {
            flexGrow: 0
        }
    },
    body: {
        root: {
            color: palette.notifyMinus1On,
            display: "-webkit-box",
            textOverflow: "ellipsis",
            overflow: "hidden",
            "-webkit-line-clamp": "4",
            "-webkit-box-orient": "vertical",
        }
    },
    mainSection: {
        root: {
            display: "flex",
            minHeight: sizes.xxLargePlus
        }
    },
    contentSection: {
        root: {
            padding: spacing.medium
        }
    },
    icon: {
        root: {
            color: palette.notifyMinus1On,
            fontSize: fonts.mega.fontSize,
            width: fonts.mega.fontSize,
            margin: `${spacing.small} 0 ${spacing.medium} ${spacing.medium}`
        }
    },
    title: {
        root: Object.assign(Object.assign({}, fonts.mediumPlus), { color: palette.notifyMinus1On, whiteSpace: "norwap", textOverflow: "ellipsis", overflow: "hidden" })
    }
}));
const useImageStyles = react_jss_1.createUseStyles(({ spacing }) => ({
    image: {
        margin: `${spacing.mediumPlus} 0 ${spacing.medium} ${spacing.medium}`,
        maxHeight: "100%",
        height: "fit-content"
    }
}));
const responsiveConfig = {
    sm: { size: 12 },
    md: { size: 8 },
    lg: { size: 6 },
    lgx: { size: 5 },
    xl: { size: 4 },
    xlx: { size: 3 }
};
const Notification = () => {
    var _a;
    const imageStyles = useImageStyles();
    const dismiss = smarthub_common_1.useDismissNotification();
    const notification = smarthub_common_1.useNextNotification();
    const handleAction = smarthub_common_1.useHandleCommand();
    const localize = smarthub_common_1.useLocalizeConfig();
    const styleProps = smarthub_common_1.useThemeStyleProps((_a = notification === null || notification === void 0 ? void 0 : notification.actions) === null || _a === void 0 ? void 0 : _a.length, responsiveConfig);
    const styles = smarthub_common_1.useFluentStyles(fluentStyles, styleProps);
    const onClick = react_1.useCallback((action) => {
        if (action)
            handleAction(action);
        dismiss(notification);
    }, [notification, dismiss]);
    return react_1.useMemo(() => {
        var _a;
        return (react_1.default.createElement(react_1.default.Fragment, null, notification && react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.Announced, { message: `${localize.notificationAnnounce}: ${notification.title}` }),
            react_1.default.createElement(react_2.Stack, { styles: styles.card },
                react_1.default.createElement(react_2.Stack.Item, { styles: styles.mainSection },
                    react_1.default.createElement(react_2.Stack, { horizontal: true },
                        react_1.default.createElement(react_2.Stack.Item, null, ((_a = notification.icon) === null || _a === void 0 ? void 0 : _a.length) > 0 && react_1.default.createElement(react_2.Icon, { styles: styles.icon, iconName: notification.icon })),
                        react_1.default.createElement(react_2.Stack.Item, null, (notification === null || notification === void 0 ? void 0 : notification.image) && react_1.default.createElement(utilities_1.ThemeImage, { alt: notification.image.text, className: imageStyles.image, image: notification.image, defaultPalette: 'Notify', defaultSize: 'medium' })),
                        react_1.default.createElement(react_2.Stack.Item, { styles: styles.contentSection },
                            react_1.default.createElement(react_2.Text, { block: true, styles: styles.title }, notification.title),
                            react_1.default.createElement(react_2.Text, { block: true, styles: styles.body }, notification.body)))),
                react_1.default.createElement(react_2.Stack.Item, null,
                    react_1.default.createElement(react_2.CommandBar, { styles: styles.actions, items: notification.actions.map(({ title, type, description, icon, action }, idx) => ({
                            key: `${title}-${idx}`,
                            text: title,
                            itemProps: {
                                styles: styles.action
                            },
                            buttonStyles: type == 'dismiss'
                                ? styles.dismissButton
                                : type == 'accept'
                                    ? styles.acceptButton
                                    : type == 'reject'
                                        ? styles.rejectButton
                                        : styles.infoButton,
                            secondaryText: description,
                            iconProps: {
                                iconName: icon
                            },
                            ariaLabel: title,
                            title,
                            onClick: () => onClick(action)
                        })), ariaLabel: localize.notificationActions }))))));
    }, [notification, styles, imageStyles]);
};
exports.Notification = Notification;


/***/ }),

/***/ "./src/content/page/add-comment.component.tsx":
/*!****************************************************!*\
  !*** ./src/content/page/add-comment.component.tsx ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AddComment = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const page_comment_form_component_1 = __webpack_require__(/*! ./page-comment-form.component */ "./src/content/page/page-comment-form.component.tsx");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const AddComment = ({ config }) => {
    const { query, consumes, provides, props: { maxLength, localisedText } = {} } = config;
    const setRefreshKey = smarthub_common_1.useSetSharedState(provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'refreshKey'));
    const page = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"));
    const handleOnSuccess = react_1.useCallback(() => setRefreshKey((new Date()).getTime()), []);
    return react_1.useMemo(() => {
        var _a, _b;
        return ((((_a = page === null || page === void 0 ? void 0 : page.comments) === null || _a === void 0 ? void 0 : _a.enabled) && !((_b = page === null || page === void 0 ? void 0 : page.comments) === null || _b === void 0 ? void 0 : _b.closed))
            ? react_1.default.createElement(core_1.ComponentChrome, { config: config },
                react_1.default.createElement(page_comment_form_component_1.PageCommentForm, { mode: "add", displayMode: 'inline', query: query, localizedText: localisedText, maxLength: maxLength, params: { page }, onSuccess: handleOnSuccess }))
            : null);
    }, [config, page]);
};
exports.AddComment = AddComment;


/***/ }),

/***/ "./src/content/page/index.ts":
/*!***********************************!*\
  !*** ./src/content/page/index.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./page-content.component */ "./src/content/page/page-content.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page-view-embed.component */ "./src/content/page/page-view-embed.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page-view.component */ "./src/content/page/page-view.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page-header.component */ "./src/content/page/page-header.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page-nav.component */ "./src/content/page/page-nav.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page-metadata.component */ "./src/content/page/page-metadata.component/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page-comments.component */ "./src/content/page/page-comments.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page-comment-form.component */ "./src/content/page/page-comment-form.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./add-comment.component */ "./src/content/page/add-comment.component.tsx"), exports);


/***/ }),

/***/ "./src/content/page/page-comment-form.component.tsx":
/*!**********************************************************!*\
  !*** ./src/content/page/page-comment-form.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageCommentForm = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_hooks_1 = __webpack_require__(/*! @fluentui/react-hooks */ "@fluentui/react-hooks");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles(({ palette, spacing }) => ({
    errorStyle: {
        color: palette.hazard,
        marginTop: spacing.smallPlus
    }
}));
const fluentStyles = (({ theme: { palette } }) => ({
    root: {
        backgroundColor: palette.hazard,
        borderColor: palette.hazard
    },
    label: {
        color: palette.hazardOn
    }
}));
const PageCommentForm = ({ mode, localizedText, displayMode = 'popup', query, maxLength = 255, id = null, params, message = '', onSuccess }) => {
    const localize = smarthub_common_1.useLocalizeConfig();
    const fetch = smarthub_common_1.useFetch();
    const styleProps = smarthub_common_1.useThemeStyleProps();
    const commonStyles = useStyles();
    const styles = smarthub_common_1.useFluentStyles(fluentStyles, styleProps);
    const { queries } = query;
    const [modeIs, setModeIs] = react_1.useState(mode);
    const [hideDialog, { toggle: toggleHideDialog }] = react_hooks_1.useBoolean(false);
    const [textValue, setTextValue] = react_1.useState(decodeURIComponent(message));
    const [errorMsg, setErrorMsg] = react_1.useState('');
    const { saveButtonText, saveButtonLabel, cancelButtonText, cancelButtonLabel, deleteButtonText, deleteButtonLabel, clearButtonText, clearButtonLabel, textBoxTitle, textBoxLabel, confirmDelete, errorEmptyComment, errorCommentTooLong } = localize[localizedText || 'commentForm'];
    const onSubmit = react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const queryRequest = queries.find(({ action }) => action == modeIs);
        const textLength = textValue.length;
        let errorMsgIs = '';
        if (textLength > maxLength) {
            errorMsgIs = smarthub_common_1.replaceExpression(errorCommentTooLong, { maxLength });
        }
        else if (textLength == 0) {
            errorMsgIs = errorEmptyComment;
        }
        setErrorMsg(errorMsgIs);
        if (errorMsgIs != '')
            return;
        try {
            const body = { 'message': textValue };
            const fetchBody = Object.assign(Object.assign(Object.assign({}, params), body), { id });
            const response = yield fetch(queryRequest, fetchBody);
            if ((response === null || response === void 0 ? void 0 : response.data) || (response === null || response === void 0 ? void 0 : response.status) === 204) {
                onSuccess(modeIs === 'add' ? 'added' : 'updated');
                if (modeIs === 'add')
                    setTextValue("");
                toggleHideDialog();
            }
            else {
                setErrorMsg('Error occurred');
            }
        }
        catch (error) {
            setErrorMsg(error);
        }
    }), [textValue, localize, id]);
    const onChange = react_1.useCallback((ev, newText) => {
        setTextValue(newText);
    }, []);
    const onClear = react_1.useCallback(() => {
        setTextValue("");
        setErrorMsg("");
    }, [toggleHideDialog]);
    const onCancelDialog = react_1.useCallback(() => {
        setTextValue("");
        setModeIs(null);
        onSuccess('');
        toggleHideDialog();
    }, [toggleHideDialog]);
    const onDeleteFromUpdate = react_1.useCallback(() => {
        setModeIs('delete');
    }, []);
    const onDelete = react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const queryRequest = queries.find(({ action }) => action == 'delete');
        try {
            const body = { 'message': textValue };
            const fetchBody = Object.assign(Object.assign(Object.assign({}, params), body), { id });
            const response = yield fetch(queryRequest, fetchBody);
            if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
                onSuccess('deleted');
                toggleHideDialog();
            }
            else {
                setErrorMsg('Error occurred');
            }
        }
        catch (error) {
            setErrorMsg(error);
        }
    }), [localize, id]);
    const displayButtons = react_1.useCallback((modeIs) => {
        if (modeIs === 'add') {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_2.TextField, { placeholder: textBoxLabel, title: textBoxTitle, multiline: true, rows: 3, value: textValue, onChange: onChange, errorMessage: errorMsg }),
                react_1.default.createElement(react_2.DialogFooter, null,
                    react_1.default.createElement(react_2.PrimaryButton, { ariaLabel: saveButtonLabel, title: saveButtonLabel, text: saveButtonText, ariaDescription: saveButtonLabel, onClick: onSubmit }),
                    displayMode == 'inline'
                        ? react_1.default.createElement(react_2.DefaultButton, { ariaLabel: clearButtonLabel, title: clearButtonLabel, text: clearButtonText, ariaDescription: clearButtonLabel, onClick: onClear })
                        : react_1.default.createElement(react_2.DefaultButton, { ariaLabel: cancelButtonLabel, title: cancelButtonLabel, text: cancelButtonText, ariaDescription: cancelButtonLabel, onClick: onCancelDialog }))));
        }
        else if (modeIs === 'update') {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_2.TextField, { placeholder: textBoxLabel, title: textBoxTitle, multiline: true, rows: 3, value: textValue, onChange: onChange, errorMessage: errorMsg }),
                react_1.default.createElement(react_2.DialogFooter, null,
                    react_1.default.createElement(react_2.PrimaryButton, { styles: styles, ariaLabel: deleteButtonLabel, title: deleteButtonLabel, text: deleteButtonText, ariaDescription: deleteButtonLabel, onClick: onDeleteFromUpdate }),
                    react_1.default.createElement(react_2.PrimaryButton, { ariaLabel: saveButtonLabel, title: saveButtonLabel, text: saveButtonText, ariaDescription: saveButtonLabel, onClick: onSubmit }),
                    react_1.default.createElement(react_2.DefaultButton, { ariaLabel: cancelButtonLabel, title: cancelButtonLabel, text: cancelButtonText, ariaDescription: cancelButtonLabel, onClick: onCancelDialog }))));
        }
        else if (modeIs === 'delete') {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_2.Text, { block: true, title: confirmDelete }, confirmDelete),
                react_1.default.createElement(react_2.Text, { className: commonStyles.errorStyle }, errorMsg),
                react_1.default.createElement(react_2.DialogFooter, null,
                    react_1.default.createElement(react_2.PrimaryButton, { ariaLabel: deleteButtonLabel, title: deleteButtonLabel, text: deleteButtonText, ariaDescription: deleteButtonLabel, onClick: onDelete }),
                    react_1.default.createElement(react_2.DefaultButton, { ariaLabel: cancelButtonLabel, title: cancelButtonLabel, text: cancelButtonText, ariaDescription: cancelButtonLabel, onClick: onCancelDialog }))));
        }
        return null;
    }, [modeIs, textValue, localize, errorMsg]);
    return react_1.useMemo(() => displayMode == 'inline'
        ? displayButtons(modeIs)
        : react_1.default.createElement(react_2.Dialog, { hidden: hideDialog, minWidth: 450, onDismiss: toggleHideDialog }, displayButtons(modeIs)), [hideDialog, textValue, toggleHideDialog, modeIs, id, errorMsg]);
};
exports.PageCommentForm = PageCommentForm;


/***/ }),

/***/ "./src/content/page/page-comments.component.tsx":
/*!******************************************************!*\
  !*** ./src/content/page/page-comments.component.tsx ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageComments = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const card_list_1 = __webpack_require__(/*! ../card-list */ "./src/content/card-list/index.ts");
const PageComments = ({ config, config: { consumes }, config: { children } }) => {
    const page = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"));
    const card = children.find(c => c.$id == 'card');
    return react_1.useMemo(() => {
        var _a, _b;
        return ((((_a = page === null || page === void 0 ? void 0 : page.comments) === null || _a === void 0 ? void 0 : _a.enabled) && !((_b = page === null || page === void 0 ? void 0 : page.comments) === null || _b === void 0 ? void 0 : _b.closed) && card)
            ? react_1.default.createElement(card_list_1.CardList, { config: config })
            : null);
    }, [config]);
};
exports.PageComments = PageComments;


/***/ }),

/***/ "./src/content/page/page-content.component.tsx":
/*!*****************************************************!*\
  !*** ./src/content/page/page-content.component.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageContent = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_hooks_1 = __webpack_require__(/*! @fluentui/react-hooks */ "@fluentui/react-hooks");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing, sizes }) => ({
    selected: {
        "&::before": {
            width: spacing.xSmall,
            height: "100%",
            backgroundColor: palette.primaryMinus1,
            content: '""',
            marginLeft: `-${spacing.medium}`,
            position: "absolute"
        }
    },
    page: Object.assign(Object.assign({}, fonts.normal), { padding: `${spacing.medium} ${spacing.xxLarge}`, minHeight: "100%", boxSizing: 'border-box', backgroundColor: palette.neutralEmpty, color: palette.neutralEmptyOn, '@global': {
            table: {
                maxWidth: "100%",
                borderSpacing: 0,
                borderCollapse: "collapse",
                border: `${spacing.tiny} solid ${palette.neutral}`
            },
            th: Object.assign(Object.assign({}, fonts.mediumPlus), { padding: spacing.smallPlus, verticalAlign: "bottom", border: `${spacing.tiny} solid ${palette.neutral}`, backgroundColor: palette.neutralMinus4, color: palette.neutralMinus4On }),
            td: {
                verticalAlign: "top",
                padding: spacing.smallPlus,
                border: `${spacing.tiny} solid ${palette.neutral}`
            },
            img: {
                maxWidth: "100%"
            },
            iframe: {
                maxWidth: "100%"
            },
            h1: Object.assign(Object.assign({}, fonts.xLarge), { color: palette.primary, margin: `0 0 ${spacing.smallPlus} 0`, lineHeight: sizes.normalPlus, position: "relative" }),
            h2: Object.assign(Object.assign({}, fonts.large), { color: palette.primary, margin: `0 0 ${spacing.smallPlus} 0`, lineHeight: sizes.normalPlus, position: "relative" }),
            h3: Object.assign(Object.assign({}, fonts.mediumPlus), { color: palette.primary, margin: `0 0 ${spacing.smallPlus} 0`, lineHeight: sizes.normalPlus, position: "relative" }),
            h4: Object.assign(Object.assign({}, fonts.medium), { margin: `0 0 ${spacing.smallPlus} 0`, position: "relative", lineHeight: sizes.normalPlus }),
            h5: Object.assign(Object.assign({}, fonts.medium), { margin: `0 0 ${spacing.smallPlus} 0`, position: "relative", lineHeight: sizes.normalPlus }),
            h6: Object.assign(Object.assign({}, fonts.medium), { margin: `0 0 ${spacing.smallPlus} 0`, position: "relative", lineHeight: sizes.normalPlus }),
            p: {
                marginBottom: spacing.medium,
            },
            a: {
                color: palette.primary,
                '&:hover': {
                    color: palette.primaryPlus2,
                },
                '&:visited': {
                    color: palette.primaryPlus2,
                },
                '&:active': {
                    color: palette.primaryPlus2,
                },
            },
        } })
}));
const PageContent = ({ config, config: { consumes, provides, props } }) => {
    const { formatProvider, maxNavHeading = "h3" } = props !== null && props !== void 0 ? props : {};
    const headingId = react_hooks_1.useId('heading');
    const container = react_1.useRef(null);
    const contentFormatter = smarthub_common_1.useContentFormat(formatProvider);
    const handleAction = smarthub_common_1.useHandleCommand();
    const styles = useStyles();
    const page = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"));
    const heading = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "heading"));
    const setHeadings = smarthub_common_1.useSetSharedState(provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == "headings"));
    const [content, setContent] = react_1.useState(null);
    react_1.useEffect(() => {
        const current = document.getElementsByClassName(styles.selected);
        if (current.length)
            current.item(0).classList.remove(styles.selected);
        const next = document.getElementById(heading);
        if (next) {
            next.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest"
            });
            next.classList.add(styles.selected);
        }
    }, [heading]);
    react_1.useEffect(() => {
        var _a;
        if (page === null || page === void 0 ? void 0 : page.content) {
            let contentIs = '';
            if (Array.isArray(page === null || page === void 0 ? void 0 : page.content)) {
                const namedContent = (props === null || props === void 0 ? void 0 : props.name) ? filterContentByName(page === null || page === void 0 ? void 0 : page.content, props === null || props === void 0 ? void 0 : props.name) : page === null || page === void 0 ? void 0 : page.content;
                contentIs = namedContent.map(content => content.text).join(' ');
            }
            else {
                contentIs = (_a = page === null || page === void 0 ? void 0 : page.content) === null || _a === void 0 ? void 0 : _a.text;
            }
            contentFormatter(contentIs, { headingId, maxNavHeading }).then(result => {
                setHeadings(result.headings);
                setContent(result.content);
            });
        }
    }, [page, headingId]);
    const filterContentByName = (content, name) => {
        let res = [];
        if (typeof name === 'string') { // To handle string prop name Eg: name: "content"
            res = content.filter((el) => (el === null || el === void 0 ? void 0 : el.name) == name);
        }
        else { // To handle Array name prop Eg: name:["servicesImpacted1","servicesImpacted2"], 
            res = content.filter(data => {
                return name.find(element => {
                    return element === (data === null || data === void 0 ? void 0 : data.name);
                });
            });
        }
        return res;
    };
    const handleLink = react_1.useCallback((e) => {
        var _a, _b;
        let target = e.target;
        if (e.type == 'keypress' && e.keyCode != react_2.KeyCodes.enter)
            return;
        while (target != container.current && target.tagName != 'A') {
            target = target.parentElement;
        }
        if (target.tagName != 'A')
            return;
        e.stopPropagation();
        e.preventDefault();
        const action = ((_b = (_a = target.dataset) === null || _a === void 0 ? void 0 : _a.action) === null || _b === void 0 ? void 0 : _b.length) ? JSON.parse(target.dataset.action)
            : {
                $schema: smarthub_common_1.RouteActionSchema,
                uri: target.href
            };
        handleAction(action);
    }, []);
    return react_1.useMemo(() => (react_1.default.createElement(core_1.ComponentChrome, { config: config, hasContent: (content === null || content === void 0 ? void 0 : content.length) > 0 }, content && react_1.default.createElement("div", { ref: container, className: styles.page, onClickCapture: handleLink, onKeyPressCapture: handleLink, dangerouslySetInnerHTML: { __html: content } }))), [content, styles]);
};
exports.PageContent = PageContent;


/***/ }),

/***/ "./src/content/page/page-header.component.tsx":
/*!****************************************************!*\
  !*** ./src/content/page/page-header.component.tsx ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageHeader = exports.useStyles = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_hooks_1 = __webpack_require__(/*! @fluentui/react-hooks */ "@fluentui/react-hooks");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const relativeTime_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/relativeTime */ "dayjs/plugin/relativeTime"));
dayjs_1.default.extend(relativeTime_1.default);
exports.useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing }) => ({
    lines: Object.assign(Object.assign({}, fonts.normal), { display: "flex", alignItems: "center", margin: spacing.medium, gap: spacing.xxLarge, flexWrap: "wrap", "& div": {
            display: "flex",
            width: "auto",
            alignItems: "center",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "el",
            "& i": {
                verticalAlign: "middle",
                marginRight: spacing.smallPlus
            },
            "& span": {
                verticalAlign: "middle",
            },
        } })
}));
const PageHeader = ({ config, data }) => {
    const { children = [], consumes } = config;
    const tooltipId = react_hooks_1.useId('tooltip');
    const panelStyles = smarthub_common_1.usePanelStyles();
    const styles = exports.useStyles();
    const render = smarthub_common_1.useRender();
    const localize = smarthub_common_1.useLocalizeConfig();
    const gridStyles = smarthub_common_1.useGridStyles();
    const page = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'page'));
    //TODO remove line.format below - AES should enable this transform.
    return react_1.useMemo(() => {
        var _a;
        const { menu, nav } = children.reduce((named, component) => {
            named[component.$id] = component;
            return named;
        }, {});
        return react_1.default.createElement("header", { className: panelStyles.header },
            react_1.default.createElement("div", { className: gridStyles.grid },
                react_1.default.createElement("div", { className: gridStyles.row },
                    react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.smmin12].join(" ") },
                        menu && render(menu, null, core_1.PanelSidebarButton)(),
                        page && react_1.default.createElement("div", null,
                            react_1.default.createElement("h1", { className: panelStyles.title, "aria-label": localize.pageTitleLabel }, page.title),
                            react_1.default.createElement("div", { className: styles.lines }, (_a = page.lines) === null || _a === void 0 ? void 0 : _a.map((line, idx) => (react_1.default.createElement(react_2.TooltipHost, { key: idx, content: `${line.label} ${line.text}`, id: `${tooltipId}-line-${idx}` },
                                react_1.default.createElement("div", { "aria-describedby": `${tooltipId}-line-${idx}` },
                                    react_1.default.createElement(react_2.Icon, { iconName: line.icon }),
                                    react_1.default.createElement("span", null, line.format == 'span'
                                        ? dayjs_1.default(line.text).fromNow()
                                        : line.text)))))))),
                    react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.smmin12].join(" ") }, nav && render(nav, data, core_1.TabNavigation)()))));
    }, [config, data, panelStyles, page]);
};
exports.PageHeader = PageHeader;


/***/ }),

/***/ "./src/content/page/page-metadata.component/index.ts":
/*!***********************************************************!*\
  !*** ./src/content/page/page-metadata.component/index.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageListing = exports.PageMetadata = exports.PageLinks = exports.PageDate = exports.PageUser = exports.PageMap = exports.PageLocation = exports.PageImage = exports.PageDetails = exports.PageCategory = void 0;
var page_category_component_1 = __webpack_require__(/*! ./page-category.component */ "./src/content/page/page-metadata.component/page-category.component.tsx");
Object.defineProperty(exports, "PageCategory", ({ enumerable: true, get: function () { return page_category_component_1.PageCategory; } }));
var page_details_component_1 = __webpack_require__(/*! ./page-details.component */ "./src/content/page/page-metadata.component/page-details.component.tsx");
Object.defineProperty(exports, "PageDetails", ({ enumerable: true, get: function () { return page_details_component_1.PageDetails; } }));
var page_image_component_1 = __webpack_require__(/*! ./page-image.component */ "./src/content/page/page-metadata.component/page-image.component.tsx");
Object.defineProperty(exports, "PageImage", ({ enumerable: true, get: function () { return page_image_component_1.PageImage; } }));
var page_location_component_1 = __webpack_require__(/*! ./page-location.component */ "./src/content/page/page-metadata.component/page-location.component.tsx");
Object.defineProperty(exports, "PageLocation", ({ enumerable: true, get: function () { return page_location_component_1.PageLocation; } }));
var page_map_component_1 = __webpack_require__(/*! ./page-map.component */ "./src/content/page/page-metadata.component/page-map.component.tsx");
Object.defineProperty(exports, "PageMap", ({ enumerable: true, get: function () { return page_map_component_1.PageMap; } }));
var page_user_component_1 = __webpack_require__(/*! ./page-user.component */ "./src/content/page/page-metadata.component/page-user.component.tsx");
Object.defineProperty(exports, "PageUser", ({ enumerable: true, get: function () { return page_user_component_1.PageUser; } }));
var page_date_component_1 = __webpack_require__(/*! ./page-date.component */ "./src/content/page/page-metadata.component/page-date.component.tsx");
Object.defineProperty(exports, "PageDate", ({ enumerable: true, get: function () { return page_date_component_1.PageDate; } }));
var page_links_component_1 = __webpack_require__(/*! ./page-links.component */ "./src/content/page/page-metadata.component/page-links.component.tsx");
Object.defineProperty(exports, "PageLinks", ({ enumerable: true, get: function () { return page_links_component_1.PageLinks; } }));
var page_metadata_component_1 = __webpack_require__(/*! ./page-metadata.component */ "./src/content/page/page-metadata.component/page-metadata.component.tsx");
Object.defineProperty(exports, "PageMetadata", ({ enumerable: true, get: function () { return page_metadata_component_1.PageMetadata; } }));
var page_listing_component_1 = __webpack_require__(/*! ./page-listing.component */ "./src/content/page/page-metadata.component/page-listing.component.tsx");
Object.defineProperty(exports, "PageListing", ({ enumerable: true, get: function () { return page_listing_component_1.PageListing; } }));


/***/ }),

/***/ "./src/content/page/page-metadata.component/page-category.component.tsx":
/*!******************************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page-category.component.tsx ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageCategory = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const page_listing_component_1 = __webpack_require__(/*! ./page-listing.component */ "./src/content/page/page-metadata.component/page-listing.component.tsx");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const PageCategory = ({ config, config: { consumes, props: { types, headerAlign } = {} }, data }) => {
    var _a;
    const page = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"))) !== null && _a !== void 0 ? _a : data;
    return react_1.useMemo(() => react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement(page_listing_component_1.PageListing, { horizontal: true, groups: page === null || page === void 0 ? void 0 : page.categoryGroups, headerAlign: headerAlign, types: types }, (group, { id, label, text }) => react_1.default.createElement(utilities_1.Tag, { key: id, tagInfo: {
                label,
                text
            } }))), [page]);
};
exports.PageCategory = PageCategory;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page-date.component.tsx":
/*!**************************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page-date.component.tsx ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageDate = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const page_styles_1 = __webpack_require__(/*! ./page.styles */ "./src/content/page/page-metadata.component/page.styles.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const PageDate = ({ config, config: { consumes }, data }) => {
    var _a;
    const localize = smarthub_common_1.useLocalizeConfig();
    const activityStyles = smarthub_common_1.useFluentStylesWithProps(page_styles_1.activityStyles);
    const styles = page_styles_1.useSectionStyles();
    const page = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"))) !== null && _a !== void 0 ? _a : data;
    return react_1.useMemo(() => {
        var _a;
        return react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.sectionContent }, (_a = page === null || page === void 0 ? void 0 : page.dates) === null || _a === void 0 ? void 0 : _a.map((d, i) => (react_1.default.createElement(react_2.ActivityItem, { key: `${d.text}${i}`, styles: activityStyles, activityDescription: [
                react_1.default.createElement("span", { key: 1 },
                    d.label,
                    " "),
                react_1.default.createElement("span", { key: 2 }, d.text)
            ], activityIcon: d.icon
                ? react_1.default.createElement(react_2.Icon, { iconName: d.icon })
                : null }))));
    }, [page, localize]);
};
exports.PageDate = PageDate;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page-details.component.tsx":
/*!*****************************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page-details.component.tsx ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageDetails = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const page_listing_component_1 = __webpack_require__(/*! ./page-listing.component */ "./src/content/page/page-metadata.component/page-listing.component.tsx");
const page_styles_1 = __webpack_require__(/*! ./page.styles */ "./src/content/page/page-metadata.component/page.styles.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const fluentStyles = (({ theme: { spacing, sizes } }) => ({
    iconStyles: {
        root: {
            lineHeight: sizes.normal
        }
    },
    buttonStyles: {
        root: {
            marginLeft: spacing.smallPlus,
            minHeight: sizes.normal,
            height: "auto"
        }
    }
}));
const PageDetails = ({ config, config: { consumes, props: { types, headerAlign } = {} }, data }) => {
    var _a;
    const page = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"))) !== null && _a !== void 0 ? _a : data;
    const { iconStyles, buttonStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const styles = page_styles_1.useSectionStyles();
    const handleAction = smarthub_common_1.useHandleCommand();
    return react_1.useMemo(() => react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement(page_listing_component_1.PageListing, { groups: page === null || page === void 0 ? void 0 : page.detailGroups, headerAlign: headerAlign, types: types }, (group, { icon, label, text, action, otherText }, idx) => (action
            ? react_1.default.createElement("div", { className: [styles.row, styles.padLeft, idx == 0 ? styles.first : ''].join(' ') },
                react_1.default.createElement(react_2.PrimaryButton, { styles: buttonStyles, iconProps: icon ? { iconName: icon } : null, title: text, ariaLabel: text, text: text, onClick: () => handleAction(action) }))
            : react_1.default.createElement("div", { className: [styles.row, idx == 0 ? styles.first : ''].join(' ') },
                icon && react_1.default.createElement(react_2.Icon, { styles: iconStyles, iconName: icon }),
                react_1.default.createElement("div", { className: styles.content },
                    label && react_1.default.createElement(react_2.Label, null,
                        label,
                        ": "),
                    react_1.default.createElement("div", { className: styles.text },
                        react_1.default.createElement(react_2.Text, null, text), otherText === null || otherText === void 0 ? void 0 :
                        otherText.map((text, i) => {
                            return react_1.default.createElement(react_2.Text, { key: i, block: true }, text);
                        }))))))), [page, config]);
};
exports.PageDetails = PageDetails;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page-image.component.tsx":
/*!***************************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page-image.component.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageImage = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const image_1 = __webpack_require__(/*! ../../image */ "./src/content/image/index.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const PageImage = ({ config, config: { consumes, props }, data }) => {
    var _a, _b, _c;
    const { imageType, height, width, fit, orientation } = props;
    const page = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"))) !== null && _a !== void 0 ? _a : data;
    const { uri, label, description } = (_c = (_b = page === null || page === void 0 ? void 0 : page.images) === null || _b === void 0 ? void 0 : _b.find(i => i.type == imageType)) !== null && _c !== void 0 ? _c : {};
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config }, (uri === null || uri === void 0 ? void 0 : uri.length) > 0 && react_1.default.createElement(image_1.ImageEmbed, { uri: uri, height: height, width: width, fit: fit, orientation: orientation, alt: label, description: description })));
};
exports.PageImage = PageImage;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page-links.component.tsx":
/*!***************************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page-links.component.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageLinks = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const page_styles_1 = __webpack_require__(/*! ./page.styles */ "./src/content/page/page-metadata.component/page.styles.ts");
const page_listing_component_1 = __webpack_require__(/*! ./page-listing.component */ "./src/content/page/page-metadata.component/page-listing.component.tsx");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const PageLinks = ({ config, config: { consumes, props: { types, headerAlign } = {} }, data }) => {
    var _a;
    const styles = page_styles_1.useSectionStyles();
    const groupedLinkStyles = smarthub_common_1.useFluentStylesWithProps(page_styles_1.groupedLinkStyles);
    const page = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"))) !== null && _a !== void 0 ? _a : data;
    const handleAction = smarthub_common_1.useHandleCommand();
    const handleLink = react_1.useCallback((e) => {
        if ((e.type == 'keypress' && e.keyCode != react_2.KeyCodes.enter))
            return;
        e.stopPropagation();
        e.preventDefault();
        const action = {
            $id: "",
            $schema: smarthub_common_1.RouteActionSchema,
            uri: e.currentTarget.href
        };
        handleAction(action);
    }, []);
    return react_1.useMemo(() => react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement(page_listing_component_1.PageListing, { groups: page === null || page === void 0 ? void 0 : page.linkGroups, headerAlign: headerAlign, types: types }, ({ icon }, { uri, text }, idx) => react_1.default.createElement("div", { className: [styles.row, , idx == 0 ? styles.first : ''].join(' ') },
            (icon === null || icon === void 0 ? void 0 : icon.length) > 0 && react_1.default.createElement(react_2.Icon, { iconName: icon }),
            react_1.default.createElement(react_2.Link, { href: uri, key: idx, title: `${text}`, "aria-label": `${text}`, styles: groupedLinkStyles, onClick: handleLink, onKeyPress: handleLink, target: "_blank" }, text)))), [page]);
};
exports.PageLinks = PageLinks;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page-listing.component.tsx":
/*!*****************************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page-listing.component.tsx ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageListing = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const fluentStyles = (({ theme: { spacing, sizes } }) => ({
    stackStyles: {
        root: {
            padding: `0 ${spacing.medium} ${spacing.medium} ${spacing.medium}`
        },
        inner: {
            gap: spacing.smallPlus,
        }
    },
    iconStyles: {
        root: {
            marginRight: spacing.smallPlus
        }
    },
    sepStyles: {
        content: {
            lineHeight: sizes.normal
        }
    }
}));
const PageListing = ({ types, headerAlign, groups, horizontal, className, children }) => {
    const { iconStyles, sepStyles, stackStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    return react_1.default.createElement(react_2.Stack, { horizontal: horizontal == true, wrap: true }, groups === null || groups === void 0 ? void 0 : groups.filter(g => {
        var _a;
        return ((_a = g === null || g === void 0 ? void 0 : g.list) === null || _a === void 0 ? void 0 : _a.length) > 0
            && (!(types === null || types === void 0 ? void 0 : types.length)
                || ~types.indexOf(g.type));
    }).map((g, i) => {
        var _a, _b;
        return react_1.default.createElement(react_2.StackItem, { key: i },
            ((_a = g.text) === null || _a === void 0 ? void 0 : _a.length) > 0 && react_1.default.createElement(react_2.Separator, { styles: sepStyles, alignContent: headerAlign !== null && headerAlign !== void 0 ? headerAlign : 'start' },
                ((_b = g.icon) === null || _b === void 0 ? void 0 : _b.length) > 0 && react_1.default.createElement(react_2.Icon, { styles: iconStyles, iconName: g.icon }),
                react_1.default.createElement("span", null, g.text)),
            react_1.default.createElement(react_2.Stack, { styles: stackStyles, horizontal: horizontal == true, wrap: true }, g.list.map((item, idx) => react_1.default.createElement(react_2.StackItem, { key: idx }, children(g, item, idx)))));
    }));
};
exports.PageListing = PageListing;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page-location.component.tsx":
/*!******************************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page-location.component.tsx ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageLocation = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const page_styles_1 = __webpack_require__(/*! ./page.styles */ "./src/content/page/page-metadata.component/page.styles.ts");
const page_helper_1 = __webpack_require__(/*! ./page.helper */ "./src/content/page/page-metadata.component/page.helper.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const PageLocation = ({ config, config: { consumes }, data }) => {
    var _a;
    const localize = smarthub_common_1.useLocalizeConfig();
    const handleCommand = smarthub_common_1.useHandleCommand();
    const styles = page_styles_1.useSectionStyles();
    const activityStyles = smarthub_common_1.useFluentStylesWithProps(page_styles_1.activityStyles);
    const page = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"))) !== null && _a !== void 0 ? _a : data;
    return react_1.useMemo(() => {
        var _a;
        return react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.sectionContent }, (_a = page === null || page === void 0 ? void 0 : page.locations) === null || _a === void 0 ? void 0 : _a.map((p, i) => (react_1.default.createElement(react_2.ActivityItem, { key: `${p.text}${i}`, styles: activityStyles, activityDescription: [
                react_1.default.createElement("span", { key: 1 },
                    p.label,
                    " "),
                react_1.default.createElement(react_2.Link, { key: 2, onClick: () => handleCommand(p.action), styles: page_styles_1.linkStyles, title: p.text, "aria-label": p.text }, p.text),
            ], timeStamp: p.date, activityPersonas: [{
                    text: p.text,
                    imageInitials: page_helper_1.getInitials(p.text),
                    onClick: () => handleCommand(p.action)
                }] }))));
    }, [page, localize]);
};
exports.PageLocation = PageLocation;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page-map.component.tsx":
/*!*************************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page-map.component.tsx ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageMap = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const map_1 = __webpack_require__(/*! ../../map */ "./src/content/map/index.ts");
const page_styles_1 = __webpack_require__(/*! ./page.styles */ "./src/content/page/page-metadata.component/page.styles.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const PageMap = ({ config, config: { consumes, props }, data }) => {
    var _a;
    const { height, width } = props;
    const styles = page_styles_1.useSectionStyles();
    const page = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"))) !== null && _a !== void 0 ? _a : data;
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.sectionContent }, (page === null || page === void 0 ? void 0 : page.geoLocation) && react_1.default.createElement(map_1.MapEmbed, { location: page.geoLocation, height: height, width: width })));
};
exports.PageMap = PageMap;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page-metadata.component.tsx":
/*!******************************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page-metadata.component.tsx ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageMetadata = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const page_category_component_1 = __webpack_require__(/*! ./page-category.component */ "./src/content/page/page-metadata.component/page-category.component.tsx");
const page_details_component_1 = __webpack_require__(/*! ./page-details.component */ "./src/content/page/page-metadata.component/page-details.component.tsx");
const page_image_component_1 = __webpack_require__(/*! ./page-image.component */ "./src/content/page/page-metadata.component/page-image.component.tsx");
const page_location_component_1 = __webpack_require__(/*! ./page-location.component */ "./src/content/page/page-metadata.component/page-location.component.tsx");
const page_map_component_1 = __webpack_require__(/*! ./page-map.component */ "./src/content/page/page-metadata.component/page-map.component.tsx");
const page_user_component_1 = __webpack_require__(/*! ./page-user.component */ "./src/content/page/page-metadata.component/page-user.component.tsx");
const page_date_component_1 = __webpack_require__(/*! ./page-date.component */ "./src/content/page/page-metadata.component/page-date.component.tsx");
const page_links_component_1 = __webpack_require__(/*! ./page-links.component */ "./src/content/page/page-metadata.component/page-links.component.tsx");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const PageMetadata = ({ config, config: { consumes, children = [], props = {} } }) => {
    const { horizontal, wrap } = props;
    const render = smarthub_common_1.useRender();
    const page = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"));
    return react_1.useMemo(() => react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement(react_2.Stack, { horizontal: horizontal, wrap: wrap }, children.map((child) => {
            const fallback = child.$id == 'category'
                ? page_category_component_1.PageCategory
                : child.$id == 'details'
                    ? page_details_component_1.PageDetails
                    : child.$id == 'image'
                        ? page_image_component_1.PageImage
                        : child.$id == 'location'
                            ? page_location_component_1.PageLocation
                            : child.$id == 'map'
                                ? page_map_component_1.PageMap
                                : child.$id == 'user'
                                    ? page_user_component_1.PageUser
                                    : child.$id == 'date'
                                        ? page_date_component_1.PageDate
                                        : child.$id == 'links'
                                            ? page_links_component_1.PageLinks
                                            : null;
            return react_1.default.createElement(react_2.StackItem, { key: child.$id, grow: true, shrink: true }, render(child, page, fallback)());
        }))), [page]);
};
exports.PageMetadata = PageMetadata;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page-user.component.tsx":
/*!**************************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page-user.component.tsx ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageUser = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const page_styles_1 = __webpack_require__(/*! ./page.styles */ "./src/content/page/page-metadata.component/page.styles.ts");
const page_helper_1 = __webpack_require__(/*! ./page.helper */ "./src/content/page/page-metadata.component/page.helper.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const PageUser = ({ config, config: { consumes }, data }) => {
    var _a;
    const activityStyles = smarthub_common_1.useFluentStylesWithProps(page_styles_1.activityStyles);
    const localize = smarthub_common_1.useLocalizeConfig();
    const handleCommand = smarthub_common_1.useHandleCommand();
    const styles = page_styles_1.useSectionStyles();
    const page = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"))) !== null && _a !== void 0 ? _a : data;
    return react_1.useMemo(() => {
        var _a;
        return react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.sectionContent }, (_a = page === null || page === void 0 ? void 0 : page.users) === null || _a === void 0 ? void 0 : _a.map((p, i) => (react_1.default.createElement(react_2.ActivityItem, { key: `${p.text}${i}`, styles: activityStyles, activityDescription: [
                react_1.default.createElement("span", { key: 1 },
                    p.label,
                    " "),
                react_1.default.createElement(react_2.Link, { key: 2, onClick: () => handleCommand(p.action), styles: page_styles_1.linkStyles, title: p.text, "aria-label": p.text }, p.text),
            ], timeStamp: p.date, activityPersonas: [{
                    imageUrl: p.image,
                    text: p.text,
                    imageInitials: page_helper_1.getInitials(p.text),
                    onClick: () => handleCommand(p.action)
                }] }))));
    }, [page, localize]);
};
exports.PageUser = PageUser;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page.helper.ts":
/*!*****************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page.helper.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getInitials = void 0;
const getInitials = (text) => {
    if (!(text === null || text === void 0 ? void 0 : text.length))
        return null;
    const letters = text.match(/([^A-Z]|^)([A-Z])/g);
    return `${letters[0]}${letters.length > 1 ? letters[letters.length - 1] : ''}`;
};
exports.getInitials = getInitials;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page.styles.ts":
/*!*****************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page.styles.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLinkStyles = exports.groupedLinkStyles = exports.useSectionStyles = exports.activityStyles = exports.linkStyles = void 0;
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
exports.linkStyles = {
    root: {
        fontWeight: 600
    }
};
exports.activityStyles = (({ theme: { palette, spacing, fonts } }) => ({
    root: {
        marginBottom: spacing.medium
    },
    activityContent: {
        alignSelf: "center"
    },
    activityText: Object.assign(Object.assign({}, fonts.normal), { display: "block", color: palette.neutralEmptyOn }),
    activityTypeIcon: {
        height: "100%",
        alignSelf: "center"
    },
    timeStamp: {
        color: palette.neutralEmptyOn
    }
}));
exports.useSectionStyles = react_jss_1.createUseStyles(({ spacing }) => ({
    section: {
        padding: `0 ${spacing.medium} ${spacing.medium} ${spacing.medium}`,
    },
    sectionContent: {
        padding: spacing.medium,
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap"
    },
    padLeft: {
        paddingLeft: spacing.mediumPlus,
    },
    first: {},
    row: {
        display: "flex",
        gap: spacing.small,
        paddingTop: spacing.normal,
        ["&$first"]: {
            paddingTop: 0,
        }
    },
    content: {
        display: "flex",
        flex: "1 1",
        justifyContent: "space-between",
        gap: spacing.small,
        flexWrap: "wrap"
    },
    text: {
        display: "flex",
        padding: `${spacing.small} 0`,
        flexDirection: "column"
    }
}));
const groupedLinkStyles = ({ theme: { spacing } }) => ({
    root: {
        marginBottom: spacing.small,
    }
});
exports.groupedLinkStyles = groupedLinkStyles;
exports.useLinkStyles = react_jss_1.createUseStyles(({ spacing }) => ({
    links: {
        display: "flex",
        flexDirection: "column"
    },
    group: {
        marginBottom: spacing.small,
        fontWeight: 600
    }
}));


/***/ }),

/***/ "./src/content/page/page-nav.component.tsx":
/*!*************************************************!*\
  !*** ./src/content/page/page-nav.component.tsx ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageNav = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const navStyles = {
    root: {
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        overflowY: 'auto',
    },
    linkText: {
        whiteSpace: "normal",
        lineHeight: "normal",
        display: "-webkit-box",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": "2",
    },
    chevronButton: {
        margin: 0
    },
    groupContent: {
        marginBottom: 0
    }
};
const transformHeadings = (headings, localize, expanded) => {
    return headings
        ? headings
            .map(({ text, id, children }) => ({
            name: `${text}`,
            ariaLabel: `${localize.pageNavLinkLabel} ${text}`,
            title: `${localize.pageNavLinkLabel} ${text}`,
            url: '',
            key: id,
            target: '_blank',
            links: transformHeadings(children, localize, expanded),
            collapseAriaLabel: `${localize.collapseLabel} ${text}`,
            expandAriaLabel: `${localize.expandLabel} ${text}`,
            isExpanded: expanded
        }))
        : null;
};
const PageNav = ({ config, config: { description, consumes, provides, props: { expanded } = { expanded: false } } }) => {
    const localize = smarthub_common_1.useLocalizeConfig();
    const headings = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "headings"));
    const heading = smarthub_common_1.useReadSharedState(provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == "heading"));
    const setHeading = smarthub_common_1.useSetSharedState(provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == "heading"));
    const onClick = react_1.useCallback((e, item) => {
        setHeading(item.key);
    }, [setHeading]);
    const links = react_1.useMemo(() => {
        return headings
            ? transformHeadings(headings, localize, expanded)
            : null;
    }, [headings]);
    return react_1.useMemo(() => (react_1.default.createElement(core_1.ComponentChrome, { hasContent: (links === null || links === void 0 ? void 0 : links.length) > 0, config: config }, links && react_1.default.createElement(react_2.Nav, { selectedKey: heading, styles: navStyles, onLinkClick: onClick, ariaLabel: description, groups: [{ links }] }))), [links, heading]);
};
exports.PageNav = PageNav;


/***/ }),

/***/ "./src/content/page/page-view-embed.component.tsx":
/*!********************************************************!*\
  !*** ./src/content/page/page-view-embed.component.tsx ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageViewEmbed = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles({
    viewer: ({ width, height }) => ({
        position: "relative",
        flex: "1 1",
        width: (width === null || width === void 0 ? void 0 : width.length) ? width : "100%",
        height: (height === null || height === void 0 ? void 0 : height.length) ? height : "100%",
        background: "transparent",
    }),
    frame: {
        height: "100%",
        width: "100%",
        border: "0"
    }
});
const PageViewEmbed = ({ uri, width, key, height }) => {
    const useWebView = navigator.userAgent.toLowerCase().indexOf(' electron/') > 0;
    const styles = useStyles({ width, height });
    return (react_1.default.createElement("div", { className: styles.viewer },
        !useWebView &&
            react_1.default.createElement("iframe", { key: key, src: uri, allowFullScreen: true, className: styles.frame }),
        useWebView &&
            react_1.default.createElement("webview", { key: key, src: uri, allowFullScreen: true, className: styles.frame })));
};
exports.PageViewEmbed = PageViewEmbed;


/***/ }),

/***/ "./src/content/page/page-view.component.tsx":
/*!**************************************************!*\
  !*** ./src/content/page/page-view.component.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageView = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const page_view_embed_component_1 = __webpack_require__(/*! ./page-view-embed.component */ "./src/content/page/page-view-embed.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles({
    wrapper: {
        display: 'flex',
        height: '100%',
    }
});
const PageView = ({ config, config: { consumes, props } }) => {
    var _a;
    const page = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"));
    const styles = useStyles();
    let uri = ((_a = page === null || page === void 0 ? void 0 : page.uri) === null || _a === void 0 ? void 0 : _a.length) ? page.uri : props === null || props === void 0 ? void 0 : props.uri;
    const message = smarthub_common_1.useLocalize(smarthub_common_1.LocalizeKeys.pageError);
    const error = !(uri === null || uri === void 0 ? void 0 : uri.length)
        ? {
            message
        }
        : undefined;
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.wrapper, error: error }, (uri === null || uri === void 0 ? void 0 : uri.length) && react_1.default.createElement(page_view_embed_component_1.PageViewEmbed, { uri: uri })));
};
exports.PageView = PageView;


/***/ }),

/***/ "./src/content/preferences/banner-image-selector.component.tsx":
/*!*********************************************************************!*\
  !*** ./src/content/preferences/banner-image-selector.component.tsx ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BannerImageSelector = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const fluentStyles = (({ theme: { spacing } }) => ({
    selectButtonStyles: {
        root: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            maxWidth: "none",
            display: "flex",
            justifyContent: "center"
        },
        flexContainer: {
            alignItems: "center",
            minWidth: "auto"
        }
    },
    imageStyles: {
        root: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            overflow: "hidden",
            borderRadius: spacing.xSmall
        },
        image: {
            maxWidth: "100%",
            position: "absolute",
            top: "50%",
            transform: "translate(0%, -50%)"
        }
    }
}));
const useStyles = react_jss_1.createUseStyles(({ spacing }) => ({
    root: {
        padding: spacing.medium,
    },
    imageContainer: {
        position: "relative",
        width: "100%",
        paddingTop: "20%"
    },
    buttons: {
        width: "100%",
        display: "flex",
        gap: spacing.smallPlus,
        justifyContent: "flex-end",
        marginTop: spacing.medium
    }
}));
const UploadResultSchema = "https://ics.ai/smarthub/file/upload-result";
const BannerImageSelector = ({ config, config: { query, props: { maxSize } = { maxSize: 0 } } }) => {
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const { queries } = query;
    const [imageRef, setImageRef] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys.userBannerImage, true);
    const [imageUri, setImageUri] = react_1.useState(null);
    const styles = useStyles();
    const { imageStyles, selectButtonStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const [upload, download] = smarthub_common_1.useFile();
    const transform = smarthub_common_1.useTransform();
    const fileRef = react_1.useRef(null);
    const [error, setError] = react_1.useState(null);
    const selectFile = react_1.useCallback(({ currentTarget }, newValue) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        setError(null);
        const file = (currentTarget).files[0];
        const { name, size, type } = file;
        if (maxSize && size > maxSize) {
            setError(localizeConfig.imageSelectSizeError);
            return;
        }
        if (!type.match(/image.*/)) {
            setError(localizeConfig.imageSelectTypeError);
            return;
        }
        const uploadQuery = queries.find(({ id }) => id == 'upload');
        const { data } = yield upload(file, uploadQuery, { name, size, type });
        const result = transform(UploadResultSchema, data);
        setImageRef(result);
    }), []);
    const remove = react_1.useCallback(() => {
        setImageRef(null);
    }, []);
    react_1.useEffect(() => {
        if (imageRef)
            (() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                const query = queries.find(({ id }) => id == 'download');
                const { uri } = yield download(query, 'dataUri', imageRef);
                setImageUri(uri);
            }))();
        else
            setImageUri(null);
    }, [imageRef]);
    const chooseFile = react_1.useCallback(() => {
        fileRef.current.click();
    }, []);
    return react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.root },
        react_1.default.createElement("input", { accept: "image/*", ref: fileRef, hidden: true, type: "file", onChange: selectFile }),
        imageUri && react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: styles.imageContainer },
                react_1.default.createElement(react_2.Image, { src: imageUri, styles: imageStyles, coverStyle: react_2.ImageCoverStyle.landscape })),
            react_1.default.createElement("div", { className: styles.buttons }, imageUri &&
                react_1.default.createElement(react_2.DefaultButton, { ariaLabel: localizeConfig.imageRemoveLabel, title: localizeConfig.imageRemoveText, text: localizeConfig.imageRemoveText, label: localizeConfig.imageRemoveLabel, onClick: remove }))),
        !imageUri && react_1.default.createElement("div", { className: styles.imageContainer },
            react_1.default.createElement(react_2.CompoundButton, { styles: selectButtonStyles, iconProps: { iconName: 'PictureCenter' }, ariaLabel: localizeConfig.imageSelectText, title: localizeConfig.imageSelectText, label: localizeConfig.imageSelectLabel, text: localizeConfig.imageSelectText, secondaryText: localizeConfig.imageSelectSecondaryText, onClick: chooseFile })),
        error && react_1.default.createElement("span", null, error));
};
exports.BannerImageSelector = BannerImageSelector;


/***/ }),

/***/ "./src/content/preferences/index.ts":
/*!******************************************!*\
  !*** ./src/content/preferences/index.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./banner-image-selector.component */ "./src/content/preferences/banner-image-selector.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./theme-list.component */ "./src/content/preferences/theme-list.component.tsx"), exports);


/***/ }),

/***/ "./src/content/preferences/theme-list.component.tsx":
/*!**********************************************************!*\
  !*** ./src/content/preferences/theme-list.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ThemeList = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const theme_option_component_1 = __webpack_require__(/*! ./theme-option.component */ "./src/content/preferences/theme-option.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const buildLinks = (themes) => {
    return themes.map(({ $id, name, description, definition }) => ({
        name: name,
        key: $id,
        description: description,
        url: "",
        definition
    }));
};
const buildGroups = (themes, localize) => {
    const types = ['light', 'mid', 'dark', 'contrast', 'tone'];
    return types.reduce((groups, t) => {
        const typeThemes = themes.filter(({ definition: { type } }) => type == t);
        if (typeThemes.length)
            groups.push({
                name: localize[`${t}ThemeTypeTitle`],
                expandAriaLabel: `${localize.expandOptions}`,
                collapseAriaLabel: `${localize.collapseOptions}`,
                links: buildLinks(typeThemes)
            });
        return groups;
    }, []);
};
const ThemeList = ({ config, data }) => {
    const themes = smarthub_common_1.useThemes();
    const theme = smarthub_common_1.useTheme();
    const localize = smarthub_common_1.useLocalizeConfig();
    const options = react_1.useMemo(() => {
        return buildGroups(themes, localize);
    }, [themes, localize]);
    return react_1.useMemo(() => (react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement(react_2.Nav, { key: theme.$id, selectedKey: theme.name, groups: options, ariaLabel: localize.themeListLabel, linkAs: theme_option_component_1.ThemeOption }))), [options, localize]);
};
exports.ThemeList = ThemeList;


/***/ }),

/***/ "./src/content/preferences/theme-option.component.tsx":
/*!************************************************************!*\
  !*** ./src/content/preferences/theme-option.component.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ThemeOption = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const paletteNames = {
    primary: ["primaryEmpty", "primaryMinus4", "primaryMinus3", "primaryMinus2", "primaryMinus1", "primary", "primaryPlus1", "primaryPlus2", "primaryFull"],
    neutral: ["neutralEmpty", "neutralMinus4", "neutralMinus3", "neutralMinus2", "neutralMinus1", "neutral", "neutralPlus1", "neutralPlus3", "neutralFull"]
};
const useThemeStyles = react_jss_1.createUseStyles(({ fonts, spacing, sizes }) => ({
    theme: {
        borderRadius: spacing.small,
        display: "flex",
        overflow: "hidden",
        flexDirection: "column",
        margin: spacing.smallPlus,
        boxShadow: "rgb(0 0 0 / 13%) 0px 1.6px 3.6px 0px, rgb(0 0 0 / 11%) 0px 0.3px 0.9px 0px"
    },
    palette: {
        height: spacing.medium,
        display: "flex",
        marginTop: spacing.tiny,
        gap: spacing.tiny,
        ['@global div']: {
            flex: "1 1"
        }
    },
    title: Object.assign(Object.assign({}, fonts.mediumPlus), { borderTopLeftRadius: spacing.small, borderTopRightRadius: spacing.small, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", padding: `0 ${spacing.medium}`, lineHeight: sizes.mediumPlus }),
    content: {
        flex: "1 1",
        padding: spacing.medium,
        display: "flex",
        flexDirection: "column",
        gap: spacing.medium
    }
}));
const ThemeOption = ({ link: { name, key, description, definition: { palette } } }) => {
    const styles = useThemeStyles();
    const localize = smarthub_common_1.useLocalizeConfig();
    const setTheme = smarthub_common_1.useSetTheme();
    const setThemePref = smarthub_common_1.useSetPreference(smarthub_common_1.preferenceKeys.userTheme);
    const select = react_1.useCallback((e) => {
        setThemePref(key);
        setTheme(key);
    }, [setTheme, setThemePref]);
    return react_1.default.createElement("div", { className: styles.theme },
        react_1.default.createElement("div", { className: styles.title, style: {
                color: palette.primaryOn,
                backgroundColor: palette.primary
            } }, name),
        react_1.default.createElement("div", { style: {
                color: palette.neutralEmptyOn,
                backgroundColor: palette.neutralEmpty
            } },
            react_1.default.createElement("div", { className: styles.palette }, paletteNames.primary.map(c => react_1.default.createElement("div", { key: c, style: {
                    backgroundColor: palette[c]
                } }))),
            react_1.default.createElement("div", { className: styles.palette }, paletteNames.neutral.map(c => react_1.default.createElement("div", { key: c, style: {
                    color: palette[`${c}On`],
                    backgroundColor: palette[c]
                } }))),
            react_1.default.createElement("div", { className: styles.content },
                react_1.default.createElement("div", { style: {
                        color: palette.primary
                    } }, description),
                react_1.default.createElement(react_2.DefaultButton, { styles: {
                        root: {
                            border: 0,
                            backgroundColor: palette.primaryMinus2,
                            color: palette.primaryMinus2On,
                        }
                    }, "aria-label": localize.themeButtonLabel, title: localize.themeButtonLabel, text: localize.themeButtonText, onClick: select }))));
};
exports.ThemeOption = ThemeOption;


/***/ }),

/***/ "./src/content/profile/hierarchy-list.component.tsx":
/*!**********************************************************!*\
  !*** ./src/content/profile/hierarchy-list.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HierarchyPersonaList = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const hierarchy_persona_component_1 = __webpack_require__(/*! ./hierarchy-persona.component */ "./src/content/profile/hierarchy-persona.component.tsx");
const useHierachyStyles = react_jss_1.createUseStyles(({ palette, spacing, sizes }) => ({
    collapsed: {
        "& $personas": {
            flexDirection: "row",
        },
        "& $connector": {
            display: "none",
        },
        "& $listConnector": {
            display: "none",
        }
    },
    list: {
        paddingTop: spacing.xSmall,
        position: "relative",
        display: "flex",
        flexDirection: "column",
        "&$collapsed": {
            flexDirection: "row",
            alignItems: "center"
        },
    },
    container: {
        position: "relative",
        paddingTop: spacing.large
    },
    personas: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        gap: spacing.large,
    },
    persona: {
        display: "flex"
    },
    connector: {},
    button: {
        marginTop: spacing.large,
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        gap: spacing.small,
        "&::before": {
            content: '""',
            height: spacing.xSmall,
            flex: "1 1",
            background: palette.neutral
        },
        "&::after": {
            content: '""',
            height: spacing.xSmall,
            flex: "1 1",
            background: palette.neutral
        },
        "$collapsed &": {
            "&::before": {
                content: "unset"
            },
            "&::after": {
                content: "unset"
            },
            justifyContent: "start",
            width: "auto",
        },
    },
    listConnector: {
        top: 0,
        width: spacing.xSmall,
        bottom: 0,
        position: "absolute",
        backgroundColor: palette.neutral,
        marginLeft: `calc((${sizes.mediumEm} - ${spacing.xSmall})/2)`
    },
    profileList: {
        "& $listConnector": {
            bottom: `calc(((${sizes.xLarge} + ${spacing.xSmall}) / 2) - ${spacing.xSmall})`
        },
        "& $connector": {
            width: sizes.smallPlus,
            marginTop: `calc((${sizes.xLarge} + ${spacing.xSmall}) / 2)`,
            height: spacing.xSmall,
            backgroundColor: palette.neutral,
            marginLeft: sizes.smallPlus
        }
    },
    managerList: {
        "& $container": {
            paddingTop: 0
        }
    },
    reportList: {
        paddingLeft: sizes.xLarge,
        "& $listConnector": {
            bottom: sizes.smallPlus
        },
        "& $connector": {
            width: sizes.smallPlus,
            height: spacing.xSmall,
            marginTop: spacing.large,
            border: 0,
            backgroundColor: palette.neutral,
            marginLeft: sizes.smallPlus
        }
    },
}));
const fluentStyles = (({ theme: { palette, sizes, spacing, fonts }, config: collapsed }) => ({
    button: {
        root: {
            borderRadius: sizes.medium,
            backgroundColor: palette.primary,
            width: sizes.medium,
            height: sizes.medium,
            marginLeft: collapsed ? spacing.large : 0
        },
        rootHovered: {
            backgroundColor: palette.primaryPlus2,
        },
        iconHovered: {
            color: palette.primaryPlus2On,
        },
        icon: {
            transition: "transform 0.1s linear 0s",
            color: palette.primaryOn,
            transform: collapsed ? "rotate(-180deg)" : undefined
        }
    },
    largeCoin: {
        coin: {
            border: `${spacing.xSmall} solid ${palette.neutral}`,
            backgroundColor: palette.neutralEmpty,
            borderRadius: sizes.xxLarge,
            minWidth: sizes.xxLarge,
            padding: spacing.xSmall,
            height: sizes.xxLarge,
            overflow: "hidden",
            boxSizing: "border-box",
            cursor: 'pointer',
        }
    },
    smallCoin: {
        coin: {
            border: `${spacing.xSmall} solid ${palette.neutral}`,
            backgroundColor: palette.neutralEmpty,
            borderRadius: sizes.mediumPlus,
            minWidth: sizes.mediumEm,
            padding: spacing.xSmall,
            height: sizes.mediumEm,
            overflow: "hidden",
            boxSizing: "border-box",
            cursor: 'pointer',
        }
    },
    persona: {
        secondaryText: {
            color: palette.neutralMinus5On
        },
        primaryText: {
            color: palette.neutralEmptyOn,
        },
        details: {
            display: collapsed ? "none" : undefined
        }
    },
    link: {
        root: Object.assign({}, fonts.normal)
    }
}));
const HierarchyPersonaList = ({ people, type, collapsable, initialCollapse }) => {
    const handeCommand = smarthub_common_1.useHandleCommand();
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const styles = useHierachyStyles();
    const [collapsed, setCollapse] = react_1.useState(initialCollapse);
    const hierarchyStyles = smarthub_common_1.useFluentStylesWithProps(fluentStyles, collapsed);
    const [list, setList] = react_1.useState([]);
    react_1.useEffect(() => {
        if (people && collapsed)
            setList(people.slice(1, 4));
        else
            setList(people !== null && people !== void 0 ? people : []);
    }, [collapsed, people]);
    return react_1.default.createElement("div", { className: [styles.list, styles[`${type}List`], collapsed ? styles.collapsed : ''].join(' ') },
        react_1.default.createElement("div", { className: styles.container },
            react_1.default.createElement("div", { className: styles.listConnector }),
            react_1.default.createElement("div", { className: styles.personas }, list.map(p => react_1.default.createElement(hierarchy_persona_component_1.HierarchyPersona, { key: p.$id, fluentStyles: hierarchyStyles, person: p, type: type, handeCommand: handeCommand, localizeConfig: localizeConfig, styles: styles })))),
        list.length > 0 && collapsable && react_1.default.createElement("div", { className: styles.button },
            react_1.default.createElement(react_2.IconButton, { styles: hierarchyStyles.button, onClick: () => setCollapse(!collapsed), iconProps: { iconName: 'ChevronUp' } })));
};
exports.HierarchyPersonaList = HierarchyPersonaList;


/***/ }),

/***/ "./src/content/profile/hierarchy-persona.component.tsx":
/*!*************************************************************!*\
  !*** ./src/content/profile/hierarchy-persona.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HierarchyPersona = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const getCustomPrimaryTextRenderer = (action, linkStyles) => {
    return (props) => {
        return (react_1.default.createElement(utilities_1.ActionLink, { styles: linkStyles, "aria-label": props["aria-label"], title: props.title, action: action }, props.text));
    };
};
const HierarchyPersona = ({ person, type, styles, fluentStyles, handeCommand, localizeConfig }) => {
    const personaProps = {
        styles: fluentStyles.persona,
        size: type == 'profile' ? react_2.PersonaSize.size56 : react_2.PersonaSize.size40,
        coinProps: {
            styles: type == 'profile' ? fluentStyles.largeCoin : fluentStyles.smallCoin,
            onClick: () => handeCommand(person.action),
        },
        text: person.name,
        secondaryText: person.jobTitle,
        tertiaryText: person.department,
        imageUrl: person.image,
        imageAlt: person.name,
        title: `${localizeConfig.personaLinkTitle} ${person.name}`,
        "aria-label": `${localizeConfig.personaLinkAria} ${person.name}`,
        onRenderPrimaryText: getCustomPrimaryTextRenderer(person.action, fluentStyles.link)
    };
    return react_1.default.createElement("div", { className: styles.persona },
        react_1.default.createElement("div", { className: styles.connector }),
        react_1.default.createElement(react_2.Persona, Object.assign({}, personaProps)));
};
exports.HierarchyPersona = HierarchyPersona;


/***/ }),

/***/ "./src/content/profile/hierarchy.component.tsx":
/*!*****************************************************!*\
  !*** ./src/content/profile/hierarchy.component.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Hierarchy = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const hierarchy_list_component_1 = __webpack_require__(/*! ./hierarchy-list.component */ "./src/content/profile/hierarchy-list.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles(({ spacing }) => ({
    inner: {
        padding: `${spacing.smallPlus} ${spacing.medium}`,
        boxSizing: "border-box",
        maxWidth: "100%"
    }
}));
const Hierarchy = ({ config }) => {
    var _a;
    const { query, consumes } = config;
    const transform = smarthub_common_1.useTransform();
    const fetch = smarthub_common_1.useFetch();
    const styles = useStyles();
    const [data, setData] = react_1.useState({ managers: [], reports: [] });
    const currentProfile = smarthub_common_1.useProfile();
    const profile = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "profile"))) !== null && _a !== void 0 ? _a : currentProfile;
    react_1.useEffect(() => {
        const fetchData = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            try {
                const { data } = yield fetch(query, { profile });
                const managers = (_a = transform(smarthub_common_1.IPersonSchema, data.managers)) !== null && _a !== void 0 ? _a : [];
                const reports = (_b = transform(smarthub_common_1.IPersonSchema, data.reports)) !== null && _b !== void 0 ? _b : [];
                setData({
                    managers: managers,
                    reports: reports,
                });
            }
            catch (ex) {
                smarthub_common_1.Logger.error("Failed to fetch hierachy data", false, { ex });
            }
        });
        fetchData();
    }, [profile, fetch]);
    const managerData = react_1.useMemo(() => {
        return [...data.managers].reverse();
    }, [data.managers]);
    return react_1.useMemo(() => (react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement("div", { className: styles.inner },
            react_1.default.createElement(hierarchy_list_component_1.HierarchyPersonaList, { people: managerData, type: "manager" }),
            react_1.default.createElement(hierarchy_list_component_1.HierarchyPersonaList, { people: [profile], type: "profile" }),
            react_1.default.createElement(hierarchy_list_component_1.HierarchyPersonaList, { people: data.reports, type: "report", collapsable: true, initialCollapse: true })))), [profile, data]);
};
exports.Hierarchy = Hierarchy;


/***/ }),

/***/ "./src/content/profile/index.ts":
/*!**************************************!*\
  !*** ./src/content/profile/index.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileSummary = exports.ProfileSkills = exports.ProfileSchools = exports.ProfileProjects = exports.ProfileInterests = exports.ProfileContactInfo = exports.ProfileAboutInfo = exports.ProfileContact = exports.ProfileHeader = exports.MyHeader = exports.Hierarchy = exports.HierarchyPersona = exports.HierarchyPersonaList = void 0;
var hierarchy_list_component_1 = __webpack_require__(/*! ./hierarchy-list.component */ "./src/content/profile/hierarchy-list.component.tsx");
Object.defineProperty(exports, "HierarchyPersonaList", ({ enumerable: true, get: function () { return hierarchy_list_component_1.HierarchyPersonaList; } }));
var hierarchy_persona_component_1 = __webpack_require__(/*! ./hierarchy-persona.component */ "./src/content/profile/hierarchy-persona.component.tsx");
Object.defineProperty(exports, "HierarchyPersona", ({ enumerable: true, get: function () { return hierarchy_persona_component_1.HierarchyPersona; } }));
var hierarchy_component_1 = __webpack_require__(/*! ./hierarchy.component */ "./src/content/profile/hierarchy.component.tsx");
Object.defineProperty(exports, "Hierarchy", ({ enumerable: true, get: function () { return hierarchy_component_1.Hierarchy; } }));
var my_header_component_1 = __webpack_require__(/*! ./my-header.component */ "./src/content/profile/my-header.component.tsx");
Object.defineProperty(exports, "MyHeader", ({ enumerable: true, get: function () { return my_header_component_1.MyHeader; } }));
var profile_header_component_1 = __webpack_require__(/*! ./profile-header.component */ "./src/content/profile/profile-header.component.tsx");
Object.defineProperty(exports, "ProfileHeader", ({ enumerable: true, get: function () { return profile_header_component_1.ProfileHeader; } }));
var profile_contact_component_1 = __webpack_require__(/*! ./profile-contact.component */ "./src/content/profile/profile-contact.component.tsx");
Object.defineProperty(exports, "ProfileContact", ({ enumerable: true, get: function () { return profile_contact_component_1.ProfileContact; } }));
var profile_about_info_component_1 = __webpack_require__(/*! ./profile-about-info.component */ "./src/content/profile/profile-about-info.component.tsx");
Object.defineProperty(exports, "ProfileAboutInfo", ({ enumerable: true, get: function () { return profile_about_info_component_1.ProfileAboutInfo; } }));
var profile_contact_info_component_1 = __webpack_require__(/*! ./profile-contact-info.component */ "./src/content/profile/profile-contact-info.component.tsx");
Object.defineProperty(exports, "ProfileContactInfo", ({ enumerable: true, get: function () { return profile_contact_info_component_1.ProfileContactInfo; } }));
var profile_interests_component_1 = __webpack_require__(/*! ./profile-interests.component */ "./src/content/profile/profile-interests.component.tsx");
Object.defineProperty(exports, "ProfileInterests", ({ enumerable: true, get: function () { return profile_interests_component_1.ProfileInterests; } }));
var profile_projects_component_1 = __webpack_require__(/*! ./profile-projects.component */ "./src/content/profile/profile-projects.component.tsx");
Object.defineProperty(exports, "ProfileProjects", ({ enumerable: true, get: function () { return profile_projects_component_1.ProfileProjects; } }));
var profile_schools_component_1 = __webpack_require__(/*! ./profile-schools.component */ "./src/content/profile/profile-schools.component.tsx");
Object.defineProperty(exports, "ProfileSchools", ({ enumerable: true, get: function () { return profile_schools_component_1.ProfileSchools; } }));
var profile_skills_component_1 = __webpack_require__(/*! ./profile-skills.component */ "./src/content/profile/profile-skills.component.tsx");
Object.defineProperty(exports, "ProfileSkills", ({ enumerable: true, get: function () { return profile_skills_component_1.ProfileSkills; } }));
var profile_summary_component_1 = __webpack_require__(/*! ./profile-summary.component */ "./src/content/profile/profile-summary.component.tsx");
Object.defineProperty(exports, "ProfileSummary", ({ enumerable: true, get: function () { return profile_summary_component_1.ProfileSummary; } }));


/***/ }),

/***/ "./src/content/profile/my-header.component.tsx":
/*!*****************************************************!*\
  !*** ./src/content/profile/my-header.component.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MyHeader = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles(({ palette }) => ({
    background: (hasImage) => ({
        position: "relative",
        backgroundColor: hasImage
            ? palette.neutalFilmMinus2
            : undefined,
    }),
    components: {
        position: "relative",
        justifyContent: "flex-end",
        flexDirection: "row",
        display: "flex",
        width: "100%",
        ["& > *"]: {
            flex: "0 0"
        }
    }
}));
const fluentStyles = (({ theme: { palette, spacing, fonts }, config: hasImage }) => ({
    image: {
        root: {
            position: 'absolute',
            width: '100%',
            height: '100%'
        }
    },
    coin: {
        coin: {
            marginLeft: spacing.smallPlus,
        }
    },
    persona: {
        tertiaryText: {
            display: "none"
        },
        details: {
            width: "auto",
            padding: `${spacing.large} ${spacing.medium} ${spacing.large} ${spacing.medium}`,
            boxSizing: "border-box",
        },
        primaryText: {
            h1: Object.assign(Object.assign({}, fonts.xLarge), { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: '400', margin: 0 })
        },
        root: {
            height: `calc(100% - ${spacing.medium})`,
            margin: `${spacing.smallPlus} 0 ${spacing.smallPlus} ${spacing.smallPlus}`,
            borderRadius: spacing.small,
            backgroundColor: hasImage
                ? palette.neutalFilmMinus2
                : undefined,
        }
    },
}));
const cache = {
    imageUri: null,
    ref: null
};
const MyHeader = ({ config, data, config: { query, children = [], props: { nav } = {} } }) => {
    const gridStyles = smarthub_common_1.useGridStyles();
    const profile = smarthub_common_1.useProfile();
    const render = smarthub_common_1.useRender();
    const download = smarthub_common_1.useGetFile();
    const [imageUri, setImageUri] = react_1.useState(cache.imageUri);
    const hasImage = cache.imageUri != null;
    const [bannerImageRef] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys.userBannerImage, true);
    react_1.useEffect(() => {
        if (cache.imageUri && cache.ref == bannerImageRef)
            return;
        (() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const { uri } = yield download(query, 'dataUri', bannerImageRef);
            cache.imageUri = uri;
            cache.ref = bannerImageRef;
            setImageUri(uri);
        }))();
    }, [bannerImageRef]);
    const panelStyles = smarthub_common_1.usePanelStyles();
    const profileStyles = smarthub_common_1.useFluentStylesWithProps(fluentStyles, hasImage);
    const styles = useStyles(hasImage);
    const props = react_1.useMemo(() => {
        return profile ? {
            size: react_2.PersonaSize.size72,
            text: profile.name,
            imageUrl: profile.image,
            secondaryText: profile.jobTitle && profile.department ? `${profile.jobTitle} - ${profile.department}` : profile.jobTitle ? profile.jobTitle : profile.department,
            styles: profileStyles.persona,
            coinProps: {
                styles: profileStyles.coin
            }
        }
            : null;
    }, [profile, profileStyles]);
    const getCustomPrimaryTextRenderer = () => {
        return (props) => {
            return (react_1.default.createElement("h1", null, props.text));
        };
    };
    return react_1.useMemo(() => {
        return react_1.default.createElement("div", { className: [panelStyles.header, gridStyles.grid, gridStyles.overflow].join(' ') },
            (imageUri === null || imageUri === void 0 ? void 0 : imageUri.length) > 0 && react_1.default.createElement(react_2.Image, { src: imageUri, styles: profileStyles.image, coverStyle: react_2.ImageCoverStyle.landscape, imageFit: react_2.ImageFit.cover }),
            react_1.default.createElement("div", { className: [gridStyles.row].join(" ") },
                react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.sm12, gridStyles.lgx4, gridStyles.xl3, gridStyles.xlx2, gridStyles.smclip].join(" ") },
                    react_1.default.createElement(react_2.Persona, Object.assign({}, props, { onRenderPrimaryText: getCustomPrimaryTextRenderer() }))),
                react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.sm12, gridStyles.lgx8, gridStyles.xl9, gridStyles.xlx10, gridStyles.smclip].join(" ") },
                    react_1.default.createElement("div", { className: styles.components }, children.map(c => render(c)())))),
            react_1.default.createElement("div", { className: [gridStyles.row, gridStyles.smnowrap].join(" ") },
                react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.sm12, gridStyles.lgx8, gridStyles.xl9, gridStyles.xlx10, styles.background].join(" ") }, render(nav, data, core_1.TabNavigation)())));
    }, [data, panelStyles, config, props, imageUri, styles, profileStyles]);
};
exports.MyHeader = MyHeader;


/***/ }),

/***/ "./src/content/profile/profile-about-info.component.tsx":
/*!**************************************************************!*\
  !*** ./src/content/profile/profile-about-info.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileAboutInfo = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const profile_styles_1 = __webpack_require__(/*! ./profile.styles */ "./src/content/profile/profile.styles.ts");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const ProfileAboutInfo = ({ config, config: { consumes, title, chrome, props }, data }) => {
    var _a, _b;
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const currentProfile = smarthub_common_1.useProfile();
    const styles = profile_styles_1.useSectionStyles();
    const contentFormatter = smarthub_common_1.useContentFormat(props.providerName);
    const profile = (_b = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "profile"))) !== null && _a !== void 0 ? _a : data === null || data === void 0 ? void 0 : data.profile) !== null && _b !== void 0 ? _b : currentProfile;
    const [content, setContent] = react_1.useState(null);
    react_1.useEffect(() => {
        var _a;
        if ((_a = profile === null || profile === void 0 ? void 0 : profile.aboutMe) === null || _a === void 0 ? void 0 : _a.length) {
            contentFormatter(`<div>${profile.aboutMe}</div>`, { headingId: '' }).then(result => {
                setContent(result.content);
            });
        }
    }, [profile, config]);
    return react_1.useMemo(() => {
        var _a, _b;
        return react_1.default.createElement(react_1.default.Fragment, null, (((_a = profile.birthday) === null || _a === void 0 ? void 0 : _a.year) > "1" || content) &&
            react_1.default.createElement(core_1.ComponentChrome, { config: config },
                ((title === null || title === void 0 ? void 0 : title.length) > 0 && !(chrome === null || chrome === void 0 ? void 0 : chrome.header)) && react_1.default.createElement(react_2.Separator, { alignContent: "start" }, title),
                react_1.default.createElement("div", { title: `${localizeConfig.profilePersonalInfo} ${profile.name}`, className: styles.section },
                    content && react_1.default.createElement("div", { className: [styles.row, styles.first].join(' ') },
                        react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: content } })),
                    ((_b = profile.birthday) === null || _b === void 0 ? void 0 : _b.year) > "1" && react_1.default.createElement("div", { className: styles.row },
                        react_1.default.createElement(react_2.Text, null, localizeConfig.profileBirthday),
                        react_1.default.createElement(react_2.Text, null,
                            profile.birthday.month,
                            " ",
                            profile.birthday.year)))));
    }, [content]);
};
exports.ProfileAboutInfo = ProfileAboutInfo;


/***/ }),

/***/ "./src/content/profile/profile-contact-info.component.tsx":
/*!****************************************************************!*\
  !*** ./src/content/profile/profile-contact-info.component.tsx ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileContactInfo = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const profile_styles_1 = __webpack_require__(/*! ./profile.styles */ "./src/content/profile/profile.styles.ts");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const ProfileContactInfo = ({ config, config: { consumes, title, chrome }, data }) => {
    var _a, _b;
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const currentProfile = smarthub_common_1.useProfile();
    const styles = profile_styles_1.useSectionStyles();
    const profile = (_b = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "profile"))) !== null && _a !== void 0 ? _a : data === null || data === void 0 ? void 0 : data.profile) !== null && _b !== void 0 ? _b : currentProfile;
    return react_1.useMemo(() => {
        var _a;
        return react_1.default.createElement(react_1.default.Fragment, null, ((_a = profile.contactActions) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
            react_1.default.createElement(core_1.ComponentChrome, { config: config },
                ((title === null || title === void 0 ? void 0 : title.length) > 0 && !(chrome === null || chrome === void 0 ? void 0 : chrome.header)) && react_1.default.createElement(react_2.Separator, { alignContent: "start" }, title),
                react_1.default.createElement("ul", { title: `${localizeConfig.profileContactInfo} ${profile.name}`, className: styles.section }, profile.contactActions.map((a, idx) => react_1.default.createElement("li", { key: idx, className: [styles.row, idx == 0 ? styles.first : ''].join(' ') },
                    react_1.default.createElement(react_2.Icon, { iconName: a.icon }),
                    react_1.default.createElement(react_2.Text, null, a.secondaryText))))));
    }, [profile, config]);
};
exports.ProfileContactInfo = ProfileContactInfo;


/***/ }),

/***/ "./src/content/profile/profile-contact.component.tsx":
/*!***********************************************************!*\
  !*** ./src/content/profile/profile-contact.component.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileContact = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const fluentStyles = (({ theme: { palette, fonts, spacing } }) => ({
    activity: {
        root: {
            margin: spacing.medium,
            flex: "1 1"
        },
        activityText: Object.assign(Object.assign({}, fonts.small), { lineHeight: "180%", display: "block", color: palette.neutralMinus5On }),
        activityTypeIcon: {
            color: palette.neutralMinus5On
        },
        timeStamp: Object.assign(Object.assign({}, fonts.normal), { wordBreak: "break-word", color: palette.neutralMinus5On })
    },
    copy: {
        root: {
            height: "100%",
            backgroundColor: palette.neutralMinus5
        }
    },
    stack: {
        root: {
            borderRadius: spacing.small,
            overflow: "hidden",
            width: "100%",
            backgroundColor: palette.neutralMinus5
        }
    }
}));
const mailIcon = { iconName: 'Mail' };
const phoneIcon = { iconName: 'Phone' };
const groupIcon = { iconName: 'Group' };
const locationIcon = { iconName: 'CityNext' };
const ProfileContact = ({ config, config: { consumes, responsive }, }) => {
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const currentProfile = smarthub_common_1.useProfile();
    const localize = smarthub_common_1.useLocalizeConfig();
    const stateRef = consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'profile');
    const state = smarthub_common_1.useReadSharedState(stateRef);
    const profile = (state === null || state === void 0 ? void 0 : state.$schema) == smarthub_common_1.IPersonSchema
        ? state
        : stateRef
            ? null
            : currentProfile;
    const renderCard = react_1.useCallback(({ data }) => {
        return react_1.default.createElement(react_2.Stack, { horizontal: true, styles: styles.stack },
            react_1.default.createElement(react_2.StackItem, { grow: true },
                react_1.default.createElement(react_2.ActivityItem, { styles: styles.activity, activityDescription: [
                        react_1.default.createElement("span", { key: 1 }, data.type),
                    ], timeStamp: data.data == null ? localize.na : data.data, activityIcon: react_1.default.createElement(react_2.Icon, Object.assign({}, data.icon)) })),
            react_1.default.createElement(react_2.StackItem, null,
                react_1.default.createElement(react_2.IconButton, { onClick: () => navigator.clipboard.writeText(data.data), styles: styles.copy, alt: localize.copyIcn, ariaLabel: localize.btnCopy },
                    react_1.default.createElement(react_2.Icon, { iconName: "Copy" }))));
    }, [styles]);
    return react_1.useMemo(() => {
        var _a;
        const items = profile
            ? [
                { $id: `${profile.$id}-email`, type: 'Email', data: profile.mail, icon: mailIcon },
                { $id: `${profile.$id}-job`, type: 'Job Title', data: profile.jobTitle, icon: groupIcon },
                { $id: `${profile.$id}-mobile`, type: 'Mobile Phone', data: profile.mobilePhone, icon: phoneIcon },
                { $id: `${profile.$id}-dept`, type: 'Department', data: profile.department, icon: groupIcon },
                { $id: `${profile.$id}-city`, type: 'City', data: profile.city, icon: locationIcon },
                { $id: `${profile.$id}-phone`, type: 'Business Phone', data: (_a = profile.businessPhones) === null || _a === void 0 ? void 0 : _a[0], icon: phoneIcon },
                { $id: `${profile.$id}-location`, type: 'Office Location', data: profile.officeLocation, icon: locationIcon }
            ].filter(i => { var _a; return (_a = i.data) === null || _a === void 0 ? void 0 : _a.length; })
            : [];
        return (react_1.default.createElement(core_1.ComponentChrome, { config: config },
            react_1.default.createElement(core_1.CardListBase, { items: items, renderCard: renderCard, responsive: responsive })));
    }, [config, profile]);
};
exports.ProfileContact = ProfileContact;


/***/ }),

/***/ "./src/content/profile/profile-header.component.tsx":
/*!**********************************************************!*\
  !*** ./src/content/profile/profile-header.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileHeader = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const fluentStyles = (({ theme: { palette, fonts, spacing, sizes } }) => ({
    personaStyles: {
        primaryText: {
            h1: Object.assign(Object.assign({ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: 400 }, fonts.superLarge), { color: palette.primaryPlus1, margin: 0 })
        },
    },
    imageStyles: {
        root: {
            margin: `0 ${sizes.smallPlus} ${sizes.smallPlus} ${sizes.smallPlus}`
        }
    },
    textCoinStyles: {
        coin: {
            display: "none"
        }
    },
    commandBarStyles: {
        root: {
            padding: 0
        }
    }
}));
const ProfileHeader = ({ config, data }) => {
    const { consumes, props: { nav } = {} } = config;
    const panelStyles = smarthub_common_1.usePanelStyles();
    const { personaStyles, commandBarStyles, imageStyles, textCoinStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const gridStyles = smarthub_common_1.useGridStyles();
    const currentProfile = smarthub_common_1.useProfile();
    const render = smarthub_common_1.useRender();
    const stateRef = consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'profile');
    const state = smarthub_common_1.useReadSharedState(stateRef);
    const handleAction = smarthub_common_1.useHandleCommand();
    const profile = (state === null || state === void 0 ? void 0 : state.$schema) == smarthub_common_1.IPersonSchema
        ? state
        : stateRef
            ? null
            : currentProfile;
    const getCustomPrimaryTextRenderer = () => {
        return (props) => {
            return (react_1.default.createElement("h1", null, props.text));
        };
    };
    return react_1.useMemo(() => {
        var _a, _b;
        const name = !((_a = profile === null || profile === void 0 ? void 0 : profile.name) === null || _a === void 0 ? void 0 : _a.length)
            ? "Error: Profile not found"
            : profile.name;
        return profile
            ? react_1.default.createElement("div", { className: [panelStyles.header, gridStyles.grid, gridStyles.overflow, gridStyles.row, gridStyles.smnowrap].join(" ") },
                react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.smclip].join(" ") },
                    react_1.default.createElement(react_2.Persona, { size: react_2.PersonaSize.size100, text: name, imageUrl: profile.image, styles: imageStyles, hidePersonaDetails: true })),
                react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.smstretch, gridStyles.smclip].join(" ") },
                    react_1.default.createElement("div", { className: [gridStyles.row, gridStyles.smnowrap, gridStyles.padT].join(" ") },
                        react_1.default.createElement("div", { className: [gridStyles.col].join(" ") },
                            react_1.default.createElement(react_2.Persona, { styles: personaStyles, text: name, coinProps: {
                                    styles: textCoinStyles
                                }, secondaryText: profile.jobTitle && profile.department
                                    ? `${profile.jobTitle} - ${profile.department}`
                                    : profile.jobTitle ? profile.jobTitle : null, onRenderPrimaryText: getCustomPrimaryTextRenderer() })),
                        react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.smstretch, gridStyles.smclip].join(" ") },
                            react_1.default.createElement(react_2.CommandBar, { styles: commandBarStyles, items: (_b = profile.contactActions) === null || _b === void 0 ? void 0 : _b.map((a, i) => ({
                                    key: `${i}`,
                                    text: a.text,
                                    title: `${a.label} ${profile.name}`,
                                    iconProps: { iconName: a.icon },
                                    onClick: () => { handleAction(a.action); }
                                })) }))),
                    react_1.default.createElement("div", { className: [gridStyles.row, gridStyles.smstretch].join(" ") },
                        react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.smfill].join(" ") }, render(nav, data, core_1.TabNavigation)()))))
            : react_1.default.createElement(react_1.default.Fragment, null);
    }, [config, data, profile, panelStyles, gridStyles, personaStyles, imageStyles]);
};
exports.ProfileHeader = ProfileHeader;


/***/ }),

/***/ "./src/content/profile/profile-interests.component.tsx":
/*!*************************************************************!*\
  !*** ./src/content/profile/profile-interests.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileInterests = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const profile_tags_component_1 = __webpack_require__(/*! ./profile-tags.component */ "./src/content/profile/profile-tags.component.tsx");
const ProfileInterests = ({ config, config: { consumes, title, chrome }, data }) => {
    var _a, _b;
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const currentProfile = smarthub_common_1.useProfile();
    const profile = (_b = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "profile"))) !== null && _a !== void 0 ? _a : data === null || data === void 0 ? void 0 : data.profile) !== null && _b !== void 0 ? _b : currentProfile;
    return react_1.useMemo(() => {
        return react_1.default.createElement(profile_tags_component_1.ProfileTags, { config: config, items: profile.interests, title: !(chrome === null || chrome === void 0 ? void 0 : chrome.header) ? title : null, label: `${localizeConfig.profileInterests} ${profile.name}`, itemLabel: localizeConfig.profileInterest });
    }, [profile, config]);
};
exports.ProfileInterests = ProfileInterests;


/***/ }),

/***/ "./src/content/profile/profile-projects.component.tsx":
/*!************************************************************!*\
  !*** ./src/content/profile/profile-projects.component.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileProjects = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const profile_tags_component_1 = __webpack_require__(/*! ./profile-tags.component */ "./src/content/profile/profile-tags.component.tsx");
const ProfileProjects = ({ config, config: { consumes, title, chrome }, data }) => {
    var _a, _b;
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const currentProfile = smarthub_common_1.useProfile();
    const profile = (_b = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "profile"))) !== null && _a !== void 0 ? _a : data === null || data === void 0 ? void 0 : data.profile) !== null && _b !== void 0 ? _b : currentProfile;
    return react_1.useMemo(() => {
        return react_1.default.createElement(profile_tags_component_1.ProfileTags, { config: config, items: profile.pastProjects, title: !(chrome === null || chrome === void 0 ? void 0 : chrome.header) ? title : null, label: `${localizeConfig.profileProjects} ${profile.name}`, itemLabel: localizeConfig.profileProject });
    }, [profile, config]);
};
exports.ProfileProjects = ProfileProjects;


/***/ }),

/***/ "./src/content/profile/profile-schools.component.tsx":
/*!***********************************************************!*\
  !*** ./src/content/profile/profile-schools.component.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileSchools = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const profile_tags_component_1 = __webpack_require__(/*! ./profile-tags.component */ "./src/content/profile/profile-tags.component.tsx");
const ProfileSchools = ({ config, config: { consumes, title, chrome }, data }) => {
    var _a, _b;
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const currentProfile = smarthub_common_1.useProfile();
    const profile = (_b = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "profile"))) !== null && _a !== void 0 ? _a : data === null || data === void 0 ? void 0 : data.profile) !== null && _b !== void 0 ? _b : currentProfile;
    return react_1.useMemo(() => {
        return react_1.default.createElement(profile_tags_component_1.ProfileTags, { config: config, items: profile.schools, title: !(chrome === null || chrome === void 0 ? void 0 : chrome.header) ? title : null, label: `${localizeConfig.profileSchools} ${profile.name}`, itemLabel: localizeConfig.profileSchool });
    }, [profile, config]);
};
exports.ProfileSchools = ProfileSchools;


/***/ }),

/***/ "./src/content/profile/profile-skills.component.tsx":
/*!**********************************************************!*\
  !*** ./src/content/profile/profile-skills.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileSkills = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const profile_tags_component_1 = __webpack_require__(/*! ./profile-tags.component */ "./src/content/profile/profile-tags.component.tsx");
const ProfileSkills = ({ config, config: { consumes, title, chrome }, data }) => {
    var _a, _b;
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const currentProfile = smarthub_common_1.useProfile();
    const profile = (_b = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "profile"))) !== null && _a !== void 0 ? _a : data === null || data === void 0 ? void 0 : data.profile) !== null && _b !== void 0 ? _b : currentProfile;
    return react_1.useMemo(() => {
        return react_1.default.createElement(profile_tags_component_1.ProfileTags, { config: config, items: profile.skills, title: !(chrome === null || chrome === void 0 ? void 0 : chrome.header) ? title : null, label: `${localizeConfig.profileSkills} ${profile.name}`, itemLabel: localizeConfig.profileSkill });
    }, [profile, config]);
};
exports.ProfileSkills = ProfileSkills;


/***/ }),

/***/ "./src/content/profile/profile-summary.component.tsx":
/*!***********************************************************!*\
  !*** ./src/content/profile/profile-summary.component.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileSummary = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const profile_contact_info_component_1 = __webpack_require__(/*! ./profile-contact-info.component */ "./src/content/profile/profile-contact-info.component.tsx");
const profile_about_info_component_1 = __webpack_require__(/*! ./profile-about-info.component */ "./src/content/profile/profile-about-info.component.tsx");
const profile_skills_component_1 = __webpack_require__(/*! ./profile-skills.component */ "./src/content/profile/profile-skills.component.tsx");
const profile_projects_component_1 = __webpack_require__(/*! ./profile-projects.component */ "./src/content/profile/profile-projects.component.tsx");
const profile_interests_component_1 = __webpack_require__(/*! ./profile-interests.component */ "./src/content/profile/profile-interests.component.tsx");
const profile_schools_component_1 = __webpack_require__(/*! ./profile-schools.component */ "./src/content/profile/profile-schools.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const fluentStyles = (({ theme: { palette, spacing, sizes } }) => ({
    coin: {
        coin: {
            border: `${spacing.small} solid ${palette.neutralMinus5}`,
            borderRadius: "100%",
            position: "absolute",
            marginTop: `calc(-${sizes.mediumPlus} - ${spacing.small})`
        },
        image: {
            marginRight: 0
        }
    },
    stack: {
        root: {
            marginTop: sizes.mediumPlus,
            backgroundColor: palette.neutralEmpty
        }
    },
    stackItem: {
        root: {
            overflow: 'overlay'
        }
    },
    persona: {
        root: {
            flexDirection: "column",
            height: 'auto'
        },
        details: {
            marginTop: `calc(${sizes.medium} * 2)`,
            marginBottom: spacing.smallPlus,
            textAlign: "center",
            padding: 0
        }
    }
}));
const ProfileSummary = ({ config, config: { consumes, children, props } }) => {
    var _a;
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const currentProfile = smarthub_common_1.useProfile();
    const render = smarthub_common_1.useRender();
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const profile = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "profile"))) !== null && _a !== void 0 ? _a : currentProfile;
    return react_1.useMemo(() => {
        return react_1.default.createElement(core_1.ComponentChrome, { config: config },
            react_1.default.createElement(react_2.Stack, { styles: (props === null || props === void 0 ? void 0 : props.showPersona) ? styles.stack : null, title: localizeConfig.profileTitle },
                (props === null || props === void 0 ? void 0 : props.showPersona) && react_1.default.createElement(react_2.Stack.Item, null,
                    react_1.default.createElement(react_2.Persona, Object.assign({}, {
                        coinProps: {
                            styles: styles.coin
                        },
                        styles: styles.persona,
                        size: react_2.PersonaSize.size120,
                        text: profile.name,
                        secondaryText: profile.jobTitle,
                        tertiaryText: profile.department,
                        imageUrl: profile.image,
                        imageAlt: profile.name,
                    }))),
                react_1.default.createElement(react_2.Stack.Item, { styles: styles.stackItem }, children.map((child) => {
                    const fallback = child.$id == 'contact'
                        ? profile_contact_info_component_1.ProfileContactInfo
                        : child.$id == 'about'
                            ? profile_about_info_component_1.ProfileAboutInfo
                            : child.$id == 'skills'
                                ? profile_skills_component_1.ProfileSkills
                                : child.$id == 'projects'
                                    ? profile_projects_component_1.ProfileProjects
                                    : child.$id == 'interests'
                                        ? profile_interests_component_1.ProfileInterests
                                        : child.$id == 'schools'
                                            ? profile_schools_component_1.ProfileSchools
                                            : null;
                    return react_1.default.createElement(react_2.StackItem, { key: child.$id, grow: true, shrink: true }, render(child, profile, fallback)());
                }))));
    }, [profile, config]);
};
exports.ProfileSummary = ProfileSummary;


/***/ }),

/***/ "./src/content/profile/profile-tags.component.tsx":
/*!********************************************************!*\
  !*** ./src/content/profile/profile-tags.component.tsx ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileTags = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const fluentStyles = (({ theme: { spacing } }) => ({
    stackStyles: {
        root: {
            padding: `0 ${spacing.medium} ${spacing.medium} ${spacing.medium}`
        },
        inner: {
            gap: spacing.smallPlus,
        }
    }
}));
const ProfileTags = ({ items, title, label, itemLabel, config }) => {
    const { stackStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    return react_1.useMemo(() => {
        return react_1.default.createElement(react_1.default.Fragment, null, (items === null || items === void 0 ? void 0 : items.length) > 0 && react_1.default.createElement(core_1.ComponentChrome, { config: config, title: label },
            (title === null || title === void 0 ? void 0 : title.length) > 0 && react_1.default.createElement(react_2.Separator, { alignContent: "start" }, title),
            react_1.default.createElement(react_2.Stack, { horizontal: true, wrap: true, styles: stackStyles }, items.map((text, idx) => react_1.default.createElement(react_2.StackItem, { key: idx },
                react_1.default.createElement(utilities_1.Tag, { tagInfo: {
                        text,
                        label: `${itemLabel} ${text}`
                    } }))))));
    }, [items, title]);
};
exports.ProfileTags = ProfileTags;


/***/ }),

/***/ "./src/content/profile/profile.styles.ts":
/*!***********************************************!*\
  !*** ./src/content/profile/profile.styles.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSectionStyles = void 0;
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
exports.useSectionStyles = react_jss_1.createUseStyles(({ palette, type, spacing }) => ({
    section: {
        padding: spacing.medium,
        display: "flex",
        flexDirection: "column"
    },
    first: {},
    row: {
        display: "flex",
        gap: spacing.smallPlus,
        borderTop: `${spacing.tiny} solid ${type == "dark" ? palette.neutralMinus5 : palette.neutralMinus3}`,
        paddingTop: spacing.normal,
        marginTop: spacing.normal,
        ["&$first"]: {
            borderTop: 0,
            paddingTop: 0,
            marginTop: 0,
        }
    }
}));


/***/ }),

/***/ "./src/content/splash-screen/index.ts":
/*!********************************************!*\
  !*** ./src/content/splash-screen/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./splash-screen.component */ "./src/content/splash-screen/splash-screen.component.tsx"), exports);


/***/ }),

/***/ "./src/content/splash-screen/splash-screen.component.tsx":
/*!***************************************************************!*\
  !*** ./src/content/splash-screen/splash-screen.component.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SplashScreen = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing, sizes }) => ({
    background: ({ responsive: { fill } }) => (Object.assign({ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: fill ? palette.primary : palette.neutralEmpty }, react_2.AnimationStyles.fadeIn500)),
    wrapper: ({ responsive: { fill, size } }) => ({
        width: smarthub_common_1.responsiveColumnWidths[size],
        display: "flex",
        flexDirection: "column",
        backgroundColor: palette.primary,
        color: palette.primaryOn,
        boxShadow: fill ? 'none' : `0 0 ${spacing.normal} ${palette.filmMinus1}`,
        minHeight: sizes.normal
    }),
    header: Object.assign(Object.assign({}, fonts.mega), { fontWeight: "100", padding: `${spacing.medium} ${spacing.xxLarge}` }),
    detail: {
        flex: "1 1 100%",
        padding: spacing.xxLarge,
        display: "flex",
        flexDirection: "row"
    },
    logo: {
        paddingTop: spacing.smallPlus,
    },
    image: {
        maxWidth: "100%",
        maxHeight: "100%",
    },
    detailList: {
        display: "flex",
        flex: "1 1",
        paddingLeft: spacing.xxLarge,
        flexDirection: "column",
    },
    description: Object.assign(Object.assign({ paddingBottom: spacing.large }, fonts.superLarge), { fontWeight: "100" }),
    info: Object.assign({}, fonts.small),
    label: Object.assign({}, fonts.smallPlus)
}));
const responsiveProps = {
    sm: {
        size: 12,
        fill: true
    },
    md: {
        size: 10,
    },
    lg: {
        size: 8,
        fill: false
    },
    xlx: {
        size: 6,
    },
    xxl: {
        size: 4,
    },
};
const SplashScreen = () => {
    var _a, _b;
    const source = smarthub_common_1.useSourceInfo();
    const localize = smarthub_common_1.useLocalizeConfig();
    const styleProps = smarthub_common_1.useStyleProps(null, responsiveProps);
    const styles = useStyles(styleProps);
    return (react_1.default.createElement("div", { className: styles.background },
        react_1.default.createElement("div", { className: styles.wrapper },
            react_1.default.createElement("div", { className: styles.header }, source.title),
            react_1.default.createElement("div", { className: styles.detail },
                react_1.default.createElement("div", { className: styles.logo },
                    react_1.default.createElement(utilities_1.ThemeImage, { alt: localize.logoImage, className: styles.image, image: smarthub_common_1.ImageKeys.appLogoOnPrimaryL })),
                react_1.default.createElement("div", { className: styles.detailList },
                    react_1.default.createElement("div", { className: styles.description }, source.description),
                    react_1.default.createElement("div", { className: styles.info },
                        react_1.default.createElement("span", { className: styles.label },
                            localize.aboutVersionPrefix,
                            ": "),
                        react_1.default.createElement("span", null, source.version)),
                    react_1.default.createElement("div", { className: styles.info },
                        react_1.default.createElement("span", { className: styles.label },
                            localize.aboutPublishedPrefix,
                            ": "),
                        react_1.default.createElement("span", null, source.publisher)),
                    ((_b = (_a = source.environment) === null || _a === void 0 ? void 0 : _a.label) === null || _b === void 0 ? void 0 : _b.length) > 0 && react_1.default.createElement("div", { className: styles.info },
                        react_1.default.createElement("span", { className: styles.label },
                            localize.aboutEnvironmentPrefix,
                            ": "),
                        react_1.default.createElement("span", null, source.environment.label)))))));
};
exports.SplashScreen = SplashScreen;


/***/ }),

/***/ "./src/content/summarizer/index.ts":
/*!*****************************************!*\
  !*** ./src/content/summarizer/index.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./summariser.component */ "./src/content/summarizer/summariser.component.tsx"), exports);


/***/ }),

/***/ "./src/content/summarizer/summariser.component.tsx":
/*!*********************************************************!*\
  !*** ./src/content/summarizer/summariser.component.tsx ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Summariser = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles(({ palette, spacing, sizes, fonts }) => ({
    summariserWrapper: {
        width: "100%",
        textAlign: "center"
    },
    summariserIcon: {
        padding: spacing.xxLargePlus,
        borderRadius: "100%",
        margin: `${spacing.large} ${spacing.large} ${spacing.large} 0`,
        backgroundColor: palette.neutralMinus3,
        fontSize: fonts.superLarge.fontSize
    },
    count: {
        fontSize: fonts.xSmall.fontSize,
        position: "absolute",
        borderRadius: "100%",
        backgroundColor: palette.hazard,
        bottom: `-${spacing.xSmall}`,
        right: `-${spacing.xSmall}`,
        lineHeight: sizes.small,
        height: sizes.small,
        width: sizes.small,
        fontWeight: 600,
        color: palette.hazardOn
    },
}));
const Summariser = ({ config }) => {
    var _a, _b, _c, _d;
    const baseStyles = useStyles();
    const handleAction = smarthub_common_1.useHandleCommand();
    const { $id, query, consumes, props: { icon } } = config;
    const fetch = smarthub_common_1.useFetch();
    const transform = smarthub_common_1.useTransform();
    const [filters, setFilters] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setFilters(consumes), [consumes]);
    const [item, setData] = react_1.useState(null);
    const fetchData = (filters) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const requiresParam = consumes === null || consumes === void 0 ? void 0 : consumes.some(({ required, name }) => required && (filters === null || filters === void 0 ? void 0 : filters[name]) == null);
            if (requiresParam)
                return;
            const { data } = yield fetch(query, filters);
            const outlook = transform(models_1.IOutlookSummariser, data);
            setData({ outlook });
        }
        catch (ex) {
            smarthub_common_1.Logger.error("Failed to fetch summarizer info", false, { ex });
        }
    });
    react_1.useEffect(() => {
        fetchData(filters);
    }, [filters, fetch, config]);
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config, hasContent: item != null },
        react_1.default.createElement(react_2.IconButton, { title: (_a = item === null || item === void 0 ? void 0 : item.outlook) === null || _a === void 0 ? void 0 : _a.title, ariaLabel: (_b = item === null || item === void 0 ? void 0 : item.outlook) === null || _b === void 0 ? void 0 : _b.title, className: baseStyles.summariserIcon, onClick: () => { var _a; handleAction((_a = item === null || item === void 0 ? void 0 : item.outlook) === null || _a === void 0 ? void 0 : _a.action); } },
            ((_c = item === null || item === void 0 ? void 0 : item.outlook) === null || _c === void 0 ? void 0 : _c.count) > 0 && react_1.default.createElement("div", { className: baseStyles.count }, (_d = item === null || item === void 0 ? void 0 : item.outlook) === null || _d === void 0 ? void 0 : _d.count),
            react_1.default.createElement(react_2.Icon, { iconName: icon }))));
};
exports.Summariser = Summariser;


/***/ }),

/***/ "./src/content/timeline/index.ts":
/*!***************************************!*\
  !*** ./src/content/timeline/index.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./timeline.component */ "./src/content/timeline/timeline.component.tsx"), exports);


/***/ }),

/***/ "./src/content/timeline/timeline-item.component.tsx":
/*!**********************************************************!*\
  !*** ./src/content/timeline/timeline-item.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TimelineItem = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const timeline_styles_1 = __webpack_require__(/*! ./timeline-styles */ "./src/content/timeline/timeline-styles.ts");
const models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
const TimelineItem = ({ data }) => {
    const styles = timeline_styles_1.useTimelineStyles();
    const transform = smarthub_common_1.useTransform();
    const [item, setItem] = react_1.useState(data);
    react_1.useEffect(() => {
        if ((data === null || data === void 0 ? void 0 : data.startText) || (data === null || data === void 0 ? void 0 : data.endText)) {
            setItem({ heading: (data === null || data === void 0 ? void 0 : data.startText) || (data === null || data === void 0 ? void 0 : data.endText) });
        }
        else {
            const result = transform(models_1.ITimelineSchema, data);
            setItem(result);
        }
    }, [data]);
    return react_1.useMemo(() => (react_1.default.createElement("div", { className: styles.timelineItem }, item && react_1.default.createElement("div", { className: styles.timelineItemContent },
        react_1.default.createElement("div", { className: "bold" }, item === null || item === void 0 ? void 0 : item.created),
        (item === null || item === void 0 ? void 0 : item.heading) ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "heading" }, item === null || item === void 0 ? void 0 : item.heading),
            react_1.default.createElement("div", { className: "outerCircle" },
                react_1.default.createElement("div", { className: "innerCircle" })))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "message" }, item === null || item === void 0 ? void 0 : item.message),
            react_1.default.createElement("div", { className: "circle" })))))), [item]);
};
exports.TimelineItem = TimelineItem;


/***/ }),

/***/ "./src/content/timeline/timeline-styles.ts":
/*!*************************************************!*\
  !*** ./src/content/timeline/timeline-styles.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTimelineStyles = void 0;
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
exports.useTimelineStyles = react_jss_1.createUseStyles(({ palette, fonts }) => ({
    timelineContainer: Object.assign(Object.assign({ display: "flex", flexDirection: "column", position: "relative", margin: "40px 0", fontWeight: "bold" }, fonts.normal), { ["&::after"]: {
            backgroundColor: palette.primaryPlus1,
            content: '""',
            position: "absolute",
            left: "31px",
            width: "4px",
            height: "100%"
        } }),
    timelineItem: {
        display: "flex",
        justifyContent: "flex-start",
        paddingLeft: "60px",
        position: "relative",
        marginBottom: "15px",
    },
    timelineItemContent: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        position: "relative",
        width: "400px",
        maxWidth: "70%",
        textAlign: "left",
        ["& .heading"]: {
            fontWeight: "bold",
            marginBottom: "15px",
        },
        ["& .message"]: {
            fontSize: "16px",
            lineHeight: "24px",
            margin: "0",
            maxWidth: "250px",
        },
        ["& .bold"]: {
            fontWeight: "bold",
            margin: "0px",
        },
        ["& .circle"]: {
            backgroundColor: palette.neutralEmpty,
            border: `3px solid ${palette.primaryPlus1}`,
            borderRadius: "50%",
            position: "absolute",
            top: "0px",
            left: "-40px",
            width: "20px",
            height: "20px",
            zIndex: "100"
        },
        ["& .outerCircle"]: {
            background: palette.primaryPlus1,
            borderRadius: "50%",
            height: "26px",
            width: "26px",
            position: "absolute",
            top: "0px",
            left: "-40px",
            zIndex: "100"
        },
        ["& .innerCircle"]: {
            position: "relative",
            background: palette.primaryPlus1,
            borderRadius: "50%",
            height: "15px",
            width: "15px",
            top: "15%",
            left: "15%",
            zIndex: "100",
            border: `2px solid ${palette.neutralEmpty}`
        }
    },
}));


/***/ }),

/***/ "./src/content/timeline/timeline.component.tsx":
/*!*****************************************************!*\
  !*** ./src/content/timeline/timeline.component.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Timeline = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const timeline_item_component_1 = __webpack_require__(/*! ./timeline-item.component */ "./src/content/timeline/timeline-item.component.tsx");
const timeline_styles_1 = __webpack_require__(/*! ./timeline-styles */ "./src/content/timeline/timeline-styles.ts");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const Timeline = ({ config }) => {
    const { $id, query, consumes, props: { timelineStartText, timelineEndText } } = config;
    const fetch = smarthub_common_1.useFetch();
    const [dataSet, setDataSet] = react_1.useState({ items: null });
    const [filters, setFilters] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setFilters(consumes), [consumes]);
    const fetchData = (filters, { items } = {}) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const requiresParam = consumes === null || consumes === void 0 ? void 0 : consumes.some(({ required, name }) => required && (filters === null || filters === void 0 ? void 0 : filters[name]) == null);
            if (requiresParam)
                return;
            const { data } = yield fetch(query, filters);
            setDataSet({
                items: [
                    ...(items !== null && items !== void 0 ? items : []),
                    ...(timelineStartText ? [{ startText: timelineStartText }] : []),
                    ...(data !== null && data !== void 0 ? data : []),
                    ...(timelineEndText ? [{ endText: timelineEndText }] : []),
                ]
            });
        }
        catch (ex) {
            setDataSet({ error: ex, items: null });
        }
    });
    react_1.useEffect(() => {
        fetchData(filters);
    }, [filters, fetch, config]);
    const hasItems = react_1.useMemo(() => {
        const { items } = dataSet;
        let count = 0;
        items === null || items === void 0 ? void 0 : items.forEach(e => {
            if (!(e['startText'] || e['endText'])) {
                count++;
            }
        });
        return count != 0;
    }, [dataSet]);
    const styles = timeline_styles_1.useTimelineStyles();
    const { items } = dataSet;
    return react_1.useMemo(() => (react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement("div", { className: styles.timelineContainer }, hasItems && (items === null || items === void 0 ? void 0 : items.map((data, index) => (react_1.default.createElement(timeline_item_component_1.TimelineItem, { data: data, key: index }))))))), [dataSet]);
};
exports.Timeline = Timeline;


/***/ }),

/***/ "./src/content/up-next/index.ts":
/*!**************************************!*\
  !*** ./src/content/up-next/index.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./up-next-activity.component */ "./src/content/up-next/up-next-activity.component.tsx"), exports);


/***/ }),

/***/ "./src/content/up-next/up-next-activity.component.tsx":
/*!************************************************************!*\
  !*** ./src/content/up-next/up-next-activity.component.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UpNextActivity = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const utc_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/utc */ "dayjs/plugin/utc"));
const duration_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/duration */ "dayjs/plugin/duration"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
dayjs_1.default.extend(duration_1.default);
dayjs_1.default.extend(utc_1.default);
//TODO Use event interface and transform
//TODO fix sizing basd on new header layout
const useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing, sizes }) => ({
    card: Object.assign(Object.assign({}, fonts.normal), { width: '300px', height: sizes.mega, display: 'flex', boxSizing: 'border-box', flexDirection: 'column', justifyContent: 'space-between', borderLeft: `${spacing.smallPlus} solid ${palette.primary}`, padding: spacing.smallPlus, margin: spacing.smallPlus, backgroundColor: palette.neutalFilmMinus1, borderRadius: spacing.small, boxShadow: "rgb(0 0 0 / 13%) 0px 1.6px 3.6px 0px, rgb(0 0 0 / 11%) 0px 0.3px 0.9px 0px" }),
    meetingInfo: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    meetTime: {
        paddingRight: spacing.smallPlus
    },
    meetingTitle: Object.assign(Object.assign({}, fonts.normalPlus), { display: "flex" })
}));
const fluentStyles = ({ theme: { spacing } }) => ({
    calendarIcon: {
        root: {
            position: "relative",
            top: spacing.small,
            marginRight: spacing.smallPlus,
        }
    },
});
const defaultDateTimeFormat = "YYYY-MM-DDTHH:mm:ss.SSS[Z]";
const UpNextActivity = ({ config }) => {
    const { query, consumes, $id } = config;
    const activityStyles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const styles = useStyles();
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const fetch = smarthub_common_1.useFetch();
    const transform = smarthub_common_1.useTransform();
    const [dataSet, setDataSet] = react_1.useState({ items: null });
    const [data, setData] = react_1.useState(null);
    const [filters, setFilters] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setFilters(consumes), [consumes]);
    const fetchData = (filters, { continuation: next } = {}) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const requiresParam = consumes === null || consumes === void 0 ? void 0 : consumes.some(({ required, name }) => required && (filters === null || filters === void 0 ? void 0 : filters[name]) == null);
            if (requiresParam)
                return;
            const { data, continuation } = yield fetch(query, filters, next);
            setDataSet({
                items: transform(models_1.ICalendarSchema, data),
                continuation
            });
        }
        catch (ex) {
            setDataSet({ error: ex, items: null });
        }
    });
    react_1.useEffect(() => {
        fetchData(filters);
    }, [filters, fetch, config]);
    react_1.useEffect(() => {
        var _a, _b;
        setData(((_a = dataSet === null || dataSet === void 0 ? void 0 : dataSet.items) === null || _a === void 0 ? void 0 : _a.meetings) ? (_b = dataSet.items) === null || _b === void 0 ? void 0 : _b.meetings.filter(m => !m.isAllDay)[0] : null);
    }, [dataSet]);
    const processNextTime = react_1.useCallback(() => {
        const timeDiff = smarthub_common_1.timeDifference(dayjs_1.default().utc().format(defaultDateTimeFormat), dayjs_1.default(data === null || data === void 0 ? void 0 : data.start.dateTime).format(defaultDateTimeFormat));
        return (Math.sign(parseInt(timeDiff)) == 1) ? `${localizeConfig.nextUpIn} ${timeDiff}` : `${localizeConfig.inProgress}`;
    }, [data, localizeConfig]);
    return react_1.useMemo(() => data
        ? react_1.default.createElement(core_1.ComponentChrome, { config: config, hasContent: data },
            react_1.default.createElement("div", { className: styles.card },
                react_1.default.createElement("div", null, processNextTime()),
                react_1.default.createElement("div", { className: styles.meetingTitle },
                    react_1.default.createElement(utilities_1.TextOverflow, { lines: 1, text: data === null || data === void 0 ? void 0 : data.subject },
                        (data === null || data === void 0 ? void 0 : data.type) != "occurrence" ? react_1.default.createElement(react_2.Icon, { styles: activityStyles.calendarIcon, iconName: "Calendar" })
                            : react_1.default.createElement(react_2.Icon, { styles: activityStyles.calendarIcon, iconName: "RecurringEvent" }),
                        react_1.default.createElement("span", { className: styles.meetTime }, smarthub_common_1.formatDateTime([data === null || data === void 0 ? void 0 : data.start.dateTime, 'HH:mm'])),
                        react_1.default.createElement(react_2.Link, { href: data === null || data === void 0 ? void 0 : data.webLink, target: "_blank" }, data === null || data === void 0 ? void 0 : data.subject))),
                react_1.default.createElement("div", { className: styles.meetingInfo }, (data === null || data === void 0 ? void 0 : data.isOnlineMeeting) ? react_1.default.createElement(react_2.DefaultButton, { ariaDescription: localizeConfig.joinMeeting, title: localizeConfig.joinMeeting, text: localizeConfig.join, onClick: () => window.open(data === null || data === void 0 ? void 0 : data.onlineMeeting.joinUrl, '_blank') }) :
                    react_1.default.createElement(react_2.DefaultButton, { ariaDescription: localizeConfig.viewMore, title: localizeConfig.viewMore, text: localizeConfig.viewMore, onClick: () => window.open(data === null || data === void 0 ? void 0 : data.webLink, '_blank') }))))
        : react_1.default.createElement(react_1.default.Fragment, null), [data, localizeConfig, activityStyles]);
};
exports.UpNextActivity = UpNextActivity;


/***/ }),

/***/ "./src/content/view/index.ts":
/*!***********************************!*\
  !*** ./src/content/view/index.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./view-navigator.component */ "./src/content/view/view-navigator.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./views.component */ "./src/content/view/views.component.tsx"), exports);


/***/ }),

/***/ "./src/content/view/view-navigator.component.tsx":
/*!*******************************************************!*\
  !*** ./src/content/view/view-navigator.component.tsx ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ViewNavigator = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const navStyles = {
    root: {
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        overflowY: 'auto',
    },
};
const transformViews = (views) => {
    return views === null || views === void 0 ? void 0 : views.map(({ name, param, description, text, children, expand }, index) => ({
        name: text,
        key: `${((name === null || name === void 0 ? void 0 : name.length) ? name : index)}${((param === null || param === void 0 ? void 0 : param.length) ? `/${param}` : '')}`,
        url: null,
        isExpanded: expand,
        ariaLabel: description,
        title: description,
        links: children ? transformViews(children) : null,
        view: name,
        param: param
    }));
};
const ViewNavigator = ({ config, config: { props: { views = [] } } }) => {
    const { provides, title } = config;
    const viewProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'view');
    const paramProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'view-param');
    const view = smarthub_common_1.useReadSharedState(viewProvider);
    const setView = smarthub_common_1.useSetSharedState(viewProvider);
    const param = smarthub_common_1.useReadSharedState(paramProvider);
    const setParam = smarthub_common_1.useSetSharedState(paramProvider);
    const onClick = (ev, { view, param }) => {
        if (view === null || view === void 0 ? void 0 : view.length) {
            setView(view);
            setParam(param);
        }
    };
    const links = react_1.useMemo(() => {
        return transformViews(views);
    }, [views]);
    react_1.useEffect(() => {
        if (!(view === null || view === void 0 ? void 0 : view.length)) {
            const { name, param } = views[0];
            setView(name);
            setParam(param);
        }
    }, []);
    return react_1.useMemo(() => react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement(react_2.Nav, { selectedKey: `${view}${((param === null || param === void 0 ? void 0 : param.length) ? `/${param}` : '')}`, ariaLabel: title, styles: navStyles, onLinkClick: onClick, groups: [{
                    links: links
                }] })), [view, links, param]);
};
exports.ViewNavigator = ViewNavigator;


/***/ }),

/***/ "./src/content/view/views.component.tsx":
/*!**********************************************!*\
  !*** ./src/content/view/views.component.tsx ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Views = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const Views = ({ config: { consumes, children = [] } }) => {
    const render = smarthub_common_1.useRender();
    const view = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'view'));
    return react_1.useMemo(() => {
        var _a;
        const child = (_a = ((view === null || view === void 0 ? void 0 : view.length) ? children.find(({ $id }) => $id == view)
            : null)) !== null && _a !== void 0 ? _a : children[0];
        return render(child)();
    }, [view]);
};
exports.Views = Views;


/***/ }),

/***/ "./src/core/actions/action-bar/action-bar.component.tsx":
/*!**************************************************************!*\
  !*** ./src/core/actions/action-bar/action-bar.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ActionBar = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const __1 = __webpack_require__(/*! ../.. */ "./src/core/index.ts");
const action_bar_styles_1 = __webpack_require__(/*! ./action-bar.styles */ "./src/core/actions/action-bar/action-bar.styles.ts");
const use_transform_actions_hook_1 = __webpack_require__(/*! ./use-transform-actions.hook */ "./src/core/actions/action-bar/use-transform-actions.hook.ts");
const ActionBar = ({ config }) => {
    const { description, title, props: { actions, showTitle } = {}, children } = config;
    const transformActions = use_transform_actions_hook_1.useTransformActions();
    const { commandStyles, rootStyles, textStyles } = action_bar_styles_1.useStyles();
    const fluentStyles = smarthub_common_1.useFluentStylesWithProps(action_bar_styles_1.commandBarStyles);
    const props = react_1.useMemo(() => transformActions(actions, children), [actions, children]);
    return react_1.useMemo(() => (react_1.default.createElement(__1.ComponentChrome, { config: config },
        react_1.default.createElement("div", { className: rootStyles },
            showTitle && react_1.default.createElement("div", { className: textStyles }, title),
            react_1.default.createElement(react_2.CommandBar, Object.assign({ styles: fluentStyles, className: commandStyles, title: description, ariaLabel: description }, props))))), [textStyles, rootStyles, commandStyles, actions, config, title]);
};
exports.ActionBar = ActionBar;


/***/ }),

/***/ "./src/core/actions/action-bar/action-bar.styles.ts":
/*!**********************************************************!*\
  !*** ./src/core/actions/action-bar/action-bar.styles.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useStyles = exports.commandBarStyles = void 0;
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const commandBarStyles = (props) => {
    const { theme } = props;
    const { spacing } = theme;
    return {
        root: {
            padding: `0 ${spacing.xSmall}`,
            alignItems: 'center',
            gap: spacing.xSmall
        },
        primarySet: {
            alignItems: 'center',
            gap: spacing.xSmall
        },
        secondarySet: {
            alignItems: 'center',
            gap: spacing.xSmall
        },
    };
};
exports.commandBarStyles = commandBarStyles;
exports.useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing }) => ({
    rootStyles: {
        display: "flex",
        width: "100%",
        backgroundColor: palette.neutralEmpty,
    },
    textStyles: Object.assign(Object.assign({}, fonts.mediumPlus), { paddingLeft: spacing.medium, color: palette.neutralEmptyOn, alignSelf: "center" }),
    commandStyles: {
        flex: "1 1"
    }
}));


/***/ }),

/***/ "./src/core/actions/action-bar/index.ts":
/*!**********************************************!*\
  !*** ./src/core/actions/action-bar/index.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./action-bar.component */ "./src/core/actions/action-bar/action-bar.component.tsx"), exports);


/***/ }),

/***/ "./src/core/actions/action-bar/use-transform-actions.hook.ts":
/*!*******************************************************************!*\
  !*** ./src/core/actions/action-bar/use-transform-actions.hook.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTransformActions = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const middleware_1 = __webpack_require__(/*! ../../../middleware */ "./src/middleware/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const transformComponent = (action, components, template) => {
    const { component } = action;
    if (typeof component === 'string')
        return components.find(({ $id }) => $id == component);
    else if (component)
        return component;
    const { permission, name, coachmark } = action, props = tslib_1.__rest(action, ["permission", "name", "coachmark"]);
    const coachmarks = coachmark
        ? [Object.assign(Object.assign({}, coachmark), { target: "component.chrome" })]
        : undefined;
    const actionComponent = {
        $id: `component.app-action-${name}`,
        template,
        $schema: smarthub_common_1.IComponentSchema,
        props,
        coachmarks
    };
    return permission
        ? {
            $id: `component.app-secured-${name}`,
            permission,
            template: middleware_1.componentMiddleWareIds.components.secured,
            $schema: smarthub_common_1.IComponentSchema,
            children: [actionComponent]
        }
        : actionComponent;
};
const transformAction = (action, components, render) => {
    const component = transformComponent(action, components, middleware_1.componentMiddleWareIds.components.actionButton);
    if (!component)
        return null;
    const { $id: key } = component;
    const onRender = (props) => render(component, props)();
    return {
        key,
        onRender
    };
};
const transformGroups = (actions, components, render) => actions.reduce((groups, action) => {
    const item = transformAction(action, components, render);
    if (item)
        groups[action.position].push(item);
    return groups;
}, {
    farAfter: [],
    farBefore: [],
    moreAfter: [],
    moreBefore: [],
    nearAfter: [],
    nearBefore: []
});
const useTransformActions = () => {
    const render = smarthub_common_1.useRender();
    return react_1.useCallback((actions, components) => {
        const { farAfter, farBefore, moreAfter, moreBefore, nearAfter, nearBefore } = transformGroups(actions, components, render);
        return {
            farItems: [...farBefore, ...farAfter],
            overflowItems: [...moreBefore, ...moreAfter],
            items: [...nearBefore, ...nearAfter]
        };
    }, []);
};
exports.useTransformActions = useTransformActions;


/***/ }),

/***/ "./src/core/actions/action-button/action-button.component.tsx":
/*!********************************************************************!*\
  !*** ./src/core/actions/action-button/action-button.component.tsx ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ActionButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const action_button_styles_1 = __webpack_require__(/*! ./action-button.styles */ "./src/core/actions/action-button/action-button.styles.ts");
const base_action_button_1 = __webpack_require__(/*! ../base-action-button */ "./src/core/actions/base-action-button/index.ts");
const ActionButton = ({ config: { $id, consumes, props: appAction, coachmarks }, data: { renderedInOverflow } }) => {
    const getThemeImageURI = smarthub_common_1.useGetThemeImageURI();
    const { imageStyles } = smarthub_common_1.useFluentStylesWithProps(action_button_styles_1.fluentStyles);
    const handleCommand = smarthub_common_1.useHandleCommand();
    const [state, setState] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setState(consumes), [consumes]);
    return react_1.useMemo(() => {
        const requiresParam = consumes === null || consumes === void 0 ? void 0 : consumes.some(({ required, name }) => required && (state === null || state === void 0 ? void 0 : state[name]) == null);
        if (requiresParam)
            return null;
        const coachmark = coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(({ target }) => target == 'component-chrome');
        const { action, description, shortTitle, title, icon } = state
            ? smarthub_common_1.transformData(appAction, state)
            : appAction;
        const extendedProps = {
            key: $id,
            title,
            ariaLabel: description,
            text: shortTitle,
            name: shortTitle,
            iconProps: {
                iconName: typeof icon == 'string' ? icon : undefined,
                imageProps: typeof icon == 'object'
                    ? {
                        styles: imageStyles,
                        src: getThemeImageURI(icon.image),
                        alt: typeof icon.image == 'object'
                            ? icon.image.text
                            : title
                    }
                    : undefined
            },
            onClick: () => {
                handleCommand(action);
            }
        };
        return react_1.default.createElement(base_action_button_1.BaseActionButton, { props: extendedProps, coachmark: coachmark, renderedInOverflow: renderedInOverflow });
    }, [state, appAction, coachmarks, renderedInOverflow]);
};
exports.ActionButton = ActionButton;


/***/ }),

/***/ "./src/core/actions/action-button/action-button.styles.ts":
/*!****************************************************************!*\
  !*** ./src/core/actions/action-button/action-button.styles.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fluentStyles = void 0;
const fluentStyles = ({ theme: { sizes } }) => ({
    imageStyles: {
        image: {
            height: sizes.xSmall
        },
    }
});
exports.fluentStyles = fluentStyles;


/***/ }),

/***/ "./src/core/actions/action-button/index.ts":
/*!*************************************************!*\
  !*** ./src/core/actions/action-button/index.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./action-button.component */ "./src/core/actions/action-button/action-button.component.tsx"), exports);


/***/ }),

/***/ "./src/core/actions/base-action-button/base-action-button.interface.ts":
/*!*****************************************************************************!*\
  !*** ./src/core/actions/base-action-button/base-action-button.interface.ts ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/core/actions/base-action-button/base-action-button.styles.ts":
/*!**************************************************************************!*\
  !*** ./src/core/actions/base-action-button/base-action-button.styles.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.baseSplitButtonStyles = exports.baseButtonStyles = void 0;
const baseButtonStyles = ({ theme: { sizes } }) => ({
    buttonStyles: {
        root: {
            height: sizes.mediumPlus
        }
    },
    imageStyles: {
        image: {
            height: sizes.xSmall
        },
    },
    contextMenuStyles: {
        root: {
            width: "100%",
            height: sizes.mediumPlus
        },
        textContainer: {
            textAlign: "left"
        }
    }
});
exports.baseButtonStyles = baseButtonStyles;
const baseSplitButtonStyles = ({ theme: { palette, fonts, sizes, spacing } }) => ({
    contextMenuStyles: {
        root: {
            width: "100%",
            height: sizes.mediumPlus
        },
        textContainer: {
            textAlign: "left"
        }
    },
    imageStyles: {
        image: {
            height: sizes.xSmall
        },
    },
    buttonStyles: {
        splitButtonContainer: {
            marginLeft: spacing.xSmall
        },
        root: {
            padding: 0,
            border: 0,
            minHeight: sizes.medium,
            height: "100%"
        },
        rootHovered: {
            border: 0,
        },
        menuIcon: {
            margin: `0 ${spacing.normal}`
        },
        splitButtonMenuButton: {
            border: 0,
            borderRadius: 0,
        },
        splitButtonMenuIcon: {
            margin: `${spacing.small} ${spacing.small} 0 ${spacing.small}`,
        },
        splitButtonDivider: {
            display: "none",
        },
        textContainer: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        flexContainer: {
            padding: `0 ${spacing.smallPlus}`,
            boxSizing: "border-box",
            alignItems: "center"
        },
        label: {
            lineHeight: "normal",
            marginBottom: "0",
            fontWeight: "400"
        },
        description: {
            lineHeight: fonts.large.fontSize,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        }
    }
});
exports.baseSplitButtonStyles = baseSplitButtonStyles;


/***/ }),

/***/ "./src/core/actions/base-action-button/base-action-button.tsx":
/*!********************************************************************!*\
  !*** ./src/core/actions/base-action-button/base-action-button.tsx ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BaseActionButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const base_action_button_styles_1 = __webpack_require__(/*! ./base-action-button.styles */ "./src/core/actions/base-action-button/base-action-button.styles.ts");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const BaseActionButton = ({ props, coachmark, buttonStyles, renderedInOverflow }) => {
    const { contextMenuStyles, buttonStyles: normalStyles } = smarthub_common_1.useFluentStylesWithProps(buttonStyles || base_action_button_styles_1.baseButtonStyles, props);
    const styles = renderedInOverflow
        ? contextMenuStyles
        : normalStyles;
    return react_1.useMemo(() => {
        if (!props)
            return null;
        const Component = props.menuProps
            ? react_2.CompoundButton
            : react_2.CommandBarButton;
        const { key, title } = props, buttonProps = tslib_1.__rest(props, ["key", "title"]);
        const content = react_1.default.createElement(react_2.TooltipHost, { id: key, content: title },
            react_1.default.createElement(Component, Object.assign({}, buttonProps, { styles: styles })));
        return coachmark
            ? react_1.default.createElement(utilities_1.CoachMarkWrapper, Object.assign({}, coachmark),
                react_1.default.createElement("div", null, content))
            : content;
    }, [props, coachmark, styles]);
};
exports.BaseActionButton = BaseActionButton;


/***/ }),

/***/ "./src/core/actions/base-action-button/index.ts":
/*!******************************************************!*\
  !*** ./src/core/actions/base-action-button/index.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./base-action-button */ "./src/core/actions/base-action-button/base-action-button.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./base-action-button.interface */ "./src/core/actions/base-action-button/base-action-button.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./base-action-button.styles */ "./src/core/actions/base-action-button/base-action-button.styles.ts"), exports);


/***/ }),

/***/ "./src/core/actions/index.ts":
/*!***********************************!*\
  !*** ./src/core/actions/index.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./action-bar */ "./src/core/actions/action-bar/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./action-button */ "./src/core/actions/action-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./split-button */ "./src/core/actions/split-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./base-action-button */ "./src/core/actions/base-action-button/index.ts"), exports);


/***/ }),

/***/ "./src/core/actions/split-button/index.ts":
/*!************************************************!*\
  !*** ./src/core/actions/split-button/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./split-button.component */ "./src/core/actions/split-button/split-button.component.tsx"), exports);


/***/ }),

/***/ "./src/core/actions/split-button/split-button.component.tsx":
/*!******************************************************************!*\
  !*** ./src/core/actions/split-button/split-button.component.tsx ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SplitButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const split_button_styles_1 = __webpack_require__(/*! ./split-button.styles */ "./src/core/actions/split-button/split-button.styles.ts");
const base_action_button_1 = __webpack_require__(/*! ../base-action-button */ "./src/core/actions/base-action-button/index.ts");
const SplitButton = ({ props, coachmark, buttonStyles, renderedInOverflow }) => {
    const styles = buttonStyles || split_button_styles_1.fluentStyles;
    return react_1.default.createElement(base_action_button_1.BaseActionButton, { props: props, coachmark: coachmark, buttonStyles: styles, renderedInOverflow: renderedInOverflow });
};
exports.SplitButton = SplitButton;


/***/ }),

/***/ "./src/core/actions/split-button/split-button.styles.ts":
/*!**************************************************************!*\
  !*** ./src/core/actions/split-button/split-button.styles.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fluentStyles = void 0;
const base_action_button_1 = __webpack_require__(/*! ../base-action-button */ "./src/core/actions/base-action-button/index.ts");
const fluentStyles = (props) => {
    var _a;
    const { theme, config } = props;
    const { spacing, fonts } = theme;
    const { buttonStyles, contextMenuStyles, imageStyles } = base_action_button_1.baseSplitButtonStyles(props);
    return {
        contextMenuStyles,
        imageStyles,
        buttonStyles: Object.assign(Object.assign({}, buttonStyles), { icon: {
                margin: `0 ${spacing.normal} 0 ${spacing.xSmall}`,
                fontSize: ((_a = config.iconProps) === null || _a === void 0 ? void 0 : _a.iconName) == 'ChromeClose'
                    ? fonts.small.fontSize
                    : fonts.superLarge.fontSize
            } })
    };
};
exports.fluentStyles = fluentStyles;


/***/ }),

/***/ "./src/core/card-list-base/card-list-base.component.tsx":
/*!**************************************************************!*\
  !*** ./src/core/card-list-base/card-list-base.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardListBase = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_visibility_sensor_1 = tslib_1.__importDefault(__webpack_require__(/*! react-visibility-sensor */ "react-visibility-sensor"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles(({ spacing }) => {
    return {
        list: ({ responsive: { spread, horizontal = true, wrap = true, } = {
            horizontal: true,
            wrap: true,
        } }) => ({
            gap: spacing.medium,
            flexWrap: wrap ? 'wrap' : 'nowrap',
            justifyContent: spread == "even" ? "space-between" : "start",
            flexDirection: horizontal ? "row" : "column",
            display: "flex",
            padding: "0",
            margin: "0",
        }),
        card: ({ responsive: { columns = 1, rows = 0 } = {
            columns: 1,
            rows: 0
        } }) => ({
            height: "auto",
            maxHeight: "100%",
            display: "flex",
            padding: "0",
            margin: "0",
            width: columns > 0 ? `calc((100% - (${spacing.medium} * ${columns - 1})) / ${columns})` : "auto",
            maxWidth: columns > 0 ? `calc((100% - (${spacing.medium} * ${columns - 1})) / ${columns})` : "100%",
            flex: rows != undefined
                ? rows > 0
                    ? `1 0 calc((100% - (${spacing.medium} * ${rows - 1})) / ${rows})`
                    : "1 1 100%"
                : columns != undefined
                    ? "none"
                    : undefined,
        }),
        loadMoreStackItem: ({ responsive: { wrap = true, horizontal = true, } = {
            wrap: true,
            horizontal: true,
        } }) => ({
            display: "flex",
            justifyContent: "center",
            flexDirection: horizontal && !wrap ? "column" : "row",
            height: horizontal && !wrap ? "100%" : "auto",
            width: !horizontal || wrap ? "100%" : "auto",
            marginTop: spacing.xxLarge,
            padding: spacing.xxLarge,
        }),
    };
});
const fluentStyles = (({ responsive: { wrap = true, horizontal = true, } = {
    wrap: true,
    horizontal: true,
    columns: 1,
    rows: 0
}, }) => {
    return {
        loadMore: {
            root: {
                width: horizontal && !wrap ? "100%" : "25%",
            }
        }
    };
});
const CardListBase = ({ items, onLoadMore, responsive, paging, renderCard, noResults = {}, coachmarks, chrome }) => {
    const loading = react_1.useRef(true);
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const styleProps = smarthub_common_1.useThemeStyleProps(chrome, responsive);
    const fStyles = smarthub_common_1.useFluentStyles(fluentStyles, styleProps);
    const styles = useStyles(styleProps);
    const onVisibilityChange = react_1.useCallback((isVisible) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        if (isVisible && !loading.current) {
            loading.current = true;
            yield onLoadMore();
            loading.current = false;
        }
    }), [onLoadMore]);
    return react_1.useMemo(() => {
        loading.current = items == null;
        return react_1.default.createElement("ul", { className: styles.list }, items === null || items === void 0 ? void 0 :
            items.map((item, index) => react_1.default.createElement("li", { key: item.$id, className: styles.card }, renderCard({ data: item, index }))),
            paging && react_1.default.createElement("li", { className: styles.loadMoreStackItem },
                react_1.default.createElement(utilities_1.DelayItem, { delay: 1000 },
                    react_1.default.createElement(react_visibility_sensor_1.default, { onChange: onVisibilityChange },
                        react_1.default.createElement(react_2.PrimaryButton, { disabled: loading.current, styles: fStyles.loadMore, ariaLabel: localizeConfig.loadMore, title: localizeConfig.loadMore, text: localizeConfig.loadMore, ariaDescription: localizeConfig.loadMoreDesc, onClick: onLoadMore })))));
    }, [items, styles.card, styles.loadMoreStackItem, styles.list, onVisibilityChange]);
};
exports.CardListBase = CardListBase;


/***/ }),

/***/ "./src/core/card-list-base/index.ts":
/*!******************************************!*\
  !*** ./src/core/card-list-base/index.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./card-list-base.component */ "./src/core/card-list-base/card-list-base.component.tsx"), exports);


/***/ }),

/***/ "./src/core/command-bar/command-bar.component.tsx":
/*!********************************************************!*\
  !*** ./src/core/command-bar/command-bar.component.tsx ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CommandBar = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const component_chrome_1 = __webpack_require__(/*! ../component-chrome */ "./src/core/component-chrome/index.ts");
const bot_1 = __webpack_require__(/*! ../../bot */ "./src/bot/index.ts");
const useStyles = react_jss_1.createUseStyles(({ sizes, palette, spacing }) => ({
    bar: {
        backgroundColor: palette.neutralMinus5,
        width: "100%",
        display: "flex",
        flexDirection: "row",
        height: "auto",
        boxSizing: "border-box",
        justifyContent: "space-between",
    },
    section: {
        flex: "1 1",
        display: "flex",
        alignItems: "center",
        height: sizes.large,
        boxSizing: "border-box",
        margin: `${spacing.medium} 0 ${spacing.medium} ${spacing.medium}`,
        justifyContent: "center"
    }
}));
const CommandBar = ({ config, config: { children, coachmarks } }) => {
    const localize = smarthub_common_1.useLocalizeConfig();
    const resetPanel = smarthub_common_1.useResetPanelId('main');
    const resetPage = smarthub_common_1.useResetPanelId('page');
    const chatPanelState = smarthub_common_1.usePanelView('chat');
    const chromeCoachmark = coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(coachmark => coachmark.target === 'chat-controls');
    const styles = useStyles();
    const buttonStyles = smarthub_common_1.useButtonStyles();
    const back = react_1.useCallback(() => {
        history.back();
    }, []);
    const forward = react_1.useCallback(() => {
        history.forward();
    }, []);
    const home = react_1.useCallback(() => {
        resetPage();
        resetPanel();
    }, []);
    return (react_1.default.createElement(component_chrome_1.ComponentChrome, { config: config, className: styles.bar },
        react_1.default.createElement("div", { className: styles.section },
            react_1.default.createElement(react_2.IconButton, { title: localize.iconBack, className: buttonStyles.medium, onClick: back },
                react_1.default.createElement(react_2.Icon, { iconName: "Back" })),
            react_1.default.createElement(react_2.IconButton, { title: localize.iconForward, className: buttonStyles.medium, onClick: forward },
                react_1.default.createElement(react_2.Icon, { iconName: "Forward" })),
            react_1.default.createElement(react_2.IconButton, { title: localize.iconHome, className: buttonStyles.medium, onClick: home },
                react_1.default.createElement(react_2.Icon, { iconName: "HomeSolid" }))),
        react_1.default.createElement(bot_1.ChatControlsInternal, { coachmark: chromeCoachmark, hideOnVisible: true }),
        !chatPanelState.visible && react_1.default.createElement("div", { className: styles.section })));
};
exports.CommandBar = CommandBar;


/***/ }),

/***/ "./src/core/command-bar/index.ts":
/*!***************************************!*\
  !*** ./src/core/command-bar/index.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./command-bar.component */ "./src/core/command-bar/command-bar.component.tsx"), exports);


/***/ }),

/***/ "./src/core/component-chrome/component-chrome.component.tsx":
/*!******************************************************************!*\
  !*** ./src/core/component-chrome/component-chrome.component.tsx ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ComponentChrome = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const component_header_1 = __webpack_require__(/*! ../component-header */ "./src/core/component-header/index.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useComponentStyles = react_jss_1.createUseStyles(({ spacing, palette }) => ({
    component: ({ responsive: { height, padding } = {}, }) => ({
        width: "100%",
        boxSizing: "border-box",
        borderRadius: spacing.small,
        display: "flex",
        flexDirection: "column",
        height: height == "full" ? "100%" : "auto",
        padding: !padding
            ? undefined
            : padding == "normal"
                ? `${spacing.medium} 0 0 ${spacing.medium}`
                : padding == "normal-left"
                    ? `0 0 0 ${spacing.medium}`
                    : padding == "normal-top"
                        ? `${spacing.medium} 0 0 0`
                        : padding == "large"
                            ? `${spacing.xxLarge} 0 0 ${spacing.xxLarge}`
                            : `${spacing.superLarge} 0 0 ${spacing.superLarge}`,
    }),
    inner: {
        display: "flex",
        height: "100%",
        width: "100%",
        flexDirection: "column",
    },
    hiddenHeader: {
        position: "absolute",
        width: "1px",
        height: "1px",
        padding: 0,
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        border: 0,
    },
    body: ({ config: { background }, responsive: { scroll, height, padding } = {}, }) => (Object.assign(Object.assign({ flex: "1 1", position: "relative", boxSizing: "border-box", borderRadius: spacing.xSmall, height: height == "full" ? "100%" : "auto" }, (scroll == "horizontal"
        ? {
            overflowY: "hidden",
            overflowX: "overlay",
            paddingBottom: spacing.medium,
        }
        : scroll == "vertical"
            ? {
                overflowY: "overlay",
                overflowX: "hidden",
                height: "0",
                paddingRight: padding && background != "fill" ? spacing.smallPlus : 0,
                marginRight: padding && background != "fill" ? `-${spacing.smallPlus}` : 0,
                flex: "auto",
            }
            : null)), (background == "fill"
        ? {
            paddingLeft: 0,
            backgroundColor: palette.neutralEmpty,
        }
        : background == "trans"
            ? {
                paddingLeft: 0,
                backgroundColor: palette.filmVar,
                backdropFilter: `blur(${spacing.medium})`,
            }
            : null))),
}));
const ComponentChrome = (_a) => {
    var { config, config: { $id, chrome: configChrome = {} }, headerContent, footerContent, hasContent = true, error, enableCoachmark, className, "aria-label": ariaLabel, title, children } = _a, props = tslib_1.__rest(_a, ["config", "config", "headerContent", "footerContent", "hasContent", "error", "enableCoachmark", "className", "aria-label", "title", "children"]);
    const chrome = Object.assign(Object.assign({}, configChrome), props);
    const { noContent, focus = true, focusable, header, footer, responsive, minimizeKey, } = chrome;
    const localize = smarthub_common_1.useLocalizeConfig();
    const render = smarthub_common_1.useRender();
    const styleProps = smarthub_common_1.useStyleProps(chrome, responsive);
    const styles = useComponentStyles(styleProps);
    const focusStyles = smarthub_common_1.useFocusStyles();
    const prefKey = (minimizeKey === null || minimizeKey === void 0 ? void 0 : minimizeKey.length) ? minimizeKey : $id;
    const [minimised] = smarthub_common_1.usePreference(`${smarthub_common_1.preferenceKeys.componentMinPrefix}${prefKey}`, true, false);
    const shouldEnterInnerZone = (ev) => ev.key == "Enter";
    const showContent = !minimised &&
        (hasContent || (noContent === null || noContent === void 0 ? void 0 : noContent.show) === null || (noContent === null || noContent === void 0 ? void 0 : noContent.show) === undefined);
    const renderHeader = react_1.useMemo(() => {
        var _a;
        if (headerContent) {
            return react_1.default.createElement("header", null, headerContent);
        }
        else if (header) {
            return react_1.default.createElement("header", null, render(header, config, component_header_1.ComponentHeader)());
        }
        else if ((_a = config.title) === null || _a === void 0 ? void 0 : _a.length) {
            return (react_1.default.createElement("header", { className: styles.hiddenHeader },
                react_1.default.createElement("h2", null, config.title)));
        }
        return null;
    }, [headerContent, header, config, styles]);
    const renderFooter = react_1.useMemo(() => {
        if (footerContent) {
            return react_1.default.createElement("footer", null, footerContent);
        }
        else if (footer) {
            return react_1.default.createElement("footer", null, render(footer, config)());
        }
        return null;
    }, [footerContent, footer, config]);
    const chromeContent = react_1.useMemo(() => {
        const showNoResults = !minimised && (noContent === null || noContent === void 0 ? void 0 : noContent.show);
        const hasChromeElements = renderHeader || renderFooter;
        const props = {
            "data-is-scrollable": true,
            className: [styles.body, className || ""].join(" "),
        };
        const content = showContent ? (children) : showNoResults ? (react_1.default.createElement(utilities_1.NoResults, Object.assign({}, noContent))) : null;
        const body = content ? (hasChromeElements ? (react_1.default.createElement("section", Object.assign({}, props), content)) : (content)) : null;
        if (focus !== false) {
            return (react_1.default.createElement(react_2.FocusZone, Object.assign({ as: !hasChromeElements ? "section" : "div", direction: focus === true
                    ? react_2.FocusZoneDirection.domOrder
                    : react_2.FocusZoneDirection[focus], shouldEnterInnerZone: !focusable ? shouldEnterInnerZone : undefined }, (!hasChromeElements ? props : { className: styles.inner })),
                renderHeader,
                body,
                renderFooter));
        }
        else {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                renderHeader,
                body,
                renderFooter));
        }
    }, [
        hasContent,
        styles,
        noContent,
        children,
        renderHeader,
        renderFooter,
        minimised,
        className,
    ]);
    const renderChrome = react_1.useMemo(() => {
        const { coachmarks, description: configDescription, title: configTitle, } = config;
        const hasChromeElements = renderHeader || renderFooter;
        const chromeCoachmark = enableCoachmark !== false
            ? coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find((coachmark) => coachmark.target === "component-chrome") : null;
        const labelPrefix = (ariaLabel === null || ariaLabel === void 0 ? void 0 : ariaLabel.length) ? ariaLabel : configDescription;
        const directionText = focus == "horizontal"
            ? localize.focusZoneHorizontalLabel
            : focus == "vertical"
                ? localize.focusZoneVerticalLabel
                : localize.focusZoneBothLabel;
        const label = `${labelPrefix} ${!focusable ? directionText : ""}`;
        const titleText = (title === null || title === void 0 ? void 0 : title.length) ? title : configTitle;
        const bodyClass = showContent && !hasChromeElements && !focus
            ? [styles.body, className || ""].join(" ")
            : "";
        const combinedClass = [
            styles.component,
            className,
            bodyClass,
            focusable ? focusStyles : "",
        ].join(" ");
        const content = (react_1.default.createElement("article", Object.assign({ "aria-label": label, title: titleText, className: combinedClass, "data-is-focusable": focusable, tabIndex: focusable ? 0 : undefined }, props), chromeContent));
        return chromeCoachmark ? (react_1.default.createElement(utilities_1.CoachMarkWrapper, Object.assign({}, chromeCoachmark), content)) : (content);
    }, [config, styles, chromeContent, ariaLabel, title, className, props]);
    return react_1.useMemo(() => error ? (react_1.default.createElement(utilities_1.ErrorBox, { error: error })) : hasContent || (noContent === null || noContent === void 0 ? void 0 : noContent.show) !== false ? (renderChrome) : (react_1.default.createElement(react_1.default.Fragment, null)), [renderChrome, noContent, hasContent, error]);
};
exports.ComponentChrome = ComponentChrome;


/***/ }),

/***/ "./src/core/component-chrome/index.ts":
/*!********************************************!*\
  !*** ./src/core/component-chrome/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./component-chrome.component */ "./src/core/component-chrome/component-chrome.component.tsx"), exports);


/***/ }),

/***/ "./src/core/component-header/component-header.component.tsx":
/*!******************************************************************!*\
  !*** ./src/core/component-header/component-header.component.tsx ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ComponentHeader = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_1 = __webpack_require__(/*! react */ "react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_3 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const fluentStyles = (({ config: { minimised }, theme: { sizes } }) => ({
    button: {
        root: {
            height: sizes.mediumPlus,
            width: sizes.mediumPlus
        }
    },
    icon: {
        root: {
            transition: "transform 0.1s linear 0s",
            transform: minimised ? "rotate(-90deg)" : undefined
        }
    }
}));
const useHeaderStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing, sizes, type }) => ({
    root: ({ config: { style, align, background } }) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: !align || align == 'left'
            ? 'flex-start'
            : align == 'right'
                ? 'flex-end'
                : 'center',
        marginBottom: style == 'detail'
            ? spacing.smallPlus
            : 0,
        backgroundColor: background == 'fill' ? palette.neutralEmpty : undefined,
        color: palette.neutralEmptyOn,
        borderRadius: style == 'mini' ? 0 : spacing.xSmall,
        borderBottom: style != 'keyline' && background == 'fill' ? `${spacing.tiny} solid ${type == "dark" ? palette.neutralMinus5 : palette.neutralMinus3}` : undefined,
        flex: "0 0",
        ['&::after']: style == 'keyline' && (!align || align == 'left' || align == 'center')
            ? {
                backgroundColor: background == "fill"
                    ? type == "dark" ? palette.neutralMinus5 : palette.neutralMinus3
                    : palette.neutral,
                height: spacing.tiny,
                content: '""',
                display: "block",
                flex: "1 1"
            }
            : undefined,
        ['&::before']: style == 'keyline' && (align == 'right' || align == 'center')
            ? {
                backgroundColor: background == "fill"
                    ? type == "dark" ? palette.neutralMinus5 : palette.neutralMinus3
                    : palette.neutral,
                height: spacing.tiny,
                content: '""',
                display: "block",
                flex: "1 1"
            }
            : undefined
    }),
    icon: {
        fontSize: sizes.mediumEm,
        color: palette.primary,
        float: "left",
        marginRight: spacing.tiny,
    },
    title: ({ config: { style } }) => (Object.assign(Object.assign({}, (style == 'detail'
        ? fonts.mediumPlus
        : fonts.medium)), { overFlow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", margin: 0, padding: style == 'mini'
            ? `0 ${spacing.smallPlus} 0 0`
            : style == 'keyline'
                ? `${spacing.smallPlus} ${spacing.medium}`
                : style == 'detail'
                    ? 0
                    : spacing.medium, display: "inline-block", verticalAlign: "top" })),
    description: {
        margin: 0,
        padding: 0
    },
}));
const defaultHeaderLevel = 'h2';
const configReplacements = (config, params) => {
    const { title = '', description = '', consumes } = config;
    if (consumes === null || consumes === void 0 ? void 0 : consumes.length) {
        return params
            ? smarthub_common_1.deepReplaceParams({ title, description }, params)
            : {
                title: '',
                description: ''
            };
    }
    return {
        title,
        description
    };
};
const ComponentHeader = ({ config, data: componentConfig }) => {
    const { $id, consumes, props: { style, align, headerLevel, icon } = {}, responsive } = config;
    const { $id: parentId, chrome: { minimizeKey, background } = { background: null, minimizeKey: null } } = componentConfig || { chrome: {} };
    const HeaderTag = headerLevel || defaultHeaderLevel;
    const prefKey = (minimizeKey === null || minimizeKey === void 0 ? void 0 : minimizeKey.length) ? minimizeKey
        : parentId;
    const [minimised, minimise] = smarthub_common_1.usePreference(`${smarthub_common_1.preferenceKeys.componentMinPrefix}${prefKey}`, true, false);
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const handleClick = react_1.useCallback(() => {
        minimise(minimised ? null : true);
    }, [minimise, minimised]);
    const styleConfig = react_1.useMemo(() => ({
        style,
        align,
        minimised,
        background
    }), [minimised, style, align, background]);
    const styleProps = smarthub_common_1.useThemeStyleProps(styleConfig, responsive);
    const buttonStyles = smarthub_common_1.useFluentStyles(fluentStyles, styleProps);
    const styles = useHeaderStyles(styleProps);
    const [replacements, setReplacements] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setReplacements(consumes), [consumes]);
    const { title, description } = react_1.useMemo(() => configReplacements(config, replacements), [replacements, config]);
    return react_1.useMemo(() => (react_3.default.createElement("div", { className: styles.root },
        style == 'mini' && react_3.default.createElement(react_2.IconButton, { styles: buttonStyles.button, ariaLabel: minimised
                ? `${localizeConfig.expandComponent} ${title}`
                : `${localizeConfig.minimiseComponent} ${title}`, title: minimised
                ? `${localizeConfig.expandComponent} ${title}`
                : `${localizeConfig.minimiseComponent} ${title}`, iconProps: {
                styles: buttonStyles.icon,
                iconName: "ChevronDownMed"
            }, onClick: handleClick }),
        style == 'detail' && react_3.default.createElement(react_2.Icon, { iconName: icon, className: styles.icon }),
        react_3.default.createElement("div", null,
            react_3.default.createElement(HeaderTag, { className: styles.title }, title),
            style == 'detail' && react_3.default.createElement("p", { className: styles.description }, description)))), [styles, title, description, handleClick]);
};
exports.ComponentHeader = ComponentHeader;


/***/ }),

/***/ "./src/core/component-header/index.ts":
/*!********************************************!*\
  !*** ./src/core/component-header/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./component-header.component */ "./src/core/component-header/component-header.component.tsx"), exports);


/***/ }),

/***/ "./src/core/index.ts":
/*!***************************!*\
  !*** ./src/core/index.ts ***!
  \***************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./card-list-base */ "./src/core/card-list-base/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./command-bar */ "./src/core/command-bar/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./component-chrome */ "./src/core/component-chrome/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./component-header */ "./src/core/component-header/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-entity-header */ "./src/core/panel-entity-header/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-entity-menu */ "./src/core/panel-entity-menu/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-entity-search */ "./src/core/panel-entity-search/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-header */ "./src/core/panel-header/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-sidebar */ "./src/core/panel-sidebar/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-sidebar-button */ "./src/core/panel-sidebar-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./tab-navigation */ "./src/core/tab-navigation/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./secured */ "./src/core/secured/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./actions */ "./src/core/actions/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./list-actions */ "./src/core/list-actions/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./view-menu */ "./src/core/view-menu/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page-menu */ "./src/core/page-menu/index.ts"), exports);


/***/ }),

/***/ "./src/core/list-actions/az-button/az-button.component.tsx":
/*!*****************************************************************!*\
  !*** ./src/core/list-actions/az-button/az-button.component.tsx ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AZButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const az_button_styles_1 = __webpack_require__(/*! ./az-button.styles */ "./src/core/list-actions/az-button/az-button.styles.ts");
const actions_1 = __webpack_require__(/*! ../../actions */ "./src/core/actions/index.ts");
const AZButton = ({ config: { $id, provides, coachmarks }, data: { renderedInOverflow } }) => {
    const provider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'az');
    const [state, setState] = smarthub_common_1.useSharedState(provider);
    const localize = smarthub_common_1.useLocalizeConfig();
    const styles = smarthub_common_1.useFluentStylesWithProps(az_button_styles_1.menuStyles);
    const items = react_1.useMemo(() => {
        const { azFilterValueDesc, azFilterValueTitle } = localize;
        const menuItems = [];
        for (let i = "A".charCodeAt(0); i <= "Z".charCodeAt(0); i++) {
            let char = String.fromCharCode(i);
            menuItems.push({
                key: char,
                text: char,
                ariaDescription: `${azFilterValueDesc} ${char}`,
                ariaLabel: `${azFilterValueTitle} ${char}`,
                title: `${azFilterValueTitle} ${char}`,
                onClick: () => setState(char)
            });
        }
        return menuItems;
    }, []);
    return react_1.useMemo(() => {
        const coachmark = coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(({ target }) => target == 'component-chrome');
        const { azFilterDesc, azFilterSecondaryText, azFilterText, azFilterTitle } = localize;
        const props = {
            key: $id,
            text: `${azFilterText}`,
            name: `${azFilterText}`,
            title: `${azFilterTitle} ${state}`,
            split: state != null,
            checked: state != null,
            menuProps: {
                items,
                styles: styles
            },
            iconProps: state
                ? { iconName: 'ChromeClose' }
                : null,
            secondaryText: state
                ? `${azFilterSecondaryText} ${state}`
                : null,
            ariaDescription: `${azFilterDesc} ${state}`,
            ariaLabel: `${azFilterTitle} ${state}`,
            onClick: () => state != null
                ? setState()
                : null
        };
        return react_1.default.createElement(actions_1.SplitButton, { props: props, coachmark: coachmark, renderedInOverflow: renderedInOverflow });
    }, [localize, state, coachmarks, renderedInOverflow]);
};
exports.AZButton = AZButton;


/***/ }),

/***/ "./src/core/list-actions/az-button/az-button.styles.ts":
/*!*************************************************************!*\
  !*** ./src/core/list-actions/az-button/az-button.styles.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.menuStyles = void 0;
const menuStyles = (props) => {
    const { sizes } = props.theme;
    return {
        list: {
            maxWidth: `calc(5 * ${sizes.mediumPlus})`
        },
        subComponentStyles: {
            menuItem: {
                root: {
                    padding: 0,
                    textAlign: "center"
                },
                item: {
                    width: sizes.mediumPlus,
                    display: "inline-block",
                }
            },
            callout: {}
        }
    };
};
exports.menuStyles = menuStyles;


/***/ }),

/***/ "./src/core/list-actions/az-button/index.ts":
/*!**************************************************!*\
  !*** ./src/core/list-actions/az-button/index.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./az-button.component */ "./src/core/list-actions/az-button/az-button.component.tsx"), exports);


/***/ }),

/***/ "./src/core/list-actions/clear-selection-button/clear-selection-button.component.tsx":
/*!*******************************************************************************************!*\
  !*** ./src/core/list-actions/clear-selection-button/clear-selection-button.component.tsx ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ClearSelectionButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const actions_1 = __webpack_require__(/*! ../../actions */ "./src/core/actions/index.ts");
const ClearSelectionButton = ({ config: { $id, consumes, props: appAction, coachmarks }, data: { renderedInOverflow } }) => {
    const { clearAllDesc, clearAllTitle, clearAllText } = smarthub_common_1.useLocalizeConfig();
    const [state, setState] = smarthub_common_1.useSharedStates($id);
    const setStates = smarthub_common_1.useSetSharedStates();
    react_1.useEffect(() => setState(consumes), [consumes]);
    const onClick = react_1.useCallback(() => {
        if (!(consumes === null || consumes === void 0 ? void 0 : consumes.length))
            return;
        const values = consumes.map(c => (Object.assign(Object.assign({}, c), { value: null })));
        setStates(values);
    }, [consumes]);
    return react_1.useMemo(() => {
        const keys = state
            ? Object.keys(state)
            : [];
        if (!keys.some(k => state[k] != null))
            return null;
        const coachmark = coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(({ target }) => target == 'component-chrome');
        const extendedProps = {
            key: $id,
            text: clearAllText,
            primary: true,
            iconProps: { iconName: 'ChromeClose' },
            ariaDescription: clearAllDesc,
            ariaLabel: clearAllTitle,
            title: clearAllTitle,
            name: clearAllText,
            onClick
        };
        return react_1.default.createElement(actions_1.BaseActionButton, { props: extendedProps, coachmark: coachmark, renderedInOverflow: renderedInOverflow });
    }, [state, appAction, coachmarks, onClick, renderedInOverflow]);
};
exports.ClearSelectionButton = ClearSelectionButton;


/***/ }),

/***/ "./src/core/list-actions/clear-selection-button/index.ts":
/*!***************************************************************!*\
  !*** ./src/core/list-actions/clear-selection-button/index.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./clear-selection-button.component */ "./src/core/list-actions/clear-selection-button/clear-selection-button.component.tsx"), exports);


/***/ }),

/***/ "./src/core/list-actions/date-picker/calendar-menu.component.tsx":
/*!***********************************************************************!*\
  !*** ./src/core/list-actions/date-picker/calendar-menu.component.tsx ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CalendarMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const utc_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/utc */ "dayjs/plugin/utc"));
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const date_picker_styles_1 = __webpack_require__(/*! ./date-picker.styles */ "./src/core/list-actions/date-picker/date-picker.styles.ts");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
dayjs_1.default.extend(utc_1.default);
const stopPropagation = (e) => e.stopPropagation();
const CalendarMenu = ({ value, onChange, isDayPickerVisible }) => {
    const onSelectDate = react_1.useCallback((date) => {
        const ISODate = dayjs_1.default(date).utc().toISOString();
        onChange(ISODate);
    }, []);
    const date = react_1.useMemo(() => {
        const date = dayjs_1.default(value);
        return date.isValid()
            ? date.toDate()
            : undefined;
    }, [value]);
    const styles = smarthub_common_1.useFluentStylesWithProps(date_picker_styles_1.datePickerStyles);
    return react_1.default.createElement("div", { onClick: stopPropagation },
        react_1.default.createElement(react_2.Calendar, { calendarMonthProps: styles, onSelectDate: onSelectDate, strings: react_2.defaultCalendarStrings, highlightSelectedMonth: true, isDayPickerVisible: isDayPickerVisible, showGoToToday: false, value: date, showCloseButton: true }));
};
exports.CalendarMenu = CalendarMenu;


/***/ }),

/***/ "./src/core/list-actions/date-picker/date-picker.component.tsx":
/*!*********************************************************************!*\
  !*** ./src/core/list-actions/date-picker/date-picker.component.tsx ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DatePicker = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const actions_1 = __webpack_require__(/*! ../../actions */ "./src/core/actions/index.ts");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const calendar_menu_component_1 = __webpack_require__(/*! ./calendar-menu.component */ "./src/core/list-actions/date-picker/calendar-menu.component.tsx");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const DatePicker = ({ config: { $id, provides, coachmarks, title, description, props: { dayView, format = '' } = {} }, data: { renderedInOverflow } }) => {
    const provider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'date');
    const buttonRef = react_1.useRef();
    const { commonDateFormat } = smarthub_common_1.useLocalizeConfig();
    const [state, setState] = smarthub_common_1.useSharedState(provider);
    const onSelectDate = react_1.useCallback((date) => {
        var _a;
        setState(date);
        (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.dismissMenu();
    }, []);
    return (react_1.useMemo(() => {
        const coachmark = coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(({ target }) => target == 'component-chrome');
        const secondaryText = state
            ? dayjs_1.default(state).format(format || commonDateFormat)
            : null;
        const props = {
            componentRef: buttonRef,
            key: $id,
            text: title,
            title: description,
            split: state != null,
            checked: state != null,
            iconProps: {
                iconName: state
                    ? 'ChromeClose'
                    : 'Calendar'
            },
            menuProps: {
                onRenderMenuList: () => react_1.default.createElement(calendar_menu_component_1.CalendarMenu, { isDayPickerVisible: dayView, value: state, onChange: onSelectDate }),
                items: [{ key: $id }]
            },
            onClick: () => state != null
                ? setState()
                : null,
            secondaryText,
        };
        return react_1.default.createElement(actions_1.SplitButton, { props: props, coachmark: coachmark, renderedInOverflow: renderedInOverflow });
    }, [state, coachmarks, renderedInOverflow]));
};
exports.DatePicker = DatePicker;


/***/ }),

/***/ "./src/core/list-actions/date-picker/date-picker.styles.ts":
/*!*****************************************************************!*\
  !*** ./src/core/list-actions/date-picker/date-picker.styles.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.datePickerStyles = void 0;
const datePickerStyles = (props) => {
    const { neutralEmptyOn } = props.theme.palette;
    return {
        styles: {
            currentItemButton: {
                color: neutralEmptyOn
            }
        }
    };
};
exports.datePickerStyles = datePickerStyles;


/***/ }),

/***/ "./src/core/list-actions/date-picker/index.ts":
/*!****************************************************!*\
  !*** ./src/core/list-actions/date-picker/index.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./date-picker.component */ "./src/core/list-actions/date-picker/date-picker.component.tsx"), exports);


/***/ }),

/***/ "./src/core/list-actions/index.ts":
/*!****************************************!*\
  !*** ./src/core/list-actions/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./az-button */ "./src/core/list-actions/az-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./sort-button */ "./src/core/list-actions/sort-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./refiner-button */ "./src/core/list-actions/refiner-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./clear-selection-button */ "./src/core/list-actions/clear-selection-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./date-picker */ "./src/core/list-actions/date-picker/index.ts"), exports);


/***/ }),

/***/ "./src/core/list-actions/refiner-button/index.ts":
/*!*******************************************************!*\
  !*** ./src/core/list-actions/refiner-button/index.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./refiner-button.component */ "./src/core/list-actions/refiner-button/refiner-button.component.tsx"), exports);


/***/ }),

/***/ "./src/core/list-actions/refiner-button/refiner-button.component.tsx":
/*!***************************************************************************!*\
  !*** ./src/core/list-actions/refiner-button/refiner-button.component.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RefinerButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const actions_1 = __webpack_require__(/*! ../../actions */ "./src/core/actions/index.ts");
const RefinerButton = ({ config: { $id, provides, consumes, coachmarks }, data: { renderedInOverflow } }) => {
    const refiners = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "refiners"));
    const provider = provides === null || provides === void 0 ? void 0 : provides[0];
    const [state, setState] = smarthub_common_1.useSharedState(provider);
    const localize = smarthub_common_1.useLocalizeConfig();
    return react_1.useMemo(() => {
        var _a;
        const refiner = Array.isArray(refiners)
            ? refiners === null || refiners === void 0 ? void 0 : refiners.find(({ name }) => name == (provider === null || provider === void 0 ? void 0 : provider.name)) : refiners;
        if (!((_a = refiner === null || refiner === void 0 ? void 0 : refiner.values) === null || _a === void 0 ? void 0 : _a.length))
            return null;
        const coachmark = coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(({ target }) => target == 'component-chrome');
        const { text, values } = refiner;
        const selected = state
            ? values.find(({ token }) => token == state)
            : null;
        const { value, text: valueText } = selected || {};
        const { refineByTitle, refineByDesc, refineByValueDesc, refineByValueTitle } = localize;
        const items = values.map(({ token, text }) => ({
            key: token,
            text: text,
            ariaDescription: `${refineByValueDesc} ${text} ${text}`,
            ariaLabel: `${refineByValueTitle} ${text} ${text}`,
            title: `${refineByValueTitle} ${text} ${text}`,
            onClick: () => setState(token)
        }));
        const props = {
            key: $id,
            text,
            secondaryText: valueText,
            split: value != null,
            checked: value != null,
            iconProps: value
                ? { iconName: 'ChromeClose' }
                : null,
            ariaDescription: `${refineByDesc} ${text} ${valueText}`,
            ariaLabel: `${refineByTitle} ${text} ${valueText}`,
            menuProps: {
                items
            },
            onClick: () => value != null
                ? setState()
                : null
        };
        return react_1.default.createElement(actions_1.SplitButton, { props: props, coachmark: coachmark, renderedInOverflow: renderedInOverflow });
    }, [localize, state, refiners, provides, coachmarks, renderedInOverflow]);
};
exports.RefinerButton = RefinerButton;


/***/ }),

/***/ "./src/core/list-actions/sort-button/index.ts":
/*!****************************************************!*\
  !*** ./src/core/list-actions/sort-button/index.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./sort-button.component */ "./src/core/list-actions/sort-button/sort-button.component.tsx"), exports);


/***/ }),

/***/ "./src/core/list-actions/sort-button/sort-button.component.tsx":
/*!*********************************************************************!*\
  !*** ./src/core/list-actions/sort-button/sort-button.component.tsx ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SortButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const actions_1 = __webpack_require__(/*! ../../actions */ "./src/core/actions/index.ts");
const SortButton = ({ config: { $id, provides, consumes, coachmarks }, data: { renderedInOverflow } }) => {
    const options = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "sort-options"));
    const provider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'sort');
    const [state, setState] = smarthub_common_1.useSharedState(provider);
    const localize = smarthub_common_1.useLocalizeConfig();
    return react_1.useMemo(() => {
        var _a;
        if (!(options === null || options === void 0 ? void 0 : options.length))
            return null;
        const coachmark = coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(({ target }) => target == 'component-chrome');
        const { sortByText, sortByDesc, sortByTitle, sortByValueDesc, sortByValueTitle } = localize;
        const items = options.map(({ text, name, direction }) => ({
            key: `${name}-${direction}`,
            text: text,
            iconProps: {
                iconName: !direction || direction == 'ascending' || direction == 'asc'
                    ? 'ascending'
                    : 'descending'
            },
            ariaDescription: `${sortByValueDesc} ${text}`,
            ariaLabel: `${sortByValueTitle} ${text}`,
            title: `${sortByValueTitle} ${text}`,
            onClick: () => setState({ name, direction })
        }));
        const sort = (_a = (state
            ? options.find(({ name, direction }) => name == state.name &&
                direction == state.direction)
            : options.find(({ preferred }) => preferred))) !== null && _a !== void 0 ? _a : options[0];
        const asc = !sort.direction || sort.direction == 'ascending' || sort.direction == 'asc';
        const props = {
            key: $id,
            text: `${sortByText}`,
            name: `${sortByText}`,
            title: `${sortByTitle} ${sort.text}`,
            split: false,
            iconProps: {
                iconName: asc ? 'ascending' : 'descending'
            },
            secondaryText: sort.text,
            ariaDescription: `${sortByDesc} ${sort.text}`,
            ariaLabel: `${sortByTitle} ${sort.text}`,
            menuProps: {
                items
            },
            onClick: () => state != null
                ? setState()
                : null
        };
        return react_1.default.createElement(actions_1.SplitButton, { props: props, coachmark: coachmark, renderedInOverflow: renderedInOverflow });
    }, [localize, state, coachmarks, options, renderedInOverflow]);
};
exports.SortButton = SortButton;


/***/ }),

/***/ "./src/core/page-menu/bookmark-command-button.component.tsx":
/*!******************************************************************!*\
  !*** ./src/core/page-menu/bookmark-command-button.component.tsx ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BookmarkCommandButton = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const use_render_action_helper_1 = __webpack_require__(/*! ./use-render-action.helper */ "./src/core/page-menu/use-render-action.helper.tsx");
const BookmarkCommandButton = (props) => {
    const getThemeImageURI = smarthub_common_1.useGetThemeImageURI();
    const entity = smarthub_common_1.usePanelEntity();
    const [bookmarked, bookmark] = smarthub_common_1.useBookmark(entity === null || entity === void 0 ? void 0 : entity.bookmark);
    const getProps = ({ title, shortTitle, description, icon, coachmark }, buttonProps) => (Object.assign(Object.assign({}, buttonProps), { title, ariaLabel: description, text: shortTitle, iconProps: {
            iconName: typeof icon == 'string' ? icon : undefined,
            imageProps: typeof icon == 'object'
                ? {
                    src: getThemeImageURI(icon.image),
                    alt: typeof icon.image == 'object'
                        ? icon.image.text
                        : title
                }
                : undefined
        }, onClick: () => { bookmark(); } }));
    return use_render_action_helper_1.useRenderAction(props, getProps, bookmarked);
};
exports.BookmarkCommandButton = BookmarkCommandButton;


/***/ }),

/***/ "./src/core/page-menu/content-view-command-button.component.tsx":
/*!**********************************************************************!*\
  !*** ./src/core/page-menu/content-view-command-button.component.tsx ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ContentViewCommandButton = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const use_render_action_helper_1 = __webpack_require__(/*! ./use-render-action.helper */ "./src/core/page-menu/use-render-action.helper.tsx");
const ContentViewCommandButton = (props) => {
    const getThemeImageURI = smarthub_common_1.useGetThemeImageURI();
    const { content } = smarthub_common_1.usePanelView() || {};
    const setContentView = smarthub_common_1.useSetPreference(smarthub_common_1.preferenceKeys.pageContentView);
    const toggle = react_1.useCallback(() => {
        setContentView(content == 'expanded' ? 'normal' : 'expanded');
    }, [content]);
    const getProps = ({ title, shortTitle, description, icon, coachmark }, buttonProps) => (Object.assign(Object.assign({}, buttonProps), { title, ariaLabel: description, text: shortTitle, iconProps: {
            iconName: typeof icon == 'string' ? icon : undefined,
            imageProps: typeof icon == 'object'
                ? {
                    src: getThemeImageURI(icon.image),
                    alt: typeof icon.image == 'object'
                        ? icon.image.text
                        : title
                }
                : undefined
        }, onClick: toggle }));
    return use_render_action_helper_1.useRenderAction(props, getProps, content == 'expanded');
};
exports.ContentViewCommandButton = ContentViewCommandButton;


/***/ }),

/***/ "./src/core/page-menu/index.ts":
/*!*************************************!*\
  !*** ./src/core/page-menu/index.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./page-menu.component */ "./src/core/page-menu/page-menu.component.tsx"), exports);


/***/ }),

/***/ "./src/core/page-menu/menu-command-button.component.tsx":
/*!**************************************************************!*\
  !*** ./src/core/page-menu/menu-command-button.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MenuCommandButton = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const use_render_action_helper_1 = __webpack_require__(/*! ./use-render-action.helper */ "./src/core/page-menu/use-render-action.helper.tsx");
const MenuCommandButton = (props) => {
    const getThemeImageURI = smarthub_common_1.useGetThemeImageURI();
    const handleCommand = smarthub_common_1.useHandleCommand();
    const entity = smarthub_common_1.usePanelEntity();
    const getProps = ({ title, shortTitle, description, icon, coachmark, action }, buttonProps) => {
        if (!entity)
            return buttonProps;
        const command = entity
            ? smarthub_common_1.deepReplaceParams(action, { entity })
            : null;
        return Object.assign(Object.assign({}, buttonProps), { title, ariaLabel: description, text: shortTitle, iconProps: {
                iconName: typeof icon == 'string' ? icon : undefined,
                imageProps: typeof icon == 'object'
                    ? {
                        src: getThemeImageURI(icon.image),
                        alt: typeof icon.image == 'object'
                            ? icon.image.text
                            : title
                    }
                    : undefined
            }, onClick: () => {
                handleCommand(command);
            } });
    };
    return use_render_action_helper_1.useRenderAction(props, getProps);
};
exports.MenuCommandButton = MenuCommandButton;


/***/ }),

/***/ "./src/core/page-menu/page-menu-command-button.component.tsx":
/*!*******************************************************************!*\
  !*** ./src/core/page-menu/page-menu-command-button.component.tsx ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageMenuCommandButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const bookmark_command_button_component_1 = __webpack_require__(/*! ./bookmark-command-button.component */ "./src/core/page-menu/bookmark-command-button.component.tsx");
const content_view_command_button_component_1 = __webpack_require__(/*! ./content-view-command-button.component */ "./src/core/page-menu/content-view-command-button.component.tsx");
const menu_command_button_component_1 = __webpack_require__(/*! ./menu-command-button.component */ "./src/core/page-menu/menu-command-button.component.tsx");
const PageMenuCommandButton = (props) => {
    const isContextMenu = props.hasOwnProperty('item');
    const { data: { name } = { name: null }, defaultRender } = isContextMenu
        ? props.item
        : props;
    const Type = !name
        ? defaultRender
        : name == 'bookmark'
            ? bookmark_command_button_component_1.BookmarkCommandButton
            : name == 'content-resize'
                ? content_view_command_button_component_1.ContentViewCommandButton
                : menu_command_button_component_1.MenuCommandButton;
    return react_1.default.createElement(Type, Object.assign({}, props));
};
exports.PageMenuCommandButton = PageMenuCommandButton;


/***/ }),

/***/ "./src/core/page-menu/page-menu.component.tsx":
/*!****************************************************!*\
  !*** ./src/core/page-menu/page-menu.component.tsx ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const view_menu_1 = __webpack_require__(/*! ../view-menu */ "./src/core/view-menu/index.ts");
const use_menu_action_buttons_hook_1 = __webpack_require__(/*! ./use-menu-action-buttons.hook */ "./src/core/page-menu/use-menu-action-buttons.hook.tsx");
const page_menu_command_button_component_1 = __webpack_require__(/*! ./page-menu-command-button.component */ "./src/core/page-menu/page-menu-command-button.component.tsx");
const component_chrome_1 = __webpack_require__(/*! ../component-chrome */ "./src/core/component-chrome/index.ts");
const onRender = (props, dismiss) => react_1.default.createElement(page_menu_command_button_component_1.PageMenuCommandButton, Object.assign({}, props));
const PageMenu = ({ config }) => {
    var _a, _b, _c;
    const viewConfig = smarthub_common_1.useViewConfig();
    const setPagePosition = smarthub_common_1.useSetPreference(smarthub_common_1.preferenceKeys.pageDockPosition);
    const setPageSize = smarthub_common_1.useSetPreference(smarthub_common_1.preferenceKeys.pageDockSize);
    const { pageMenuTitle, pageMenuLabel, pageMenuCloseDesc, pageMenuCloseTitle, pageMenuCloseText } = smarthub_common_1.useLocalizeConfig();
    const entity = smarthub_common_1.usePanelEntity();
    const setPanel = smarthub_common_1.useSetPanelId();
    const view = smarthub_common_1.usePanelView();
    const { panel } = smarthub_common_1.usePanelViewContext() || {};
    const dockConfig = smarthub_common_1.useResponsiveProps((_b = (_a = panel === null || panel === void 0 ? void 0 : panel.dock) === null || _a === void 0 ? void 0 : _a.options) !== null && _b !== void 0 ? _b : (_c = viewConfig.page) === null || _c === void 0 ? void 0 : _c.dockSizes);
    const buttons = use_menu_action_buttons_hook_1.useMenuActionButtons(panel, entity, onRender);
    const close = react_1.useCallback(() => {
        setPanel();
    }, []);
    const changePageSize = react_1.useCallback((dock) => {
        setPageSize(dock);
    }, []);
    return react_1.useMemo(() => (react_1.default.createElement(component_chrome_1.ComponentChrome, { config: config },
        react_1.default.createElement(view_menu_1.ViewMenu, { title: pageMenuTitle, label: pageMenuLabel, changeDockSize: changePageSize, changeDockPosition: setPagePosition, focusName: "pageMenu", dockSize: view.size, dockPosition: view.position, dockConfig: dockConfig, dockPositionConfig: viewConfig.page.dockPositions, buttons: buttons, closeProps: {
                onClick: close,
                text: pageMenuCloseText,
                title: pageMenuCloseTitle,
                description: pageMenuCloseDesc
            } }))), [close, changePageSize, view, dockConfig, buttons]);
};
exports.PageMenu = PageMenu;


/***/ }),

/***/ "./src/core/page-menu/use-menu-action-buttons.hook.tsx":
/*!*************************************************************!*\
  !*** ./src/core/page-menu/use-menu-action-buttons.hook.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useMenuActionButtons = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const useMenuActionButtons = (panel, entity, onRender) => {
    const getPermission = smarthub_common_1.useHasPermission();
    const [actions, setActions] = react_1.useState(null);
    react_1.useEffect(() => {
        var _a;
        if (!panel || !entity)
            return null;
        let all = [
            ...(((_a = panel === null || panel === void 0 ? void 0 : panel.dock) === null || _a === void 0 ? void 0 : _a.actions) || []),
            ...((entity === null || entity === void 0 ? void 0 : entity.actions) || [])
        ];
        const promises = all
            .filter(({ permission }) => permission)
            .map((action) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const allowed = yield getPermission(action.permission);
            return {
                action,
                allowed
            };
        }));
        if (promises.length)
            Promise.all(promises).then((results) => setActions(all
                .filter(action => {
                const result = results.find(r => r.action == action);
                return result
                    ? result.allowed
                    : true;
            })));
        else
            setActions(all);
    }, [entity, panel]);
    const buildActions = react_1.useCallback((position) => actions
        .filter(({ position: p }) => Array.isArray(position)
        ? ~position.indexOf(p)
        : p == position)
        .map(data => ({
        key: data.name,
        data,
        onRender
    })), [actions]);
    return react_1.useMemo(() => {
        return actions ? {
            overflowItems: buildActions([smarthub_common_1.AppActionPosition.moreBefore, smarthub_common_1.AppActionPosition.moreAfter]),
            beforeItems: buildActions(smarthub_common_1.AppActionPosition.nearBefore),
            afterItems: [
                ...buildActions([smarthub_common_1.AppActionPosition.nearAfter, undefined]),
            ],
            farItems: [
                ...buildActions([smarthub_common_1.AppActionPosition.farBefore, smarthub_common_1.AppActionPosition.farAfter]),
            ]
        } : null;
    }, [actions, buildActions]);
};
exports.useMenuActionButtons = useMenuActionButtons;


/***/ }),

/***/ "./src/core/page-menu/use-render-action.helper.tsx":
/*!*********************************************************!*\
  !*** ./src/core/page-menu/use-render-action.helper.tsx ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useRenderAction = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
//TODO use sizes in next version
const fluentStyles = ({ theme: { sizes } }) => ({
    buttonStyles: {
        root: {
            height: sizes.mediumPlus
        }
    },
    contextMenuStyles: {
        root: {
            width: "100%",
            height: sizes.mediumPlus
        },
        textContainer: {
            textAlign: "left"
        }
    }
});
const useRenderAction = (props, getProps, useAlt) => {
    const { buttonStyles, contextMenuStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    return react_1.useMemo(() => {
        const buttonProps = Object.assign(Object.assign({}, props), { styles: props.renderedInOverflow
                ? contextMenuStyles
                : buttonStyles });
        const { data, data: { alt } } = buttonProps;
        const action = useAlt && alt
            ? Object.assign(Object.assign({}, data), alt) : data;
        const { coachmark } = action;
        const _a = getProps
            ? getProps(action, buttonProps)
            : buttonProps, { title } = _a, extendedProps = tslib_1.__rest(_a, ["title"]);
        const { key } = extendedProps;
        const content = react_1.default.createElement(react_2.TooltipHost, { id: key, content: title },
            react_1.default.createElement(react_2.CommandBarButton, Object.assign({}, extendedProps)));
        return coachmark
            ? react_1.default.createElement(utilities_1.CoachMarkWrapper, Object.assign({}, coachmark),
                react_1.default.createElement("div", null, content))
            : content;
    }, [props, useAlt, buttonStyles, contextMenuStyles]);
};
exports.useRenderAction = useRenderAction;


/***/ }),

/***/ "./src/core/panel-entity-header/index.ts":
/*!***********************************************!*\
  !*** ./src/core/panel-entity-header/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-entity-header.component */ "./src/core/panel-entity-header/panel-entity-header.component.tsx"), exports);


/***/ }),

/***/ "./src/core/panel-entity-header/panel-entity-header.component.tsx":
/*!************************************************************************!*\
  !*** ./src/core/panel-entity-header/panel-entity-header.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelEntityHeader = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_2 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const tab_navigation_1 = __webpack_require__(/*! ../tab-navigation */ "./src/core/tab-navigation/index.ts");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const panel_sidebar_button_1 = __webpack_require__(/*! ../panel-sidebar-button */ "./src/core/panel-sidebar-button/index.ts");
const fluentStyles = (({ theme: { spacing } }) => ({
    personaStyles: {
        root: {
            margin: `${spacing.medium} 0 ${spacing.medium} ${spacing.medium}`
        },
        details: {
            display: "none"
        }
    },
    coinStyles: {
        initials: {
            borderRadius: spacing.small
        }
    }
}));
const PanelEntityHeader = ({ config, data }) => {
    const { children = [], props: { logo } = {} } = config;
    const render = smarthub_common_1.useRender();
    const panelStyles = smarthub_common_1.usePanelStyles();
    const gridStyles = smarthub_common_1.useGridStyles();
    const { personaStyles, coinStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const entity = smarthub_common_1.usePanelEntity();
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    return react_2.useMemo(() => {
        const { menu, nav } = children.reduce((named, component) => {
            named[component.$id] = component;
            return named;
        }, {});
        return react_2.default.createElement(react_2.default.Fragment, null, entity && react_2.default.createElement("div", { className: [panelStyles.header, gridStyles.grid, gridStyles.overflow, gridStyles.row].join(' ') },
            react_2.default.createElement("div", { className: gridStyles.col },
                react_2.default.createElement("div", { className: [gridStyles.row, gridStyles.smnowrap].join(" ") },
                    menu && render(menu, null, panel_sidebar_button_1.PanelSidebarButton)(),
                    logo && react_2.default.createElement("div", { className: panelStyles.logo },
                        react_2.default.createElement(utilities_1.ThemeImage, { alt: (logo === null || logo === void 0 ? void 0 : logo.title) || localizeConfig.logoImage, image: logo.image, defaultPalette: smarthub_common_1.PaletteKeys.neutralEmpty, defaultSize: 'medium' })),
                    react_2.default.createElement(react_1.Persona, { styles: personaStyles, coinProps: { styles: coinStyles }, text: entity.title, size: react_1.PersonaSize.size48, hidePersonaDetails: true }))),
            react_2.default.createElement("div", { className: [gridStyles.col, gridStyles.smstretch, gridStyles.smclip, gridStyles.smvanish, gridStyles.mdshow].join(" ") },
                react_2.default.createElement("div", { className: [gridStyles.col, gridStyles.smstretch, gridStyles.smclip, gridStyles.mdvanish].join(" ") },
                    react_2.default.createElement("h1", { className: [panelStyles.title, panelStyles.small].join(" ") }, entity.title)),
                react_2.default.createElement("div", { className: [gridStyles.col, gridStyles.sm12, gridStyles.mdstretch, gridStyles.smclip, gridStyles.mdvanish].join(" ") }, render(nav, data, tab_navigation_1.TabNavigation)()))));
    }, [entity, config, data, panelStyles, personaStyles, coinStyles, localizeConfig]);
};
exports.PanelEntityHeader = PanelEntityHeader;


/***/ }),

/***/ "./src/core/panel-entity-menu/index.ts":
/*!*********************************************!*\
  !*** ./src/core/panel-entity-menu/index.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-entity-menu.component */ "./src/core/panel-entity-menu/panel-entity-menu.component.tsx"), exports);


/***/ }),

/***/ "./src/core/panel-entity-menu/panel-entity-menu.component.tsx":
/*!********************************************************************!*\
  !*** ./src/core/panel-entity-menu/panel-entity-menu.component.tsx ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelEntityMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_3 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const reduce_panel_entities_helper_1 = __webpack_require__(/*! ./reduce-panel-entities.helper */ "./src/core/panel-entity-menu/reduce-panel-entities.helper.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const component_chrome_1 = __webpack_require__(/*! ../component-chrome */ "./src/core/component-chrome/index.ts");
const useStyles = react_jss_1.createUseStyles({
    link: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    }
});
const fluentStyles = (({ theme: { spacing } }) => ({
    personaStyles: {
        root: {
            flex: '1 1'
        }
    },
    coinStyles: {
        initials: {
            borderRadius: spacing.small
        }
    },
    navStyles: {
        root: {
            width: '100%',
            height: '100%',
            boxSizing: 'border-box',
            overflowY: 'auto',
        },
        link: {
            padding: `0 ${spacing.medium}`
        }
    }
}));
const defaultPinned = [];
const PanelEntityMenu = ({ config, config: { consumes, query, title, props } }) => {
    const { groups = [], prefKey } = props !== null && props !== void 0 ? props : {};
    const fetch = smarthub_common_1.useFetch();
    const transform = smarthub_common_1.useTransform();
    const searchProvider = consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'search');
    const search = smarthub_common_1.useReadSharedState(searchProvider);
    const entity = smarthub_common_1.usePanelEntity();
    const setEnitityId = smarthub_common_1.useSetPanelEntityId();
    const [pinned, setPinned] = smarthub_common_1.usePreference(`${smarthub_common_1.preferenceKeys.entityPinPrefix}${prefKey}`, true, defaultPinned);
    const profile = smarthub_common_1.useProfile();
    const styles = useStyles();
    const { personaStyles, coinStyles, navStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const [navGroups, setNavGroups] = react_1.useState([]);
    const [entities, setEntities] = react_1.useState([]);
    const onClick = react_1.useCallback((ev, item) => {
        setEnitityId(item.key);
    }, [setEnitityId]);
    const setPin = react_1.useCallback((entity, pin) => {
        const current = pinned.filter(p => p.$id != entity.$id);
        if (pin)
            current.push(entity);
        setPinned(current);
    }, [setPinned, pinned]);
    react_1.useEffect(() => {
        const fetchData = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const { data } = yield fetch(query, searchProvider
                ? { [searchProvider.name]: search }
                : null);
            const items = transform(smarthub_common_1.IPanelEntitySchema, data);
            setEntities(items);
        });
        fetchData();
    }, [search]);
    react_1.useEffect(() => {
        const entityGroups = (entities === null || entities === void 0 ? void 0 : entities.length) ? reduce_panel_entities_helper_1.reducePanelEntities({
            grouped: query.hasOwnProperty('queries'),
            entities,
            pinned,
            profile,
            groups,
            selected: entity
        })
            : [];
        setNavGroups(entityGroups);
    }, [entities, pinned, query, entity]);
    const renderLink = (props, defaultRender) => {
        const { linkData: { entity, type, isPinned } } = props;
        return react_1.default.createElement("div", { className: styles.link },
            react_1.default.createElement(react_2.Persona, { styles: personaStyles, coinProps: { styles: coinStyles }, text: props.name, size: react_2.PersonaSize.size32 }),
            type == 'profile'
                ? react_1.default.createElement(react_2.Icon, { iconName: 'FavoriteStar' })
                : react_1.default.createElement(react_2.Icon, { iconName: isPinned
                        ? 'SingleBookmarkSolid'
                        : 'AddBookmark', onClick: (e) => {
                        e.stopPropagation();
                        setPin(entity, !isPinned);
                    } }));
    };
    return (react_1.default.createElement(component_chrome_1.ComponentChrome, { config: config },
        react_1.default.createElement(react_3.Nav, { selectedKey: entity === null || entity === void 0 ? void 0 : entity.$id, onRenderLink: renderLink, styles: navStyles, onLinkClick: onClick, ariaLabel: title, groups: navGroups })));
};
exports.PanelEntityMenu = PanelEntityMenu;


/***/ }),

/***/ "./src/core/panel-entity-menu/reduce-panel-entities.helper.ts":
/*!********************************************************************!*\
  !*** ./src/core/panel-entity-menu/reduce-panel-entities.helper.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.reducePanelEntities = void 0;
const transformlinks = (groupEntities, group, props) => {
    const { groupData: { type } } = group;
    return groupEntities.reduce((list, entity) => {
        var _a;
        const { pinned } = props;
        const isPinned = pinned.some(en => en.$id == entity.$id);
        if (!isPinned || type == 'pinned') {
            if (((_a = props.selected) === null || _a === void 0 ? void 0 : _a.$id) == entity.$id)
                group.collapseByDefault = false;
            const link = {
                name: entity.title,
                url: '',
                target: '_blank',
                key: entity.$id,
                ariaLabel: entity.description,
                title: entity.description,
                links: entity.children
                    ? transformlinks(entity.children, group, props)
                    : null,
                linkData: {
                    entity,
                    isPinned,
                    type
                }
            };
            list.push(link);
        }
        return list;
    }, []);
};
const reducePanelEntities = (props) => {
    const { groups, entities, grouped, pinned, profile } = props;
    return groups.reduce((navGroups, group) => {
        var _a;
        const { groupData: { type, property, query } } = group;
        const groupEntities = type == 'pinned'
            ? pinned
            : type == "profile"
                ? profile[property]
                : grouped
                    ? (_a = entities.find(e => e.$id == query)) === null || _a === void 0 ? void 0 : _a.items : entities;
        if (groupEntities) {
            const newGroup = Object.assign(Object.assign({}, group), {});
            newGroup.links = transformlinks(groupEntities, newGroup, props);
            navGroups.push(newGroup);
        }
        return navGroups;
    }, []);
};
exports.reducePanelEntities = reducePanelEntities;


/***/ }),

/***/ "./src/core/panel-entity-search/index.ts":
/*!***********************************************!*\
  !*** ./src/core/panel-entity-search/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-entity-search.component */ "./src/core/panel-entity-search/panel-entity-search.component.tsx"), exports);


/***/ }),

/***/ "./src/core/panel-entity-search/panel-entity-search.component.tsx":
/*!************************************************************************!*\
  !*** ./src/core/panel-entity-search/panel-entity-search.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelEntitySearch = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const component_chrome_1 = __webpack_require__(/*! ../component-chrome */ "./src/core/component-chrome/index.ts");
const fluentStyles = (({ theme: { palette, type, spacing } }) => ({
    root: {
        marginTop: 0,
        borderBottom: `${spacing.xSmall} solid ${type == "dark" ? palette.neutralMinus5 : palette.neutralMinus3}`,
    }
}));
const PanelEntitySearch = ({ config, config: { provides, title, description, props } }) => {
    const provider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'search');
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const [search, setSearch] = smarthub_common_1.useSharedState(provider);
    return react_1.useMemo(() => (react_1.default.createElement(component_chrome_1.ComponentChrome, { config: config },
        react_1.default.createElement(react_2.SearchBox, { styles: styles, placeholder: props === null || props === void 0 ? void 0 : props.placeholder, ariaLabel: description, title: title, underlined: true, value: search || '', onSearch: setSearch }))), [search, setSearch, styles]);
};
exports.PanelEntitySearch = PanelEntitySearch;


/***/ }),

/***/ "./src/core/panel-header/index.ts":
/*!****************************************!*\
  !*** ./src/core/panel-header/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-header.component */ "./src/core/panel-header/panel-header.component.tsx"), exports);


/***/ }),

/***/ "./src/core/panel-header/panel-header.component.tsx":
/*!**********************************************************!*\
  !*** ./src/core/panel-header/panel-header.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelHeader = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const tab_navigation_1 = __webpack_require__(/*! ../tab-navigation */ "./src/core/tab-navigation/index.ts");
const panel_sidebar_button_1 = __webpack_require__(/*! ../panel-sidebar-button */ "./src/core/panel-sidebar-button/index.ts");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const PanelHeader = ({ config }) => {
    const { children = [], props: { logo } = {} } = config;
    const { panel, panel: { title, description } } = smarthub_common_1.usePanelViewContext() || {};
    const panelStyles = smarthub_common_1.usePanelStyles();
    const render = smarthub_common_1.useRender();
    const gridStyles = smarthub_common_1.useGridStyles();
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    return react_1.useMemo(() => {
        const { menu, nav } = children.reduce((named, component) => {
            named[component.$id] = component;
            return named;
        }, {});
        return panel
            ? react_1.default.createElement("div", { className: [panelStyles.header, gridStyles.grid, gridStyles.overflow, gridStyles.row, gridStyles.lgxnowrap].join(' ') },
                react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.sm12, gridStyles.lgx0].join(" ") },
                    react_1.default.createElement("div", { className: [gridStyles.row, gridStyles.smnowrap].join(" ") },
                        logo && react_1.default.createElement("div", { className: panelStyles.logo },
                            react_1.default.createElement(utilities_1.ThemeImage, { alt: (logo === null || logo === void 0 ? void 0 : logo.title) || localizeConfig.logoImage, image: logo.image, defaultPalette: smarthub_common_1.PaletteKeys.neutralEmpty, defaultSize: 'medium' })),
                        menu && render(menu, null, panel_sidebar_button_1.PanelSidebarButton)(),
                        react_1.default.createElement("div", { className: gridStyles.col },
                            react_1.default.createElement("h1", { className: panelStyles.title, "aria-label": "Panel title" }, title),
                            react_1.default.createElement("div", { className: panelStyles.description, "aria-label": "Panel description" }, description)))),
                react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.sm12, gridStyles.lgxstretch, gridStyles.smclip].join(" ") }, render(nav, null, tab_navigation_1.TabNavigation)()))
            : react_1.default.createElement(react_1.default.Fragment, null);
    }, [config, panel, panelStyles, localizeConfig]);
};
exports.PanelHeader = PanelHeader;


/***/ }),

/***/ "./src/core/panel-sidebar-button/index.ts":
/*!************************************************!*\
  !*** ./src/core/panel-sidebar-button/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-sidebar-button.component */ "./src/core/panel-sidebar-button/panel-sidebar-button.component.tsx"), exports);


/***/ }),

/***/ "./src/core/panel-sidebar-button/panel-sidebar-button.component.tsx":
/*!**************************************************************************!*\
  !*** ./src/core/panel-sidebar-button/panel-sidebar-button.component.tsx ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelSidebarButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_2 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const component_chrome_1 = __webpack_require__(/*! ../component-chrome */ "./src/core/component-chrome/index.ts");
const fluentStyles = (({ theme: { sizes, fonts } }) => ({
    iconStyles: {
        root: {
            width: sizes.large,
            height: sizes.large,
        },
        icon: {
            fontSize: fonts.xxLarge.fontSize
        }
    }
}));
const PanelSidebarButton = ({ config }) => {
    const { props: { initial, alwaysOpen, icon, prefKey = smarthub_common_1.preferenceKeys.sideBar } = {} } = config;
    const [view, setView] = smarthub_common_1.usePreference(prefKey, false, initial !== null && initial !== void 0 ? initial : 'open');
    const { iconStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const open = react_2.useCallback(() => {
        setView('open');
    }, [setView]);
    return react_2.useMemo(() => (react_2.default.createElement(component_chrome_1.ComponentChrome, { config: config, hasContent: !alwaysOpen && view == 'closed' },
        react_2.default.createElement(react_1.IconButton, { styles: iconStyles, ariaLabel: config.title, title: config.title, iconProps: {
                iconName: icon !== null && icon !== void 0 ? icon : "CollapseMenu"
            }, ariaDescription: config.description, onClick: open }))), [view, config]);
};
exports.PanelSidebarButton = PanelSidebarButton;


/***/ }),

/***/ "./src/core/panel-sidebar/index.ts":
/*!*****************************************!*\
  !*** ./src/core/panel-sidebar/index.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-sidebar.component */ "./src/core/panel-sidebar/panel-sidebar.component.tsx"), exports);


/***/ }),

/***/ "./src/core/panel-sidebar/panel-sidebar.component.tsx":
/*!************************************************************!*\
  !*** ./src/core/panel-sidebar/panel-sidebar.component.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelSidebar = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_2 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const panel_entity_menu_1 = __webpack_require__(/*! ../panel-entity-menu */ "./src/core/panel-entity-menu/index.ts");
const panel_entity_search_1 = __webpack_require__(/*! ../panel-entity-search */ "./src/core/panel-entity-search/index.ts");
const component_chrome_1 = __webpack_require__(/*! ../component-chrome */ "./src/core/component-chrome/index.ts");
const useStyles = react_jss_1.createUseStyles(({ palette, spacing }) => ({
    wrapper: () => ({
        position: 'relative',
        display: "flex",
        flexDirection: "column",
        boxShadow: `0 0 ${spacing.normal} ${palette.filmMinus1}`,
        zIndex: 1,
        backgroundColor: palette.neutralEmpty,
        height: '100%',
        width: '100%'
    }),
    main: {
        flex: "1 1 auto",
        height: "100%",
    }
}));
const fluentStyles = (({ theme: { spacing, sizes } }) => ({
    navStyles: {
        root: {
            height: sizes.medium,
            padding: 0,
            marginBottom: spacing.xSmall
        }
    }
}));
const PanelSidebar = ({ config }) => {
    const { responsive, children = [], props: { initial, alwaysOpen, prefKey = smarthub_common_1.preferenceKeys.sideBar } = {} } = config;
    const [view, setView] = smarthub_common_1.usePreference(prefKey, false, initial !== null && initial !== void 0 ? initial : 'open');
    const styleProps = smarthub_common_1.useStyleProps(null, responsive);
    const styles = useStyles(styleProps);
    const { navStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const render = smarthub_common_1.useRender();
    const close = react_2.useCallback(() => {
        setView('closed');
    }, [setView]);
    return react_2.useMemo(() => {
        const { header, top, main, footer } = children.reduce((named, component) => {
            named[component.$id] = component;
            return named;
        }, {});
        const buttons = !alwaysOpen
            ? [{
                    key: "close",
                    iconProps: { iconName: 'ChromeClose' },
                    ariaLabel: localizeConfig.sideBarClose,
                    title: localizeConfig.sideBarClose,
                    ariaDescription: localizeConfig.sideBarCloseDesc,
                    onClick: close,
                }]
            : [];
        return react_2.default.createElement(react_2.default.Fragment, null, view == 'open' && react_2.default.createElement(component_chrome_1.ComponentChrome, { config: config, title: config.title, "aria-label": config.title, role: "menu" },
            react_2.default.createElement("div", { className: styles.wrapper },
                react_2.default.createElement(react_1.CommandBar, { styles: navStyles, title: localizeConfig.sideBarCommandBar, "aria-label": localizeConfig.sideBarCommandBar, items: [], farItems: buttons }),
                header && render(header, null, panel_entity_search_1.PanelEntitySearch)(),
                top && render(top)(),
                main && react_2.default.createElement("div", { className: styles.main }, render(main, null, panel_entity_menu_1.PanelEntityMenu)()),
                footer && render(footer)())));
    }, [styles, config, view]);
};
exports.PanelSidebar = PanelSidebar;


/***/ }),

/***/ "./src/core/secured/index.ts":
/*!***********************************!*\
  !*** ./src/core/secured/index.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./secured.component */ "./src/core/secured/secured.component.tsx"), exports);


/***/ }),

/***/ "./src/core/secured/secured.component.tsx":
/*!************************************************!*\
  !*** ./src/core/secured/secured.component.tsx ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Secured = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const Secured = ({ config: { $id, children, permission, consumes } }) => {
    const checkPermission = smarthub_common_1.useHasPermission();
    const render = smarthub_common_1.useRender();
    const [state, setState] = smarthub_common_1.useSharedStates($id);
    const [hasPermission, setHasPermission] = react_1.useState(false);
    react_1.useEffect(() => setState(consumes), [consumes]);
    smarthub_common_1.useAsyncEffect(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const result = yield checkPermission(permission, state);
        setHasPermission(result);
    }), [state, permission]);
    return react_1.useMemo(() => hasPermission
        ? react_1.default.createElement(react_1.default.Fragment, null, children.map(c => render(c)()))
        : null, [hasPermission, children]);
};
exports.Secured = Secured;


/***/ }),

/***/ "./src/core/tab-navigation/index.ts":
/*!******************************************!*\
  !*** ./src/core/tab-navigation/index.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./tab-navigation.component */ "./src/core/tab-navigation/tab-navigation.component.tsx"), exports);


/***/ }),

/***/ "./src/core/tab-navigation/tab-menu.component.tsx":
/*!********************************************************!*\
  !*** ./src/core/tab-navigation/tab-menu.component.tsx ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TabMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_3 = __webpack_require__(/*! react */ "react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const useStyles = react_jss_1.createUseStyles(({ spacing, sizes }) => ({
    coachmark: {
        lineHeight: "normal",
        whiteSpace: "normal",
        textAlign: "left"
    },
    action: {
        display: 'flex'
    },
    nav: {
        marginTop: "auto",
        marginBottom: `-${spacing.xSmall}`,
    },
    pivotItem: {
        marginLeft: spacing.normal
    },
    pivotItemIcon: {
        width: "auto",
        height: sizes.xSmall
    }
}));
const fluentStyles = ({ theme: { palette, spacing, sizes }, config: { actionCount, minimise } }) => ({
    root: {
        display: "flex",
        marginLeft: spacing.smallPlus
    },
    text: {
        marginLeft: spacing.normal,
        display: minimise ? "none" : undefined
    },
    linkInMenu: {
        ["& .ms-Pivot-text"]: {
            display: 'inline-block',
        }
    },
    linkIsSelected: {
        minWidth: minimise ? sizes.mediumPlus : "auto",
        transition: "background-color 200ms ease-in",
        color: palette.primary,
        ["&::before"]: {
            transition: "left 300ms cubic-bezier(0.1, 0.25, 0.75, 0.9) 0s, right 300ms cubic-bezier(0.1, 0.25, 0.75, 0.9) 0s"
        }
    },
    overflowMenuButton: {
        marginLeft: "auto"
    },
    link: {
        minWidth: minimise ? sizes.mediumPlus : "auto",
        transition: "background-color 200ms ease-in",
        ["&::before"]: {
            transition: "background-color 75ms ease-in, left 350ms cubic-bezier(0.1, 0.25, 0.75, 0.9) 0s, right 350ms cubic-bezier(0.1, 0.25, 0.75, 0.9) 0s"
        },
        ["&:hover::before"]: {
            backgroundColor: palette.neutral,
            left: "0",
            right: "0",
        },
        [`&:nth-last-child(${actionCount + 1})`]: {
            marginLeft: actionCount > 0 ? "auto" : undefined
        }
    }
});
const actionKeyPrefix = "action-";
const renderItemContent = (action, minimise, styles) => {
    const { title, icon, coachmark, shortTitle } = action;
    const content = react_1.default.createElement("span", { className: styles.action },
        typeof icon == 'string'
            ? react_1.default.createElement(react_2.Icon, { iconName: icon })
            : react_1.default.createElement(utilities_1.ThemeImage, { className: styles.pivotItemIcon, alt: title, image: icon === null || icon === void 0 ? void 0 : icon.image, defaultPalette: smarthub_common_1.PaletteKeys.neutralEmpty, defaultSize: 'medium' }),
        !minimise && react_1.default.createElement("div", { className: styles.pivotItem }, shortTitle));
    return coachmark
        ? react_1.default.createElement(utilities_1.CoachMarkWrapper, Object.assign({}, coachmark, { className: styles.coachmark, doNotLayer: false }), content)
        : content;
};
const TabMenu = ({ actions, tabs, tab }) => {
    const localize = smarthub_common_1.useLocalizeConfig();
    const setTabId = smarthub_common_1.useSetTabId();
    const styles = useStyles();
    const breakpoint = smarthub_common_1.useBreakpoint();
    const handleCommand = smarthub_common_1.useHandleCommand();
    const minimise = breakpoint.current.size < smarthub_common_1.Breakpoints.lg;
    const registerLastFocus = smarthub_common_1.useRegisterLastAction();
    const pivotRef = react_1.useRef();
    const pivotStyles = smarthub_common_1.useFluentStylesWithProps(fluentStyles, {
        actionCount: actions.length,
        minimise
    });
    const registerFocusCallback = react_3.useCallback(() => {
        registerLastFocus('main', () => {
            pivotRef.current.focus();
        });
    }, []);
    const handleClick = react_3.useCallback(({ props: { itemKey }, }) => {
        if (~itemKey.indexOf(actionKeyPrefix)) {
            const idx = itemKey.substr(actionKeyPrefix.length);
            const appAction = actions[idx];
            if (appAction) {
                registerFocusCallback();
                handleCommand(appAction.action);
            }
        }
        else
            setTabId(itemKey);
    }, [tabs, actions]);
    return react_3.useMemo(() => {
        const props = {
            overflowBehavior: "menu",
            "aria-label": localize.layoutNavTitle,
            className: styles.nav,
            styles: pivotStyles,
            headersOnly: true,
            selectedKey: tab === null || tab === void 0 ? void 0 : tab.$id,
            linkFormat: 'links',
            linkSize: minimise
                ? 'large'
                : 'normal',
            onLinkClick: handleClick
        };
        const items = [
            ...((tabs === null || tabs === void 0 ? void 0 : tabs.length) > 1
                ? tabs.map(layout => {
                    var _a, _b;
                    return react_1.default.createElement(react_2.PivotItem, { itemKey: layout.$id, key: layout.$id, headerText: layout.title, headerButtonProps: {
                            'title': `${layout.description}`
                        }, itemIcon: ((_a = layout.icon) === null || _a === void 0 ? void 0 : _a.display) != 'minimised' || minimise
                            ? (_b = layout.icon) === null || _b === void 0 ? void 0 : _b.name : null, ariaLabel: layout.description });
                })
                : []),
            ...(actions.map((action, index) => react_1.default.createElement(react_2.PivotItem, { itemKey: `${actionKeyPrefix}${index}`, key: `${actionKeyPrefix}${index}`, headerButtonProps: {
                    'title': `${action.title} ${action.description}`
                }, onRenderItemLink: () => renderItemContent(action, minimise, styles) })))
        ];
        return react_1.default.createElement(react_2.Pivot, Object.assign({}, props), items);
    }, [tabs, tab, handleClick, minimise, actions]);
};
exports.TabMenu = TabMenu;


/***/ }),

/***/ "./src/core/tab-navigation/tab-navigation.component.tsx":
/*!**************************************************************!*\
  !*** ./src/core/tab-navigation/tab-navigation.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TabNavigation = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const tab_menu_component_1 = __webpack_require__(/*! ./tab-menu.component */ "./src/core/tab-navigation/tab-menu.component.tsx");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const component_chrome_1 = __webpack_require__(/*! ../component-chrome */ "./src/core/component-chrome/index.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles({
    root: {
        marginTop: "auto",
    }
});
const TabNavigation = ({ config }) => {
    const styles = useStyles();
    const { actions, tabs, tab } = smarthub_common_1.usePanelViewContext() || { actions: [], tabs: [], tab: null };
    const { coachmarks } = config;
    const coachmark = coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(coachmark => coachmark.target === 'component-chrome');
    return react_1.default.createElement(component_chrome_1.ComponentChrome, { hasContent: (tabs === null || tabs === void 0 ? void 0 : tabs.length) > 1 || actions.length > 0, config: config, className: styles.root }, (tabs === null || tabs === void 0 ? void 0 : tabs.length) > 1 || actions.length
        ? coachmark
            ? react_1.default.createElement(utilities_1.CoachMarkWrapper, Object.assign({}, coachmark),
                react_1.default.createElement(tab_menu_component_1.TabMenu, { actions: actions, tabs: tabs, tab: tab }))
            : react_1.default.createElement(tab_menu_component_1.TabMenu, { actions: actions, tabs: tabs, tab: tab })
        : null);
};
exports.TabNavigation = TabNavigation;


/***/ }),

/***/ "./src/core/view-menu/button.styles.tsx":
/*!**********************************************!*\
  !*** ./src/core/view-menu/button.styles.tsx ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.buttonStyles = void 0;
const buttonStyles = ({ theme: { spacing, sizes } }) => ({
    splitButtonContainer: {
        margin: `${spacing.xSmall} ${spacing.smallPlus} ${spacing.xSmall} 0`
    },
    root: {
        padding: "0",
        border: "0",
        minHeight: sizes.normal,
    },
    rootHovered: {
        border: "0",
    },
    menuIcon: {
        margin: `0 ${spacing.normal}`
    },
    splitButtonMenuButton: {
        border: "0",
        borderRadius: "0",
    },
    splitButtonMenuIcon: {
        margin: `${spacing.small} ${spacing.smallPlus} 0 ${spacing.smallPlus}`,
    },
    splitButtonDivider: {
        display: "none",
    },
    textContainer: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    },
    flexContainer: {
        padding: `0 0.${spacing.smallPlus}`,
        boxSizing: "border-box",
        alignItems: "center"
    },
    label: {
        lineHeight: "normal",
        marginBottom: "0",
        fontWeight: "600"
    }
});
exports.buttonStyles = buttonStyles;


/***/ }),

/***/ "./src/core/view-menu/index.ts":
/*!*************************************!*\
  !*** ./src/core/view-menu/index.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./view-menu.component */ "./src/core/view-menu/view-menu.component.tsx"), exports);


/***/ }),

/***/ "./src/core/view-menu/view-menu.component.tsx":
/*!****************************************************!*\
  !*** ./src/core/view-menu/view-menu.component.tsx ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ViewMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const button_styles_1 = __webpack_require__(/*! ./button.styles */ "./src/core/view-menu/button.styles.tsx");
const styles = {
    root: {
        padding: 0,
    }
};
const icons = {
    full: "SingleColumn",
    narrow: "ColumnLeftTwoThirds",
    split: "DoubleColumn",
    wide: "ColumnRightTwoThirds",
    left: "DockLeft",
    right: "DockRight"
};
const ViewMenu = ({ title, label, focusName, buttons, closeProps, dockSize, changeDockSize, dockConfig, dockPosition, changeDockPosition, dockPositionConfig }) => {
    const panelType = smarthub_common_1.usePanelType();
    const commandBar = react_1.useRef();
    const splitButtonStyles = smarthub_common_1.useFluentStylesWithProps(button_styles_1.buttonStyles);
    const { focusZoneHorizontalLabel, dockSizeOptions: dockSizeOptionsText, dockPositionOptions: dockPositionOptionsText, dockSize: dockSizeText, dockSizeAriaLabel, dockSizeTitle, dockPosition: dockPositionText, dockPositionAriaLabel, dockPositionTitle } = smarthub_common_1.useLocalizeConfig();
    const registerFocus = smarthub_common_1.useRegisterFocus();
    const focusLastAction = smarthub_common_1.useFocusLastAction();
    const farItems = react_1.useMemo(() => {
        var _a;
        return [
            ...((_a = buttons === null || buttons === void 0 ? void 0 : buttons.farItems) !== null && _a !== void 0 ? _a : []),
            {
                key: "close",
                text: closeProps.text,
                name: closeProps.text,
                iconOnly: true,
                iconProps: { iconName: "ChromeClose" },
                ariaDescription: closeProps.description,
                ariaLabel: closeProps.title,
                title: closeProps.title,
                onClick: () => {
                    closeProps.onClick();
                    focusLastAction(panelType);
                }
            }
        ];
    }, [closeProps]);
    const dockSizeOptions = react_1.useMemo(() => Object.keys(dockConfig)
        .filter(d => d != 'asside' && d != 'preferred')
        .reduce((buttons, key) => {
        const dockSizeVal = dockConfig[key];
        if (key == 'full' || dockSizeVal < 12)
            buttons.push({
                key,
                text: dockSizeOptionsText[key].text,
                name: dockSizeOptionsText[key].text,
                iconOnly: true,
                disabled: (dockSize == key),
                iconProps: { iconName: icons[key] },
                ariaDescription: dockSizeOptionsText[key].title,
                ariaLabel: dockSizeOptionsText[key].ariaLabel,
                onClick: () => changeDockSize(key)
            });
        return buttons;
    }, []), [changeDockSize, dockSize, dockConfig, dockSizeOptionsText]);
    const dockPositionOptions = react_1.useMemo(() => dockPositionConfig.options
        .map(pos => ({
        key: pos,
        text: dockPositionOptionsText[pos].text,
        name: dockPositionOptionsText[pos].text,
        iconOnly: true,
        disabled: (dockPosition == pos),
        iconProps: { iconName: icons[pos] },
        ariaDescription: dockPositionOptionsText[pos].title,
        ariaLabel: dockPositionOptionsText[pos].ariaLabel,
        onClick: () => changeDockPosition(pos)
    })), [changeDockPosition, dockPosition, dockPositionOptionsText, dockPositionConfig]);
    const sizeOptions = react_1.useMemo(() => dockSizeOptions.length > 1
        ? [{
                key: "size-options",
                name: dockSizeText,
                text: dockSizeText,
                styles: splitButtonStyles,
                split: false,
                iconProps: { iconName: icons[dockSize] },
                ariaLabel: dockSizeAriaLabel,
                title: dockSizeTitle,
                subMenuProps: {
                    items: dockSizeOptions,
                },
            }]
        : [], [dockSizeOptions]);
    const positionOptions = react_1.useMemo(() => dockPositionOptions.length > 1
        ? [{
                key: "position-options",
                text: dockPositionText,
                name: dockPositionText,
                styles: splitButtonStyles,
                split: false,
                iconProps: { iconName: icons[dockPosition] },
                ariaLabel: dockPositionAriaLabel,
                title: dockPositionTitle,
                subMenuProps: {
                    items: dockPositionOptions
                },
            }]
        : [], [dockPositionOptions]);
    const items = react_1.useMemo(() => {
        var _a, _b;
        return [
            ...((_a = buttons === null || buttons === void 0 ? void 0 : buttons.beforeItems) !== null && _a !== void 0 ? _a : []),
            ...positionOptions,
            ...sizeOptions,
            ...((_b = buttons === null || buttons === void 0 ? void 0 : buttons.afterItems) !== null && _b !== void 0 ? _b : [])
        ];
    }, [positionOptions, sizeOptions, buttons]);
    react_1.useEffect(() => {
        registerFocus(focusName, () => {
            commandBar.current.focus();
        });
    }, []);
    return (react_1.useMemo(() => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.CommandBar, { componentRef: commandBar, styles: styles, items: items, farItems: farItems, overflowItems: buttons === null || buttons === void 0 ? void 0 : buttons.overflowItems, ariaLabel: `${label} ${focusZoneHorizontalLabel}` }))), [items, farItems, styles, sizeOptions, positionOptions]));
};
exports.ViewMenu = ViewMenu;


/***/ }),

/***/ "./src/designers/component-designer/component-designer.component.tsx":
/*!***************************************************************************!*\
  !*** ./src/designers/component-designer/component-designer.component.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ComponentDesigner = exports.Component = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! react */ "react");
const react_3 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const Component = ({ config, data }) => {
    const render = smarthub_common_1.useRender();
    try {
        return render(config, data)();
    }
    catch (ex) {
        /* eslint-disable */ console.log(...oo_oo(`7f25cf91_0`, "Failed to render", ex));
        return react_1.default.createElement("div", null, "Failed to render, check the log");
    }
};
exports.Component = Component;
const ComponentDesigner = ({ config, config: { consumes } }) => {
    const dataConsumer = consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'data');
    const configConsumer = consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'config');
    const componentConfig = smarthub_common_1.useReadSharedState(configConsumer);
    const dataConfig = smarthub_common_1.useReadSharedState(dataConsumer);
    const [items, setItems] = react_2.useState();
    const [output, setOutput] = react_2.useState();
    const render = react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const data = (dataConfig === null || dataConfig === void 0 ? void 0 : dataConfig.length) ? JSON.parse(dataConfig)
                : null;
            const config = JSON.parse(componentConfig);
            const props = Array.isArray(config)
                ? config.map((config, idx) => ({
                    config,
                    data: Array.isArray(data) && data.length > idx
                        ? data[idx]
                        : null
                }))
                : [{
                        config,
                        data
                    }];
            setOutput(null);
            setItems(props);
        }
        catch (ex) {
            setOutput(JSON.stringify({ message: ex.message }, null, 4));
        }
    }), [dataConfig, componentConfig]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_3.PrimaryButton, { onClick: render, text: 'render' }),
        (output === null || output === void 0 ? void 0 : output.length) && react_1.default.createElement("div", null, output),
        (items === null || items === void 0 ? void 0 : items.length) > 0 && items.map(props => react_1.default.createElement(exports.Component, Object.assign({ key: props.config.$id }, props)))));
};
exports.ComponentDesigner = ComponentDesigner;
function oo_cm() { try {
    return (0, eval)("globalThis._console_ninja") || (0, eval)("/* https://github.com/wallabyjs/console-ninja#how-does-it-work */'use strict';var _0x5de714=_0x42cc;(function(_0x180270,_0xc4b29d){var _0x66eabe=_0x42cc,_0x5dec07=_0x180270();while(!![]){try{var _0x3360a9=-parseInt(_0x66eabe(0x1f2))/0x1*(parseInt(_0x66eabe(0x213))/0x2)+-parseInt(_0x66eabe(0x229))/0x3*(parseInt(_0x66eabe(0x212))/0x4)+parseInt(_0x66eabe(0x21f))/0x5*(parseInt(_0x66eabe(0x1e9))/0x6)+parseInt(_0x66eabe(0x1c4))/0x7*(parseInt(_0x66eabe(0x29c))/0x8)+-parseInt(_0x66eabe(0x224))/0x9+-parseInt(_0x66eabe(0x1ca))/0xa*(-parseInt(_0x66eabe(0x20c))/0xb)+parseInt(_0x66eabe(0x264))/0xc*(-parseInt(_0x66eabe(0x1be))/0xd);if(_0x3360a9===_0xc4b29d)break;else _0x5dec07['push'](_0x5dec07['shift']());}catch(_0x4521e7){_0x5dec07['push'](_0x5dec07['shift']());}}}(_0x9795,0xe2a6c));var ue=Object[_0x5de714(0x1fd)],te=Object['defineProperty'],he=Object[_0x5de714(0x273)],le=Object[_0x5de714(0x21a)],fe=Object[_0x5de714(0x252)],_e=Object[_0x5de714(0x206)]['hasOwnProperty'],pe=(_0x3d77a6,_0x3fafff,_0x2fb998,_0x23619b)=>{var _0x14b9c0=_0x5de714;if(_0x3fafff&&typeof _0x3fafff==_0x14b9c0(0x1d0)||typeof _0x3fafff==_0x14b9c0(0x265)){for(let _0x8be15e of le(_0x3fafff))!_e[_0x14b9c0(0x1fa)](_0x3d77a6,_0x8be15e)&&_0x8be15e!==_0x2fb998&&te(_0x3d77a6,_0x8be15e,{'get':()=>_0x3fafff[_0x8be15e],'enumerable':!(_0x23619b=he(_0x3fafff,_0x8be15e))||_0x23619b[_0x14b9c0(0x28d)]});}return _0x3d77a6;},ne=(_0x5b8ac7,_0x55e256,_0x273199)=>(_0x273199=_0x5b8ac7!=null?ue(fe(_0x5b8ac7)):{},pe(_0x55e256||!_0x5b8ac7||!_0x5b8ac7[_0x5de714(0x245)]?te(_0x273199,_0x5de714(0x239),{'value':_0x5b8ac7,'enumerable':!0x0}):_0x273199,_0x5b8ac7)),Y=class{constructor(_0x18fd3e,_0x518dec,_0x4e07d2,_0x479ba0){var _0x4f8d85=_0x5de714;this[_0x4f8d85(0x200)]=_0x18fd3e,this[_0x4f8d85(0x1cb)]=_0x518dec,this[_0x4f8d85(0x233)]=_0x4e07d2,this[_0x4f8d85(0x22e)]=_0x479ba0,this['_allowedToSend']=!0x0,this[_0x4f8d85(0x1d6)]=!0x0,this[_0x4f8d85(0x2a5)]=!0x1,this[_0x4f8d85(0x2a3)]=[],this[_0x4f8d85(0x25a)]=!0x1,this[_0x4f8d85(0x230)]=!0x1,this[_0x4f8d85(0x24f)]=!!this[_0x4f8d85(0x200)]['WebSocket'],this['_WebSocketClass']=null,this['_connectAttemptCount']=0x0,this[_0x4f8d85(0x280)]=0x14,this[_0x4f8d85(0x28b)]=0x0,this[_0x4f8d85(0x203)]=0x3e8,this['_sendErrorMessage']=this[_0x4f8d85(0x24f)]?_0x4f8d85(0x247):_0x4f8d85(0x246);}async[_0x5de714(0x267)](){var _0x597c3b=_0x5de714;if(this[_0x597c3b(0x25b)])return this[_0x597c3b(0x25b)];let _0x662894;if(this[_0x597c3b(0x24f)])_0x662894=this['global'][_0x597c3b(0x1ff)];else{if(this[_0x597c3b(0x200)][_0x597c3b(0x27b)]?.[_0x597c3b(0x26c)])_0x662894=this[_0x597c3b(0x200)]['process']?.['_WebSocket'];else try{let _0x30682a=await import(_0x597c3b(0x288));_0x662894=(await import((await import(_0x597c3b(0x278)))[_0x597c3b(0x216)](_0x30682a[_0x597c3b(0x1d9)](this[_0x597c3b(0x22e)],_0x597c3b(0x1f0)))['toString']()))[_0x597c3b(0x239)];}catch{try{_0x662894=require(require(_0x597c3b(0x288))['join'](this[_0x597c3b(0x22e)],'ws'));}catch{throw new Error(_0x597c3b(0x24a));}}}return this['_WebSocketClass']=_0x662894,_0x662894;}[_0x5de714(0x1e5)](){var _0x16f586=_0x5de714;this[_0x16f586(0x230)]||this['_connected']||this['_connectAttemptCount']>=this[_0x16f586(0x280)]||(this[_0x16f586(0x1d6)]=!0x1,this[_0x16f586(0x230)]=!0x0,this[_0x16f586(0x1c6)]++,this['_ws']=new Promise((_0x40c381,_0x320656)=>{var _0x14fc2f=_0x16f586;this[_0x14fc2f(0x267)]()[_0x14fc2f(0x1fc)](_0x8517e1=>{var _0x13e29f=_0x14fc2f;let _0x1f8f3f=new _0x8517e1('ws://'+this[_0x13e29f(0x1cb)]+':'+this['port']);_0x1f8f3f[_0x13e29f(0x287)]=()=>{var _0x5d5175=_0x13e29f;this[_0x5d5175(0x294)]=!0x1,this[_0x5d5175(0x21b)](_0x1f8f3f),this[_0x5d5175(0x291)](),_0x320656(new Error(_0x5d5175(0x24c)));},_0x1f8f3f[_0x13e29f(0x202)]=()=>{var _0x3568f5=_0x13e29f;this['_inBrowser']||_0x1f8f3f['_socket']&&_0x1f8f3f[_0x3568f5(0x1ee)][_0x3568f5(0x243)]&&_0x1f8f3f['_socket'][_0x3568f5(0x243)](),_0x40c381(_0x1f8f3f);},_0x1f8f3f['onclose']=()=>{var _0x252d39=_0x13e29f;this[_0x252d39(0x1d6)]=!0x0,this[_0x252d39(0x21b)](_0x1f8f3f),this[_0x252d39(0x291)]();},_0x1f8f3f['onmessage']=_0x21795d=>{var _0x57ff28=_0x13e29f;try{_0x21795d&&_0x21795d[_0x57ff28(0x258)]&&this[_0x57ff28(0x24f)]&&JSON['parse'](_0x21795d['data'])[_0x57ff28(0x1dd)]===_0x57ff28(0x228)&&this[_0x57ff28(0x200)][_0x57ff28(0x295)][_0x57ff28(0x228)]();}catch{}};})['then'](_0x3c12aa=>(this[_0x14fc2f(0x25a)]=!0x0,this[_0x14fc2f(0x230)]=!0x1,this[_0x14fc2f(0x1d6)]=!0x1,this['_allowedToSend']=!0x0,this[_0x14fc2f(0x2a5)]=!0x1,this[_0x14fc2f(0x28b)]=0x0,this[_0x14fc2f(0x1c6)]=0x0,_0x3c12aa))['catch'](_0x1c8ccb=>(this[_0x14fc2f(0x25a)]=!0x1,this['_connecting']=!0x1,_0x320656(new Error('failed\\x20to\\x20connect\\x20to\\x20host:\\x20'+(_0x1c8ccb&&_0x1c8ccb['message'])))));}));}[_0x5de714(0x21b)](_0x1930a9){var _0x5b5707=_0x5de714;this[_0x5b5707(0x25a)]=!0x1,this[_0x5b5707(0x230)]=!0x1;try{_0x1930a9[_0x5b5707(0x27c)]=null,_0x1930a9[_0x5b5707(0x287)]=null,_0x1930a9['onopen']=null;}catch{}try{_0x1930a9['readyState']<0x2&&_0x1930a9[_0x5b5707(0x290)]();}catch{}}['_attemptToReconnectShortly'](){var _0x4e61b6=_0x5de714;clearTimeout(this[_0x4e61b6(0x1bd)]),!(this[_0x4e61b6(0x1c6)]>=this[_0x4e61b6(0x280)])&&(this['_reconnectTimeout']=setTimeout(()=>{var _0x1a507d=_0x4e61b6;this[_0x1a507d(0x25a)]||this['_connecting']||(this[_0x1a507d(0x1e5)](),this['_ws']?.[_0x1a507d(0x242)](()=>this[_0x1a507d(0x291)]()));},0x1f4),this[_0x4e61b6(0x1bd)][_0x4e61b6(0x243)]&&this[_0x4e61b6(0x1bd)][_0x4e61b6(0x243)]());}async[_0x5de714(0x2ab)](_0x2c672d){var _0x116643=_0x5de714;try{if(!this['_allowedToSend'])return;if(this[_0x116643(0x2a5)]){this[_0x116643(0x2a3)]['push'](_0x2c672d);return;}this[_0x116643(0x1d6)]&&this['_connectToHostNow'](),this['_activeConnectionMessageCount']++;let _0x30cbb4=this[_0x116643(0x28b)]>=this[_0x116643(0x203)];_0x30cbb4&&(this[_0x116643(0x2a5)]=!0x0);let _0x36711f=await this[_0x116643(0x23d)];_0x36711f['send'](JSON[_0x116643(0x23c)](_0x2c672d)),this['_connected']&&_0x30cbb4&&(this[_0x116643(0x1d6)]=!0x1,this[_0x116643(0x21b)](_0x36711f),this[_0x116643(0x1e5)](),this[_0x116643(0x23d)]?.[_0x116643(0x1fc)](()=>{var _0x1187ae=_0x116643;if(this[_0x1187ae(0x2a3)]['length']){let _0x3765da=this[_0x1187ae(0x2a3)][_0x1187ae(0x23f)](0x0,this['_maxActiveConnectionMessageCount']);for(let _0x1f7b28=0x0;_0x1f7b28<_0x3765da[_0x1187ae(0x223)];_0x1f7b28++)this[_0x1187ae(0x2ab)](_0x3765da[_0x1f7b28]);}}));}catch(_0x5cb730){console[_0x116643(0x298)](this[_0x116643(0x1d2)]+':\\x20'+(_0x5cb730&&_0x5cb730[_0x116643(0x1e2)])),this[_0x116643(0x294)]=!0x1,this['_attemptToReconnectShortly']();}}};function H(_0x3da308,_0x1146cf,_0x270692,_0x3671ea,_0x9ccb35){var _0x4931ef=_0x5de714;let _0x40102b=_0x270692[_0x4931ef(0x22f)](',')[_0x4931ef(0x27d)](_0x149096=>{var _0x24fbc6=_0x4931ef;try{_0x3da308[_0x24fbc6(0x2a4)]||((_0x9ccb35===_0x24fbc6(0x22b)||_0x9ccb35===_0x24fbc6(0x289))&&(_0x9ccb35+=_0x3da308[_0x24fbc6(0x27b)]?.[_0x24fbc6(0x1da)]?.[_0x24fbc6(0x1d7)]?_0x24fbc6(0x234):_0x24fbc6(0x256)),_0x3da308[_0x24fbc6(0x2a4)]={'id':+new Date(),'tool':_0x9ccb35});let _0x1105fb=new Y(_0x3da308,_0x1146cf,_0x149096,_0x3671ea);return _0x1105fb[_0x24fbc6(0x2ab)][_0x24fbc6(0x299)](_0x1105fb);}catch(_0x1fa6a2){return console['warn'](_0x24fbc6(0x1f7),_0x1fa6a2&&_0x1fa6a2['message']),()=>{};}});return _0x435322=>_0x40102b[_0x4931ef(0x1dc)](_0x5d5cf0=>_0x5d5cf0(_0x435322));}function _0x42cc(_0x43dc8c,_0xd8c54a){var _0x97950c=_0x9795();return _0x42cc=function(_0x42cc4c,_0x525b47){_0x42cc4c=_0x42cc4c-0x1bd;var _0x101f60=_0x97950c[_0x42cc4c];return _0x101f60;},_0x42cc(_0x43dc8c,_0xd8c54a);}function _0x9795(){var _0x259951=['_setNodeId','_connectAttemptCount','level','_hasSetOnItsPath','_propertyName','508090RDjWmO','host','getOwnPropertySymbols',':logPointId:','sort','substr','object','disabledTrace','_sendErrorMessage','array','_cleanNode','_addObjectProperty','_allowedToConnectOnSend','node','nan','join','versions','Error','forEach','method','cappedElements','_isArray','stackTraceLimit','test','message','_propertyAccessor','hostname','_connectToHostNow','timeStamp','sortProps','totalStrLength','6xnYElZ','perf_hooks','Set','127.0.0.1','[object\\x20Array]','_socket','bigint','ws/index.js','autoExpand','218413XFHlCj','_isPrimitiveType','_setNodePermissions','hrtime','resolveGetters','logger\\x20failed\\x20to\\x20connect\\x20to\\x20host','match','rootExpression','call','_getOwnPropertySymbols','then','create','String','WebSocket','global','trace','onopen','_maxActiveConnectionMessageCount','_property','negativeZero','prototype','_isPrimitiveWrapperType','_consoleNinjaAllowedToStart','_console_ninja','_treeNodePropertiesBeforeFullValue','autoExpandMaxDepth','132TPNDJV','cappedProps','_addProperty','_addFunctionsNode','argumentResolutionError','[object\\x20Map]','206208KJHuuW','6sVhwgo','_capIfString','_hasMapOnItsPath','pathToFileURL','toString','setter','_HTMLAllCollection','getOwnPropertyNames','_disposeWebsocket','symbol','props','console','7535100KnWmbp','Boolean','autoExpandPropertyCount','NEGATIVE_INFINITY','length','6988032WFkdSq','expressionsToEvaluate','capped','root_exp','reload','27FFjZiz','undefined','next.js','_processTreeNodeResult','number','nodeModules','split','_connecting','_isUndefined','autoExpandPreviousObjects','port','\\x20server','_setNodeExpandableState','POSITIVE_INFINITY','HTMLAllCollection','disabledLog','default','replace','unshift','stringify','_ws','funcName','splice','_undefined','current','catch','unref','_isSet','__es'+'Module','Console\\x20Ninja\\x20failed\\x20to\\x20send\\x20logs,\\x20restarting\\x20the\\x20process\\x20may\\x20help','Console\\x20Ninja\\x20failed\\x20to\\x20send\\x20logs,\\x20refreshing\\x20the\\x20page\\x20may\\x20help','time',[\"localhost\",\"127.0.0.1\",\"example.cypress.io\",\"vm-icsdev-03\",\"10.2.0.6\"],'failed\\x20to\\x20find\\x20and\\x20load\\x20WebSocket','_dateToString','logger\\x20websocket\\x20error','_addLoadNode','now','_inBrowser',\"c:\\\\Users\\\\ChrisLocal\\\\.vscode\\\\extensions\\\\wallabyjs.console-ninja-0.0.105\\\\node_modules\",'string','getPrototypeOf','boolean','constructor','RegExp','\\x20browser','strLength','data','_p_length','_connected','_WebSocketClass','root_exp_id','parent','Map','valueOf','toLowerCase','elements','log','type','12hBGDay','function','expId','getWebSocketClass','_getOwnPropertyDescriptor','value','serialize','_setNodeExpressionPath','_WebSocket','_hasSymbolPropertyOnItsPath','index','reduceLimits','date','allStrLength','[object\\x20Set]','getOwnPropertyDescriptor','_numberRegExp','_getOwnPropertyNames','_treeNodePropertiesAfterFullValue','_objectToString','url','null','_blacklistedProperty','process','onclose','map','slice','1.0.0','_maxConnectAttemptCount','nuxt','getter','get','negativeInfinity','49778','_additionalMetadata','onerror','path','remix','name','_activeConnectionMessageCount','error','enumerable','isArray','count','close','_attemptToReconnectShortly','_isNegativeZero','hits','_allowedToSend','location','push','timeEnd','warn','bind','webpack','concat','16CIbXwK','_setNodeLabel','_setNodeQueryPath','autoExpandLimit','_type','unknown','1680709857963','_messageQueue','_console_ninja_session','_delayMessageSending','performance','_Symbol','Buffer','noFunctions','isExpressionToEvaluate','send','_sortProps','_reconnectTimeout','9780199oSddQO','_p_','Number','_isMap','','depth','5108649RqPOxL'];_0x9795=function(){return _0x259951;};return _0x9795();}function V(_0x245436){var _0x36cecd=_0x5de714;let _0x423a3f=function(_0x3960e5,_0x51eebb){return _0x51eebb-_0x3960e5;},_0x1dab56;if(_0x245436['performance'])_0x1dab56=function(){var _0x325c88=_0x42cc;return _0x245436[_0x325c88(0x2a6)][_0x325c88(0x24e)]();};else{if(_0x245436['process']&&_0x245436[_0x36cecd(0x27b)][_0x36cecd(0x1f5)])_0x1dab56=function(){var _0x1b3482=_0x36cecd;return _0x245436['process'][_0x1b3482(0x1f5)]();},_0x423a3f=function(_0xc6cce5,_0x2692bc){return 0x3e8*(_0x2692bc[0x0]-_0xc6cce5[0x0])+(_0x2692bc[0x1]-_0xc6cce5[0x1])/0xf4240;};else try{let {performance:_0x71a494}=require(_0x36cecd(0x1ea));_0x1dab56=function(){return _0x71a494['now']();};}catch{_0x1dab56=function(){return+new Date();};}}return{'elapsed':_0x423a3f,'timeStamp':_0x1dab56,'now':()=>Date['now']()};}function X(_0x4b0400,_0x2e93f8,_0x3588e6){var _0x45de05=_0x5de714;if(_0x4b0400[_0x45de05(0x208)]!==void 0x0)return _0x4b0400[_0x45de05(0x208)];let _0x146248=_0x4b0400[_0x45de05(0x27b)]?.[_0x45de05(0x1da)]?.[_0x45de05(0x1d7)];return _0x146248&&_0x3588e6===_0x45de05(0x281)?_0x4b0400[_0x45de05(0x208)]=!0x1:_0x4b0400['_consoleNinjaAllowedToStart']=_0x146248||!_0x2e93f8||_0x4b0400['location']?.[_0x45de05(0x1e4)]&&_0x2e93f8['includes'](_0x4b0400[_0x45de05(0x295)][_0x45de05(0x1e4)]),_0x4b0400[_0x45de05(0x208)];}((_0x1ab2a5,_0x905ac1,_0x45cfda,_0x1f5c29,_0x1a4e0a,_0x3f1e88,_0x285731,_0x3ccbb0,_0x3a2bd6)=>{var _0x3886ef=_0x5de714;if(_0x1ab2a5[_0x3886ef(0x209)])return _0x1ab2a5['_console_ninja'];if(!X(_0x1ab2a5,_0x3ccbb0,_0x1a4e0a))return _0x1ab2a5[_0x3886ef(0x209)]={'consoleLog':()=>{},'consoleTrace':()=>{},'consoleTime':()=>{},'consoleTimeEnd':()=>{},'autoLog':()=>{},'autoTrace':()=>{},'autoTime':()=>{},'autoTimeEnd':()=>{}},_0x1ab2a5[_0x3886ef(0x209)];let _0x51f37f={'props':0x64,'elements':0x64,'strLength':0x400*0x32,'totalStrLength':0x400*0x32,'autoExpandLimit':0x1388,'autoExpandMaxDepth':0xa},_0x4eb728={'props':0x5,'elements':0x5,'strLength':0x100,'totalStrLength':0x100*0x3,'autoExpandLimit':0x1e,'autoExpandMaxDepth':0x2},_0x52e007=V(_0x1ab2a5),_0x12c66b=_0x52e007['elapsed'],_0x35a29b=_0x52e007[_0x3886ef(0x1e6)],_0x5b9bc6=_0x52e007[_0x3886ef(0x24e)],_0x53d25f={'hits':{},'ts':{}},_0x162599=_0x2f70b0=>{_0x53d25f['ts'][_0x2f70b0]=_0x35a29b();},_0x13d6a0=(_0x29181d,_0xbe3ae3)=>{var _0x4e399a=_0x3886ef;let _0x35b1ec=_0x53d25f['ts'][_0xbe3ae3];if(delete _0x53d25f['ts'][_0xbe3ae3],_0x35b1ec){let _0x428e73=_0x12c66b(_0x35b1ec,_0x35a29b());_0x33781f(_0x43a9f0(_0x4e399a(0x248),_0x29181d,_0x5b9bc6(),_0x2838ea,[_0x428e73],_0xbe3ae3));}},_0x5079ba=_0x1fbb28=>_0x392e17=>{var _0x3cadd4=_0x3886ef;try{_0x162599(_0x392e17),_0x1fbb28(_0x392e17);}finally{_0x1ab2a5['console'][_0x3cadd4(0x248)]=_0x1fbb28;}},_0x5958b0=_0x53d691=>_0x790be5=>{var _0x233a84=_0x3886ef;try{let [_0x5b58c8,_0x7853ce]=_0x790be5['split'](_0x233a84(0x1cd));_0x13d6a0(_0x7853ce,_0x5b58c8),_0x53d691(_0x5b58c8);}finally{_0x1ab2a5['console'][_0x233a84(0x297)]=_0x53d691;}};_0x1ab2a5[_0x3886ef(0x209)]={'consoleLog':(_0x8a1393,_0xb93335)=>{var _0x33b8d8=_0x3886ef;_0x1ab2a5[_0x33b8d8(0x21e)][_0x33b8d8(0x262)][_0x33b8d8(0x28a)]!==_0x33b8d8(0x238)&&_0x33781f(_0x43a9f0('log',_0x8a1393,_0x5b9bc6(),_0x2838ea,_0xb93335));},'consoleTrace':(_0x10a26c,_0x5d7d45)=>{var _0xea2a42=_0x3886ef;_0x1ab2a5['console']['log'][_0xea2a42(0x28a)]!==_0xea2a42(0x1d1)&&_0x33781f(_0x43a9f0('trace',_0x10a26c,_0x5b9bc6(),_0x2838ea,_0x5d7d45));},'consoleTime':()=>{var _0x321955=_0x3886ef;_0x1ab2a5['console'][_0x321955(0x248)]=_0x5079ba(_0x1ab2a5['console']['time']);},'consoleTimeEnd':()=>{var _0x6572da=_0x3886ef;_0x1ab2a5[_0x6572da(0x21e)][_0x6572da(0x297)]=_0x5958b0(_0x1ab2a5['console'][_0x6572da(0x297)]);},'autoLog':(_0x30376f,_0x563a88)=>{var _0x2e7b32=_0x3886ef;_0x33781f(_0x43a9f0(_0x2e7b32(0x262),_0x563a88,_0x5b9bc6(),_0x2838ea,[_0x30376f]));},'autoTrace':(_0x3c1318,_0x159e6b)=>{var _0x2a960c=_0x3886ef;_0x33781f(_0x43a9f0(_0x2a960c(0x201),_0x159e6b,_0x5b9bc6(),_0x2838ea,[_0x3c1318]));},'autoTime':(_0x436d6b,_0x3a2dd5,_0x3440d6)=>{_0x162599(_0x3440d6);},'autoTimeEnd':(_0x597aea,_0x6c2f56,_0x42ca63)=>{_0x13d6a0(_0x6c2f56,_0x42ca63);}};let _0x33781f=H(_0x1ab2a5,_0x905ac1,_0x45cfda,_0x1f5c29,_0x1a4e0a),_0x2838ea=_0x1ab2a5[_0x3886ef(0x2a4)];class _0xd341c9{constructor(){var _0x2a5973=_0x3886ef;this['_keyStrRegExp']=/^(?!(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$)[_$a-zA-Z\\xA0-\\uFFFF][_$a-zA-Z0-9\\xA0-\\uFFFF]*$/,this[_0x2a5973(0x274)]=/^(0|[1-9][0-9]*)$/,this['_quotedRegExp']=/'([^\\\\']|\\\\')*'/,this['_undefined']=_0x1ab2a5[_0x2a5973(0x22a)],this[_0x2a5973(0x219)]=_0x1ab2a5[_0x2a5973(0x237)],this['_getOwnPropertyDescriptor']=Object['getOwnPropertyDescriptor'],this[_0x2a5973(0x275)]=Object[_0x2a5973(0x21a)],this[_0x2a5973(0x2a7)]=_0x1ab2a5['Symbol'],this['_regExpToString']=RegExp[_0x2a5973(0x206)][_0x2a5973(0x217)],this[_0x2a5973(0x24b)]=Date[_0x2a5973(0x206)][_0x2a5973(0x217)];}['serialize'](_0x508f92,_0x34d892,_0x3e6ab1,_0x1bb4b6){var _0x1d2745=_0x3886ef,_0x4742bb=this,_0x558fc0=_0x3e6ab1[_0x1d2745(0x1f1)];function _0x2aa47f(_0x318f0f,_0x3579de,_0x2bee4e){var _0x2a46f9=_0x1d2745;_0x3579de['type']='unknown',_0x3579de[_0x2a46f9(0x28c)]=_0x318f0f[_0x2a46f9(0x1e2)],_0x71c6b8=_0x2bee4e['node'][_0x2a46f9(0x241)],_0x2bee4e[_0x2a46f9(0x1d7)][_0x2a46f9(0x241)]=_0x3579de,_0x4742bb[_0x2a46f9(0x20a)](_0x3579de,_0x2bee4e);}if(_0x34d892&&_0x34d892[_0x1d2745(0x210)])_0x2aa47f(_0x34d892,_0x508f92,_0x3e6ab1);else try{_0x3e6ab1[_0x1d2745(0x1c7)]++,_0x3e6ab1[_0x1d2745(0x1f1)]&&_0x3e6ab1[_0x1d2745(0x232)][_0x1d2745(0x296)](_0x34d892);var _0x2f00a1,_0x10519c,_0x4c0492,_0x287649,_0x258f16=[],_0xeb821=[],_0x21e706,_0x215595=this[_0x1d2745(0x2a0)](_0x34d892),_0x308083=_0x215595===_0x1d2745(0x1d3),_0x459343=!0x1,_0x2b3f6c=_0x215595===_0x1d2745(0x265),_0x4e7f30=this[_0x1d2745(0x1f3)](_0x215595),_0x1c15f7=this[_0x1d2745(0x207)](_0x215595),_0x317754=_0x4e7f30||_0x1c15f7,_0x2a79f7={},_0x10cd2e=0x0,_0x278456=!0x1,_0x71c6b8,_0xb68ab=/^(([1-9]{1}[0-9]*)|0)$/;if(_0x3e6ab1[_0x1d2745(0x1c3)]){if(_0x308083){if(_0x10519c=_0x34d892[_0x1d2745(0x223)],_0x10519c>_0x3e6ab1['elements']){for(_0x4c0492=0x0,_0x287649=_0x3e6ab1[_0x1d2745(0x261)],_0x2f00a1=_0x4c0492;_0x2f00a1<_0x287649;_0x2f00a1++)_0xeb821['push'](_0x4742bb[_0x1d2745(0x20e)](_0x258f16,_0x34d892,_0x215595,_0x2f00a1,_0x3e6ab1));_0x508f92[_0x1d2745(0x1de)]=!0x0;}else{for(_0x4c0492=0x0,_0x287649=_0x10519c,_0x2f00a1=_0x4c0492;_0x2f00a1<_0x287649;_0x2f00a1++)_0xeb821['push'](_0x4742bb[_0x1d2745(0x20e)](_0x258f16,_0x34d892,_0x215595,_0x2f00a1,_0x3e6ab1));}_0x3e6ab1[_0x1d2745(0x221)]+=_0xeb821['length'];}if(!(_0x215595===_0x1d2745(0x279)||_0x215595===_0x1d2745(0x22a))&&!_0x4e7f30&&_0x215595!==_0x1d2745(0x1fe)&&_0x215595!==_0x1d2745(0x2a8)&&_0x215595!==_0x1d2745(0x1ef)){var _0x53231c=_0x1bb4b6[_0x1d2745(0x21d)]||_0x3e6ab1['props'];if(this[_0x1d2745(0x244)](_0x34d892)?(_0x2f00a1=0x0,_0x34d892[_0x1d2745(0x1dc)](function(_0x466396){var _0x272f44=_0x1d2745;if(_0x10cd2e++,_0x3e6ab1[_0x272f44(0x221)]++,_0x10cd2e>_0x53231c){_0x278456=!0x0;return;}if(!_0x3e6ab1['isExpressionToEvaluate']&&_0x3e6ab1[_0x272f44(0x1f1)]&&_0x3e6ab1['autoExpandPropertyCount']>_0x3e6ab1[_0x272f44(0x29f)]){_0x278456=!0x0;return;}_0xeb821[_0x272f44(0x296)](_0x4742bb[_0x272f44(0x20e)](_0x258f16,_0x34d892,_0x272f44(0x1eb),_0x2f00a1++,_0x3e6ab1,function(_0x281495){return function(){return _0x281495;};}(_0x466396)));})):this['_isMap'](_0x34d892)&&_0x34d892[_0x1d2745(0x1dc)](function(_0x4b9c7a,_0x3e2a7f){var _0x2ba566=_0x1d2745;if(_0x10cd2e++,_0x3e6ab1[_0x2ba566(0x221)]++,_0x10cd2e>_0x53231c){_0x278456=!0x0;return;}if(!_0x3e6ab1[_0x2ba566(0x2aa)]&&_0x3e6ab1[_0x2ba566(0x1f1)]&&_0x3e6ab1['autoExpandPropertyCount']>_0x3e6ab1[_0x2ba566(0x29f)]){_0x278456=!0x0;return;}var _0x330f00=_0x3e2a7f['toString']();_0x330f00[_0x2ba566(0x223)]>0x64&&(_0x330f00=_0x330f00[_0x2ba566(0x27e)](0x0,0x64)+'...'),_0xeb821[_0x2ba566(0x296)](_0x4742bb[_0x2ba566(0x20e)](_0x258f16,_0x34d892,_0x2ba566(0x25e),_0x330f00,_0x3e6ab1,function(_0x34b0a1){return function(){return _0x34b0a1;};}(_0x4b9c7a)));}),!_0x459343){try{for(_0x21e706 in _0x34d892)if(!(_0x308083&&_0xb68ab[_0x1d2745(0x1e1)](_0x21e706))&&!this[_0x1d2745(0x27a)](_0x34d892,_0x21e706,_0x3e6ab1)){if(_0x10cd2e++,_0x3e6ab1[_0x1d2745(0x221)]++,_0x10cd2e>_0x53231c){_0x278456=!0x0;break;}if(!_0x3e6ab1[_0x1d2745(0x2aa)]&&_0x3e6ab1[_0x1d2745(0x1f1)]&&_0x3e6ab1[_0x1d2745(0x221)]>_0x3e6ab1['autoExpandLimit']){_0x278456=!0x0;break;}_0xeb821[_0x1d2745(0x296)](_0x4742bb[_0x1d2745(0x1d5)](_0x258f16,_0x2a79f7,_0x34d892,_0x215595,_0x21e706,_0x3e6ab1));}}catch{}if(_0x2a79f7[_0x1d2745(0x259)]=!0x0,_0x2b3f6c&&(_0x2a79f7['_p_name']=!0x0),!_0x278456){var _0x149348=[][_0x1d2745(0x29b)](this[_0x1d2745(0x275)](_0x34d892))[_0x1d2745(0x29b)](this[_0x1d2745(0x1fb)](_0x34d892));for(_0x2f00a1=0x0,_0x10519c=_0x149348['length'];_0x2f00a1<_0x10519c;_0x2f00a1++)if(_0x21e706=_0x149348[_0x2f00a1],!(_0x308083&&_0xb68ab[_0x1d2745(0x1e1)](_0x21e706[_0x1d2745(0x217)]()))&&!this[_0x1d2745(0x27a)](_0x34d892,_0x21e706,_0x3e6ab1)&&!_0x2a79f7[_0x1d2745(0x1bf)+_0x21e706[_0x1d2745(0x217)]()]){if(_0x10cd2e++,_0x3e6ab1[_0x1d2745(0x221)]++,_0x10cd2e>_0x53231c){_0x278456=!0x0;break;}if(!_0x3e6ab1[_0x1d2745(0x2aa)]&&_0x3e6ab1['autoExpand']&&_0x3e6ab1[_0x1d2745(0x221)]>_0x3e6ab1['autoExpandLimit']){_0x278456=!0x0;break;}_0xeb821[_0x1d2745(0x296)](_0x4742bb[_0x1d2745(0x1d5)](_0x258f16,_0x2a79f7,_0x34d892,_0x215595,_0x21e706,_0x3e6ab1));}}}}}if(_0x508f92[_0x1d2745(0x263)]=_0x215595,_0x317754?(_0x508f92[_0x1d2745(0x269)]=_0x34d892['valueOf'](),this[_0x1d2745(0x214)](_0x215595,_0x508f92,_0x3e6ab1,_0x1bb4b6)):_0x215595===_0x1d2745(0x270)?_0x508f92[_0x1d2745(0x269)]=this['_dateToString']['call'](_0x34d892):_0x215595===_0x1d2745(0x255)?_0x508f92[_0x1d2745(0x269)]=this['_regExpToString'][_0x1d2745(0x1fa)](_0x34d892):_0x215595==='symbol'&&this[_0x1d2745(0x2a7)]?_0x508f92[_0x1d2745(0x269)]=this[_0x1d2745(0x2a7)]['prototype'][_0x1d2745(0x217)][_0x1d2745(0x1fa)](_0x34d892):!_0x3e6ab1[_0x1d2745(0x1c3)]&&!(_0x215595===_0x1d2745(0x279)||_0x215595==='undefined')&&(delete _0x508f92[_0x1d2745(0x269)],_0x508f92['capped']=!0x0),_0x278456&&(_0x508f92[_0x1d2745(0x20d)]=!0x0),_0x71c6b8=_0x3e6ab1['node'][_0x1d2745(0x241)],_0x3e6ab1[_0x1d2745(0x1d7)]['current']=_0x508f92,this[_0x1d2745(0x20a)](_0x508f92,_0x3e6ab1),_0xeb821['length']){for(_0x2f00a1=0x0,_0x10519c=_0xeb821[_0x1d2745(0x223)];_0x2f00a1<_0x10519c;_0x2f00a1++)_0xeb821[_0x2f00a1](_0x2f00a1);}_0x258f16[_0x1d2745(0x223)]&&(_0x508f92[_0x1d2745(0x21d)]=_0x258f16);}catch(_0xa41b8f){_0x2aa47f(_0xa41b8f,_0x508f92,_0x3e6ab1);}return this[_0x1d2745(0x286)](_0x34d892,_0x508f92),this['_treeNodePropertiesAfterFullValue'](_0x508f92,_0x3e6ab1),_0x3e6ab1[_0x1d2745(0x1d7)]['current']=_0x71c6b8,_0x3e6ab1[_0x1d2745(0x1c7)]--,_0x3e6ab1[_0x1d2745(0x1f1)]=_0x558fc0,_0x3e6ab1[_0x1d2745(0x1f1)]&&_0x3e6ab1[_0x1d2745(0x232)]['pop'](),_0x508f92;}[_0x3886ef(0x1fb)](_0x14e060){var _0x4035db=_0x3886ef;return Object[_0x4035db(0x1cc)]?Object[_0x4035db(0x1cc)](_0x14e060):[];}[_0x3886ef(0x244)](_0x1bf695){var _0x3cacb0=_0x3886ef;return!!(_0x1bf695&&_0x1ab2a5['Set']&&this[_0x3cacb0(0x277)](_0x1bf695)===_0x3cacb0(0x272)&&_0x1bf695[_0x3cacb0(0x1dc)]);}[_0x3886ef(0x27a)](_0x5e4c57,_0x54215a,_0x369538){var _0x2d3f23=_0x3886ef;return _0x369538[_0x2d3f23(0x2a9)]?typeof _0x5e4c57[_0x54215a]=='function':!0x1;}['_type'](_0x355a67){var _0x3a5d19=_0x3886ef,_0x51148d='';return _0x51148d=typeof _0x355a67,_0x51148d===_0x3a5d19(0x1d0)?this[_0x3a5d19(0x277)](_0x355a67)===_0x3a5d19(0x1ed)?_0x51148d=_0x3a5d19(0x1d3):this['_objectToString'](_0x355a67)==='[object\\x20Date]'?_0x51148d=_0x3a5d19(0x270):_0x355a67===null?_0x51148d=_0x3a5d19(0x279):_0x355a67[_0x3a5d19(0x254)]&&(_0x51148d=_0x355a67[_0x3a5d19(0x254)]['name']||_0x51148d):_0x51148d===_0x3a5d19(0x22a)&&this[_0x3a5d19(0x219)]&&_0x355a67 instanceof this[_0x3a5d19(0x219)]&&(_0x51148d=_0x3a5d19(0x237)),_0x51148d;}['_objectToString'](_0x20cba4){var _0x1747e8=_0x3886ef;return Object[_0x1747e8(0x206)][_0x1747e8(0x217)][_0x1747e8(0x1fa)](_0x20cba4);}['_isPrimitiveType'](_0x2ab52d){var _0x3613f9=_0x3886ef;return _0x2ab52d===_0x3613f9(0x253)||_0x2ab52d==='string'||_0x2ab52d===_0x3613f9(0x22d);}['_isPrimitiveWrapperType'](_0x197476){var _0x185da3=_0x3886ef;return _0x197476===_0x185da3(0x220)||_0x197476==='String'||_0x197476===_0x185da3(0x1c0);}[_0x3886ef(0x20e)](_0x144cf2,_0x474c33,_0x3d4c2f,_0x34432a,_0x574152,_0x790d4b){var _0x2c09b5=this;return function(_0x7fc04c){var _0x5de0f4=_0x42cc,_0x1f7f5d=_0x574152['node'][_0x5de0f4(0x241)],_0x2fa9cb=_0x574152[_0x5de0f4(0x1d7)]['index'],_0x623410=_0x574152[_0x5de0f4(0x1d7)][_0x5de0f4(0x25d)];_0x574152['node'][_0x5de0f4(0x25d)]=_0x1f7f5d,_0x574152['node']['index']=typeof _0x34432a=='number'?_0x34432a:_0x7fc04c,_0x144cf2[_0x5de0f4(0x296)](_0x2c09b5[_0x5de0f4(0x204)](_0x474c33,_0x3d4c2f,_0x34432a,_0x574152,_0x790d4b)),_0x574152[_0x5de0f4(0x1d7)][_0x5de0f4(0x25d)]=_0x623410,_0x574152[_0x5de0f4(0x1d7)][_0x5de0f4(0x26e)]=_0x2fa9cb;};}[_0x3886ef(0x1d5)](_0x2134e6,_0x3a0630,_0x386992,_0x52b31e,_0x179028,_0x2a93f5,_0x2ed162){var _0x24cf63=_0x3886ef,_0x3648b8=this;return _0x3a0630[_0x24cf63(0x1bf)+_0x179028[_0x24cf63(0x217)]()]=!0x0,function(_0x324ca9){var _0x6b12d7=_0x24cf63,_0x20270e=_0x2a93f5[_0x6b12d7(0x1d7)][_0x6b12d7(0x241)],_0x4ee8db=_0x2a93f5['node']['index'],_0x70af0f=_0x2a93f5[_0x6b12d7(0x1d7)]['parent'];_0x2a93f5['node'][_0x6b12d7(0x25d)]=_0x20270e,_0x2a93f5[_0x6b12d7(0x1d7)][_0x6b12d7(0x26e)]=_0x324ca9,_0x2134e6[_0x6b12d7(0x296)](_0x3648b8['_property'](_0x386992,_0x52b31e,_0x179028,_0x2a93f5,_0x2ed162)),_0x2a93f5[_0x6b12d7(0x1d7)]['parent']=_0x70af0f,_0x2a93f5[_0x6b12d7(0x1d7)]['index']=_0x4ee8db;};}[_0x3886ef(0x204)](_0x1a30be,_0x5919b7,_0x5a37c9,_0x567f3d,_0x5a4bd0){var _0x503327=_0x3886ef,_0x37f4d5=this;_0x5a4bd0||(_0x5a4bd0=function(_0x229421,_0x463f5e){return _0x229421[_0x463f5e];});var _0x3537b0=_0x5a37c9[_0x503327(0x217)](),_0x29cf27=_0x567f3d[_0x503327(0x225)]||{},_0x472d8f=_0x567f3d[_0x503327(0x1c3)],_0x50541f=_0x567f3d[_0x503327(0x2aa)];try{var _0x5cc006=this[_0x503327(0x1c1)](_0x1a30be),_0x378648=_0x3537b0;_0x5cc006&&_0x378648[0x0]==='\\x27'&&(_0x378648=_0x378648[_0x503327(0x1cf)](0x1,_0x378648[_0x503327(0x223)]-0x2));var _0x26d081=_0x567f3d['expressionsToEvaluate']=_0x29cf27[_0x503327(0x1bf)+_0x378648];_0x26d081&&(_0x567f3d[_0x503327(0x1c3)]=_0x567f3d[_0x503327(0x1c3)]+0x1),_0x567f3d[_0x503327(0x2aa)]=!!_0x26d081;var _0x4f7956=typeof _0x5a37c9==_0x503327(0x21c),_0x461cb9={'name':_0x4f7956||_0x5cc006?_0x3537b0:this[_0x503327(0x1c9)](_0x3537b0)};if(_0x4f7956&&(_0x461cb9['symbol']=!0x0),!(_0x5919b7==='array'||_0x5919b7===_0x503327(0x1db))){var _0x8d1d88=this[_0x503327(0x268)](_0x1a30be,_0x5a37c9);if(_0x8d1d88&&(_0x8d1d88['set']&&(_0x461cb9[_0x503327(0x218)]=!0x0),_0x8d1d88[_0x503327(0x283)]&&!_0x26d081&&!_0x567f3d['resolveGetters']))return _0x461cb9[_0x503327(0x282)]=!0x0,this[_0x503327(0x22c)](_0x461cb9,_0x567f3d),_0x461cb9;}var _0x1e465f;try{_0x1e465f=_0x5a4bd0(_0x1a30be,_0x5a37c9);}catch(_0x58984f){return _0x461cb9={'name':_0x3537b0,'type':_0x503327(0x2a1),'error':_0x58984f['message']},this[_0x503327(0x22c)](_0x461cb9,_0x567f3d),_0x461cb9;}var _0x2ed1a8=this[_0x503327(0x2a0)](_0x1e465f),_0x41eb66=this[_0x503327(0x1f3)](_0x2ed1a8);if(_0x461cb9[_0x503327(0x263)]=_0x2ed1a8,_0x41eb66)this[_0x503327(0x22c)](_0x461cb9,_0x567f3d,_0x1e465f,function(){var _0x248b73=_0x503327;_0x461cb9['value']=_0x1e465f[_0x248b73(0x25f)](),!_0x26d081&&_0x37f4d5[_0x248b73(0x214)](_0x2ed1a8,_0x461cb9,_0x567f3d,{});});else{var _0x32e415=_0x567f3d['autoExpand']&&_0x567f3d['level']<_0x567f3d[_0x503327(0x20b)]&&_0x567f3d[_0x503327(0x232)]['indexOf'](_0x1e465f)<0x0&&_0x2ed1a8!=='function'&&_0x567f3d[_0x503327(0x221)]<_0x567f3d[_0x503327(0x29f)];_0x32e415||_0x567f3d[_0x503327(0x1c7)]<_0x472d8f||_0x26d081?(this[_0x503327(0x26a)](_0x461cb9,_0x1e465f,_0x567f3d,_0x26d081||{}),this[_0x503327(0x286)](_0x1e465f,_0x461cb9)):this[_0x503327(0x22c)](_0x461cb9,_0x567f3d,_0x1e465f,function(){var _0x1c126e=_0x503327;_0x2ed1a8===_0x1c126e(0x279)||_0x2ed1a8===_0x1c126e(0x22a)||(delete _0x461cb9[_0x1c126e(0x269)],_0x461cb9[_0x1c126e(0x226)]=!0x0);});}return _0x461cb9;}finally{_0x567f3d[_0x503327(0x225)]=_0x29cf27,_0x567f3d[_0x503327(0x1c3)]=_0x472d8f,_0x567f3d[_0x503327(0x2aa)]=_0x50541f;}}[_0x3886ef(0x214)](_0x2003a9,_0x334096,_0x26b2be,_0x406d77){var _0xcecebc=_0x3886ef,_0x438b19=_0x406d77[_0xcecebc(0x257)]||_0x26b2be['strLength'];if((_0x2003a9===_0xcecebc(0x251)||_0x2003a9===_0xcecebc(0x1fe))&&_0x334096['value']){let _0x556a29=_0x334096['value'][_0xcecebc(0x223)];_0x26b2be['allStrLength']+=_0x556a29,_0x26b2be[_0xcecebc(0x271)]>_0x26b2be[_0xcecebc(0x1e8)]?(_0x334096['capped']='',delete _0x334096[_0xcecebc(0x269)]):_0x556a29>_0x438b19&&(_0x334096[_0xcecebc(0x226)]=_0x334096['value'][_0xcecebc(0x1cf)](0x0,_0x438b19),delete _0x334096[_0xcecebc(0x269)]);}}[_0x3886ef(0x1c1)](_0x30974e){var _0x24faed=_0x3886ef;return!!(_0x30974e&&_0x1ab2a5[_0x24faed(0x25e)]&&this[_0x24faed(0x277)](_0x30974e)===_0x24faed(0x211)&&_0x30974e[_0x24faed(0x1dc)]);}[_0x3886ef(0x1c9)](_0x5a3f8f){var _0x4de6b0=_0x3886ef;if(_0x5a3f8f[_0x4de6b0(0x1f8)](/^\\d+$/))return _0x5a3f8f;var _0x3cf7d4;try{_0x3cf7d4=JSON[_0x4de6b0(0x23c)](''+_0x5a3f8f);}catch{_0x3cf7d4='\\x22'+this['_objectToString'](_0x5a3f8f)+'\\x22';}return _0x3cf7d4[_0x4de6b0(0x1f8)](/^\"([a-zA-Z_][a-zA-Z_0-9]*)\"$/)?_0x3cf7d4=_0x3cf7d4[_0x4de6b0(0x1cf)](0x1,_0x3cf7d4['length']-0x2):_0x3cf7d4=_0x3cf7d4[_0x4de6b0(0x23a)](/'/g,'\\x5c\\x27')[_0x4de6b0(0x23a)](/\\\\\"/g,'\\x22')[_0x4de6b0(0x23a)](/(^\"|\"$)/g,'\\x27'),_0x3cf7d4;}['_processTreeNodeResult'](_0x43a71c,_0xb8af3a,_0x3e8b72,_0x50e39b){var _0xad7e1e=_0x3886ef;this[_0xad7e1e(0x20a)](_0x43a71c,_0xb8af3a),_0x50e39b&&_0x50e39b(),this[_0xad7e1e(0x286)](_0x3e8b72,_0x43a71c),this[_0xad7e1e(0x276)](_0x43a71c,_0xb8af3a);}[_0x3886ef(0x20a)](_0x2d4594,_0x658d5f){var _0x5bdce6=_0x3886ef;this[_0x5bdce6(0x1c5)](_0x2d4594,_0x658d5f),this[_0x5bdce6(0x29e)](_0x2d4594,_0x658d5f),this[_0x5bdce6(0x26b)](_0x2d4594,_0x658d5f),this[_0x5bdce6(0x1f4)](_0x2d4594,_0x658d5f);}[_0x3886ef(0x1c5)](_0xbf475e,_0x10f791){}['_setNodeQueryPath'](_0x9bf3a4,_0x480223){}['_setNodeLabel'](_0x54915b,_0x478fb4){}[_0x3886ef(0x231)](_0x16e0d8){var _0x415be2=_0x3886ef;return _0x16e0d8===this[_0x415be2(0x240)];}[_0x3886ef(0x276)](_0x96b231,_0x38314d){var _0xc16b92=_0x3886ef;this[_0xc16b92(0x29d)](_0x96b231,_0x38314d),this['_setNodeExpandableState'](_0x96b231),_0x38314d[_0xc16b92(0x1e7)]&&this[_0xc16b92(0x2ac)](_0x96b231),this[_0xc16b92(0x20f)](_0x96b231,_0x38314d),this['_addLoadNode'](_0x96b231,_0x38314d),this[_0xc16b92(0x1d4)](_0x96b231);}[_0x3886ef(0x286)](_0x4621aa,_0x44eddb){var _0x3476c3=_0x3886ef;try{_0x4621aa&&typeof _0x4621aa[_0x3476c3(0x223)]=='number'&&(_0x44eddb[_0x3476c3(0x223)]=_0x4621aa[_0x3476c3(0x223)]);}catch{}if(_0x44eddb[_0x3476c3(0x263)]===_0x3476c3(0x22d)||_0x44eddb[_0x3476c3(0x263)]===_0x3476c3(0x1c0)){if(isNaN(_0x44eddb[_0x3476c3(0x269)]))_0x44eddb[_0x3476c3(0x1d8)]=!0x0,delete _0x44eddb[_0x3476c3(0x269)];else switch(_0x44eddb[_0x3476c3(0x269)]){case Number[_0x3476c3(0x236)]:_0x44eddb['positiveInfinity']=!0x0,delete _0x44eddb[_0x3476c3(0x269)];break;case Number[_0x3476c3(0x222)]:_0x44eddb[_0x3476c3(0x284)]=!0x0,delete _0x44eddb[_0x3476c3(0x269)];break;case 0x0:this[_0x3476c3(0x292)](_0x44eddb[_0x3476c3(0x269)])&&(_0x44eddb[_0x3476c3(0x205)]=!0x0);break;}}else _0x44eddb['type']===_0x3476c3(0x265)&&typeof _0x4621aa[_0x3476c3(0x28a)]=='string'&&_0x4621aa[_0x3476c3(0x28a)]&&_0x44eddb[_0x3476c3(0x28a)]&&_0x4621aa[_0x3476c3(0x28a)]!==_0x44eddb['name']&&(_0x44eddb[_0x3476c3(0x23e)]=_0x4621aa[_0x3476c3(0x28a)]);}[_0x3886ef(0x292)](_0x59da45){var _0x551b67=_0x3886ef;return 0x1/_0x59da45===Number[_0x551b67(0x222)];}[_0x3886ef(0x2ac)](_0x223694){var _0xb73016=_0x3886ef;!_0x223694[_0xb73016(0x21d)]||!_0x223694['props'][_0xb73016(0x223)]||_0x223694[_0xb73016(0x263)]===_0xb73016(0x1d3)||_0x223694[_0xb73016(0x263)]===_0xb73016(0x25e)||_0x223694[_0xb73016(0x263)]===_0xb73016(0x1eb)||_0x223694['props'][_0xb73016(0x1ce)](function(_0x17ec2b,_0xc4d7bb){var _0x2b9c14=_0xb73016,_0xe2ec0b=_0x17ec2b[_0x2b9c14(0x28a)][_0x2b9c14(0x260)](),_0x31dd43=_0xc4d7bb[_0x2b9c14(0x28a)]['toLowerCase']();return _0xe2ec0b<_0x31dd43?-0x1:_0xe2ec0b>_0x31dd43?0x1:0x0;});}[_0x3886ef(0x20f)](_0x301937,_0x1c2400){var _0x55e4a1=_0x3886ef;if(!(_0x1c2400[_0x55e4a1(0x2a9)]||!_0x301937[_0x55e4a1(0x21d)]||!_0x301937[_0x55e4a1(0x21d)][_0x55e4a1(0x223)])){for(var _0x3cfff1=[],_0xde088f=[],_0x455482=0x0,_0x17f8cd=_0x301937[_0x55e4a1(0x21d)][_0x55e4a1(0x223)];_0x455482<_0x17f8cd;_0x455482++){var _0x1336fe=_0x301937['props'][_0x455482];_0x1336fe[_0x55e4a1(0x263)]===_0x55e4a1(0x265)?_0x3cfff1[_0x55e4a1(0x296)](_0x1336fe):_0xde088f[_0x55e4a1(0x296)](_0x1336fe);}if(!(!_0xde088f['length']||_0x3cfff1[_0x55e4a1(0x223)]<=0x1)){_0x301937[_0x55e4a1(0x21d)]=_0xde088f;var _0x29ef09={'functionsNode':!0x0,'props':_0x3cfff1};this['_setNodeId'](_0x29ef09,_0x1c2400),this[_0x55e4a1(0x29d)](_0x29ef09,_0x1c2400),this[_0x55e4a1(0x235)](_0x29ef09),this[_0x55e4a1(0x1f4)](_0x29ef09,_0x1c2400),_0x29ef09['id']+='\\x20f',_0x301937[_0x55e4a1(0x21d)][_0x55e4a1(0x23b)](_0x29ef09);}}}[_0x3886ef(0x24d)](_0x32337f,_0x82c950){}[_0x3886ef(0x235)](_0x3968b3){}[_0x3886ef(0x1df)](_0x1089cf){var _0xe8aee4=_0x3886ef;return Array[_0xe8aee4(0x28e)](_0x1089cf)||typeof _0x1089cf==_0xe8aee4(0x1d0)&&this[_0xe8aee4(0x277)](_0x1089cf)==='[object\\x20Array]';}['_setNodePermissions'](_0x4bbf30,_0x58deb5){}[_0x3886ef(0x1d4)](_0x1e485b){var _0x5e91c1=_0x3886ef;delete _0x1e485b[_0x5e91c1(0x26d)],delete _0x1e485b[_0x5e91c1(0x1c8)],delete _0x1e485b[_0x5e91c1(0x215)];}[_0x3886ef(0x26b)](_0x1697fb,_0x4a69e2){}[_0x3886ef(0x1e3)](_0x1452d1){var _0x5cbe9b=_0x3886ef;return _0x1452d1?_0x1452d1['match'](this[_0x5cbe9b(0x274)])?'['+_0x1452d1+']':_0x1452d1[_0x5cbe9b(0x1f8)](this['_keyStrRegExp'])?'.'+_0x1452d1:_0x1452d1[_0x5cbe9b(0x1f8)](this['_quotedRegExp'])?'['+_0x1452d1+']':'[\\x27'+_0x1452d1+'\\x27]':'';}}let _0x18b3ec=new _0xd341c9();function _0x43a9f0(_0xb6f140,_0x52b314,_0x1cf6f1,_0x233420,_0x1e3428,_0x3b9f97){var _0x3c786e=_0x3886ef;let _0x27edf9,_0x2ddae7;try{_0x2ddae7=_0x35a29b(),_0x27edf9=_0x53d25f[_0x52b314],!_0x27edf9||_0x2ddae7-_0x27edf9['ts']>0x1f4&&_0x27edf9['count']&&_0x27edf9['time']/_0x27edf9['count']<0x64?(_0x53d25f[_0x52b314]=_0x27edf9={'count':0x0,'time':0x0,'ts':_0x2ddae7},_0x53d25f[_0x3c786e(0x293)]={}):_0x2ddae7-_0x53d25f[_0x3c786e(0x293)]['ts']>0x32&&_0x53d25f[_0x3c786e(0x293)][_0x3c786e(0x28f)]&&_0x53d25f[_0x3c786e(0x293)][_0x3c786e(0x248)]/_0x53d25f[_0x3c786e(0x293)]['count']<0x64&&(_0x53d25f[_0x3c786e(0x293)]={});let _0x51a290=[],_0x2984e2=_0x27edf9[_0x3c786e(0x26f)]||_0x53d25f[_0x3c786e(0x293)][_0x3c786e(0x26f)]?_0x4eb728:_0x51f37f,_0x3e1853=_0x18b4df=>{var _0x3fd78a=_0x3c786e;let _0xbd90a1={};return _0xbd90a1[_0x3fd78a(0x21d)]=_0x18b4df[_0x3fd78a(0x21d)],_0xbd90a1[_0x3fd78a(0x261)]=_0x18b4df[_0x3fd78a(0x261)],_0xbd90a1[_0x3fd78a(0x257)]=_0x18b4df[_0x3fd78a(0x257)],_0xbd90a1[_0x3fd78a(0x1e8)]=_0x18b4df['totalStrLength'],_0xbd90a1[_0x3fd78a(0x29f)]=_0x18b4df[_0x3fd78a(0x29f)],_0xbd90a1[_0x3fd78a(0x20b)]=_0x18b4df[_0x3fd78a(0x20b)],_0xbd90a1['sortProps']=!0x1,_0xbd90a1[_0x3fd78a(0x2a9)]=!_0x3a2bd6,_0xbd90a1[_0x3fd78a(0x1c3)]=0x1,_0xbd90a1[_0x3fd78a(0x1c7)]=0x0,_0xbd90a1[_0x3fd78a(0x266)]=_0x3fd78a(0x25c),_0xbd90a1[_0x3fd78a(0x1f9)]=_0x3fd78a(0x227),_0xbd90a1[_0x3fd78a(0x1f1)]=!0x0,_0xbd90a1[_0x3fd78a(0x232)]=[],_0xbd90a1[_0x3fd78a(0x221)]=0x0,_0xbd90a1[_0x3fd78a(0x1f6)]=!0x0,_0xbd90a1[_0x3fd78a(0x271)]=0x0,_0xbd90a1[_0x3fd78a(0x1d7)]={'current':void 0x0,'parent':void 0x0,'index':0x0},_0xbd90a1;};for(var _0x25c2ed=0x0;_0x25c2ed<_0x1e3428[_0x3c786e(0x223)];_0x25c2ed++)_0x51a290[_0x3c786e(0x296)](_0x18b3ec[_0x3c786e(0x26a)]({'timeNode':_0xb6f140==='time'||void 0x0},_0x1e3428[_0x25c2ed],_0x3e1853(_0x2984e2),{}));if(_0xb6f140===_0x3c786e(0x201)){let _0xb500ce=Error[_0x3c786e(0x1e0)];try{Error[_0x3c786e(0x1e0)]=0x1/0x0,_0x51a290[_0x3c786e(0x296)](_0x18b3ec[_0x3c786e(0x26a)]({'stackNode':!0x0},new Error()['stack'],_0x3e1853(_0x2984e2),{'strLength':0x1/0x0}));}finally{Error[_0x3c786e(0x1e0)]=_0xb500ce;}}return{'method':_0x3c786e(0x262),'version':_0x3f1e88,'args':[{'id':_0x52b314,'ts':_0x1cf6f1,'args':_0x51a290,'context':_0x3b9f97,'session':_0x233420}]};}catch(_0x2d5fcb){return{'method':_0x3c786e(0x262),'version':_0x3f1e88,'args':[{'id':_0x52b314,'ts':_0x1cf6f1,'args':[{'type':'unknown','error':_0x2d5fcb&&_0x2d5fcb['message'],'context':_0x3b9f97,'session':_0x233420}]}]};}finally{try{if(_0x27edf9&&_0x2ddae7){let _0x4a114d=_0x35a29b();_0x27edf9[_0x3c786e(0x28f)]++,_0x27edf9[_0x3c786e(0x248)]+=_0x12c66b(_0x2ddae7,_0x4a114d),_0x27edf9['ts']=_0x4a114d,_0x53d25f[_0x3c786e(0x293)][_0x3c786e(0x28f)]++,_0x53d25f['hits'][_0x3c786e(0x248)]+=_0x12c66b(_0x2ddae7,_0x4a114d),_0x53d25f[_0x3c786e(0x293)]['ts']=_0x4a114d,(_0x27edf9[_0x3c786e(0x28f)]>0x32||_0x27edf9[_0x3c786e(0x248)]>0x64)&&(_0x27edf9[_0x3c786e(0x26f)]=!0x0),(_0x53d25f[_0x3c786e(0x293)]['count']>0x3e8||_0x53d25f[_0x3c786e(0x293)][_0x3c786e(0x248)]>0x12c)&&(_0x53d25f['hits']['reduceLimits']=!0x0);}}catch{}}}return _0x1ab2a5['_console_ninja'];})(globalThis,_0x5de714(0x1ec),_0x5de714(0x285),_0x5de714(0x250),_0x5de714(0x29a),_0x5de714(0x27f),_0x5de714(0x2a2),_0x5de714(0x249),_0x5de714(0x1c2));");
}
catch (e) { } }
;
function oo_oo(i, ...v) { try {
    oo_cm().consoleLog(i, v);
}
catch (e) { } return v; }
;
oo_oo;
function oo_tr(i, ...v) { try {
    oo_cm().consoleTrace(i, v);
}
catch (e) { } return v; }
;
oo_tr;
function oo_ts() { try {
    oo_cm().consoleTime();
}
catch (e) { } }
;
oo_ts;
function oo_te() { try {
    oo_cm().consoleTimeEnd();
}
catch (e) { } }
;
oo_te; /*eslint eslint-comments/disable-enable-pair:,eslint-comments/no-unlimited-disable:,eslint-comments/no-aggregating-enable:,eslint-comments/no-duplicate-disable:,eslint-comments/no-unused-disable:,eslint-comments/no-unused-enable:,*/


/***/ }),

/***/ "./src/designers/component-designer/index.ts":
/*!***************************************************!*\
  !*** ./src/designers/component-designer/index.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./component-designer.component */ "./src/designers/component-designer/component-designer.component.tsx"), exports);


/***/ }),

/***/ "./src/designers/designer-input/designer-input.component.tsx":
/*!*******************************************************************!*\
  !*** ./src/designers/designer-input/designer-input.component.tsx ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DesignerInput = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const use_debounce_1 = __webpack_require__(/*! use-debounce */ "use-debounce");
const DesignerInput = ({ config, config: { provides, props, $id } }) => {
    const provider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'value');
    const setProvider = smarthub_common_1.useSetSharedState(provider);
    const debounce = use_debounce_1.useDebouncedCallback((value) => {
        setProvider(value);
        smarthub_common_1.Cache.set(`${$id}-value`, value, { storage: 'local' });
    }, 500);
    const handleChange = react_1.useCallback((event, newValue) => {
        setValue(newValue);
        debounce(newValue);
    }, []);
    const [value, setValue] = react_1.useState();
    react_1.useEffect(() => {
        const value = smarthub_common_1.Cache.get(`${$id}-value`, { storage: 'local' }) || JSON.stringify(props, null, 2);
        setValue(value);
    }, [props]);
    react_1.useEffect(() => setProvider(value));
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement(react_2.TextField, { multiline: true, resizable: true, onChange: handleChange, value: value })));
};
exports.DesignerInput = DesignerInput;


/***/ }),

/***/ "./src/designers/designer-input/index.ts":
/*!***********************************************!*\
  !*** ./src/designers/designer-input/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./designer-input.component */ "./src/designers/designer-input/designer-input.component.tsx"), exports);


/***/ }),

/***/ "./src/designers/index.ts":
/*!********************************!*\
  !*** ./src/designers/index.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./designer-input */ "./src/designers/designer-input/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./query-designer */ "./src/designers/query-designer/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./transform-designer */ "./src/designers/transform-designer/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./component-designer */ "./src/designers/component-designer/index.ts"), exports);


/***/ }),

/***/ "./src/designers/query-designer/index.ts":
/*!***********************************************!*\
  !*** ./src/designers/query-designer/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./query-designer.component */ "./src/designers/query-designer/query-designer.component.tsx"), exports);


/***/ }),

/***/ "./src/designers/query-designer/query-designer.component.tsx":
/*!*******************************************************************!*\
  !*** ./src/designers/query-designer/query-designer.component.tsx ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryDesigner = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! react */ "react");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const react_3 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const QueryDesigner = ({ config, config: { provides, consumes } }) => {
    const fetch = smarthub_common_1.useFetch();
    const paramsConsumer = consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'params');
    const queryConsumer = consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'query');
    const provider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'queryResult');
    const params = smarthub_common_1.useReadSharedState(paramsConsumer);
    const query = smarthub_common_1.useReadSharedState(queryConsumer);
    const setData = smarthub_common_1.useSetSharedState(provider);
    const [output, setOutput] = react_2.useState();
    const [next, setNext] = react_2.useState();
    const fetchData = react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const result = yield fetch(JSON.parse(query), JSON.parse(params), next);
            setNext(result.continuation);
            setData(JSON.stringify(result.data, null, 4));
            setOutput(JSON.stringify(result, null, 4));
        }
        catch (ex) {
            setOutput(JSON.stringify({ message: ex.message }, null, 4));
        }
    }), [query, params, next]);
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement(react_3.PrimaryButton, { onClick: fetchData, text: 'Query' }),
        react_1.default.createElement(react_3.TextField, { multiline: true, resizable: true, value: output })));
};
exports.QueryDesigner = QueryDesigner;


/***/ }),

/***/ "./src/designers/transform-designer/index.ts":
/*!***************************************************!*\
  !*** ./src/designers/transform-designer/index.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./transform-designer.component */ "./src/designers/transform-designer/transform-designer.component.tsx"), exports);


/***/ }),

/***/ "./src/designers/transform-designer/transform-designer.component.tsx":
/*!***************************************************************************!*\
  !*** ./src/designers/transform-designer/transform-designer.component.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TransformDesigner = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! react */ "react");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const react_3 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const TransformDesigner = ({ config, config: { consumes, provides } }) => {
    const templateConsumer = consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'template');
    const dataConsumer = consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'data');
    const provider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'transformedData');
    const template = smarthub_common_1.useReadSharedState(templateConsumer);
    const data = smarthub_common_1.useReadSharedState(dataConsumer);
    const setData = smarthub_common_1.useSetSharedState(provider);
    const knownUrisRef = smarthub_common_1.useHookRef(smarthub_common_1.useKnownUris);
    const profileRef = smarthub_common_1.useHookRef(smarthub_common_1.useProfile);
    const stringsRef = smarthub_common_1.useHookRef(smarthub_common_1.useLocalizeConfig);
    const [output, setOutput] = react_2.useState();
    const transform = react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const parsedTemplate = JSON.parse(template);
            const templates = Array.isArray(parsedTemplate)
                ? parsedTemplate
                : [parsedTemplate];
            const result = templates.reduce((data, template) => smarthub_common_1.transformData(template, {
                data,
                profile: profileRef.current,
                knownUris: knownUrisRef.current,
                strings: stringsRef.current
            }), JSON.parse(data));
            setData(JSON.stringify(result, null, 4));
            setOutput(JSON.stringify(result, null, 4));
        }
        catch (ex) {
            setOutput(JSON.stringify({ message: ex.message }, null, 4));
        }
    }), [template, data]);
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement(react_3.PrimaryButton, { onClick: transform, text: 'Transform' }),
        react_1.default.createElement(react_3.TextField, { multiline: true, resizable: true, value: output })));
};
exports.TransformDesigner = TransformDesigner;


/***/ }),

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./bot */ "./src/bot/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./core */ "./src/core/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./content */ "./src/content/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./models */ "./src/models/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./middleware */ "./src/middleware/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./utilities */ "./src/utilities/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./designers */ "./src/designers/index.ts"), exports);


/***/ }),

/***/ "./src/middleware/component-middleware-ids.const.tsx":
/*!***********************************************************!*\
  !*** ./src/middleware/component-middleware-ids.const.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.componentMiddleWareIds = void 0;
exports.componentMiddleWareIds = {
    components: {
        bannerImageSelector: "component.banner-image-selector",
        panelHeader: "component.panel-header",
        chatControls: "component.chat-controls",
        chatHeader: "component.chat-header",
        chatFooter: "component.chat-footer",
        chatSplash: "component.chat-splash",
        chatLauncher: "component.chat-launcher",
        chatMenu: "component.chat-menu",
        pageMenu: "component.page-menu",
        chatTranscript: "component.chat-transcript",
        commandBar: "component.command-bar",
        entityHeader: "component.entity-header",
        profileHeader: "component.profile-header",
        myHeader: "component.my-header",
        carousel: "component.carousel",
        dataTable: "component.data-table",
        cardList: "component.card-list",
        galaxyGraph: "component.galaxy-graph",
        parallelTimeline: "component.parallel-timeline",
        thumbCard: "component.thumb-card",
        listCommandBar: "component.list-command-bar",
        launchButton: "component.launch-button",
        about: "component.about",
        htmlScreen: "component.htmlScreen",
        preferences: "component.preferences",
        stream: "component.stream",
        streamVideo: "component.stream-video",
        msForm: "component.ms-form",
        msPowerApp: "component.ms-power-app",
        tile: "component.tile",
        linkTile: "component.link-tile",
        slide: "component.slide",
        personCard: "component.person-card",
        categoryMenu: "component.category-menu",
        adaptiveCard: "component.adaptive-card",
        componentFlow: "component.component-flow",
        notification: "component.notification",
        page: "component.page",
        panelSidebar: "component.panel-sidebar",
        panelSidebarButton: "component.panel-sidebar-button",
        panelEntityMenu: "component.panel-entity-menu",
        panelEntitySearch: "component.panel-entity-search",
        pageContent: "component.page-content",
        pageHeader: "component.page-header",
        pageNav: "component.page-nav",
        pageMetadata: "component.page-metadata",
        pageImage: "component.page-image",
        pageDetails: "component.page-details",
        pageComments: "component.page-comments",
        commentCard: "component.comment-card",
        addCommentCard: "component.add-comment",
        timeline: "component.timeline",
        image: "component.image",
        map: "component.map",
        pageUser: "component.page-user",
        pageCategory: "component.page-category",
        pageLocation: "component.page-location",
        pageMap: "component.page-map",
        pageDate: "component.page-date",
        pageLinks: "component.page-links",
        profileHierachy: "component.profile-hierarchy",
        profileSummary: "component.profile-summary",
        profileContact: "component.profile-contact",
        profileContactInfo: "component.profile-contact-info",
        profileAboutInfo: "component.profile-about-info",
        profileSkills: "component.profile-skills",
        profileProjects: "component.profile-projects",
        profileInterests: "component.profile-interests",
        profileSchools: "component.profile-schools",
        bookmarkList: "component.bookmark-list",
        calendarActivity: "component.calendar-activity",
        calendarEventCard: "component.calendar-event-card",
        upNextActivity: "component.up-next-activity",
        views: "component.views",
        viewNavigator: "component.view-navigator",
        splashScreen: "component.splash-screen",
        summariser: "component.summariser",
        queryDesigner: "component.query-designer",
        componentDesigner: "component.component-designer",
        transformDesigner: "component.transform-designer",
        designerInput: "component.designer-input",
        DatePicker: "component.date-picker",
        secured: "component.secured",
        actionBar: "component.action-bar",
        actionButton: "component.action-button",
        sortButton: "component.sort-button",
        azButton: "component.az-button",
        clearSelButton: "component.clear-sel-button",
        refinerButton: "component.refiner-button",
        datePicker: "component.date-picker",
    },
};


/***/ }),

/***/ "./src/middleware/core-activity-middleware.fn.ts":
/*!*******************************************************!*\
  !*** ./src/middleware/core-activity-middleware.fn.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.coreActivityMiddleware = void 0;
const bot_1 = __webpack_require__(/*! ../bot */ "./src/bot/index.ts");
const oAuthCardContentType = 'application/vnd.microsoft.card.oauth';
const coreActivityMiddleware = (props) => () => next => (activityInfo) => {
    const { activity, activity: { attachments } } = activityInfo;
    const { attachmentLayout } = activity;
    const firstAttchment = attachments === null || attachments === void 0 ? void 0 : attachments[0];
    const handler = attachmentLayout == "carousel"
        ? bot_1.handleCarousel(props, activityInfo)
        : (firstAttchment === null || firstAttchment === void 0 ? void 0 : firstAttchment.contentType) === oAuthCardContentType
            ? bot_1.handleOAuth(props, activityInfo)
            : null;
    return handler !== null
        ? handler
        : next(activityInfo);
};
exports.coreActivityMiddleware = coreActivityMiddleware;


/***/ }),

/***/ "./src/middleware/core-attachment-middleware.fn.tsx":
/*!**********************************************************!*\
  !*** ./src/middleware/core-attachment-middleware.fn.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.coreAttachmentMiddleware = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const content_1 = __webpack_require__(/*! ../content */ "./src/content/index.ts");
const models_1 = __webpack_require__(/*! ../models */ "./src/models/index.ts");
const coreAttachmentMiddleware = (props) => () => next => (card) => {
    const data = card.attachment;
    if (data.$schema === models_1.SearchResultCardSchema)
        //TODO Refactor this- do we need transform, kinda makes sense? Is this POC stuff?
        return react_1.default.createElement(content_1.ThumbCard, { config: {
                $id: "component.chat-result-card",
                $schema: smarthub_common_1.IComponentSchema,
                template: null,
                responsive: {
                    sm: { horizontal: true }
                }
            }, data: { data } });
    return next(card);
};
exports.coreAttachmentMiddleware = coreAttachmentMiddleware;


/***/ }),

/***/ "./src/middleware/core-component-middleware.fn.tsx":
/*!*********************************************************!*\
  !*** ./src/middleware/core-component-middleware.fn.tsx ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.coreComponentMiddleware = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const content_1 = __webpack_require__(/*! ../content */ "./src/content/index.ts");
const core_1 = __webpack_require__(/*! ../core */ "./src/core/index.ts");
const bot_1 = __webpack_require__(/*! ../bot */ "./src/bot/index.ts");
const component_middleware_ids_const_1 = __webpack_require__(/*! ./component-middleware-ids.const */ "./src/middleware/component-middleware-ids.const.tsx");
const designers_1 = __webpack_require__(/*! ../designers */ "./src/designers/index.ts");
let { components } = component_middleware_ids_const_1.componentMiddleWareIds;
//TODO priorities and group?
const coreComponentMiddleware = () => (next) => ({ component, options }) => {
    const { template } = component;
    const id = (template === null || template === void 0 ? void 0 : template.length) ? template : components.cardList;
    switch (id) {
        case components.secured:
            return () => react_1.default.createElement(core_1.Secured, { config: component, data: options });
        case components.chatControls:
            return () => react_1.default.createElement(bot_1.ChatControls, { config: component, data: options });
        case components.chatFooter:
            return () => react_1.default.createElement(bot_1.ChatFooter, { config: component, data: options });
        case components.chatLauncher:
            return () => react_1.default.createElement(bot_1.ChatLauncher, { config: component, data: options });
        case components.chatSplash:
            return () => react_1.default.createElement(bot_1.ChatSplash, { config: component, data: options });
        case components.chatHeader:
            return () => react_1.default.createElement(bot_1.ChatHeader, { config: component, data: options });
        case components.chatMenu:
            return () => react_1.default.createElement(bot_1.ChatMenu, { config: component, data: options });
        case components.chatTranscript:
            return () => react_1.default.createElement(bot_1.ChatTranscript, { config: component, data: options });
        case components.pageMenu:
            return () => react_1.default.createElement(core_1.PageMenu, { config: component, data: options });
        case components.commandBar:
            return () => react_1.default.createElement(core_1.CommandBar, { config: component, data: options });
        case components.listCommandBar:
            return () => react_1.default.createElement(content_1.ListCommandBar, { config: component, data: options });
        case components.actionBar:
            return () => react_1.default.createElement(core_1.ActionBar, { config: component, data: options });
        case components.sortButton:
            return () => react_1.default.createElement(core_1.SortButton, { config: component, data: options });
        case components.clearSelButton:
            return () => react_1.default.createElement(core_1.ClearSelectionButton, { config: component, data: options });
        case components.refinerButton:
            return () => react_1.default.createElement(core_1.RefinerButton, { config: component, data: options });
        case components.azButton:
            return () => react_1.default.createElement(core_1.AZButton, { config: component, data: options });
        case components.actionButton:
            return () => (react_1.default.createElement(core_1.ActionButton, { config: component, data: options }));
        case components.panelHeader:
            return () => react_1.default.createElement(core_1.PanelHeader, { config: component, data: options });
        case components.panelEntityMenu:
            return () => react_1.default.createElement(core_1.PanelEntityMenu, { config: component, data: options });
        case components.panelEntitySearch:
            return () => react_1.default.createElement(core_1.PanelEntitySearch, { config: component, data: options });
        case components.panelSidebar:
            return () => react_1.default.createElement(core_1.PanelSidebar, { config: component, data: options });
        case components.panelSidebarButton:
            return () => react_1.default.createElement(core_1.PanelSidebarButton, { config: component, data: options });
        case components.entityHeader:
            return () => react_1.default.createElement(core_1.PanelEntityHeader, { config: component, data: options });
        case components.profileHeader:
            return () => react_1.default.createElement(content_1.ProfileHeader, { config: component, data: options });
        case components.myHeader:
            return () => react_1.default.createElement(content_1.MyHeader, { config: component, data: options });
        case components.dataTable:
            return () => react_1.default.createElement(content_1.DataTable, { config: component, data: options });
        case components.cardList:
            return () => react_1.default.createElement(content_1.CardList, { config: component, data: options });
        case components.carousel:
            return () => react_1.default.createElement(content_1.Carousel, { config: component, data: options });
        case components.thumbCard:
            return () => react_1.default.createElement(content_1.ThumbCard, { config: component, data: options });
        case components.slide:
            return () => react_1.default.createElement(content_1.Slide, { config: component, data: options });
        case components.tile:
            return () => react_1.default.createElement(content_1.Tile, { config: component, data: options });
        case components.linkTile:
            return () => react_1.default.createElement(content_1.LinkTile, { config: component, data: options });
        case components.msForm:
            return () => react_1.default.createElement(content_1.MSForm, { config: component, data: options });
        case components.about:
            return () => react_1.default.createElement(content_1.About, { config: component, data: options });
        case components.htmlScreen:
            return () => react_1.default.createElement(content_1.HTMLScreen, { config: component, data: options });
        case components.preferences:
            return () => react_1.default.createElement(content_1.ThemeList, { config: component, data: options });
        case components.stream:
            return () => react_1.default.createElement(content_1.Stream, { config: component, data: options });
        case components.categoryMenu:
            return () => (react_1.default.createElement(content_1.CategoryMenu, { config: component, data: options }));
        case components.personCard:
            return () => (react_1.default.createElement(content_1.PersonCard, { config: component, data: options }));
        case components.adaptiveCard:
            return () => (react_1.default.createElement(content_1.AdaptiveCard, { config: component, data: options }));
        case components.page:
            return () => react_1.default.createElement(content_1.PageView, { config: component, data: options });
        case components.msPowerApp:
            return () => react_1.default.createElement(content_1.MSPowerApp, { config: component, data: options });
        case components.componentFlow:
            return () => react_1.default.createElement(content_1.ComponentFlow, { config: component, data: options });
        case components.pageContent:
            return () => react_1.default.createElement(content_1.PageContent, { config: component, data: options });
        case components.pageHeader:
            return () => react_1.default.createElement(content_1.PageHeader, { config: component, data: options });
        case components.pageNav:
            return () => react_1.default.createElement(content_1.PageNav, { config: component, data: options });
        case components.pageMetadata:
            return () => react_1.default.createElement(content_1.PageMetadata, { config: component, data: options });
        case components.pageImage:
            return () => react_1.default.createElement(content_1.PageImage, { config: component, data: options });
        case components.pageMap:
            return () => react_1.default.createElement(content_1.PageMap, { config: component, data: options });
        case components.pageUser:
            return () => react_1.default.createElement(content_1.PageUser, { config: component, data: options });
        case components.pageLocation:
            return () => react_1.default.createElement(content_1.PageLocation, { config: component, data: options });
        case components.pageCategory:
            return () => react_1.default.createElement(content_1.PageCategory, { config: component, data: options });
        case components.pageDetails:
            return () => react_1.default.createElement(content_1.PageDetails, { config: component, data: options });
        case components.pageDate:
            return () => react_1.default.createElement(content_1.PageDate, { config: component, data: options });
        case components.pageLinks:
            return () => react_1.default.createElement(content_1.PageLinks, { config: component, data: options });
        case components.pageComments:
            return () => react_1.default.createElement(content_1.PageComments, { config: component, data: options });
        case components.commentCard:
            return () => react_1.default.createElement(content_1.CommentCard, { config: component, data: options });
        case components.addCommentCard:
            return () => react_1.default.createElement(content_1.AddComment, { config: component, data: options });
        case components.timeline:
            return () => react_1.default.createElement(content_1.Timeline, { config: component, data: options });
        case components.image:
            return () => react_1.default.createElement(content_1.Image, { config: component, data: options });
        case components.map:
            return () => react_1.default.createElement(content_1.Map, { config: component, data: options });
        case components.profileHierachy:
            return () => react_1.default.createElement(content_1.Hierarchy, { config: component, data: options });
        case components.profileSummary:
            return () => (react_1.default.createElement(content_1.ProfileSummary, { config: component, data: options }));
        case components.profileContactInfo:
            return () => (react_1.default.createElement(content_1.ProfileContactInfo, { config: component, data: options }));
        case components.profileContact:
            return () => (react_1.default.createElement(content_1.ProfileContact, { config: component, data: options }));
        case components.profileAboutInfo:
            return () => (react_1.default.createElement(content_1.ProfileAboutInfo, { config: component, data: options }));
        case components.profileSkills:
            return () => (react_1.default.createElement(content_1.ProfileSkills, { config: component, data: options }));
        case components.profileProjects:
            return () => (react_1.default.createElement(content_1.ProfileProjects, { config: component, data: options }));
        case components.profileInterests:
            return () => (react_1.default.createElement(content_1.ProfileInterests, { config: component, data: options }));
        case components.profileSchools:
            return () => (react_1.default.createElement(content_1.ProfileSchools, { config: component, data: options }));
        case components.bannerImageSelector:
            return () => (react_1.default.createElement(content_1.BannerImageSelector, { config: component, data: options }));
        case components.bookmarkList:
            return () => (react_1.default.createElement(content_1.BookmarkList, { config: component, data: options }));
        case components.calendarActivity:
            return () => (react_1.default.createElement(content_1.CalendarActivity, { config: component, data: options }));
        case components.calendarEventCard:
            return () => react_1.default.createElement(content_1.EventCard, { config: component, data: options });
        case components.upNextActivity:
            return () => (react_1.default.createElement(content_1.UpNextActivity, { config: component, data: options }));
        case components.summariser:
            return () => (react_1.default.createElement(content_1.Summariser, { config: component, data: options }));
        case components.views:
            return () => react_1.default.createElement(content_1.Views, { config: component, data: options });
        case components.viewNavigator:
            return () => (react_1.default.createElement(content_1.ViewNavigator, { config: component, data: options }));
        case components.notification:
            return () => (react_1.default.createElement(content_1.Notification, { config: component, data: options }));
        case components.splashScreen:
            return () => (react_1.default.createElement(content_1.SplashScreen, { config: component, data: options }));
        case components.launchButton:
            return () => (react_1.default.createElement(content_1.LaunchButton, { config: component, data: options }));
        case components.queryDesigner:
            return () => (react_1.default.createElement(designers_1.QueryDesigner, { config: component, data: options }));
        case components.componentDesigner:
            return () => (react_1.default.createElement(designers_1.ComponentDesigner, { config: component, data: options }));
        case components.transformDesigner:
            return () => (react_1.default.createElement(designers_1.TransformDesigner, { config: component, data: options }));
        case components.designerInput:
            return () => (react_1.default.createElement(designers_1.DesignerInput, { config: component, data: options }));
        case components.datePicker:
            return () => (react_1.default.createElement(core_1.DatePicker, { config: component, data: options }));
        default:
            return next({ component, options });
    }
};
exports.coreComponentMiddleware = coreComponentMiddleware;


/***/ }),

/***/ "./src/middleware/index.ts":
/*!*********************************!*\
  !*** ./src/middleware/index.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./core-component-middleware.fn */ "./src/middleware/core-component-middleware.fn.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./component-middleware-ids.const */ "./src/middleware/component-middleware-ids.const.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./core-activity-middleware.fn */ "./src/middleware/core-activity-middleware.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./core-attachment-middleware.fn */ "./src/middleware/core-attachment-middleware.fn.tsx"), exports);


/***/ }),

/***/ "./src/models/card-list-item-props.interface.ts":
/*!******************************************************!*\
  !*** ./src/models/card-list-item-props.interface.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/index.ts":
/*!*****************************!*\
  !*** ./src/models/index.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ICommentSchema = exports.IOutlookSummariser = exports.ICalendarSchema = exports.IToDoSchema = exports.IOutlookSchema = exports.ILinkTileSchema = exports.IAdaptiveCardSchema = exports.ISlideSchema = exports.ITileSchema = exports.IThumbCardSchema = exports.SearchResultCardSchema = exports.ExtendedAdaptiveCardSchema = exports.ITimelineSchema = exports.IPersonCardSchema = exports.IDataTableRowSchema = exports.ICategoryLinkSchema = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./thumb-card.interface */ "./src/models/thumb-card.interface.ts"), exports);
var schemas_const_1 = __webpack_require__(/*! ./schemas.const */ "./src/models/schemas.const.ts");
Object.defineProperty(exports, "ICategoryLinkSchema", ({ enumerable: true, get: function () { return schemas_const_1.ICategoryLinkSchema; } }));
Object.defineProperty(exports, "IDataTableRowSchema", ({ enumerable: true, get: function () { return schemas_const_1.IDataTableRowSchema; } }));
Object.defineProperty(exports, "IPersonCardSchema", ({ enumerable: true, get: function () { return schemas_const_1.IPersonCardSchema; } }));
Object.defineProperty(exports, "ITimelineSchema", ({ enumerable: true, get: function () { return schemas_const_1.ITimelineSchema; } }));
Object.defineProperty(exports, "ExtendedAdaptiveCardSchema", ({ enumerable: true, get: function () { return schemas_const_1.ExtendedAdaptiveCardSchema; } }));
Object.defineProperty(exports, "SearchResultCardSchema", ({ enumerable: true, get: function () { return schemas_const_1.SearchResultCardSchema; } }));
Object.defineProperty(exports, "IThumbCardSchema", ({ enumerable: true, get: function () { return schemas_const_1.IThumbCardSchema; } }));
Object.defineProperty(exports, "ITileSchema", ({ enumerable: true, get: function () { return schemas_const_1.ITileSchema; } }));
Object.defineProperty(exports, "ISlideSchema", ({ enumerable: true, get: function () { return schemas_const_1.ISlideSchema; } }));
Object.defineProperty(exports, "IAdaptiveCardSchema", ({ enumerable: true, get: function () { return schemas_const_1.IAdaptiveCardSchema; } }));
Object.defineProperty(exports, "ILinkTileSchema", ({ enumerable: true, get: function () { return schemas_const_1.ILinkTileSchema; } }));
Object.defineProperty(exports, "IOutlookSchema", ({ enumerable: true, get: function () { return schemas_const_1.IOutlookSchema; } }));
Object.defineProperty(exports, "IToDoSchema", ({ enumerable: true, get: function () { return schemas_const_1.IToDoSchema; } }));
Object.defineProperty(exports, "ICalendarSchema", ({ enumerable: true, get: function () { return schemas_const_1.ICalendarSchema; } }));
Object.defineProperty(exports, "IOutlookSummariser", ({ enumerable: true, get: function () { return schemas_const_1.IOutlookSummariser; } }));
Object.defineProperty(exports, "ICommentSchema", ({ enumerable: true, get: function () { return schemas_const_1.ICommentSchema; } }));
tslib_1.__exportStar(__webpack_require__(/*! ./card-list-item-props.interface */ "./src/models/card-list-item-props.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./tag.interface */ "./src/models/tag.interface.ts"), exports);


/***/ }),

/***/ "./src/models/schemas.const.ts":
/*!*************************************!*\
  !*** ./src/models/schemas.const.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ICommentSchema = exports.IOutlookSummariser = exports.ICalendarSchema = exports.ICategoryLinkSchema = exports.ISlideSchema = exports.IDataTableRowSchema = exports.SearchResultCardSchema = exports.ExtendedAdaptiveCardSchema = exports.IPersonCardSchema = exports.ITimelineSchema = exports.IThumbCardSchema = exports.IToDoSchema = exports.IOutlookSchema = exports.ILinkTileSchema = exports.ITileSchema = exports.IAdaptiveCardSchema = void 0;
exports.IAdaptiveCardSchema = "http://adaptivecards.io/schemas/adaptive-card.json";
exports.ITileSchema = "https://ics.ai/smarthub/tile";
exports.ILinkTileSchema = "https://ics.ai/smarthub/link-tile";
exports.IOutlookSchema = "https://ics.ai/smarthub/outlook";
exports.IToDoSchema = "https://ics.ai/smarthub/todo";
exports.IThumbCardSchema = "https://ics.ai/smarthub/thumb-card";
exports.ITimelineSchema = "https://ics.ai/smarthub/timeline";
exports.IPersonCardSchema = "https://ics.ai/smarthub/component/person";
exports.ExtendedAdaptiveCardSchema = "https://ics.ai/smarthub/chat-card";
exports.SearchResultCardSchema = "https://ics.ai/smarthub/chat-search-result-card";
exports.IDataTableRowSchema = "https://ics.ai/intranet/table-row";
exports.ISlideSchema = "https://ics.ai/smarthub/slide";
exports.ICategoryLinkSchema = "https://ics.ai/smarthub/category/link";
exports.ICalendarSchema = "https://ics.ai/smarthub/event-card";
exports.IOutlookSummariser = "https://ics.ai/smarthub/summariser";
exports.ICommentSchema = "https://ics.ai/smarthub/comment";


/***/ }),

/***/ "./src/models/tag.interface.ts":
/*!*************************************!*\
  !*** ./src/models/tag.interface.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/thumb-card.interface.ts":
/*!********************************************!*\
  !*** ./src/models/thumb-card.interface.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/utilities/action-link/action-link.component.tsx":
/*!*************************************************************!*\
  !*** ./src/utilities/action-link/action-link.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ActionLink = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const action_to_uri_helper_1 = __webpack_require__(/*! ./action-to-uri.helper */ "./src/utilities/action-link/action-to-uri.helper.ts");
const useStyles = react_jss_1.createUseStyles(({ palette }) => ({
    text: (colour) => {
        return {
            color: (colour === null || colour === void 0 ? void 0 : colour.length) ? palette[colour]
                : undefined,
        };
    },
    header: {
        padding: "0",
        margin: "0",
        display: 'inline'
    },
}));
const defaultLevel = 'h3';
const ActionLink = (_a) => {
    var { headerLevel, action, colour, className } = _a, rest = tslib_1.__rest(_a, ["headerLevel", "action", "colour", "className"]);
    const openAction = smarthub_common_1.useHandleCommand();
    const registerLastFocus = smarthub_common_1.useRegisterLastAction();
    const styles = useStyles(colour);
    const linkRef = react_1.useRef();
    const currentType = smarthub_common_1.usePanelType();
    const registerFocusCallback = react_1.useCallback(() => {
        registerLastFocus(currentType, () => {
            linkRef.current.focus();
        });
    }, []);
    const onClick = react_1.useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        openAction(action);
        registerFocusCallback();
    }, [action]);
    const url = action_to_uri_helper_1.actionToUri(action);
    const { uri } = action;
    const { target = '_blank' } = action;
    const link = react_1.default.createElement(react_2.Link, Object.assign({ componentRef: linkRef, className: [styles.text, className].join(' ') }, rest, { href: target != '_blank' ? uri : url, onClick: onClick }));
    if (headerLevel === false)
        return link;
    const HeaderTag = typeof headerLevel === 'string' && headerLevel.length
        ? headerLevel
        : defaultLevel;
    return react_1.default.createElement(HeaderTag, { className: styles.header }, link);
};
exports.ActionLink = ActionLink;


/***/ }),

/***/ "./src/utilities/action-link/action-to-uri.helper.ts":
/*!***********************************************************!*\
  !*** ./src/utilities/action-link/action-to-uri.helper.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.actionToUri = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const query_string_1 = tslib_1.__importDefault(__webpack_require__(/*! query-string */ "query-string"));
const flatten = (obj, flat, keyPath) => {
    const keys = Object.keys(obj);
    flat = flat !== null && flat !== void 0 ? flat : {};
    keyPath = keyPath !== null && keyPath !== void 0 ? keyPath : '';
    keys
        .sort()
        .forEach(key => {
        const value = obj[key];
        const flatKey = `${keyPath}${keyPath.length ? '.' : ''}${key}`;
        if (value && typeof value == 'object')
            flatten(value, flat, flatKey);
        else if (value && (typeof value != 'string' || value.length > 0))
            flat[flatKey] = value;
    });
    return flat;
};
const schemaPrefix = `${smarthub_common_1.ActionSchema}/`;
const actionToUri = (action) => {
    const prefix = './#';
    if (!action || !Object.keys(action).length)
        return prefix;
    let { $schema } = action, rest = tslib_1.__rest(action, ["$schema"]);
    if (!$schema.length)
        $schema = smarthub_common_1.RouteActionSchema;
    else if ($schema.startsWith(schemaPrefix))
        $schema = $schema.substring(schemaPrefix.length);
    const $action = Object.assign(Object.assign({}, rest), { $schema });
    const flat = flatten({ $action });
    const serialised = query_string_1.default.stringify(flat, { encode: true });
    return serialised.length
        ? `${prefix}?${serialised}`
        : prefix;
};
exports.actionToUri = actionToUri;


/***/ }),

/***/ "./src/utilities/action-link/index.ts":
/*!********************************************!*\
  !*** ./src/utilities/action-link/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./action-link.component */ "./src/utilities/action-link/action-link.component.tsx"), exports);


/***/ }),

/***/ "./src/utilities/bookmark/bookmark.component.tsx":
/*!*******************************************************!*\
  !*** ./src/utilities/bookmark/bookmark.component.tsx ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Bookmark = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
exports.Bookmark = react_1.forwardRef(({ title, bookmarkInfo, className }, ref) => {
    const [bookmark, toggle] = smarthub_common_1.useBookmark(bookmarkInfo);
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const handleBookmark = (e) => {
        e.stopPropagation();
        toggle();
    };
    return react_1.default.createElement("div", { className: className, ref: ref },
        react_1.default.createElement(react_2.IconButton, { ariaLabel: bookmark ? `${localizeConfig.unbookmark} ${title}` : `${localizeConfig.bookmark} ${title}`, onClick: (e) => handleBookmark(e) },
            react_1.default.createElement(react_2.Icon, { iconName: bookmark ? "SingleBookmarkSolid" : "SingleBookmark" })));
});


/***/ }),

/***/ "./src/utilities/bookmark/index.ts":
/*!*****************************************!*\
  !*** ./src/utilities/bookmark/index.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./bookmark.component */ "./src/utilities/bookmark/bookmark.component.tsx"), exports);


/***/ }),

/***/ "./src/utilities/coach-mark-wrapper/coach-mark-wrapper.component.tsx":
/*!***************************************************************************!*\
  !*** ./src/utilities/coach-mark-wrapper/coach-mark-wrapper.component.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CoachMarkWrapper = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_visibility_sensor_1 = tslib_1.__importDefault(__webpack_require__(/*! react-visibility-sensor */ "react-visibility-sensor"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const styles = {
    entityInnerHost: {
        minWidth: "300px"
    }
};
const CoachMarkWrapper = ({ name, position, children, cacheLevel, version, className, doNotLayer = true }) => {
    const ref = react_1.useRef(null);
    const [showCoachMark, setShowCoachMark] = react_1.useState(false);
    const localiseConfig = smarthub_common_1.useLocalizeConfig();
    const [coachMarks, setCoachMarks] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys.coachMarks, true, [], cacheLevel);
    const coachMark = coachMarks === null || coachMarks === void 0 ? void 0 : coachMarks.find(({ name: n, version: v }) => n == name && v == version);
    const hideCoachmark = react_1.useCallback(() => {
        setCoachMarks([
            ...coachMarks.filter(({ name: n }) => n != name),
            {
                name, version
            }
        ]);
    }, [coachMarks]);
    const directionalHint = typeof position == 'string' ? react_2.DirectionalHint[position] : position;
    const onVisibilityChange = react_1.useCallback((isVisible) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        setShowCoachMark(isVisible);
    }), []);
    const child = !coachMark
        ? react_1.Children.only(children)
        : null;
    const content = !coachMark
        ? react_1.cloneElement(child, Object.assign(Object.assign({}, child.props), { ref }))
        : null;
    return react_1.default.createElement(react_1.default.Fragment, null, !coachMark
        ? react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_visibility_sensor_1.default, { onChange: onVisibilityChange }, content),
            showCoachMark && react_1.default.createElement(react_2.Coachmark, { preventFocusOnMount: true, target: ref.current, positioningContainerProps: {
                    directionalHint,
                    doNotLayer: doNotLayer
                }, className: className, styles: styles, ariaAlertText: localiseConfig[`${name}CoachAlert`], ariaDescribedBy: `${name}-coach-desc`, ariaLabelledBy: `${name}-coach-label`, ariaDescribedByText: localiseConfig[`${name}CoachDesc`], ariaLabelledByText: localiseConfig[`${name}CoachLabel`] },
                react_1.default.createElement(react_2.TeachingBubbleContent, { headline: localiseConfig[`${name}CoachTitle`], hasCloseButton: true, isWide: true, closeButtonAriaLabel: localiseConfig.hideCoachMark, onDismiss: hideCoachmark, ariaDescribedBy: `${name}-bubble-desc`, ariaLabelledBy: `${name}-bubble-label` }, localiseConfig[`${name}CoachText`])))
        : children);
};
exports.CoachMarkWrapper = CoachMarkWrapper;


/***/ }),

/***/ "./src/utilities/coach-mark-wrapper/index.ts":
/*!***************************************************!*\
  !*** ./src/utilities/coach-mark-wrapper/index.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./coach-mark-wrapper.component */ "./src/utilities/coach-mark-wrapper/coach-mark-wrapper.component.tsx"), exports);


/***/ }),

/***/ "./src/utilities/delay-item/delay-item.component.tsx":
/*!***********************************************************!*\
  !*** ./src/utilities/delay-item/delay-item.component.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DelayItem = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const DelayItem = ({ index = 1, delay, children }) => {
    const [show, setShow] = react_1.useState(false);
    react_1.useEffect(() => {
        const id = setTimeout(() => setShow(true), index * delay);
        return () => clearTimeout(id);
    }, []);
    return show ? children : null;
};
exports.DelayItem = DelayItem;


/***/ }),

/***/ "./src/utilities/delay-item/index.ts":
/*!*******************************************!*\
  !*** ./src/utilities/delay-item/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./delay-item.component */ "./src/utilities/delay-item/delay-item.component.tsx"), exports);


/***/ }),

/***/ "./src/utilities/error-box/error-box.component.tsx":
/*!*********************************************************!*\
  !*** ./src/utilities/error-box/error-box.component.tsx ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ErrorBox = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const ErrorBox = ({ error: { message, description } }) => {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", null, "An error has occurred."),
        (message === null || message === void 0 ? void 0 : message.length) > 0 && react_1.default.createElement("div", null, message),
        (description === null || description === void 0 ? void 0 : description.length) > 0 && react_1.default.createElement("div", null, description)));
};
exports.ErrorBox = ErrorBox;


/***/ }),

/***/ "./src/utilities/error-box/index.ts":
/*!******************************************!*\
  !*** ./src/utilities/error-box/index.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./error-box.component */ "./src/utilities/error-box/error-box.component.tsx"), exports);


/***/ }),

/***/ "./src/utilities/index.ts":
/*!********************************!*\
  !*** ./src/utilities/index.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./action-link */ "./src/utilities/action-link/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./bookmark */ "./src/utilities/bookmark/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./delay-item */ "./src/utilities/delay-item/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./error-box */ "./src/utilities/error-box/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./info-box */ "./src/utilities/info-box/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./no-results */ "./src/utilities/no-results/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./tag */ "./src/utilities/tag/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./text-overflow */ "./src/utilities/text-overflow/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./theme-image */ "./src/utilities/theme-image/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./coach-mark-wrapper */ "./src/utilities/coach-mark-wrapper/index.ts"), exports);


/***/ }),

/***/ "./src/utilities/info-box/index.ts":
/*!*****************************************!*\
  !*** ./src/utilities/info-box/index.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./info-box.component */ "./src/utilities/info-box/info-box.component.tsx"), exports);


/***/ }),

/***/ "./src/utilities/info-box/info-box.component.tsx":
/*!*******************************************************!*\
  !*** ./src/utilities/info-box/info-box.component.tsx ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InfoBox = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const React = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const InfoBox = ({ message, details, children }) => {
    return (React.createElement("div", null,
        React.createElement("div", null, message),
        (details === null || details === void 0 ? void 0 : details.length) > 0 && React.createElement("div", null, details),
        React.createElement("div", null, children)));
};
exports.InfoBox = InfoBox;


/***/ }),

/***/ "./src/utilities/no-results/index.ts":
/*!*******************************************!*\
  !*** ./src/utilities/no-results/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./no-results.component */ "./src/utilities/no-results/no-results.component.tsx"), exports);


/***/ }),

/***/ "./src/utilities/no-results/no-results.component.tsx":
/*!***********************************************************!*\
  !*** ./src/utilities/no-results/no-results.component.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NoResults = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing, sizes }) => ({
    wrapper: {
        maxWidth: "100%",
        maxHeight: "100%",
        padding: spacing.medium,
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    title: Object.assign(Object.assign({}, fonts.superLarge), { color: palette.primary }),
    description: Object.assign(Object.assign({}, fonts.medium), { color: palette.neutralEmptyOn }),
    cloud: {
        maxWidth: `calc(${sizes.mega} * 3)`,
        fill: palette.primaryMinus3
    }
}));
const NoResults = (props) => {
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const { show = true, title = localizeConfig.noResultsTitle, description = localizeConfig.noResultsDescription } = props !== null && props !== void 0 ? props : {};
    const styles = useStyles();
    return (show
        ? react_1.default.createElement("div", { className: styles.wrapper },
            react_1.default.createElement("svg", { viewBox: "0 0 480 300", className: styles.cloud },
                react_1.default.createElement("path", { d: "M 179.32617 10.005859 C 171.67594 10.081205 163.91978 10.850578 156.13672 12.345703 C 117.1555 19.833988 84.534191 46.058853 69.691406 81.84375 C 64.232056 95.005867 61.705546 107.27721 61.158203 123.29883 L 60.853516 132.24219 L 58.929688 132.95508 C 56.15698 133.98042 47.467491 139.0654 43.285156 142.11133 C 38.716236 145.4388 33.045525 150.67877 29.292969 155.04102 C 5.0127755 183.26613 3.4795846 225.86105 25.660156 255.92188 C 39.379166 274.51494 61.104609 286.90333 84.648438 289.55859 C 89.719626 290.13057 389.62664 290.15318 394.7793 289.58203 C 431.48207 285.5137 460.49794 260.0922 468.10547 225.33789 C 475.16564 193.08425 462.15154 160.2571 434.73242 141.15625 C 432.40681 139.53619 427.51862 136.76105 423.86914 134.98828 L 417.23438 131.76562 L 416.17773 127.60547 C 414.10301 119.43153 409.87951 109.7461 405.2168 102.46875 C 389.93552 78.618149 364.86859 63.315177 335.63086 59.988281 C 328.22685 59.145806 314.36344 59.701594 307.38086 61.123047 C 300.68837 62.485448 293.42478 64.854536 288.32031 67.337891 C 286.30167 68.319968 284.56237 69.123047 284.45703 69.123047 C 284.35165 69.123047 282.81474 66.85717 281.04102 64.087891 C 258.82295 29.399162 220.63748 9.5989923 179.32617 10.005859 z M 236.63672 98.6875 C 242.35652 98.6875 247.7677 99.290567 252.86914 100.49414 C 258.12518 101.54727 262.76388 103.50284 266.7832 106.36133 C 270.80253 109.06936 273.97022 112.83024 276.28906 117.64453 C 278.76249 122.45882 280 128.55195 280 135.92383 C 280 140.43722 279.53691 144.49866 278.60938 148.10938 C 277.68184 151.72009 276.29062 155.10429 274.43555 158.26367 C 272.73507 161.2726 270.64726 164.1318 268.17383 166.83984 C 265.7004 169.39743 262.99579 172.03024 260.05859 174.73828 C 255.5755 178.64989 252.01864 181.95993 249.39062 184.66797 C 246.76261 187.22556 244.67675 189.70809 243.13086 192.11523 C 241.58497 194.52238 240.50312 197.07907 239.88477 199.78711 C 239.26641 202.49515 238.8792 205.95546 238.72461 210.16797 L 226.89844 210.16797 C 222.41535 210.16797 220.17383 206.40709 220.17383 198.88477 C 220.17383 195.42449 220.56104 192.34085 221.33398 189.63281 C 222.10693 186.92477 223.26661 184.29197 224.8125 181.73438 C 226.51298 179.17678 228.59884 176.62009 231.07227 174.0625 C 233.70028 171.35446 236.71427 168.41914 240.11523 165.25977 C 243.20702 162.40128 245.75792 159.91875 247.76758 157.8125 C 249.93183 155.5558 251.63243 153.52606 252.86914 151.7207 C 254.10586 149.7649 254.95615 147.88349 255.41992 146.07812 C 256.03828 144.12232 256.34766 141.86619 256.34766 139.30859 C 256.34766 131.93671 254.2618 126.74526 250.08789 123.73633 C 246.06857 120.57695 239.72926 118.99805 231.07227 118.99805 C 225.35246 118.99805 220.09695 119.44888 215.30469 120.35156 C 210.51242 121.1038 207.03339 121.48047 204.86914 121.48047 C 202.85948 121.48047 201.54609 121.02963 200.92773 120.12695 C 200.30938 119.22427 200 117.94593 200 116.29102 L 200 105.23242 C 204.48309 103.57751 209.7386 102.07277 215.76758 100.71875 C 221.95115 99.364731 228.90726 98.6875 236.63672 98.6875 z M 231.53711 230.02734 C 236.94773 230.02734 240.8879 231.15541 243.36133 233.41211 C 245.83476 235.51836 247.07227 239.12896 247.07227 244.24414 C 247.07227 249.50977 245.83476 253.2726 243.36133 255.5293 C 240.8879 257.63555 236.94773 258.6875 231.53711 258.6875 C 225.9719 258.6875 221.95194 257.63555 219.47852 255.5293 C 217.15968 253.2726 216 249.50977 216 244.24414 C 216 239.12896 217.23751 235.51836 219.71094 233.41211 C 222.18437 231.15541 226.12648 230.02734 231.53711 230.02734 z " })),
            react_1.default.createElement("div", { className: styles.title }, title),
            react_1.default.createElement("div", { className: styles.description }, description))
        : null);
};
exports.NoResults = NoResults;


/***/ }),

/***/ "./src/utilities/tag/index.ts":
/*!************************************!*\
  !*** ./src/utilities/tag/index.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./tag.component */ "./src/utilities/tag/tag.component.tsx"), exports);


/***/ }),

/***/ "./src/utilities/tag/tag.component.tsx":
/*!*********************************************!*\
  !*** ./src/utilities/tag/tag.component.tsx ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Tag = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const text_overflow_component_1 = __webpack_require__(/*! ../text-overflow/text-overflow.component */ "./src/utilities/text-overflow/text-overflow.component.tsx");
const useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing }) => ({
    rootStyle: ({ width }) => ({
        width: width == 'fill'
            ? "100%"
            : "auto",
        display: width == 'fill'
            ? "block"
            : "inline-block",
    }),
    innerStyle: {
        display: "flex",
        gap: spacing.smallPlus,
        alignItems: "start",
        width: "100%",
        maxWidth: "100%",
    },
    textStyle: Object.assign(Object.assign({}, fonts.small), { color: palette.neutralMinus3On })
}));
const Tag = (props) => {
    const { tagInfo: { label, text, icon } = {}, width } = props;
    const { rootStyle, innerStyle, textStyle } = useStyles(props);
    return (react_1.default.createElement("div", { className: rootStyle },
        react_1.default.createElement("div", { className: innerStyle },
            icon && react_1.default.createElement(react_2.Icon, { "aria-hidden": true, iconName: icon, title: text }),
            react_1.default.createElement(text_overflow_component_1.TextOverflow, { lines: 2, label: label, className: textStyle, fixed: width == 'fill', text: text }))));
};
exports.Tag = Tag;


/***/ }),

/***/ "./src/utilities/text-overflow/index.ts":
/*!**********************************************!*\
  !*** ./src/utilities/text-overflow/index.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./text-overflow.component */ "./src/utilities/text-overflow/text-overflow.component.tsx"), exports);


/***/ }),

/***/ "./src/utilities/text-overflow/text-overflow.component.tsx":
/*!*****************************************************************!*\
  !*** ./src/utilities/text-overflow/text-overflow.component.tsx ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TextOverflow = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const useStyles = react_jss_1.createUseStyles(({ palette, fonts }) => ({
    text: ({ lines, colour, fixed, font }) => {
        const textFont = (font === null || font === void 0 ? void 0 : font.length) ? fonts[font]
            : fonts.normal;
        return Object.assign(Object.assign({}, textFont), { lineHeight: `calc(${textFont.fontSize} * 1.3)`, height: fixed
                ? `calc(${lines} * (${textFont.fontSize} * 1.3))`
                : 'auto', overflow: "hidden", color: (colour === null || colour === void 0 ? void 0 : colour.length) ? palette[colour]
                : undefined, whiteSpace: "normal", wordWrap: "normal", "-webkit-line-clamp": lines, display: "-webkit-box", "-webkit-box-orient": "vertical" });
    }
}));
const TextOverflow = (props) => {
    const { text, showTooltip, toolTipDir, className, children, label } = props;
    const styles = useStyles(props);
    const focusStyle = smarthub_common_1.useFocusStyles();
    return showTooltip
        ? react_1.default.createElement(react_2.TooltipHost, { overflowMode: react_2.TooltipOverflowMode.Self, hostClassName: [styles.text, focusStyle.focus, className ? className : ''].join(" "), content: text, directionalHint: toolTipDir !== null && toolTipDir !== void 0 ? toolTipDir : react_2.DirectionalHint.topCenter },
            react_1.default.createElement("div", { "data-is-focusable": true, "aria-label": label }, children ? children : text))
        : react_1.default.createElement("div", { className: [styles.text, focusStyle.focus, className ? className : ''].join(" "), "data-is-focusable": true, "aria-label": label }, children ? children : text);
};
exports.TextOverflow = TextOverflow;


/***/ }),

/***/ "./src/utilities/theme-image/index.ts":
/*!********************************************!*\
  !*** ./src/utilities/theme-image/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./theme-image.component */ "./src/utilities/theme-image/theme-image.component.tsx"), exports);


/***/ }),

/***/ "./src/utilities/theme-image/theme-image.component.tsx":
/*!*************************************************************!*\
  !*** ./src/utilities/theme-image/theme-image.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ThemeImage = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles({
    image: {
        maxHeight: "100%"
    }
});
const sizes = {
    small: "S",
    medium: "M",
    large: "L",
    default: "L"
};
const parseUri = ({ image, defaultSize, defaultPalette }, theme) => {
    if (typeof image == 'string')
        return theme.image[image];
    const { name, definition: { prefix, size, palette } = {}, uri } = image;
    let imageUri;
    if (prefix === null || prefix === void 0 ? void 0 : prefix.length)
        imageUri = theme.image[`${prefix}On${(palette === null || palette === void 0 ? void 0 : palette.length) ? palette : defaultPalette}${sizes[(size === null || size === void 0 ? void 0 : size.length) ? size : defaultSize]}`];
    if (!imageUri && (name === null || name === void 0 ? void 0 : name.length))
        imageUri = theme.image[name];
    if (!imageUri && (uri === null || uri === void 0 ? void 0 : uri.length))
        imageUri = uri;
    return imageUri;
};
const ThemeImage = (props) => {
    const { image, alt, className } = props;
    const { definition: theme } = smarthub_common_1.useTheme();
    const styles = useStyles();
    const uri = parseUri(props, theme);
    const altText = typeof image == "object"
        ? image.text
        : alt;
    return react_1.default.createElement("img", { alt: altText, title: altText, src: uri, className: [styles.image, className !== null && className !== void 0 ? className : ''].join(' ') });
};
exports.ThemeImage = ThemeImage;


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/index.js":
/*!****************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/index.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useBoolean": () => (/* reexport safe */ _useBoolean_useBoolean__WEBPACK_IMPORTED_MODULE_0__["default"]),
/* harmony export */   "useClickAnyWhere": () => (/* reexport safe */ _useClickAnyWhere_useClickAnyWhere__WEBPACK_IMPORTED_MODULE_1__["default"]),
/* harmony export */   "useCopyToClipboard": () => (/* reexport safe */ _useCopyToClipboard_useCopyToClipboard__WEBPACK_IMPORTED_MODULE_2__["default"]),
/* harmony export */   "useCountdown": () => (/* reexport safe */ _useCountdown_useCountdown__WEBPACK_IMPORTED_MODULE_3__["default"]),
/* harmony export */   "useCounter": () => (/* reexport safe */ _useCounter_useCounter__WEBPACK_IMPORTED_MODULE_4__["default"]),
/* harmony export */   "useDarkMode": () => (/* reexport safe */ _useDarkMode_useDarkMode__WEBPACK_IMPORTED_MODULE_5__["default"]),
/* harmony export */   "useDebounce": () => (/* reexport safe */ _useDebounce_useDebounce__WEBPACK_IMPORTED_MODULE_6__["default"]),
/* harmony export */   "useDocumentTitle": () => (/* reexport safe */ _useDocumentTitle_useDocumentTitle__WEBPACK_IMPORTED_MODULE_7__["default"]),
/* harmony export */   "useEffectOnce": () => (/* reexport safe */ _useEffectOnce_useEffectOnce__WEBPACK_IMPORTED_MODULE_8__["default"]),
/* harmony export */   "useElementSize": () => (/* reexport safe */ _useElementSize_useElementSize__WEBPACK_IMPORTED_MODULE_9__["default"]),
/* harmony export */   "useEventCallback": () => (/* reexport safe */ _useEventCallback_useEventCallback__WEBPACK_IMPORTED_MODULE_10__["default"]),
/* harmony export */   "useEventListener": () => (/* reexport safe */ _useEventListener_useEventListener__WEBPACK_IMPORTED_MODULE_11__["default"]),
/* harmony export */   "useFetch": () => (/* reexport safe */ _useFetch_useFetch__WEBPACK_IMPORTED_MODULE_12__["default"]),
/* harmony export */   "useHover": () => (/* reexport safe */ _useHover_useHover__WEBPACK_IMPORTED_MODULE_13__["default"]),
/* harmony export */   "useImageOnLoad": () => (/* reexport safe */ _useImageOnLoad_useImageOnLoad__WEBPACK_IMPORTED_MODULE_14__["default"]),
/* harmony export */   "useIntersectionObserver": () => (/* reexport safe */ _useIntersectionObserver_useIntersectionObserver__WEBPACK_IMPORTED_MODULE_15__["default"]),
/* harmony export */   "useInterval": () => (/* reexport safe */ _useInterval_useInterval__WEBPACK_IMPORTED_MODULE_16__["default"]),
/* harmony export */   "useIsClient": () => (/* reexport safe */ _useIsClient_useIsClient__WEBPACK_IMPORTED_MODULE_17__["default"]),
/* harmony export */   "useIsFirstRender": () => (/* reexport safe */ _useIsFirstRender_useIsFirstRender__WEBPACK_IMPORTED_MODULE_18__["default"]),
/* harmony export */   "useIsMounted": () => (/* reexport safe */ _useIsMounted_useIsMounted__WEBPACK_IMPORTED_MODULE_19__["default"]),
/* harmony export */   "useIsomorphicLayoutEffect": () => (/* reexport safe */ _useIsomorphicLayoutEffect_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_20__["default"]),
/* harmony export */   "useLocalStorage": () => (/* reexport safe */ _useLocalStorage_useLocalStorage__WEBPACK_IMPORTED_MODULE_21__["default"]),
/* harmony export */   "useLockedBody": () => (/* reexport safe */ _useLockedBody_useLockedBody__WEBPACK_IMPORTED_MODULE_22__["default"]),
/* harmony export */   "useMap": () => (/* reexport safe */ _useMap_useMap__WEBPACK_IMPORTED_MODULE_23__["default"]),
/* harmony export */   "useMediaQuery": () => (/* reexport safe */ _useMediaQuery_useMediaQuery__WEBPACK_IMPORTED_MODULE_24__["default"]),
/* harmony export */   "useOnClickOutside": () => (/* reexport safe */ _useOnClickOutside_useOnClickOutside__WEBPACK_IMPORTED_MODULE_25__["default"]),
/* harmony export */   "useReadLocalStorage": () => (/* reexport safe */ _useReadLocalStorage_useReadLocalStorage__WEBPACK_IMPORTED_MODULE_26__["default"]),
/* harmony export */   "useScreen": () => (/* reexport safe */ _useScreen_useScreen__WEBPACK_IMPORTED_MODULE_27__["default"]),
/* harmony export */   "useScript": () => (/* reexport safe */ _useScript_useScript__WEBPACK_IMPORTED_MODULE_28__["default"]),
/* harmony export */   "useSessionStorage": () => (/* reexport safe */ _useSessionStorage_useSessionStorage__WEBPACK_IMPORTED_MODULE_29__["default"]),
/* harmony export */   "useSsr": () => (/* reexport safe */ _useSsr_useSsr__WEBPACK_IMPORTED_MODULE_30__["default"]),
/* harmony export */   "useStep": () => (/* reexport safe */ _useStep_useStep__WEBPACK_IMPORTED_MODULE_31__["default"]),
/* harmony export */   "useTernaryDarkMode": () => (/* reexport safe */ _useTernaryDarkMode_useTernaryDarkMode__WEBPACK_IMPORTED_MODULE_32__["default"]),
/* harmony export */   "useTimeout": () => (/* reexport safe */ _useTimeout_useTimeout__WEBPACK_IMPORTED_MODULE_33__["default"]),
/* harmony export */   "useToggle": () => (/* reexport safe */ _useToggle_useToggle__WEBPACK_IMPORTED_MODULE_34__["default"]),
/* harmony export */   "useUpdateEffect": () => (/* reexport safe */ _useUpdateEffect_useUpdateEffect__WEBPACK_IMPORTED_MODULE_35__["default"]),
/* harmony export */   "useWindowSize": () => (/* reexport safe */ _useWindowSize_useWindowSize__WEBPACK_IMPORTED_MODULE_36__["default"])
/* harmony export */ });
/* harmony import */ var _useBoolean_useBoolean__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./useBoolean/useBoolean */ "./node_modules/usehooks-ts/dist/esm/useBoolean/useBoolean.js");
/* harmony import */ var _useClickAnyWhere_useClickAnyWhere__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./useClickAnyWhere/useClickAnyWhere */ "./node_modules/usehooks-ts/dist/esm/useClickAnyWhere/useClickAnyWhere.js");
/* harmony import */ var _useCopyToClipboard_useCopyToClipboard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./useCopyToClipboard/useCopyToClipboard */ "./node_modules/usehooks-ts/dist/esm/useCopyToClipboard/useCopyToClipboard.js");
/* harmony import */ var _useCountdown_useCountdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./useCountdown/useCountdown */ "./node_modules/usehooks-ts/dist/esm/useCountdown/useCountdown.js");
/* harmony import */ var _useCounter_useCounter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./useCounter/useCounter */ "./node_modules/usehooks-ts/dist/esm/useCounter/useCounter.js");
/* harmony import */ var _useDarkMode_useDarkMode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./useDarkMode/useDarkMode */ "./node_modules/usehooks-ts/dist/esm/useDarkMode/useDarkMode.js");
/* harmony import */ var _useDebounce_useDebounce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./useDebounce/useDebounce */ "./node_modules/usehooks-ts/dist/esm/useDebounce/useDebounce.js");
/* harmony import */ var _useDocumentTitle_useDocumentTitle__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./useDocumentTitle/useDocumentTitle */ "./node_modules/usehooks-ts/dist/esm/useDocumentTitle/useDocumentTitle.js");
/* harmony import */ var _useEffectOnce_useEffectOnce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./useEffectOnce/useEffectOnce */ "./node_modules/usehooks-ts/dist/esm/useEffectOnce/useEffectOnce.js");
/* harmony import */ var _useElementSize_useElementSize__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./useElementSize/useElementSize */ "./node_modules/usehooks-ts/dist/esm/useElementSize/useElementSize.js");
/* harmony import */ var _useEventCallback_useEventCallback__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./useEventCallback/useEventCallback */ "./node_modules/usehooks-ts/dist/esm/useEventCallback/useEventCallback.js");
/* harmony import */ var _useEventListener_useEventListener__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./useEventListener/useEventListener */ "./node_modules/usehooks-ts/dist/esm/useEventListener/useEventListener.js");
/* harmony import */ var _useFetch_useFetch__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./useFetch/useFetch */ "./node_modules/usehooks-ts/dist/esm/useFetch/useFetch.js");
/* harmony import */ var _useHover_useHover__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./useHover/useHover */ "./node_modules/usehooks-ts/dist/esm/useHover/useHover.js");
/* harmony import */ var _useImageOnLoad_useImageOnLoad__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./useImageOnLoad/useImageOnLoad */ "./node_modules/usehooks-ts/dist/esm/useImageOnLoad/useImageOnLoad.js");
/* harmony import */ var _useIntersectionObserver_useIntersectionObserver__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./useIntersectionObserver/useIntersectionObserver */ "./node_modules/usehooks-ts/dist/esm/useIntersectionObserver/useIntersectionObserver.js");
/* harmony import */ var _useInterval_useInterval__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./useInterval/useInterval */ "./node_modules/usehooks-ts/dist/esm/useInterval/useInterval.js");
/* harmony import */ var _useIsClient_useIsClient__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./useIsClient/useIsClient */ "./node_modules/usehooks-ts/dist/esm/useIsClient/useIsClient.js");
/* harmony import */ var _useIsFirstRender_useIsFirstRender__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./useIsFirstRender/useIsFirstRender */ "./node_modules/usehooks-ts/dist/esm/useIsFirstRender/useIsFirstRender.js");
/* harmony import */ var _useIsMounted_useIsMounted__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./useIsMounted/useIsMounted */ "./node_modules/usehooks-ts/dist/esm/useIsMounted/useIsMounted.js");
/* harmony import */ var _useIsomorphicLayoutEffect_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./useIsomorphicLayoutEffect/useIsomorphicLayoutEffect */ "./node_modules/usehooks-ts/dist/esm/useIsomorphicLayoutEffect/useIsomorphicLayoutEffect.js");
/* harmony import */ var _useLocalStorage_useLocalStorage__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./useLocalStorage/useLocalStorage */ "./node_modules/usehooks-ts/dist/esm/useLocalStorage/useLocalStorage.js");
/* harmony import */ var _useLockedBody_useLockedBody__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./useLockedBody/useLockedBody */ "./node_modules/usehooks-ts/dist/esm/useLockedBody/useLockedBody.js");
/* harmony import */ var _useMap_useMap__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./useMap/useMap */ "./node_modules/usehooks-ts/dist/esm/useMap/useMap.js");
/* harmony import */ var _useMediaQuery_useMediaQuery__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./useMediaQuery/useMediaQuery */ "./node_modules/usehooks-ts/dist/esm/useMediaQuery/useMediaQuery.js");
/* harmony import */ var _useOnClickOutside_useOnClickOutside__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./useOnClickOutside/useOnClickOutside */ "./node_modules/usehooks-ts/dist/esm/useOnClickOutside/useOnClickOutside.js");
/* harmony import */ var _useReadLocalStorage_useReadLocalStorage__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./useReadLocalStorage/useReadLocalStorage */ "./node_modules/usehooks-ts/dist/esm/useReadLocalStorage/useReadLocalStorage.js");
/* harmony import */ var _useScreen_useScreen__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./useScreen/useScreen */ "./node_modules/usehooks-ts/dist/esm/useScreen/useScreen.js");
/* harmony import */ var _useScript_useScript__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./useScript/useScript */ "./node_modules/usehooks-ts/dist/esm/useScript/useScript.js");
/* harmony import */ var _useSessionStorage_useSessionStorage__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./useSessionStorage/useSessionStorage */ "./node_modules/usehooks-ts/dist/esm/useSessionStorage/useSessionStorage.js");
/* harmony import */ var _useSsr_useSsr__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./useSsr/useSsr */ "./node_modules/usehooks-ts/dist/esm/useSsr/useSsr.js");
/* harmony import */ var _useStep_useStep__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./useStep/useStep */ "./node_modules/usehooks-ts/dist/esm/useStep/useStep.js");
/* harmony import */ var _useTernaryDarkMode_useTernaryDarkMode__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./useTernaryDarkMode/useTernaryDarkMode */ "./node_modules/usehooks-ts/dist/esm/useTernaryDarkMode/useTernaryDarkMode.js");
/* harmony import */ var _useTimeout_useTimeout__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./useTimeout/useTimeout */ "./node_modules/usehooks-ts/dist/esm/useTimeout/useTimeout.js");
/* harmony import */ var _useToggle_useToggle__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./useToggle/useToggle */ "./node_modules/usehooks-ts/dist/esm/useToggle/useToggle.js");
/* harmony import */ var _useUpdateEffect_useUpdateEffect__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./useUpdateEffect/useUpdateEffect */ "./node_modules/usehooks-ts/dist/esm/useUpdateEffect/useUpdateEffect.js");
/* harmony import */ var _useWindowSize_useWindowSize__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./useWindowSize/useWindowSize */ "./node_modules/usehooks-ts/dist/esm/useWindowSize/useWindowSize.js");












































































/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useBoolean/useBoolean.js":
/*!********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useBoolean/useBoolean.js ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useBoolean(defaultValue) {
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!!defaultValue);
    const setTrue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => setValue(true), []);
    const setFalse = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => setValue(false), []);
    const toggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => setValue(x => !x), []);
    return { value, setValue, setTrue, setFalse, toggle };
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useBoolean);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useClickAnyWhere/useClickAnyWhere.js":
/*!********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useClickAnyWhere/useClickAnyWhere.js ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");

function useClickAnyWhere(handler) {
    (0,___WEBPACK_IMPORTED_MODULE_0__.useEventListener)('click', event => {
        handler(event);
    });
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useClickAnyWhere);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useCopyToClipboard/useCopyToClipboard.js":
/*!************************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useCopyToClipboard/useCopyToClipboard.js ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

function useCopyToClipboard() {
    const [copiedText, setCopiedText] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const copy = (text) => __awaiter(this, void 0, void 0, function* () {
        if (!(navigator === null || navigator === void 0 ? void 0 : navigator.clipboard)) {
            console.warn('Clipboard not supported');
            return false;
        }
        try {
            yield navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        }
        catch (error) {
            console.warn('Copy failed', error);
            setCopiedText(null);
            return false;
        }
    });
    return [copiedText, copy];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCopyToClipboard);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useCountdown/useCountdown.js":
/*!************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useCountdown/useCountdown.js ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useCountdown(countdownOption) {
    let isDeprecated = false;
    let countStart, intervalMs, isIncrement, countStop;
    if ('seconds' in countdownOption) {
        console.warn('[useCountdown:DEPRECATED] new interface is already available (see https://usehooks-ts.com/react-hook/use-countdown), the old version will retire on usehooks-ts@3.');
        isDeprecated = true;
        countStart = countdownOption.seconds;
        intervalMs = countdownOption.interval;
        isIncrement = countdownOption.isIncrement;
    }
    else {
        ;
        ({ countStart, intervalMs, isIncrement, countStop } = countdownOption);
    }
    intervalMs = intervalMs !== null && intervalMs !== void 0 ? intervalMs : 1000;
    isIncrement = isIncrement !== null && isIncrement !== void 0 ? isIncrement : false;
    countStop = countStop !== null && countStop !== void 0 ? countStop : 0;
    const { count, increment, decrement, reset: resetCounter, } = (0,___WEBPACK_IMPORTED_MODULE_1__.useCounter)(countStart);
    const { value: isCountdownRunning, setTrue: startCountdown, setFalse: stopCountdown, } = (0,___WEBPACK_IMPORTED_MODULE_1__.useBoolean)(false);
    const resetCountdown = () => {
        stopCountdown();
        resetCounter();
    };
    const countdownCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) {
            increment();
        }
        else {
            decrement();
        }
    }, [count, countStop, decrement, increment, isIncrement, stopCountdown]);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useInterval)(countdownCallback, isCountdownRunning ? intervalMs : null);
    return isDeprecated
        ? [
            count,
            {
                start: startCountdown,
                stop: stopCountdown,
                reset: resetCountdown,
            },
        ]
        : [
            count,
            {
                startCountdown,
                stopCountdown,
                resetCountdown,
            },
        ];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCountdown);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useCounter/useCounter.js":
/*!********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useCounter/useCounter.js ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useCounter(initialValue) {
    const [count, setCount] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialValue || 0);
    const increment = () => setCount(x => x + 1);
    const decrement = () => setCount(x => x - 1);
    const reset = () => setCount(initialValue || 0);
    return {
        count,
        increment,
        decrement,
        reset,
        setCount,
    };
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCounter);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useDarkMode/useDarkMode.js":
/*!**********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useDarkMode/useDarkMode.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");

const COLOR_SCHEME_QUERY = '(prefers-color-scheme: dark)';
function useDarkMode(defaultValue) {
    var _a;
    const isDarkOS = (0,___WEBPACK_IMPORTED_MODULE_0__.useMediaQuery)(COLOR_SCHEME_QUERY);
    const [isDarkMode, setDarkMode] = (0,___WEBPACK_IMPORTED_MODULE_0__.useLocalStorage)('usehooks-ts-dark-mode', (_a = defaultValue !== null && defaultValue !== void 0 ? defaultValue : isDarkOS) !== null && _a !== void 0 ? _a : false);
    (0,___WEBPACK_IMPORTED_MODULE_0__.useUpdateEffect)(() => {
        setDarkMode(isDarkOS);
    }, [isDarkOS]);
    return {
        isDarkMode,
        toggle: () => setDarkMode(prev => !prev),
        enable: () => setDarkMode(true),
        disable: () => setDarkMode(false),
    };
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useDarkMode);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useDebounce/useDebounce.js":
/*!**********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useDebounce/useDebounce.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const timer = setTimeout(() => setDebouncedValue(value), delay || 500);
        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);
    return debouncedValue;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useDebounce);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useDocumentTitle/useDocumentTitle.js":
/*!********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useDocumentTitle/useDocumentTitle.js ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");

function useDocumentTitle(title) {
    (0,___WEBPACK_IMPORTED_MODULE_0__.useIsomorphicLayoutEffect)(() => {
        window.document.title = title;
    }, [title]);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useDocumentTitle);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useEffectOnce/useEffectOnce.js":
/*!**************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useEffectOnce/useEffectOnce.js ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useEffectOnce(effect) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(effect, []);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useEffectOnce);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useElementSize/useElementSize.js":
/*!****************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useElementSize/useElementSize.js ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useElementSize() {
    const [ref, setRef] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const [size, setSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: 0,
        height: 0,
    });
    const handleSize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        setSize({
            width: (ref === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0,
            height: (ref === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0,
        });
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('resize', handleSize);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        handleSize();
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    return [setRef, size];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useElementSize);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useEventCallback/useEventCallback.js":
/*!********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useEventCallback/useEventCallback.js ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ useEventCallback)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useEventCallback(fn) {
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(() => {
        throw new Error('Cannot call an event handler while rendering.');
    });
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        ref.current = fn;
    }, [fn]);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((...args) => ref.current(...args), [ref]);
}


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useEventListener/useEventListener.js":
/*!********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useEventListener/useEventListener.js ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useEventListener(eventName, handler, element, options) {
    const savedHandler = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(handler);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        savedHandler.current = handler;
    }, [handler]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        var _a;
        const targetElement = (_a = element === null || element === void 0 ? void 0 : element.current) !== null && _a !== void 0 ? _a : window;
        if (!(targetElement && targetElement.addEventListener))
            return;
        const listener = event => savedHandler.current(event);
        targetElement.addEventListener(eventName, listener, options);
        return () => {
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [eventName, element, options]);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useEventListener);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useFetch/useFetch.js":
/*!****************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useFetch/useFetch.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

function useFetch(url, options) {
    const cache = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const cancelRequest = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const initialState = {
        error: undefined,
        data: undefined,
    };
    const fetchReducer = (state, action) => {
        switch (action.type) {
            case 'loading':
                return Object.assign({}, initialState);
            case 'fetched':
                return Object.assign(Object.assign({}, initialState), { data: action.payload });
            case 'error':
                return Object.assign(Object.assign({}, initialState), { error: action.payload });
            default:
                return state;
        }
    };
    const [state, dispatch] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(fetchReducer, initialState);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (!url)
            return;
        cancelRequest.current = false;
        const fetchData = () => __awaiter(this, void 0, void 0, function* () {
            dispatch({ type: 'loading' });
            if (cache.current[url]) {
                dispatch({ type: 'fetched', payload: cache.current[url] });
                return;
            }
            try {
                const response = yield fetch(url, options);
                if (!response.ok) {
                    throw new Error(response.statusText);
                }
                const data = (yield response.json());
                cache.current[url] = data;
                if (cancelRequest.current)
                    return;
                dispatch({ type: 'fetched', payload: data });
            }
            catch (error) {
                if (cancelRequest.current)
                    return;
                dispatch({ type: 'error', payload: error });
            }
        });
        void fetchData();
        return () => {
            cancelRequest.current = true;
        };
    }, [url]);
    return state;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useFetch);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useHover/useHover.js":
/*!****************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useHover/useHover.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useHover(elementRef) {
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const handleMouseEnter = () => setValue(true);
    const handleMouseLeave = () => setValue(false);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('mouseenter', handleMouseEnter, elementRef);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('mouseleave', handleMouseLeave, elementRef);
    return value;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useHover);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useImageOnLoad/useImageOnLoad.js":
/*!****************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useImageOnLoad/useImageOnLoad.js ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useImageOnLoad() {
    const [isLoaded, setIsLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const handleImageOnLoad = () => {
        setIsLoaded(true);
    };
    const css = {
        thumbnail: {
            visibility: isLoaded ? 'hidden' : 'visible',
            filter: 'blur(8px)',
            transition: 'visibility 0ms ease-out 500ms',
        },
        fullSize: {
            opacity: isLoaded ? 1 : 0,
            transition: 'opacity 500ms ease-in 0ms',
        },
    };
    return { handleImageOnLoad, css };
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useImageOnLoad);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useIntersectionObserver/useIntersectionObserver.js":
/*!**********************************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useIntersectionObserver/useIntersectionObserver.js ***!
  \**********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useIntersectionObserver(elementRef, { threshold = 0, root = null, rootMargin = '0%', freezeOnceVisible = false, }) {
    const [entry, setEntry] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    const frozen = (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && freezeOnceVisible;
    const updateEntry = ([entry]) => {
        setEntry(entry);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const node = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        const hasIOSupport = !!window.IntersectionObserver;
        if (!hasIOSupport || frozen || !node)
            return;
        const observerParams = { threshold, root, rootMargin };
        const observer = new IntersectionObserver(updateEntry, observerParams);
        observer.observe(node);
        return () => observer.disconnect();
    }, [elementRef === null || elementRef === void 0 ? void 0 : elementRef.current, JSON.stringify(threshold), root, rootMargin, frozen]);
    return entry;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useIntersectionObserver);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useInterval/useInterval.js":
/*!**********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useInterval/useInterval.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useInterval(callback, delay) {
    const savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        savedCallback.current = callback;
    }, [callback]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (!delay && delay !== 0) {
            return;
        }
        const id = setInterval(() => savedCallback.current(), delay);
        return () => clearInterval(id);
    }, [delay]);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useInterval);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useIsClient/useIsClient.js":
/*!**********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useIsClient/useIsClient.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useIsClient() {
    const [isClient, setClient] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        setClient(true);
    }, []);
    return isClient;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useIsClient);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useIsFirstRender/useIsFirstRender.js":
/*!********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useIsFirstRender/useIsFirstRender.js ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useIsFirstRender() {
    const isFirst = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useIsFirstRender);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useIsMounted/useIsMounted.js":
/*!************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useIsMounted/useIsMounted.js ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useIsMounted() {
    const isMounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => isMounted.current, []);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useIsMounted);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useIsomorphicLayoutEffect/useIsomorphicLayoutEffect.js":
/*!**************************************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useIsomorphicLayoutEffect/useIsomorphicLayoutEffect.js ***!
  \**************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useIsomorphicLayoutEffect);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useLocalStorage/useLocalStorage.js":
/*!******************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useLocalStorage/useLocalStorage.js ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useLocalStorage(key, initialValue) {
    const readValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            const item = window.localStorage.getItem(key);
            return item ? parseJSON(item) : initialValue;
        }
        catch (error) {
            console.warn(`Error reading localStorage key “${key}”:`, error);
            return initialValue;
        }
    }, [initialValue, key]);
    const [storedValue, setStoredValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(readValue);
    const setValue = (0,___WEBPACK_IMPORTED_MODULE_1__.useEventCallback)(value => {
        if (typeof window === 'undefined') {
            console.warn(`Tried setting localStorage key “${key}” even though environment is not a client`);
        }
        try {
            const newValue = value instanceof Function ? value(storedValue) : value;
            window.localStorage.setItem(key, JSON.stringify(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new Event('local-storage'));
        }
        catch (error) {
            console.warn(`Error setting localStorage key “${key}”:`, error);
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((event) => {
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) {
            return;
        }
        setStoredValue(readValue());
    }, [key, readValue]);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('storage', handleStorageChange);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('local-storage', handleStorageChange);
    return [storedValue, setValue];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useLocalStorage);
function parseJSON(value) {
    try {
        return value === 'undefined' ? undefined : JSON.parse(value !== null && value !== void 0 ? value : '');
    }
    catch (_a) {
        console.log('parsing error on', { value });
        return undefined;
    }
}


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useLockedBody/useLockedBody.js":
/*!**************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useLockedBody/useLockedBody.js ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useLockedBody(initialLocked = false, rootId = '___gatsby') {
    const [locked, setLocked] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialLocked);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        if (!locked) {
            return;
        }
        const originalOverflow = document.body.style.overflow;
        const originalPaddingRight = document.body.style.paddingRight;
        document.body.style.overflow = 'hidden';
        const root = document.getElementById(rootId);
        const scrollBarWidth = root ? root.offsetWidth - root.scrollWidth : 0;
        if (scrollBarWidth) {
            document.body.style.paddingRight = `${scrollBarWidth}px`;
        }
        return () => {
            document.body.style.overflow = originalOverflow;
            if (scrollBarWidth) {
                document.body.style.paddingRight = originalPaddingRight;
            }
        };
    }, [locked]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (locked !== initialLocked) {
            setLocked(initialLocked);
        }
    }, [initialLocked]);
    return [locked, setLocked];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useLockedBody);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useMap/useMap.js":
/*!************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useMap/useMap.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useMap(initialState = new Map()) {
    const [map, setMap] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(new Map(initialState));
    const actions = {
        set: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((key, value) => {
            setMap(prev => {
                const copy = new Map(prev);
                copy.set(key, value);
                return copy;
            });
        }, []),
        setAll: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(entries => {
            setMap(() => new Map(entries));
        }, []),
        remove: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(key => {
            setMap(prev => {
                const copy = new Map(prev);
                copy.delete(key);
                return copy;
            });
        }, []),
        reset: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
            setMap(() => new Map());
        }, []),
    };
    return [map, actions];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useMap);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useMediaQuery/useMediaQuery.js":
/*!**************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useMediaQuery/useMediaQuery.js ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useMediaQuery(query) {
    const getMatches = (query) => {
        if (typeof window !== 'undefined') {
            return window.matchMedia(query).matches;
        }
        return false;
    };
    const [matches, setMatches] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getMatches(query));
    function handleChange() {
        setMatches(getMatches(query));
    }
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) {
            matchMedia.addListener(handleChange);
        }
        else {
            matchMedia.addEventListener('change', handleChange);
        }
        return () => {
            if (matchMedia.removeListener) {
                matchMedia.removeListener(handleChange);
            }
            else {
                matchMedia.removeEventListener('change', handleChange);
            }
        };
    }, [query]);
    return matches;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useMediaQuery);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useOnClickOutside/useOnClickOutside.js":
/*!**********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useOnClickOutside/useOnClickOutside.js ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");

function useOnClickOutside(ref, handler, mouseEvent = 'mousedown') {
    (0,___WEBPACK_IMPORTED_MODULE_0__.useEventListener)(mouseEvent, event => {
        const el = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!el || el.contains(event.target)) {
            return;
        }
        handler(event);
    });
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useOnClickOutside);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useReadLocalStorage/useReadLocalStorage.js":
/*!**************************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useReadLocalStorage/useReadLocalStorage.js ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useReadLocalStorage(key) {
    const readValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        if (typeof window === 'undefined') {
            return null;
        }
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        }
        catch (error) {
            console.warn(`Error reading localStorage key “${key}”:`, error);
            return null;
        }
    }, [key]);
    const [storedValue, setStoredValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(readValue);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((event) => {
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) {
            return;
        }
        setStoredValue(readValue());
    }, [key, readValue]);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('storage', handleStorageChange);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('local-storage', handleStorageChange);
    return storedValue;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useReadLocalStorage);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useScreen/useScreen.js":
/*!******************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useScreen/useScreen.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useScreen() {
    const getScreen = () => {
        if (typeof window !== 'undefined' && window.screen) {
            return window.screen;
        }
        return undefined;
    };
    const [screen, setScreen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getScreen());
    function handleSize() {
        setScreen(getScreen());
    }
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('resize', handleSize);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        handleSize();
    }, []);
    return screen;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useScreen);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useScript/useScript.js":
/*!******************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useScript/useScript.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

const cachedScriptStatuses = {};
function getScriptNode(src) {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node === null || node === void 0 ? void 0 : node.getAttribute('data-status');
    return {
        node,
        status,
    };
}
function useScript(src, options) {
    const [status, setStatus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
        var _a;
        if (!src || (options === null || options === void 0 ? void 0 : options.shouldPreventLoad)) {
            return 'idle';
        }
        if (typeof window === 'undefined') {
            return 'loading';
        }
        return (_a = cachedScriptStatuses[src]) !== null && _a !== void 0 ? _a : 'loading';
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        var _a, _b;
        if (!src || (options === null || options === void 0 ? void 0 : options.shouldPreventLoad)) {
            return;
        }
        const cachedScriptStatus = cachedScriptStatuses[src];
        if (cachedScriptStatus === 'ready' || cachedScriptStatus === 'error') {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = getScriptNode(src);
        let scriptNode = script.node;
        if (!scriptNode) {
            scriptNode = document.createElement('script');
            scriptNode.src = src;
            scriptNode.async = true;
            scriptNode.setAttribute('data-status', 'loading');
            document.body.appendChild(scriptNode);
            const setAttributeFromEvent = (event) => {
                const scriptStatus = event.type === 'load' ? 'ready' : 'error';
                scriptNode === null || scriptNode === void 0 ? void 0 : scriptNode.setAttribute('data-status', scriptStatus);
            };
            scriptNode.addEventListener('load', setAttributeFromEvent);
            scriptNode.addEventListener('error', setAttributeFromEvent);
        }
        else {
            setStatus((_b = (_a = script.status) !== null && _a !== void 0 ? _a : cachedScriptStatus) !== null && _b !== void 0 ? _b : 'loading');
        }
        const setStateFromEvent = (event) => {
            const newStatus = event.type === 'load' ? 'ready' : 'error';
            setStatus(newStatus);
            cachedScriptStatuses[src] = newStatus;
        };
        scriptNode.addEventListener('load', setStateFromEvent);
        scriptNode.addEventListener('error', setStateFromEvent);
        return () => {
            if (scriptNode) {
                scriptNode.removeEventListener('load', setStateFromEvent);
                scriptNode.removeEventListener('error', setStateFromEvent);
            }
            if (scriptNode && (options === null || options === void 0 ? void 0 : options.removeOnUnmount)) {
                scriptNode.remove();
            }
        };
    }, [src, options === null || options === void 0 ? void 0 : options.shouldPreventLoad, options === null || options === void 0 ? void 0 : options.removeOnUnmount]);
    return status;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useScript);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useSessionStorage/useSessionStorage.js":
/*!**********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useSessionStorage/useSessionStorage.js ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useSessionStorage(key, initialValue) {
    const readValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            const item = window.sessionStorage.getItem(key);
            return item ? parseJSON(item) : initialValue;
        }
        catch (error) {
            console.warn(`Error reading sessionStorage key “${key}”:`, error);
            return initialValue;
        }
    }, [initialValue, key]);
    const [storedValue, setStoredValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(readValue);
    const setValue = (0,___WEBPACK_IMPORTED_MODULE_1__.useEventCallback)(value => {
        if (typeof window == 'undefined') {
            console.warn(`Tried setting sessionStorage key “${key}” even though environment is not a client`);
        }
        try {
            const newValue = value instanceof Function ? value(storedValue) : value;
            window.sessionStorage.setItem(key, JSON.stringify(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new Event('session-storage'));
        }
        catch (error) {
            console.warn(`Error setting sessionStorage key “${key}”:`, error);
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((event) => {
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) {
            return;
        }
        setStoredValue(readValue());
    }, [key, readValue]);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('storage', handleStorageChange);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('session-storage', handleStorageChange);
    return [storedValue, setValue];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useSessionStorage);
function parseJSON(value) {
    try {
        return value === 'undefined' ? undefined : JSON.parse(value !== null && value !== void 0 ? value : '');
    }
    catch (_a) {
        console.log('parsing error on', { value });
        return undefined;
    }
}


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useSsr/useSsr.js":
/*!************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useSsr/useSsr.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function useSsr() {
    const isDOM = typeof window !== 'undefined' &&
        window.document &&
        window.document.documentElement;
    return {
        isBrowser: isDOM,
        isServer: !isDOM,
    };
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useSsr);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useStep/useStep.js":
/*!**************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useStep/useStep.js ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useStep(maxStep) {
    const [currentStep, setCurrentStep] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(1);
    const canGoToNextStep = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => currentStep + 1 <= maxStep, [currentStep, maxStep]);
    const canGoToPrevStep = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => currentStep - 1 >= 1, [currentStep]);
    const setStep = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(step => {
        const newStep = step instanceof Function ? step(currentStep) : step;
        if (newStep >= 1 && newStep <= maxStep) {
            setCurrentStep(newStep);
            return;
        }
        throw new Error('Step not valid');
    }, [maxStep, currentStep]);
    const goToNextStep = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        if (canGoToNextStep) {
            setCurrentStep(step => step + 1);
        }
    }, [canGoToNextStep]);
    const goToPrevStep = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        if (canGoToPrevStep) {
            setCurrentStep(step => step - 1);
        }
    }, [canGoToPrevStep]);
    const reset = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        setCurrentStep(1);
    }, []);
    return [
        currentStep,
        {
            goToNextStep,
            goToPrevStep,
            canGoToNextStep,
            canGoToPrevStep,
            setStep,
            reset,
        },
    ];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useStep);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useTernaryDarkMode/useTernaryDarkMode.js":
/*!************************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useTernaryDarkMode/useTernaryDarkMode.js ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


const COLOR_SCHEME_QUERY = '(prefers-color-scheme: dark)';
function useTernaryDarkMode() {
    const isDarkOS = (0,___WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)(COLOR_SCHEME_QUERY);
    const [ternaryDarkMode, setTernaryDarkMode] = (0,___WEBPACK_IMPORTED_MODULE_1__.useLocalStorage)('usehooks-ts-ternary-dark-mode', 'system');
    const [isDarkMode, setDarkMode] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isDarkOS);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useUpdateEffect)(() => {
        if (ternaryDarkMode === 'system') {
            setDarkMode(isDarkOS);
        }
    }, [isDarkOS]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        switch (ternaryDarkMode) {
            case 'light':
                setDarkMode(false);
                break;
            case 'system':
                setDarkMode(isDarkOS);
                break;
            case 'dark':
                setDarkMode(true);
                break;
        }
    }, [ternaryDarkMode, isDarkOS]);
    function toggleTernaryDarkMode() {
        const toggleDict = {
            light: 'system',
            system: 'dark',
            dark: 'light',
        };
        setTernaryDarkMode(prevMode => toggleDict[prevMode]);
    }
    return {
        isDarkMode,
        ternaryDarkMode,
        setTernaryDarkMode,
        toggleTernaryDarkMode,
    };
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useTernaryDarkMode);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useTimeout/useTimeout.js":
/*!********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useTimeout/useTimeout.js ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useTimeout(callback, delay) {
    const savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        savedCallback.current = callback;
    }, [callback]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (!delay && delay !== 0) {
            return;
        }
        const id = setTimeout(() => savedCallback.current(), delay);
        return () => clearTimeout(id);
    }, [delay]);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useTimeout);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useToggle/useToggle.js":
/*!******************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useToggle/useToggle.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useToggle(defaultValue) {
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!!defaultValue);
    const toggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => setValue(x => !x), []);
    return [value, toggle, setValue];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useToggle);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useUpdateEffect/useUpdateEffect.js":
/*!******************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useUpdateEffect/useUpdateEffect.js ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useUpdateEffect(effect, deps) {
    const isFirst = (0,___WEBPACK_IMPORTED_MODULE_1__.useIsFirstRender)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (!isFirst) {
            return effect();
        }
    }, deps);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useUpdateEffect);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useWindowSize/useWindowSize.js":
/*!**************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useWindowSize/useWindowSize.js ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useWindowSize() {
    const [windowSize, setWindowSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: 0,
        height: 0,
    });
    const handleSize = () => {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    };
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('resize', handleSize);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        handleSize();
    }, []);
    return windowSize;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useWindowSize);


/***/ }),

/***/ "@fluentui/react":
/*!**********************************!*\
  !*** external "@fluentui/react" ***!
  \**********************************/
/***/ ((module) => {

"use strict";
module.exports = require("@fluentui/react");

/***/ }),

/***/ "@fluentui/react-file-type-icons":
/*!**************************************************!*\
  !*** external "@fluentui/react-file-type-icons" ***!
  \**************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@fluentui/react-file-type-icons");

/***/ }),

/***/ "@fluentui/react-hooks":
/*!****************************************!*\
  !*** external "@fluentui/react-hooks" ***!
  \****************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@fluentui/react-hooks");

/***/ }),

/***/ "adaptivecards":
/*!********************************!*\
  !*** external "adaptivecards" ***!
  \********************************/
/***/ ((module) => {

"use strict";
module.exports = require("adaptivecards");

/***/ }),

/***/ "botframework-webchat":
/*!***************************************!*\
  !*** external "botframework-webchat" ***!
  \***************************************/
/***/ ((module) => {

"use strict";
module.exports = require("botframework-webchat");

/***/ }),

/***/ "botframework-webchat-component":
/*!*************************************************!*\
  !*** external "botframework-webchat-component" ***!
  \*************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("botframework-webchat-component");

/***/ }),

/***/ "dayjs":
/*!************************!*\
  !*** external "dayjs" ***!
  \************************/
/***/ ((module) => {

"use strict";
module.exports = require("dayjs");

/***/ }),

/***/ "dayjs/plugin/advancedFormat":
/*!**********************************************!*\
  !*** external "dayjs/plugin/advancedFormat" ***!
  \**********************************************/
/***/ ((module) => {

"use strict";
module.exports = require("dayjs/plugin/advancedFormat");

/***/ }),

/***/ "dayjs/plugin/duration":
/*!****************************************!*\
  !*** external "dayjs/plugin/duration" ***!
  \****************************************/
/***/ ((module) => {

"use strict";
module.exports = require("dayjs/plugin/duration");

/***/ }),

/***/ "dayjs/plugin/relativeTime":
/*!********************************************!*\
  !*** external "dayjs/plugin/relativeTime" ***!
  \********************************************/
/***/ ((module) => {

"use strict";
module.exports = require("dayjs/plugin/relativeTime");

/***/ }),

/***/ "dayjs/plugin/utc":
/*!***********************************!*\
  !*** external "dayjs/plugin/utc" ***!
  \***********************************/
/***/ ((module) => {

"use strict";
module.exports = require("dayjs/plugin/utc");

/***/ }),

/***/ "query-string":
/*!*******************************!*\
  !*** external "query-string" ***!
  \*******************************/
/***/ ((module) => {

"use strict";
module.exports = require("query-string");

/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ "react-jss":
/*!****************************!*\
  !*** external "react-jss" ***!
  \****************************/
/***/ ((module) => {

"use strict";
module.exports = require("react-jss");

/***/ }),

/***/ "react-visibility-sensor":
/*!******************************************!*\
  !*** external "react-visibility-sensor" ***!
  \******************************************/
/***/ ((module) => {

"use strict";
module.exports = require("react-visibility-sensor");

/***/ }),

/***/ "smarthub-common":
/*!**********************************!*\
  !*** external "smarthub-common" ***!
  \**********************************/
/***/ ((module) => {

"use strict";
module.exports = require("smarthub-common");

/***/ }),

/***/ "tslib":
/*!************************!*\
  !*** external "tslib" ***!
  \************************/
/***/ ((module) => {

"use strict";
module.exports = require("tslib");

/***/ }),

/***/ "use-debounce":
/*!*******************************!*\
  !*** external "use-debounce" ***!
  \*******************************/
/***/ ((module) => {

"use strict";
module.exports = require("use-debounce");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./src/index.ts");
/******/ 	var __webpack_export_target__ = exports;
/******/ 	for(var i in __webpack_exports__) __webpack_export_target__[i] = __webpack_exports__[i];
/******/ 	if(__webpack_exports__.__esModule) Object.defineProperty(__webpack_export_target__, "__esModule", { value: true });
/******/ 	
/******/ })()
;
//# sourceMappingURL=index.js.map